//js code packages
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';

//general functions
import * as JSFUNC from '../Library/JSFUNC.js';
import * as LibraryReact from '../Library/LibraryReact.js';
import * as JSPHP from '../CaptureExecLocalDatabaseMobx/JSPHP.js';
import * as CEIconsReact from './CEIconsReact.js';

import * as ContactsReact from '../CaptureExecReactMobxPairs/Contacts/ContactsReact.js';

//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Custom Buttons
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export function CEButton(props) { //props: p_type, p_text, p_fontClass, p_tabIndex, p_title, p_errorTF, p_styleObj, f_onClick, f_onMouseDown
  const p_type = props.p_type; //"blue", "blueDisabled", "gray", "red", "captureRed", "green", "add", "hyperlink", "hyperlinkUnderline", "hyperlinkBoldUnderline"
  const p_text = props.p_text;
  const p_fontClass = JSFUNC.prop_value(props.p_fontClass, "font11");
  const p_tabIndex = props.p_tabIndex;
  const p_title = props.p_title;
  const p_errorTF = props.p_errorTF;
  const f_onClick = props.f_onClick;

  var buttonClass = "";
  var fontClass = p_fontClass;
  var allowButtonClickTF = JSFUNC.is_function(f_onClick);
  if(p_type === "blue") { buttonClass = "ceButton ceButtonBlue cursorPointer"; }
  else if(p_type === "blueDisabled") { buttonClass = "ceButton ceButtonBlueDisabled cursorNotAllowed"; allowButtonClickTF = false; }
  else if(p_type === "gray") { buttonClass = "ceButton ceButtonGray cursorPointer"; }
  else if(p_type === "red") { buttonClass = "ceButton ceButtonRed cursorPointer"; }
  else if(p_type === "captureRed") { buttonClass = "ceButton ceButtonCaptureRed cursorPointer"; }
  else if(p_type === "green") { buttonClass = "ceButton ceButtonGreen cursorPointer"; }
  else if(p_type === "add") { buttonClass = "ceButtonAdd cursorPointer"; }
  else if(p_type === "hyperlink") { buttonClass = "cursorPointer"; }
  else if(p_type === "hyperlinkUnderline") { buttonClass = "cursorPointer"; fontClass += " fontUnderline fontBlue"; }
  else if(p_type === "hyperlinkBoldUnderline") { buttonClass = "cursorPointer"; fontClass += " fontBold fontUnderline fontBlue"; }
  return(
    <LibraryReact.ButtonFlexibleWidthFitsSingleLineText
      p_text={p_text}
      p_class={buttonClass}
      p_fontClass={fontClass}
      p_tabIndex={p_tabIndex}
      p_hoverText={p_title}
      p_errorTF={p_errorTF}
      p_styleObj={props.p_styleObj}
      f_onClick={((allowButtonClickTF) ? (f_onClick) : (undefined))}
      f_onMouseDown={((allowButtonClickTF) ? (props.f_onMouseDown) : (undefined))}
    />
  );
}




export function ButtonExpandCollapse(props) { //props: p_isExpandedTF, p_sizeEm, p_bgClass, p_tabIndex, p_title, f_onClick
  const p_isExpandedTF = JSFUNC.prop_value(props.p_isExpandedTF, false);
  const p_sizeEm = JSFUNC.prop_value(props.p_sizeEm, 1.5);
  const p_bgClass = JSFUNC.prop_value(props.p_bgClass, "");
  const p_tabIndex = props.p_tabIndex;
  const p_title = props.p_title;
  const f_onClick = props.f_onClick;

  return(
    <LibraryReact.ButtonFixedHeightWidthCenteredContent
      p_widthEm={p_sizeEm}
      p_heightEm={p_sizeEm}
      p_class={p_bgClass + " hoverLightestestGray cursorPointer"}
      p_styleObj={{border:"solid 1px #aaa", borderRadius:(p_sizeEm / 2) + "em"}}
      p_tabIndex={p_tabIndex}
      p_hoverText={p_title}
      f_onClick={f_onClick}
      f_onKeyDownEnter={((JSFUNC.is_number_not_nan_gt_0(p_tabIndex)) ? (f_onClick) : (undefined))}>
      <CEIconsReact.SvgUpDownCarat
        p_isDownTF={!p_isExpandedTF} //currently expanded, arrow is pointing up to collapse it again
        p_sizeEm={(p_sizeEm / 1.7)}
      />
    </LibraryReact.ButtonFixedHeightWidthCenteredContent>
  );
}


export function ButtonLeftRightCircledCarat(props) { //props: p_leftFalseRightTrue, p_sizeEm, p_bgClass, p_tabIndex, p_title, f_onClick
  const p_leftFalseRightTrue = JSFUNC.prop_value(props.p_leftFalseRightTrue, false);
  const p_sizeEm = JSFUNC.prop_value(props.p_sizeEm, 1.5);
  const p_bgClass = JSFUNC.prop_value(props.p_bgClass, "");
  const p_tabIndex = props.p_tabIndex;
  const p_title = props.p_title;
  const f_onClick = props.f_onClick;

  return(
    <LibraryReact.ButtonFixedHeightWidthCenteredContent
      p_widthEm={p_sizeEm}
      p_heightEm={p_sizeEm}
      p_class={p_bgClass + " border1ddd hoverLightestestGray cursorPointer"}
      p_styleObj={{borderRadius:(p_sizeEm / 2) + "em"}}
      p_tabIndex={p_tabIndex}
      p_hoverText={p_title}
      f_onClick={f_onClick}
      f_onKeyDownEnter={((JSFUNC.is_number_not_nan_gt_0(p_tabIndex)) ? (f_onClick) : (undefined))}>
      <CEIconsReact.SvgLeftRightCarat
        p_leftFalseRightTrue={p_leftFalseRightTrue}
        p_sizeEm={(p_sizeEm / 1.7)}
      />
    </LibraryReact.ButtonFixedHeightWidthCenteredContent>
  );
}


export function ButtonPageIncrementOrDecrement(props) { //p_incTrueDecFalse, p_canClickTF, p_widthEm, p_heightEm, p_canClickBgClass, p_canClickFontClass, p_cantClickBgClass, p_cantClickFontClass, p_tabIndex, p_title, f_onClick
  const p_incTrueDecFalse = props.p_incTrueDecFalse;
  const p_canClickTF = props.p_canClickTF;
  const p_widthEm = JSFUNC.prop_value(props.p_widthEm, 2.5);
  const p_heightEm = JSFUNC.prop_value(props.p_heightEm, 1.6);
  const p_canClickBgClass = JSFUNC.prop_value(props.p_canClickBgClass, "bgLighterGrayGradient hoverLightestGrayGradient");
  const p_canClickFontClass = JSFUNC.prop_value(props.p_canClickFontClass, "");
  const p_cantClickBgClass = JSFUNC.prop_value(props.p_cantClickBgClass, "bgDarkGrayGradient");
  const p_cantClickFontClass = JSFUNC.prop_value(props.p_cantClickFontClass, "fontTextLighter");
  const p_tabIndex = props.p_tabIndex;
  const p_title = props.p_title;
  const f_onClick = props.f_onClick;

  const canClickTF = (JSFUNC.is_function(f_onClick) && p_canClickTF);

  return(
    <LibraryReact.ButtonFixedHeightWidthCenteredText
      p_text={((p_incTrueDecFalse) ? (">") : ("<"))}
      p_widthEm={p_widthEm}
      p_heightEm={p_heightEm}
      p_class={"border1 bevelBorderColors borderRadius05 textCenter " + ((canClickTF) ? (p_canClickBgClass + " cursorPointer") : (p_cantClickBgClass))}
      p_fontClass={((canClickTF) ? (p_canClickFontClass) : (p_cantClickFontClass))}
      p_tabIndex={p_tabIndex}
      p_hoverText={p_title}
      f_onClick={((canClickTF) ? (f_onClick) : (undefined))}
    />
  );
}


export function ClearXWithLabel(props) { //props: p_labelText, p_class, p_fontClass, p_tabIndex, p_title, f_onClick
  const p_labelText = props.p_labelText;
  const p_class = JSFUNC.prop_value(props.p_class, "");
  const p_fontClass = JSFUNC.prop_value(props.p_fontClass, "");
  const p_tabIndex = props.p_tabIndex;
  const p_title = props.p_title;
  const f_onClick = props.f_onClick;

  const canClickTF = JSFUNC.is_function(f_onClick);

  return(
    <div
      className={"displayFlexRowVc " + p_class + " " + ((canClickTF) ? ("cursorPointer") : (""))}
      tabIndex={p_tabIndex}
      title={p_title}
      onClick={f_onClick}>
      <span className={p_fontClass}>
        {"\u2715 " + p_labelText}
      </span>
    </div>
  );
}


export const EditSaveCancelIcon = inject("UserMobx")(observer(
class EditSaveCancelIcon extends Component { //props: p_iconType, p_containerWidthEm, p_tabIndex, p_title, f_onClick, f_onHover
  constructor(props) {
    super(props);
    this.state = {
      s_hoverTF: false
    };
  }

  onhover_container = (i_hoverTF) => {
    this.setState({s_hoverTF:i_hoverTF});

    if(JSFUNC.is_function(this.props.f_onHover)) {
      this.props.f_onHover(i_hoverTF);
    }
  }

  render() {
    const hoverTF = this.state.s_hoverTF;

    const iconType = this.props.p_iconType; //"edit", "save", "cancel", "blank"
    const p_containerWidthEm = JSFUNC.prop_value(this.props.p_containerWidthEm, 2.2);
    const tabIndex = this.props.p_tabIndex;
    const title = this.props.p_title;

    const c_svgEditPencil11White = this.props.UserMobx.c_svgEditPencil11White;
    const c_svgEditPencil11Gray = this.props.UserMobx.c_svgEditPencil11Gray;

    const containerHeightEm = 1.6;
    const circleSizeEm = 1.6;

    var isBlankTF = false;
    var iconComponent = null;
    var bgColor = "";
    if(iconType === "blank") {
      isBlankTF = true;
    }
    else if(iconType === "edit") {
      iconComponent = ((hoverTF) ? (c_svgEditPencil11White) : (c_svgEditPencil11Gray));
      bgColor = ((hoverTF) ? ("68a") : ("fafafa"));
    }
    else if(iconType === "save") {
      iconComponent = (
        <font className="font09 fontBold fontWhite">
          {"\u2713"}
        </font>
      );
      bgColor = ((hoverTF) ? ("3c3") : ("6a6"));
    }
    else if(iconType === "cancel") {
      iconComponent = (
        <font className="font09 fontBold fontWhite">
          {"\u2715"}
        </font>
      );
      bgColor = ((hoverTF) ? ("766") : ("988"));
    }

    //blank icon, space is same size as normal icon container, but cannot be clicked or hovered (even if those inputs are provided)
    if(isBlankTF) {
      return(
        <div className="flex00a" style={{minHeight:containerHeightEm + "em", width:p_containerWidthEm + "em"}} />
      );
    }

    return(
      <LibraryReact.InteractiveDiv
        p_class="flex00a displayFlexColumnHcVc cursorPointer"
        p_styleObj={{minHeight:containerHeightEm + "em", width:p_containerWidthEm + "em"}}
        p_tabIndex={tabIndex}
        p_title={title}
        f_onClick={this.props.f_onClick}
        f_onKeyDownEnter={this.props.f_onClick}
        f_onHover={this.onhover_container}>
        <div
          className="displayFlexColumnHcVc"
          style={{height:circleSizeEm + "em", width:circleSizeEm + "em", borderRadius:"0.8em", border:"solid 1px #eee", background:"#" + bgColor}}>
          {iconComponent}
        </div>
      </LibraryReact.InteractiveDiv>
    );
  }
}));



export const HelpHoverIconWithFloatingBox = inject("CaptureExecMobx")(observer(
class HelpHoverIconWithFloatingBox extends Component { //props: p_trblFlag, p_floatingBoxTitle, p_tabIndex, p_title, children
  constructor(props) {
    super(props);
    this.state = {
      s_helpFloatingBoxIsOpenTF: false
    };
  }

  onclick_open_help_floating_box = () => {
    this.setState({s_helpFloatingBoxIsOpenTF:true});
  }

  onclick_close_help_floating_box = () => {
    this.setState({s_helpFloatingBoxIsOpenTF:false});
  }

  render() {
    const s_helpFloatingBoxIsOpenTF = this.state.s_helpFloatingBoxIsOpenTF;

    const p_trblFlag = JSFUNC.prop_value(this.props.p_trblFlag, "smallVertical");
    const p_floatingBoxTitle = this.props.p_floatingBoxTitle;
    const p_tabIndex = this.props.p_tabIndex;
    const p_title = this.props.p_title;

    const messageOrArrayOfMessageLines = this.props.children;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    var titleMessage = undefined;
    var floatingBoxMessage = undefined;
    if(JSFUNC.is_array(messageOrArrayOfMessageLines)) {
      titleMessage = messageOrArrayOfMessageLines.join("\n");
      floatingBoxMessage = (
        messageOrArrayOfMessageLines.map((m_messageLine) =>
          <div className="displayFlexRow smallBottomMargin">
            <LibraryReact.DivFont p_class="flex00a lrMargin" p_fontClass="fontTextLighter">
              {"-"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="flex11a lrMargin" p_fontClass="fontTextLight">
              {m_messageLine}
            </LibraryReact.DivFont>
          </div>
        )
      );
    }
    else if(JSFUNC.is_string(messageOrArrayOfMessageLines)) { //single string passed in, use it as both the title and the box message
      titleMessage = messageOrArrayOfMessageLines;
      floatingBoxMessage = messageOrArrayOfMessageLines;
    }
    else { //component passed in, display whole thing 
      titleMessage = p_title;
      floatingBoxMessage = messageOrArrayOfMessageLines;
    }

    var floatingBoxTitle = p_floatingBoxTitle;
    if(!JSFUNC.is_string(p_floatingBoxTitle)) {
      floatingBoxTitle = c_productStylingObj.productName + " Help";
    }

    return(
      <>
        <LibraryReact.InteractiveDiv
          p_class="flex00a displayFlexColumnHcVc cursorHelp helpIcon hoverLightBlueGradient fontBold"
          p_styleObj={{height:"1.4em", width:"1.5em", borderRadius:"0.8em"}}
          p_tabIndex={p_tabIndex}
          p_title={titleMessage}
          f_onClick={this.onclick_open_help_floating_box}
          f_onKeyDownEnter={this.onclick_open_help_floating_box}>
          {"?"}
        </LibraryReact.InteractiveDiv>
        {(s_helpFloatingBoxIsOpenTF) &&
          <FloatingBoxWithSaveCancel
            p_trblFlag={p_trblFlag}
            p_title={floatingBoxTitle}
            f_onClickCancel={this.onclick_close_help_floating_box}>
            <div className="flex11a medFullPad yScroll">
              {floatingBoxMessage}
            </div>
            <div className="Flex00a displayFlexColumnHcVc borderT1bbb tbMedPad">
              <CEButton
                p_type="blue"
                p_text="Close"
                f_onClick={this.onclick_close_help_floating_box}
              />
            </div>
          </FloatingBoxWithSaveCancel>
        }
      </>
    );
  }
}));


export function NotificationIcon(props) { //props: p_type, p_number
  var bgClass = "";
  var fontColorClass = "";
  if(props.p_type === "red") {
    bgClass = "bgRed";
    fontColorClass = "fontWhite";
  }
  else if(props.p_type === "gray") {
    bgClass = "bgLightGray";
    fontColorClass = "";
  }

  return(
    <LibraryReact.DivFont
      p_class={"positionAbsolute border bevelBorderColors borderRadius10 textCenter " + bgClass}
      p_styleObj={{bottom:"0.15em", right:"0.15em", padding:"0.05em 0.45em"}}
      p_fontClass={"font09 fontBold " + fontColorClass}>
      {props.p_number}
    </LibraryReact.DivFont>
  );
}

export class RemoveItemXWithRedHover extends Component { //props: p_tabIndex, p_title, p_heightEm, p_fontClass, f_onClick
  //small x used for single click removal of items such as editing capture owners or reasons won/lost
  constructor(props) {
    super(props);
    this.state = {
      s_icon: "\u2715"
    }
  }

  onhover_remove_button = (i_hoverTF) => {
    this.setState({s_icon:((i_hoverTF) ? ("\u2716") : ("\u2715"))});
  }

  render() {
    const heightEm = JSFUNC.prop_value(this.props.p_heightEm, 1.5);
    const fontClass = JSFUNC.prop_value(this.props.p_fontClass, "font12 fontTextLightester");
    return(
      <div
        className="flex00a displayFlexColumn"
        style={{flexBasis:"1.5em", height:heightEm + "em"}}
        title={this.props.p_title}>
        <LibraryReact.InteractiveDiv
          p_class={"flex11a displayFlexColumnHcVc smallFullPad textCenter cursorPointer hoverDeleteButtonX " + fontClass}
          p_styleObj={{lineHeight:(heightEm / 2) + "em"}}
          p_tabIndex={this.props.p_tabIndex}
          f_onClick={this.props.f_onClick}
          f_onKeyDownEnter={this.props.f_onClick}
          f_onHover={this.onhover_remove_button}>
          {this.state.s_icon}
        </LibraryReact.InteractiveDiv>
      </div>
    );
  }
}


export class ButtonCopyToClipboard extends Component { //props: p_clipboardText, p_preCopyText, p_postCopyText, p_preCopyClass, p_postCopyClass, p_styleObj, p_preCopyFontClass, p_postCopyFontClass, p_tabIndex, p_title
  constructor(props) {
    super(props);

    this.state = {
      s_copiedTF: false
    }
  }

  onclick_copy_input_text_value_to_clipboard = () => {
    const p_clipboardText = this.props.p_clipboardText;

    if(navigator.clipboard) {
      navigator.clipboard.writeText(p_clipboardText);
      this.setState({s_copiedTF:true});
      this.timeoutID = setTimeout(() => this.reset_to_initial_state_and_clear_timeout(), 1500);
    }
  }

  reset_to_initial_state_and_clear_timeout = () => {
    this.setState({s_copiedTF:false});
    clearTimeout(this.timeoutID);
  }

  render() {
    const s_copiedTF = this.state.s_copiedTF;

    const p_clipboardText = this.props.p_clipboardText;
    const p_preCopyText = this.props.p_preCopyText;
    const p_postCopyText = this.props.p_postCopyText;
    const p_preCopyClass = this.props.p_preCopyClass;
    const p_postCopyClass = this.props.p_postCopyClass;
    const p_styleObj = this.props.p_styleObj;
    const p_preCopyFontClass = this.props.p_preCopyFontClass;
    const p_postCopyFontClass = this.props.p_postCopyFontClass;
    const p_tabIndex = this.props.p_tabIndex;
    const p_title = this.props.p_title;

    var inputClass = ((s_copiedTF) ? (p_postCopyClass) : (p_preCopyClass));

    var buttonClass = "cursorPointer";
    if(JSFUNC.string_is_filled_out_tf(inputClass)) {
      buttonClass = buttonClass + " " + inputClass;
    }

    return(
      <LibraryReact.ButtonFlexibleWidthFitsSingleLineText
        p_text={((s_copiedTF) ? (p_postCopyText) : (p_preCopyText))}
        p_class={buttonClass}
        p_styleObj={p_styleObj}
        p_fontClass={((s_copiedTF) ? (p_postCopyFontClass) : (p_preCopyFontClass))}
        p_tabIndex={p_tabIndex}
        p_hoverText={p_title}
        p_errorTF={false}
        f_onClick={this.onclick_copy_input_text_value_to_clipboard}
      />
    );
  }
}



export class SwitchWithTextAndConfirmBox extends Component { //props:
  //p_isOnTF, p_sizeEm, p_onColor, p_offColor, p_onText, p_offText, p_onTextFontClass, p_offTextFontClass, 
  //p_switchToOnMessage, p_switchToOnButtonName, p_switchToOffMessage, p_switchToOffButtonName, 
  //p_labelText, p_labelFontClass, p_labelWidthEm, p_tabIndex, p_title,
  //f_onSwitch
  constructor(props) {
    super(props);
    this.state = {
      s_confirmSwitchOnOrOffFloatingBoxIsOpenTF: false
    }
  }

  onclick_switch = () => {
    const isOnTF = this.props.p_isOnTF;
    const p_switchToOnMessage = this.props.p_switchToOnMessage;
    const p_switchToOffMessage = this.props.p_switchToOffMessage;

    if((isOnTF && (p_switchToOffMessage !== undefined)) || (!isOnTF && (p_switchToOnMessage !== undefined))) { //if it's on and there's an off message OR it's off and there's an on message, open the confirm floating box, otherwise just call the output f_onSwitch
      this.setState({s_confirmSwitchOnOrOffFloatingBoxIsOpenTF:true});
    }
    else {
      this.call_onswitch();
    }
  }

  call_onswitch = () => {
    this.onclick_cancel_confirm_switch();

    if(JSFUNC.is_function(this.props.f_onSwitch)) {
      this.props.f_onSwitch();
    }
  }

  onclick_cancel_confirm_switch = () => {
    this.setState({s_confirmSwitchOnOrOffFloatingBoxIsOpenTF:false});
  }

  render() {
    const s_confirmSwitchOnOrOffFloatingBoxIsOpenTF = this.state.s_confirmSwitchOnOrOffFloatingBoxIsOpenTF;

    const p_isOnTF = this.props.p_isOnTF;
    const p_sizeEm = this.props.p_sizeEm;
    const p_onColor = this.props.p_onColor;
    const p_offColor = this.props.p_offColor;
    const p_onText = this.props.p_onText;
    const p_offText = this.props.p_offText;
    const p_onTextFontClass = this.props.p_onTextFontClass;
    const p_offTextFontClass = this.props.p_offTextFontClass;
    const p_switchToOnMessage = this.props.p_switchToOnMessage;
    const p_switchToOnButtonName = this.props.p_switchToOnButtonName;
    const p_switchToOffMessage = this.props.p_switchToOffMessage;
    const p_switchToOffButtonName = this.props.p_switchToOffButtonName;
    const p_labelText = this.props.p_labelText;
    const p_labelFontClass = this.props.p_labelFontClass;
    const p_labelWidthEm = this.props.p_labelWidthEm;
    const p_tabIndex = this.props.p_tabIndex;
    const p_title = this.props.p_title;

    const canClickTF = JSFUNC.is_function(this.props.f_onSwitch);

    const switchComponent = (
      <LibraryReact.Switch
        p_isOnTF={p_isOnTF}
        p_sizeEm={p_sizeEm}
        p_onColor={p_onColor}
        p_offColor={p_offColor}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        f_onClick={((canClickTF) ? (this.onclick_switch) : (undefined))}
      />
    );

    var switchWithTextComponent = null;
    if((p_onText !== undefined) || (p_offText !== undefined)) { //if using switch with text written next to it
      var textFontClass = undefined;
      var textColor = undefined;
      var switchText = "";
      if(p_isOnTF) {
        textFontClass = JSFUNC.prop_value(p_onTextFontClass, "font11 fontBold");
        textColor = JSFUNC.prop_value(p_onColor, "005da3");
        switchText = p_onText;
      }
      else {
        textFontClass = JSFUNC.prop_value(p_offTextFontClass, "font11");
        textColor = JSFUNC.prop_value(p_offColor, "6b6b6b");
        switchText = p_offText;
      }

      switchWithTextComponent = (
        <div className="displayFlexRow" title={p_title}>
          <div className="flex00a displayFlexColumnVc smallRightMargin">
            {switchComponent}
          </div>
          <LibraryReact.DivFont p_class="flex11a displayFlexColumnVc lrPad" p_fontClass={textFontClass} p_fontStyleObj={{color:"#" + textColor}}>
            {switchText}
          </LibraryReact.DivFont>
        </div>
      );
    }
    else { //just the switch with no text
      switchWithTextComponent = switchComponent;
    }

    //apply a label to the left side of the switch if the input p_labelText is filled out
    const labelTextIsArrayTF = JSFUNC.is_array_not_empty(p_labelText);
    const labelIsFilledOutTF = labelTextIsArrayTF || JSFUNC.string_is_filled_out_tf(p_labelText);
    if(labelIsFilledOutTF) {
      switchWithTextComponent = (
        <div className="displayFlexRow" title={p_title}>
          {(labelTextIsArrayTF) ? (
            <div className="flex00a displayFlexColumnVc lrPad" style={{flexBasis:p_labelWidthEm + "em"}}>
              {p_labelText.map((labelText, labelIndex) =>
                <div key={"switchLabel" + labelIndex} className={p_labelFontClass}>{labelText}</div>
              )}
            </div>
          ) : (
            <LibraryReact.DivFont p_class="flex00a displayFlexRowVc lrPad" p_styleObj={{flexBasis:p_labelWidthEm + "em"}} p_fontClass={p_labelFontClass}>
              {p_labelText}
            </LibraryReact.DivFont>
          )}
          <div className="flex11a displayFlexRowVc">
            {switchWithTextComponent}
          </div>
        </div>
      );
    }

    return(
      <>
        {switchWithTextComponent}
        {(s_confirmSwitchOnOrOffFloatingBoxIsOpenTF) &&
          <ConfirmBox
            p_type="confirm"
            p_button1Name={((p_isOnTF) ? (p_switchToOffButtonName) : (p_switchToOnButtonName))}
            f_onClickConfirm={this.call_onswitch}
            f_onClickCancel={this.onclick_cancel_confirm_switch}>
            {((p_isOnTF) ? (p_switchToOffMessage) : (p_switchToOnMessage))}
          </ConfirmBox>
        }
      </>
    );
  }
}


export class VerticalSwitch extends Component { //props:
  //p_valueArray, p_displayArray, p_selectConfirmMessagesArray, p_selectConfirmButtonNamesArray, p_selectedValue, p_rowHeightEm, p_sizeMultiplier, 
  //p_selectedColor, p_unselectedColor, p_selectedDisplayFontClass, p_unselectedDisplayFontClass, p_tabIndex, 
  //f_onSelect, f_onKeyDownEnter
  constructor(props) {
    super(props);
    this.state = {
      s_confirmSwitchFloatingBoxIsOpenTF: false
    }
  }

  onclick_switch_zone = (i_selectedValueIndex) => {
    const p_valueArray = this.props.p_valueArray;
    const p_displayArray = this.props.p_displayArray;
    const p_selectConfirmMessagesArray = this.props.p_selectConfirmMessagesArray;
    const p_selectConfirmButtonNamesArray = this.props.p_selectConfirmButtonNamesArray;

    const selectedValue = p_valueArray[i_selectedValueIndex];

    if(false) { //if it's on and there's an off message OR it's off and there's an on message, open the confirm floating box, otherwise just call the output f_onSwitch
      this.setState({s_confirmSwitchFloatingBoxIsOpenTF:true});
    }
    else {
      this.call_onselect(selectedValue);
    }
  }

  call_onselect = (i_selectedValue) => {
    this.onclick_cancel_confirm_switch();

    if(JSFUNC.is_function(this.props.f_onSelect)) {
      this.props.f_onSelect(i_selectedValue);
    }
  }

  onclick_cancel_confirm_switch = () => {
    this.setState({s_confirmSwitchFloatingBoxIsOpenTF:false});
  }

  onselect_next_option = () => {
    const p_valueArray = this.props.p_valueArray;
    const p_selectedValue = this.props.p_selectedValue;

    const numValues = p_valueArray.length;
    if(numValues > 1) { //have to be at least 2 options to switch between to do keydown action
      const selectedValueIndex = JSFUNC.array_index_of_first_matching_value(p_valueArray, p_selectedValue, -1);

      //go to next option, if on the last option, go back to the first option
      var nextSelectedValueIndex = (selectedValueIndex + 1);
      if(nextSelectedValueIndex >= numValues) {
        nextSelectedValueIndex = 0;
      }

      this.onclick_switch_zone(nextSelectedValueIndex);
    }
  }

  onselect_previous_option = () => {
    const p_valueArray = this.props.p_valueArray;
    const p_selectedValue = this.props.p_selectedValue;

    const numValues = p_valueArray.length;
    if(numValues > 1) { //have to be at least 2 options to switch between to do keydown action
      const selectedValueIndex = JSFUNC.array_index_of_first_matching_value(p_valueArray, p_selectedValue, 1);

      //go to previous option, if on the first option [0], go to the last option
      var previousSelectedValueIndex = (selectedValueIndex - 1);
      if(previousSelectedValueIndex < 0) {
        previousSelectedValueIndex = (numValues - 1);
      }

      this.onclick_switch_zone(previousSelectedValueIndex);
    }
  }

  render() {
    const s_confirmSwitchFloatingBoxIsOpenTF = this.state.s_confirmSwitchFloatingBoxIsOpenTF;

    const p_valueArray = this.props.p_valueArray;
    const p_displayArray = this.props.p_displayArray;
    const p_selectConfirmMessagesArray = this.props.p_selectConfirmMessagesArray;
    const p_selectConfirmButtonNamesArray = this.props.p_selectConfirmButtonNamesArray;
    const p_selectedValue = this.props.p_selectedValue;
    const p_rowHeightEm = JSFUNC.prop_number_positive(this.props.p_rowHeightEm, 1.5);
    const p_sizeMultiplier = JSFUNC.prop_number_positive(this.props.p_sizeMultiplier, 1);
    const p_selectedColor = JSFUNC.prop_value(this.props.p_selectedColor, "005da3");
    const p_unselectedColor = JSFUNC.prop_value(this.props.p_unselectedColor, "6b6b6b");
    const p_selectedDisplayFontClass = JSFUNC.prop_value(this.props.p_selectedDisplayFontClass, "fontBold fontBlue");
    const p_unselectedDisplayFontClass = JSFUNC.prop_value(this.props.p_unselectedDisplayFontClass, "fontTextLight");
    const p_tabIndex = this.props.p_tabIndex;

    var errorMessage = undefined;

    if(!JSFUNC.is_array(p_valueArray)) {
      errorMessage = "--p_valueArray is not an array (" + typeof(p_valueArray) + ")--";
    }

    if(!JSFUNC.is_array(p_displayArray)) {
      errorMessage = "--p_displayArray is not an array (" + typeof(p_displayArray) + ")--";
    }

    const numValues = p_valueArray.length;
    const numDisplays = p_displayArray.length;
    if(numValues !== numDisplays) {
      errorMessage = "--p_valueArray (" + numValues + ") and p_displayArray (" + numDisplays + ") lengths do not match--";
    }

    if(numValues === 0) {
      errorMessage = "--Vertical Switch has 0 options--";
    }

    if(errorMessage !== undefined) {
      return(
        <LibraryReact.DivFont p_class="displayFlexColumnHcVc border1bbb smallFullPad textCenter" p_fontClass="fontItalic fontTextLight">
          {errorMessage}
        </LibraryReact.DivFont>
      );
    }

    //variability parameters
    const channelBgColor = "bbbbbb";
    const channelCoverBgColor = "f3f3f3";
    const dotsContainerWidthEm = (p_sizeMultiplier * 2);
    const selectedDotWidthEm = (p_sizeMultiplier * 1.15);
    const selectedDotBoxShadow = "0 0 " + (selectedDotWidthEm / 5) + "em " + (selectedDotWidthEm / 7) + "em #" + p_selectedColor;
    const selectedDotTransition = "0.15s";
    const holeWidthEm = (selectedDotWidthEm * 1.1);
    const channelWidthEm = (selectedDotWidthEm * 0.3);
    const displayBgColor = "fafafa";
    const displayMaxHeightEm = (p_rowHeightEm * 0.8);

    //find the index of the current selected value within the p_valueArray
    const selectedValueIndex = JSFUNC.array_index_of_first_matching_value(p_valueArray, p_selectedValue, -1); //-1 is a flag that an invalid option is selected

    //calculated sizes
    const allRowsHeightEm = (numValues * p_rowHeightEm);
    const selectedDotLeftEm = ((dotsContainerWidthEm - selectedDotWidthEm) / 2);
    const selectedDotTopEm = (selectedValueIndex * p_rowHeightEm) + ((p_rowHeightEm - selectedDotWidthEm) / 2);
    const channelWidth0to100 = ((channelWidthEm / dotsContainerWidthEm) * 100);
    const channelLeft0to100 = (50 - (channelWidth0to100 / 2));
    const channelRight0to100 = (50 + (channelWidth0to100 / 2));
    const holeYScaleFactor = (dotsContainerWidthEm / p_rowHeightEm);
    const holeRadius0to100 = (((holeWidthEm / dotsContainerWidthEm) / 2) * 100);
    const holeLeft0to100 = (50 - holeRadius0to100);
    const holeRight0to100 = (50 + holeRadius0to100);
    const holeTop0to100 = (50 - (holeRadius0to100 * holeYScaleFactor));
    const holeBottom0to100 = (50 + (holeRadius0to100 * holeYScaleFactor));

    const circle24CosXArray = [1, 0.966, 0.866, 0.707, 0.5, 0.259, 0, -0.259, -0.5, -0.707, -0.866, -0.966, -1, -0.966, -0.866, -0.707, -0.5, -0.259, 0, 0.259, 0.5, 0.707, 0.866, 0.966, 1, 0.966, 0.866, 0.707, 0.5, 0.259, 0, -0.259, -0.5, -0.707, -0.866, -0.966, -1, -0.966, -0.866, -0.707, -0.5, -0.259, 0, 0.259, 0.5, 0.707, 0.866, 0.966];
    const circle24SinXArray = [0, 0.259, 0.5, 0.707, 0.866, 0.966, 1, 0.966, 0.866, 0.707, 0.5, 0.259, 0, -0.259, -0.5, -0.707, -0.866, -0.966, -1, -0.966, -0.866, -0.707, -0.5, -0.259, 0, 0.259, 0.5, 0.707, 0.866, 0.966, 1, 0.966, 0.866, 0.707, 0.5, 0.259, 0, -0.259, -0.5, -0.707, -0.866, -0.966, -1, -0.966, -0.866, -0.707, -0.5, -0.259];
    var polygonPointsStringsPerValue1Array = [];
    var polygonPointsStringsPerValue2Array = []; //middle segments need 2 halves drawn, while top and bottom only need single polygon
    for(let i = 0; i < numValues; i++) {
      var polygonPointsString1 = undefined;
      var polygonPointsString2 = undefined;

      if((i === 0) || (i === (numValues - 1))) { //top or bottom segment like U or upsidedown U
        //all straignt edges of shape
        var topOrBottomXYCoords0to100ArrayOfArrays = [[channelLeft0to100, holeBottom0to100],[channelLeft0to100,100],[0,100],[0,0],[100,0],[100,100],[channelRight0to100,100],[channelRight0to100,holeBottom0to100]];

        //apply almost full circle of points
        for(let c = 21; c <= 39; c++) {
          var circleX = ((circle24CosXArray[c] * holeRadius0to100) + 50);
          var circleY = (50 - (circle24SinXArray[c] * holeRadius0to100 * holeYScaleFactor));
          topOrBottomXYCoords0to100ArrayOfArrays.push([circleX, circleY]);
        }

        //reapply initial point at end to close the polygon
        topOrBottomXYCoords0to100ArrayOfArrays.push([channelLeft0to100, holeBottom0to100]);

        //if this is the bottom, flip every y coordinate (100 - Y) to flip the shape
        if(i > 0) {
          for(let xyCoord0to100 of topOrBottomXYCoords0to100ArrayOfArrays) {
            xyCoord0to100[1] = (100 - xyCoord0to100[1]);
          }
        }

        //convert the arrayOfArrays to a string of points (all also scaled 0 to 100)
        polygonPointsString1 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(topOrBottomXYCoords0to100ArrayOfArrays, 100);
      }
      else { //middle segments 2 plygons to form middle channel with bubble
        //all straignt edges of shape
        var leftXYCoords0to100ArrayOfArrays = [[channelLeft0to100, holeBottom0to100],[channelLeft0to100,100],[0,100],[0,0],[channelLeft0to100,0],[channelLeft0to100,holeTop0to100]];

        //apply almost half circle of points
        for(let c = 9; c <= 15; c++) {
          var circleX = ((circle24CosXArray[c] * holeRadius0to100) + 50);
          var circleY = (50 - (circle24SinXArray[c] * holeRadius0to100 * holeYScaleFactor));
          leftXYCoords0to100ArrayOfArrays.push([circleX, circleY]);
        }

        //reapply initial point at end to close the polygon
        leftXYCoords0to100ArrayOfArrays.push([channelLeft0to100, holeBottom0to100]);

        //copy flipped to make the right half, flip every x coordinate (100 - X)
        var rightXYCoords0to100ArrayOfArrays = [];
        for(let xyCoord0to100 of leftXYCoords0to100ArrayOfArrays) {
          var rightX = (100 - xyCoord0to100[0]);
          var rightY = xyCoord0to100[1];
          rightXYCoords0to100ArrayOfArrays.push([rightX, rightY]);
        }

        //convert the arrayOfArrays to a string of points (all also scaled 0 to 100)
        polygonPointsString1 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(leftXYCoords0to100ArrayOfArrays, 100);
        polygonPointsString2 = JSFUNC.svg_polygon_points_string_from_xy_coords_0to100_array_of_arrays(rightXYCoords0to100ArrayOfArrays, 100);
      }

      polygonPointsStringsPerValue1Array.push(polygonPointsString1);
      polygonPointsStringsPerValue2Array.push(polygonPointsString2);
    }

    return(
      <LibraryReact.InteractiveDiv
        p_class="displayFlexColumn border1bbb"
        p_tabIndex={p_tabIndex}
        f_onKeyDownUpArrow={this.onselect_previous_option}
        f_onKeyDownDownArrow={this.onselect_next_option}
        f_onKeyDownEnter={this.props.f_onKeyDownEnter}>
        <div className="flex11a displayFlexRow" style={{height:allRowsHeightEm + "em"}}>
          <div className="flex00a positionRelative" style={{flexBasis:dotsContainerWidthEm + "em", background:"#" + channelBgColor}}>
            {(selectedValueIndex >= 0) &&
              <div
                className="positionAbsolute"
                style={{left:selectedDotLeftEm + "em", top:selectedDotTopEm + "em", width:selectedDotWidthEm + "em", height:selectedDotWidthEm + "em", borderRadius:selectedDotWidthEm + "em", background:"#" + p_selectedColor, boxShadow:selectedDotBoxShadow, transition:selectedDotTransition}}
              />
            }
            {p_valueArray.map((m_value, m_index) =>
              <div
                key={m_index}
                className={"positionAbsolute " + ((m_index !== selectedValueIndex) ? ("cursorPointer") : (""))}
                style={{left:0, top:(m_index * p_rowHeightEm) + "em", right:0, height:p_rowHeightEm + "em"}}
                title={((m_index !== selectedValueIndex) ? ("Click to select option '" + p_displayArray[m_index] + "'") : (""))}
                onClick={((m_index !== selectedValueIndex) ? (() => { this.onclick_switch_zone(m_index); }) : (undefined))}>
                <svg height="100%" width="100%" viewBox="0 0 100 100" preserveAspectRatio="none" style={{background:"transparent"}}>
                  {(polygonPointsStringsPerValue1Array[m_index] !== undefined) &&
                    <polygon points={polygonPointsStringsPerValue1Array[m_index]} style={{fill:"#" + channelCoverBgColor}} />
                  }
                  {(polygonPointsStringsPerValue2Array[m_index] !== undefined) &&
                    <polygon points={polygonPointsStringsPerValue2Array[m_index]} style={{fill:"#" + channelCoverBgColor}} />
                  }
                </svg>
              </div>
            )}
          </div>
          <div className="flex11a displayFlexColumn lrPad" style={{background:"#" + displayBgColor}}>
            {p_displayArray.map((m_display, m_index) =>
              <div
                key={m_index}
                className={"flex11a displayFlexRowVc " + ((m_index > 0) ? ("borderT1ddd") : ("")) + " hoverLightestBlueGradient " + ((m_index !== selectedValueIndex) ? ("cursorPointer") : (""))}
                style={{flexBasis:"100em"}}
                title={m_display + ((m_index !== selectedValueIndex) ? ("\n[click to select this option]") : ("\n[currently selected option]"))}
                onClick={((m_index !== selectedValueIndex) ? (() => { this.onclick_switch_zone(m_index); }) : (undefined))}>
                <LibraryReact.MaxHeightWrap p_maxHeight={displayMaxHeightEm + "em"} p_fontClass={((m_index === selectedValueIndex) ? (p_selectedDisplayFontClass) : (p_unselectedDisplayFontClass))}>
                  {m_display}
                </LibraryReact.MaxHeightWrap>
              </div>
            )}
          </div>
        </div>
      </LibraryReact.InteractiveDiv>
    );
  }
}



export function HeaderSortArrow(props) { //props: p_isSortedTF, p_sortedAscTF
  const p_isSortedTF = props.p_isSortedTF;
  const p_sortedAscTF = props.p_sortedAscTF;

  var sortArrow = "\u25bc"; //all arrows start as down arrow
  if(p_isSortedTF) {
    sortArrow = ((p_sortedAscTF) ? ("\u25bc") : ("\u25b2"));
  }

  const sortArrowColor = ((p_isSortedTF) ? ("#444") : ("#ddd"));

  return(
    <span style={{color:sortArrowColor}}>
      {sortArrow}
    </span>
  );
}



export function Message(props) { //props: p_messageObj{type, message}
  const p_messageObj = props.p_messageObj;

  if(!JSFUNC.is_obj(p_messageObj)) {
    return(null);
  }

  if(!(p_messageObj.hasOwnProperty("type") && p_messageObj.hasOwnProperty("message"))) {
    return(null);
  }

  return(
    <div className={"width100 medTopMargin medBottomMargin smallFullPad messageBorder textCenter fontItalic message_" + p_messageObj.type}>
      {p_messageObj.message}
    </div>
  );
}



export function Notification(props) { //props: p_num
  const p_num = props.p_num;

  if(p_num > 0) {
    return(
      <div className="notification notificationBottomRight lrMargin">
        {p_num}
      </div>
    );
  }
  return(null);
}

export function ErrorText(props) { //props: p_class, p_text
  const p_class = props.p_class;
  const p_text = props.p_text;
  return(
    <LibraryReact.DivFont p_class={p_class} p_fontClass="fontItalic font09 fontRed">
      {p_text}
    </LibraryReact.DivFont>
  );
}

export function PhpWorkingMessage(props) { //props: p_text
  const p_text = props.p_text;
  return(
    <div className="displayFlexColumnHcVc">
      <LibraryReact.DivFont p_fontClass="fontItalic fontTextLighter">
        {p_text}
      </LibraryReact.DivFont>
      <LoadingAnimation />
    </div>
  );
}

export function EmptyScreenMessage(props) { //props: p_fontClass, children
  const p_fontClass = JSFUNC.prop_value(props.p_fontClass, "");
  return(
    <LibraryReact.DivFont p_class="flex11a displayFlexColumnHcVc yScroll medFullPad textCenter" p_fontClass={p_fontClass}>
      {props.children}
    </LibraryReact.DivFont>
  );
}

export function EmptyScreenWhite(props) { //props: p_fontClass, children
  const p_fontClass = JSFUNC.prop_value(props.p_fontClass, "");
  return(
    <LibraryReact.DivFont p_class="flex11a displayFlexColumnHcVc yScroll medFullPad bgWhite textCenter" p_fontClass={"fontItalic fontTextLight " + p_fontClass}>
      {props.children}
    </LibraryReact.DivFont>
  );
}

export function EmptyScreenGray(props) { //props: p_fontClass, children
  const p_fontClass = JSFUNC.prop_value(props.p_fontClass, "");
  return(
    <LibraryReact.DivFont p_class="flex11a displayFlexColumnHcVc yScroll medFullPad bgPanelLightGray textCenter" p_fontClass={"fontItalic fontTextLight " + p_fontClass}>
      {props.children}
    </LibraryReact.DivFont>
  );
}

export function EmptyScreenWhiteWithLoadingAnimation(props) { //props: children
  return(
    <div className="flex11a displayFlexColumnHcVc yScroll medFullPad bgWhite textCenter">
      <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight">
        {props.children}
      </LibraryReact.DivFont>
      <LoadingAnimation />
    </div>
  );
}

export function EmptyScreenGrayWithLoadingAnimation(props) { //props: children
  return(
    <div className="flex11a displayFlexColumnHcVc yScroll lrMedPad bgPanelLightGray textCenter">
      <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight">
        {props.children}
      </LibraryReact.DivFont>
      <LoadingAnimation />
    </div>
  );
}

export function BulletList(props) { //props: p_linesArray, p_fontClass, p_dashFontClass
  const linesArray = ((JSFUNC.is_array(props.p_linesArray)) ? (props.p_linesArray) : ([]));
  const fontClass = JSFUNC.prop_value(props.p_fontClass, "");
  const dashFontClass = JSFUNC.prop_value(props.p_dashFontClass, fontClass);
  return(
    linesArray.map((m_descriptionLine, m_index) =>
      <div key={JSFUNC.key_rand()} className={"displayFlexRow " + ((m_index > 0) ? ("microTopMargin") : (""))}>
        <LibraryReact.DivFont p_class="flex00a lrMargin" p_fontClass={dashFontClass}>
          {"-"}
        </LibraryReact.DivFont>
        <LibraryReact.DivFont p_class="flex11a smallRightMargin" p_fontClass={fontClass}>
          {m_descriptionLine}
        </LibraryReact.DivFont>
      </div>
    )
  );
}


export function RecursiveProgressBarFloatingBox(props) { //p_floatingBoxTitle, p_progressTextHtmlOrUndefined, p_currentItemNumber, p_totalNumItems, p_progressColor, f_onClickCancel
  const p_floatingBoxTitle = props.p_floatingBoxTitle;
  const p_progressTextHtmlOrUndefined = props.p_progressTextHtmlOrUndefined;
  const p_currentItemNumber = props.p_currentItemNumber; //1
  const p_totalNumItems = props.p_totalNumItems; //12
  const p_progressColor = props.p_progressColor; //"bd238f"

  var progressPercent0to100 = 0;
  if(p_totalNumItems > 0) {
    progressPercent0to100 = Math.round((p_currentItemNumber / p_totalNumItems) * 100);
  }

  return(
    <FloatingBoxWithSaveCancel
      p_trblFlag="confirmBox"
      p_title={p_floatingBoxTitle}
      f_onClickCancel={props.f_onClickCancel}>
      <div className="flex11a displayFlexColumnHcVc hugeTopPad hugeBottomPad lrMedPad">
        {(p_progressTextHtmlOrUndefined !== undefined) ? (
          p_progressTextHtmlOrUndefined
        ) : (
          <LibraryReact.DivFont p_class="" p_fontClass="">
            {p_currentItemNumber + " of " + p_totalNumItems}
          </LibraryReact.DivFont>
        )}
        <div className="medTopMargin" />
        <div
          key={JSFUNC.key_rand()}
          className="displayFlexColumnHcVc overflowHidden border bevelBorderColors"
          style={{width:"60%", height:"1.5em", background:"linear-gradient(90deg, #" + p_progressColor + " " + progressPercent0to100 + "%, #eee " + progressPercent0to100 + "%)"}}
        />
      </div>
    </FloatingBoxWithSaveCancel>
  );
}


export function RatingScoreBox1to5(props) { //props: p_rating, p_sizeEm
  const ratingIsAvailableTF = ((props.p_rating !== undefined) && (props.p_rating >= 1));
  const ratingColorStopsArrayOfObjs = [
    {red:158, green:66, blue:91},
    {red:178, green:74, blue:71},
    {red:174, green:91, blue:53},
    {red:142, green:109, blue:42},
    {red:80, green:117, blue:66},
    {red:38, green:116, blue:103}
  ];
  const rating = ((ratingIsAvailableTF) ? (Math.min(props.p_rating, 5)) : (0));
  const ratingColorStopIndex = Math.min(Math.floor(rating), ratingColorStopsArrayOfObjs.length - 2);
  const ratingPercentWithinColorStop0to100 = ((rating - ratingColorStopIndex) * 100);
  const ratingColorStopLowerObj = ratingColorStopsArrayOfObjs[ratingColorStopIndex];
  const ratingColorStopUpperObj = ratingColorStopsArrayOfObjs[ratingColorStopIndex + 1];
  const bgColor = ((ratingIsAvailableTF) ? (
    JSFUNC.color_interpolation(
      ratingPercentWithinColorStop0to100,
      ratingColorStopLowerObj.red,
      ratingColorStopUpperObj.red,
      ratingColorStopLowerObj.green,
      ratingColorStopUpperObj.green,
      ratingColorStopLowerObj.blue,
      ratingColorStopUpperObj.blue
    )
  ) : ("eee"));
  const fontColorClass = ((ratingIsAvailableTF) ? ("fontWhite") : ("fontTextLightester"));
  const ratingDisplay = ((ratingIsAvailableTF) ? (props.p_rating.toFixed(1)) : ("N/A"));
  const widthEm = JSFUNC.prop_value(props.p_sizeEm, 2.5);
  const fontClass = "font" + Math.round(4.5 * widthEm);

  return(
    <div className="displayFlexColumnHcVc border bevelBorderColors" style={{width:widthEm + "em", height:widthEm + "em", background:"#" + bgColor}}>
      <div className={fontClass + " fontBold " + fontColorClass}>
        {ratingDisplay}
      </div>
    </div>
  );
}

export class RatingNA1To5CELogos extends Component { //props: p_rating1to5NAm1, p_canEditTF, f_onSelectRating
  onclick_rating_na_minus1 = () => {
    if(JSFUNC.is_function(this.props.f_onSelectRating)) {
      this.props.f_onSelectRating(-1);
    }
  }

  render() {
    const rating1to5NAm1 = this.props.p_rating1to5NAm1;
    const canEditTF = this.props.p_canEditTF;

    const naIsSelectedTF = (!JSFUNC.is_number(rating1to5NAm1) || (rating1to5NAm1 < 1) || (rating1to5NAm1 > 5));

    var selectedRating1to5NAm1 = -1;
    if(!naIsSelectedTF) {
      selectedRating1to5NAm1 = rating1to5NAm1;
    }

    return(
      <div className="displayFlexRowVc">
        <div
          className={"flex00a displayFlexColumnHcVc " + ((naIsSelectedTF) ? ("bgLighterGray") : ("bgLightesterGray")) + " " + ((canEditTF) ? ("cursorPointer") : (""))}
          style={{marginRight:"0.2em", width:"2.2em", height:"2em", borderRadius:"0.3em", border:"solid 2px #" + ((naIsSelectedTF) ? ("77b") : ("ddd"))}}
          title="Mark this rating as Not Applicable"
          onClick={((naIsSelectedTF) ? (undefined) : (this.onclick_rating_na_minus1))}>
          <div className={"font09 " + ((naIsSelectedTF) ? ("fontBold fontTextLight") : ("fontTextLightester"))}>
            {"N/A"}
          </div>
        </div>
        {[1,2,3,4,5].map((m_rating1to5) =>
          <Rating1To5CELogo
            p_rating1to5={m_rating1to5}
            p_selectedRating1to5NAm1={selectedRating1to5NAm1}
            p_canEditTF={canEditTF}
            f_onSelectRating={this.props.f_onSelectRating}
          />
        )}
      </div>
    );
  }
}

const Rating1To5CELogo = inject("CaptureExecMobx", "UserMobx")(observer(
class Rating1To5CELogo extends Component { //props: p_rating1to5, p_selectedRating1to5NAm1, p_canEditTF, f_onSelectRating
  onclick_rating_ce_logo = () => {
    if(JSFUNC.is_function(this.props.f_onSelectRating)) {
      this.props.f_onSelectRating(this.props.p_rating1to5);
    }
  }

  render() {
    const p_rating1to5 = this.props.p_rating1to5;
    const p_selectedRating1to5NAm1 = this.props.p_selectedRating1to5NAm1;
    const p_canEditTF = this.props.p_canEditTF;

    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;
    const c_userTeammatesRatingsCELogoSizePx = this.props.UserMobx.c_userTeammatesRatingsCELogoSizePx;

    const isColorTF = (p_selectedRating1to5NAm1 >= p_rating1to5);

    const celogoratingFileName = "celogorating" + c_userTeammatesRatingsCELogoSizePx + "px" + ((isColorTF) ? ("color") : ("gray")) + ".png";
    const celogoratingFilePath = c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/" + celogoratingFileName;

    return(
      <div
        className={"flex00a " + ((p_canEditTF) ? ("cursorPointer") : (""))}
        style={{padding:"0 0.22em"}}
        title={"Rate as a " + p_rating1to5 + " out of 5"}
        onClick={((p_canEditTF) ? (this.onclick_rating_ce_logo) : (undefined))}>
        <div style={{width:c_userTeammatesRatingsCELogoSizePx + "px", height:c_userTeammatesRatingsCELogoSizePx + "px"}}>
          <LibraryReact.Image p_src={celogoratingFilePath} p_alt="CE" />
        </div>
      </div>
    );
  }
}));

export function RatingNA1To5OutOf5Display(props) { //props: p_rating1to5NAm1
  const rating1to5NAm1 = props.p_rating1to5NAm1;

  if((rating1to5NAm1 === undefined) || (rating1to5NAm1 < 1) || (rating1to5NAm1 > 5)) {
    return(
      <font className="fontItalic fontTextLighter">
        {"N/A"}
      </font>
    );
  }

  return(
    <>
      {rating1to5NAm1.toFixed(1) + " "}
      <font className="fontItalic fontTextLighter">{"/ 5"}</font>
    </>
  );
}


export function CEGCSSDataSourceConnectedToIcon(props) { //props: p_dataSourceSam0GovWin1, p_title, f_onClick
  const p_dataSourceSam0GovWin1 = props.p_dataSourceSam0GovWin1;
  const p_title = props.p_title;

  const onClickIsFunctionTF = JSFUNC.is_function(props.f_onClick);

  var dataSourceName = "--Invalid Data Source Flag '" + p_dataSourceSam0GovWin1 + "'--";
  var connectedBorderColorClass = "bevelBorderColors";
  var connectedBgClass = "bgLighterGrayGradient";
  var connectedFontColorClass = "";
  if(p_dataSourceSam0GovWin1 === 0) {
    dataSourceName = "SAM.gov";
    connectedBorderColorClass = "bevelBorderColors";
    connectedBgClass = "bgLighterOrangeGradient";
    connectedFontColorClass = "fontDarkOrange";
  }
  else if(p_dataSourceSam0GovWin1 === 1) {
    dataSourceName = "GovWin";
    connectedBorderColorClass = "bevelBorderColorBlue";
    connectedBgClass = "bgLighterBlueGradient";
    connectedFontColorClass = "fontBlue";
  }
  else if(p_dataSourceSam0GovWin1 === 2) {
    dataSourceName = "Federal Compass";
    connectedBorderColorClass = "bevelBorderColors";
    connectedBgClass = "bgGcssFedCompLighterGradient";
    connectedFontColorClass = "fontGcssFedCompDark";
  }

  return(
    <div
      className={"flex00a tbMicroMargin lrMargin border " + connectedBorderColorClass + " borderRadius10 " + connectedBgClass + " tbMicroPad lrMedPad" + ((onClickIsFunctionTF) ? (" cursorPointer") : (undefined))}
      title={p_title}
      onClick={props.f_onClick}>
      <font className={"fontItalic " + connectedFontColorClass}>
        {"Connected to " + dataSourceName}
      </font>
    </div>
  );
}



export class LoadingAnimation extends Component { //props: p_frameDelay, p_class, p_styleObj
  constructor(props) {
    super(props);
    this.state = {
      s_loadingAnimationFrame: ((this.props.p_frameDelay === undefined) ? (0) : (-1 * this.props.p_frameDelay))
    }
  }

  componentDidMount() { //run the loading animation through the frames
    const waitTimeSec = 0.09;
    this.loadingAnimationTimerID = setInterval(this.advance_frame, (1000*waitTimeSec));
  }

  componentWillUnmount() {
    clearInterval(this.loadingAnimationTimerID);
  }

  advance_frame = () => { //count from 1 to 6 repeatedly
    this.setState({
      s_loadingAnimationFrame: ((this.state.s_loadingAnimationFrame > 6) ? (1) : (this.state.s_loadingAnimationFrame + 1))
    });
  }

  render() {
    const divClass = JSFUNC.prop_value(this.props.p_class, "");
    const styleObj = JSFUNC.prop_value(this.props.p_styleObj, {});

    //determine the color of each of the 3 loading dots based on which frame the animation is on
    var loadingAnimationColor1 = "transparent";
    var loadingAnimationColor2 = "transparent";
    var loadingAnimationColor3 = "transparent";
    if(this.state.s_loadingAnimationFrame === 2) { loadingAnimationColor1 = "#555"; }
    else if(this.state.s_loadingAnimationFrame === 3) { loadingAnimationColor1 = "#888"; loadingAnimationColor2 = "#555"; }
    else if(this.state.s_loadingAnimationFrame === 4) { loadingAnimationColor1 = "#aaa"; loadingAnimationColor2 = "#888"; loadingAnimationColor3 = "#555"; }
    else if(this.state.s_loadingAnimationFrame === 5) { loadingAnimationColor1 = "#ddd"; loadingAnimationColor2 = "#aaa"; loadingAnimationColor3 = "#888"; }
    else if(this.state.s_loadingAnimationFrame === 6) { loadingAnimationColor1 = "transparent"; loadingAnimationColor2 = "#ddd"; loadingAnimationColor3 = "#aaa"; }

    return(
      <div className={"inlineBlock " + divClass} style={styleObj}>
        <font style={{color:loadingAnimationColor1}}>{"\u25CF "}</font>
        <font style={{color:loadingAnimationColor2}}>{"\u25CF "}</font>
        <font style={{color:loadingAnimationColor3}}>{"\u25CF "}</font>
      </div>
    );
  }
}


export const GovWinLoadingAnimation = inject("CaptureExecMobx")(observer(
class GovWinLoadingAnimation extends Component {
  render() {
    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;

    const govWinFromDeltekLogoFilePath = c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/govwinfromdelteklogo.png";
    const govWinArrowFilePath = c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/govwinarrow.png";

    return(
      <div className="displayFlexRow" style={{width:"130px"}}>
        <div className="flex00a displayFlexRowVc" style={{flexBasis:"100px"}}>
          <LibraryReact.Image p_src={govWinFromDeltekLogoFilePath} p_alt="GovWin Deltek" />
        </div>
        <div className="flex11a displayFlexColumnHcVc">
          <LibraryReact.Image p_src={govWinArrowFilePath} p_alt=">" p_class="animateDisappearReappear1sInfinite" />
        </div>
      </div>
    );
  }
}));


export const FedCompLoadingAnimation = inject("CaptureExecMobx")(observer(
class FedCompLoadingAnimation extends Component {
  render() {
    const c_computedUrlAndProductObj = this.props.CaptureExecMobx.c_computedUrlAndProductObj;

    const govWinFromDeltekLogoFilePath = c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/gcss_loading_fedcomp_logo.png";
    const govWinArrowFilePath = c_computedUrlAndProductObj.productGraphicsSubfolderAddress + "/gcss_loading_fedcomp_arrow.png";

    return(
      <div className="displayFlexRow" style={{background:"#172432", width:"130px"}}>
        <div className="flex00a displayFlexRowVc" style={{flexBasis:"100px"}}>
          <LibraryReact.Image p_src={govWinFromDeltekLogoFilePath} p_alt="Federal Compass" />
        </div>
        <div className="flex11a displayFlexColumnHcVc">
          <LibraryReact.Image p_src={govWinArrowFilePath} p_alt=">" p_class="animateDisappearReappear1sInfinite" />
        </div>
      </div>
    );
  }
}));





export function NewCaptureSectionContainer(props) { //props: p_drawBorderTF, children
  const p_drawBorderTF = JSFUNC.prop_value(props.p_drawBorderTF, false);

  var boxShadow = undefined;
  var border = undefined;
  var borderRadius = undefined;
  if(p_drawBorderTF) {
    boxShadow = "0.2em 0.2em 0.5em 0.03em #bbb";
    border = "solid 1px #cce";
    borderRadius = "1em";
  }

  return(
    <div
      className="flex11a displayFlexColumn"
      style={{flexBasis:"100em", boxShadow:boxShadow, border:border, borderRadius:borderRadius}}>
      {props.children}
    </div>
  );
}

export function NewCaptureSectionLabel(props) { //props: p_label, children
  const p_label = props.p_label;

  return(
    <div className="tbBigMargin lrMedMargin">
      <div className="smallBottomMargin textCenter">
        <font className="font13 fontBold fontTextLighter">
          {p_label}
        </font>
      </div>
      {props.children}
    </div>
  );
}

export function NewCaptureFieldLabel(props) { //props: p_label, p_widthEm
  const p_label = props.p_label;
  const p_widthEm = props.p_widthEm;
  
  return(
    <div className="flex00a lrPad" style={{flexBasis:p_widthEm + "em"}} title={p_label}>
      <LibraryReact.NowrapEllipsis p_fontClass="font11 fontBold fontTextLighter">
        {p_label}
      </LibraryReact.NowrapEllipsis>
    </div>
  );
}








//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Tabs List
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export class TabsList extends Component { //props:
  //p_canMultiSelectTabsFromSelectedDbNamesCommaTF, p_tabDbNamesArray, p_tabDisplayNamesArray, p_selectedTabDbName, p_tabHeight, p_textMaxHeight, p_tabWidth, 
  //p_selectedBgClass, p_selectedFontClass, p_unselectedBgClass, p_unselectedFontClass,
  //p_canEditTF, p_rowFlexWrapTF, p_verticalTabsTF, p_tabSpacing, p_borderRadiusClass, p_underlineSelectionTF, p_unselectValue
  //f_onSelect(i_selectedTabDbName)

  onclick_multi_select_all_tabs = () => {
    const p_tabDbNamesArray = this.props.p_tabDbNamesArray;
    const p_selectedTabDbName = this.props.p_selectedTabDbName;

    if(JSFUNC.is_function(this.props.f_onSelect)) {
      const oldSelectedTabDbNamesArray = JSFUNC.convert_comma_list_to_int_array(p_selectedTabDbName);
      if(!JSFUNC.all_of_array1_is_in_array2(p_tabDbNamesArray, oldSelectedTabDbNamesArray)) { //only need to update if not every tab is currently selected
        const updatedSelecteTabDbNamesComma = JSFUNC.convert_array_to_comma_list(p_tabDbNamesArray);
        this.props.f_onSelect(updatedSelecteTabDbNamesComma);
      }
    }
  }

  onclick_multi_clear_all_tabs = () => {
    const p_selectedTabDbName = this.props.p_selectedTabDbName;

    if(JSFUNC.is_function(this.props.f_onSelect)) {
      if(p_selectedTabDbName !== "") { //no need to update selection if already cleared
        this.props.f_onSelect("");
      }
    }
  }

  render() {
    const p_canMultiSelectTabsFromSelectedDbNamesCommaTF = JSFUNC.prop_value(this.props.p_canMultiSelectTabsFromSelectedDbNamesCommaTF, false); //default false, if true, input p_selectedTabDbName is a string comma list of selected tab dbNames (assumed to be integers like tab ID numbers) and multiple or 0 tabs can be selected
    const p_tabDbNamesArray = this.props.p_tabDbNamesArray;
    const p_tabDisplayNamesArray = this.props.p_tabDisplayNamesArray;
    const p_selectedTabDbName = this.props.p_selectedTabDbName;
    const p_tabHeight = JSFUNC.prop_value(this.props.p_tabHeight, "3.2em");
    const p_textMaxHeight = JSFUNC.prop_value(this.props.p_textMaxHeight, "3em"); //"nowrap" - Nowrap element, otherwise a MaxHeightWrap is used with this height
    const p_tabWidth = this.props.p_tabWidth; //undefined is a flag that will stretch the entire bar of all tabs to the full width of the container and make each tab an equal width
    const p_selectedBgClass = JSFUNC.prop_value(this.props.p_selectedBgClass, "bgLightBlueGradient");
    const p_selectedFontClass = this.props.p_selectedFontClass;
    const p_unselectedBgClass = JSFUNC.prop_value(this.props.p_unselectedBgClass, "bgLighterGrayGradient hoverLighterBlueGradient");
    const p_unselectedFontClass = JSFUNC.prop_value(this.props.p_unselectedFontClass, "font11 fontBold fontTextLight");
    const p_canEditTF = JSFUNC.prop_value(this.props.p_canEditTF, true);
    const p_rowFlexWrapTF = JSFUNC.prop_value(this.props.p_rowFlexWrapTF, false); //true - flexWrap row, false - xScroll in single row
    const p_verticalTabsTF = JSFUNC.prop_value(this.props.p_verticalTabsTF, false); //true - vertical centered tabs, false - horizontal tabs in a row (wrapped or not wrapped with x scroll)
    const p_tabSpacing = this.props.p_tabSpacing; //(default vertical/horizontal spacing values set below)
    const p_borderRadiusClass = JSFUNC.prop_value(this.props.p_borderRadiusClass, "borderRadius05");
    const p_underlineSelectionTF = JSFUNC.prop_value(this.props.p_underlineSelectionTF, false);
    const p_unselectValue = this.props.p_unselectValue; //undefined (default) - cannot click a selected tab, value/dbName - clicking a selected tab unselects it (sends unselect value as output), meaning no tabs are selected

    //error printed if tab dbNames and displayNames inputs are not arrays
    if(!JSFUNC.is_array(p_tabDbNamesArray) || !JSFUNC.is_array(p_tabDisplayNamesArray)) {
      return(
        <div className="flex00a medFullPad bgLighterGray">
          <font className="fontItalic fontRed">
            <div>{"--CEGeneralReact/TabsList--"}</div>
            <div>{"p_tabDbNamesArray: " + JSFUNC.print(p_tabDbNamesArray)}</div>
            <div>{"p_tabDisplayNamesArray: " + JSFUNC.print(p_tabDisplayNamesArray)}</div>
            <div>{"p_selectedTabDbName: " + JSFUNC.print(p_selectedTabDbName)}</div>
          </font>
        </div>
      );
    }

    //precompute selected tabs as an array for multiselect mode
    var multiSelectedTabsDbNamesArray = [];
    if(p_canMultiSelectTabsFromSelectedDbNamesCommaTF) {
      multiSelectedTabsDbNamesArray = JSFUNC.convert_comma_list_to_int_array(p_selectedTabDbName);
    }

    //set defaults for vertical/horizontal tab spacing, or use the input p_tabSpacing
    var verticalOrHorizontalTabSpacing = p_tabSpacing;
    if(p_tabSpacing === undefined) {
      if(p_verticalTabsTF) {
        verticalOrHorizontalTabSpacing = "0.3em";
      }
      else {
        verticalOrHorizontalTabSpacing = "0.8em";
      }
    }
    
    const textIsNowrapTF = (p_textMaxHeight === "nowrap");
    const tavWidthIsFixedTF = (p_tabWidth !== undefined);

    var flexClass = "";
    if(tavWidthIsFixedTF) { //tabs are evenly sized to fit full container
      flexClass = "flex00a";
    }
    else {
      flexClass = "flex11a";
    }

    var tabsContainerDisplayFlexClass = "";
    if(p_verticalTabsTF) {
      tabsContainerDisplayFlexClass = "displayFlexColumn";
    }
    else {
      tabsContainerDisplayFlexClass = "displayFlexRowVc";
    }

    var flexScrollClass = "";
    if(p_rowFlexWrapTF) {
      flexScrollClass = "flexWrap";
    }
    else if(tavWidthIsFixedTF) {
      flexScrollClass = "xyScroll";
    }

    //select all/clear all buttons for multiselect
    var mutliselectControlButtonsComponent = null;
    if(p_canMultiSelectTabsFromSelectedDbNamesCommaTF) {
      mutliselectControlButtonsComponent = (
        <div className="flex00a displayFlexColumnVc" style={{marginRight:"0.5em"}}>
          <div
            className="flex00a displayFlexColumnHcVc border bevelBorderColors borderRadius05 bgLightGrayGradient hoverLightestGrayGradient textCenter cursorPointer"
            style={{width:"3.3em", height:"1.1em"}}
            onClick={this.onclick_multi_select_all_tabs}>
            <font className="font09">
              {"All"}
            </font>
          </div>
          <div className="flex00a" style={{flexBasis:"0.15em"}} />
          <div
            className="flex00a displayFlexColumnHcVc border bevelBorderColors borderRadius05 bgLightGrayGradient hoverLightestGrayGradient textCenter cursorPointer"
            style={{width:"3.3em", height:"1.1em"}}
            onClick={this.onclick_multi_clear_all_tabs}>
            <font className="font09">
              {"Clear"}
            </font>
          </div>
        </div>
      );
    }

    return(
      <div className={flexClass + " " + tabsContainerDisplayFlexClass + " " + flexScrollClass}>
        {mutliselectControlButtonsComponent}
        {p_tabDbNamesArray.map((m_tabDbName, m_index) =>
          <SingleTab
            key={m_tabDbName}
            p_canMultiSelectTabsFromSelectedDbNamesCommaTF={p_canMultiSelectTabsFromSelectedDbNamesCommaTF}
            p_tabIndex={m_index}
            p_tabDbName={m_tabDbName}
            p_tabDisplayName={p_tabDisplayNamesArray[m_index]}
            p_selectedTabDbName={p_selectedTabDbName}
            p_multiSelectedTabsDbNamesArray={multiSelectedTabsDbNamesArray}
            p_tabHeight={p_tabHeight}
            p_textMaxHeight={p_textMaxHeight}
            p_textIsNowrapTF={textIsNowrapTF}
            p_tabWidth={p_tabWidth}
            p_tavWidthIsFixedTF={tavWidthIsFixedTF}
            p_underlineSelectionTF={p_underlineSelectionTF}
            p_selectedBgClass={p_selectedBgClass}
            p_selectedFontClass={p_selectedFontClass}
            p_unselectedBgClass={p_unselectedBgClass}
            p_unselectedFontClass={p_unselectedFontClass}
            p_canEditTF={p_canEditTF}
            p_verticalTabsTF={p_verticalTabsTF}
            p_tabSpacing={verticalOrHorizontalTabSpacing}
            p_borderRadiusClass={p_borderRadiusClass}
            p_unselectValue={p_unselectValue}
            f_onClick={this.props.f_onSelect}
          />
        )}
      </div>
    );
  }
}

class SingleTab extends Component { //props:
  //p_canMultiSelectTabsFromSelectedDbNamesCommaTF, p_tabIndex, p_tabDbName, p_tabDisplayName, p_selectedTabDbName, p_multiSelectedTabsDbNamesArray, p_tabHeight, p_textMaxHeight, p_textIsNowrapTF, p_tabWidth, p_tavWidthIsFixedTF, 
  //p_selectedBgClass, p_selectedFontClass, p_unselectedBgClass, p_unselectedFontClass,
  //p_canEditTF, p_verticalTabsTF, p_tabSpacing, p_borderRadiusClass, p_underlineSelectionTF, p_unselectValue
  //f_onClick
  onclick_tab_checkbox_area = () => {
    const p_tabDbName = this.props.p_tabDbName;
    const p_selectedTabDbName = this.props.p_selectedTabDbName;
    const p_multiSelectedTabsDbNamesArray = this.props.p_multiSelectedTabsDbNamesArray;

    if(JSFUNC.is_function(this.props.f_onClick)) {
      var updatedSelecteTabDbName = undefined;
      if(JSFUNC.in_array(p_tabDbName, p_multiSelectedTabsDbNamesArray)) { //clicked tab was already selected, unselect it by removing it from the comma list
        const updatedSelecteTabDbNamesArray = JSFUNC.remove_all_values_from_array(p_tabDbName, p_multiSelectedTabsDbNamesArray);
        updatedSelecteTabDbName = JSFUNC.convert_array_to_comma_list(updatedSelecteTabDbNamesArray);
      }
      else { //clicked tab was not yet selected, add it to the comma list of selected tab dbNames
        updatedSelecteTabDbName = JSFUNC.add_value_to_comma_list(p_tabDbName, p_selectedTabDbName);
      }
    }

    this.props.f_onClick(updatedSelecteTabDbName);
  }
  
  onclick_tab = () => {
    const p_tabDbName = this.props.p_tabDbName;
    const p_selectedTabDbName = this.props.p_selectedTabDbName;
    const p_unselectValue = this.props.p_unselectValue;

    if(JSFUNC.is_function(this.props.f_onClick)) {
      var updatedSelecteTabDbName = p_tabDbName; //new selected tab is tab just clicked on
      if((p_unselectValue !== undefined) && (p_selectedTabDbName === updatedSelecteTabDbName)) { //if unselect is possible and the currently selected tab was just clicked, send the unselect value as output
        updatedSelecteTabDbName = p_unselectValue;
      }
      
      this.props.f_onClick(updatedSelecteTabDbName);
    }
  }

  render() {
    const p_canMultiSelectTabsFromSelectedDbNamesCommaTF = this.props.p_canMultiSelectTabsFromSelectedDbNamesCommaTF;
    const p_tabIndex = this.props.p_tabIndex;
    const p_tabDbName = this.props.p_tabDbName;
    const p_tabDisplayName = this.props.p_tabDisplayName;
    const p_selectedTabDbName = this.props.p_selectedTabDbName;
    const p_multiSelectedTabsDbNamesArray = this.props.p_multiSelectedTabsDbNamesArray;
    const p_tabHeight = this.props.p_tabHeight;
    const p_textMaxHeight = this.props.p_textMaxHeight;
    const p_textIsNowrapTF = this.props.p_textIsNowrapTF;
    const p_tabWidth = this.props.p_tabWidth;
    const p_tavWidthIsFixedTF = this.props.p_tavWidthIsFixedTF;
    const p_underlineSelectionTF = this.props.p_underlineSelectionTF;
    const p_selectedBgClass = this.props.p_selectedBgClass;
    const p_selectedFontClass = this.props.p_selectedFontClass;
    const p_unselectedBgClass = this.props.p_unselectedBgClass;
    const p_unselectedFontClass = this.props.p_unselectedFontClass;
    const p_canEditTF = this.props.p_canEditTF;
    const p_verticalTabsTF = this.props.p_verticalTabsTF;
    const p_tabSpacing = this.props.p_tabSpacing;
    const p_borderRadiusClass = this.props.p_borderRadiusClass;
    const p_unselectValue = this.props.p_unselectValue;

    const canUnselectTF = (p_unselectValue !== undefined);

    var isSelectedTF = false;
    if(p_canMultiSelectTabsFromSelectedDbNamesCommaTF) { //can multiselect tabs from input p_selectedTabDbName as a comma list of selected tab dbNames
      isSelectedTF = JSFUNC.in_array(p_tabDbName, p_multiSelectedTabsDbNamesArray);
    }
    else { //single tab selected or not
      isSelectedTF = (p_tabDbName === p_selectedTabDbName);
    }

    var flexClass = "";
    var flexBasis = undefined;
    if(!p_tavWidthIsFixedTF && !p_verticalTabsTF) {
      flexClass = "flex11a";
      flexBasis = "100em";
    }

    var marginLeft = undefined; //no margin right for first tab
    var marginTop = undefined; //vertical tabs have marginTop instead of left
    if(p_tabIndex > 0) {
      if(p_verticalTabsTF) {
        marginTop = p_tabSpacing;
      }
      else {
        marginLeft = p_tabSpacing;
      }
    }

    var fontClass = "";
    var bgClass = "";
    if(isSelectedTF) {
      fontClass = ((p_selectedFontClass !== undefined) ? (p_selectedFontClass) : (p_unselectedFontClass));
      bgClass = ((p_underlineSelectionTF) ? ("tabsListUnderlineSelected") : (p_selectedBgClass));
      if(p_canEditTF && (canUnselectTF || p_canMultiSelectTabsFromSelectedDbNamesCommaTF)) {
        bgClass += " cursorPointer";
      }
    }
    else {
      fontClass = p_unselectedFontClass;
      bgClass = ((p_underlineSelectionTF) ? ("tabsListUnderlineUnselected") : (p_unselectedBgClass));
      if(p_canEditTF) {
        bgClass += " cursorPointer";
      }
    }

    var tabTextComponent = null;
    if(p_textIsNowrapTF) {
      tabTextComponent = (
        <LibraryReact.NowrapEllipsis p_fontClass={fontClass}>
          {p_tabDisplayName}
        </LibraryReact.NowrapEllipsis>
      );
    }
    else {
      tabTextComponent = (
        <LibraryReact.MaxHeightWrap p_maxHeight={p_textMaxHeight} p_fontClass={fontClass}>
          {p_tabDisplayName}
        </LibraryReact.MaxHeightWrap>
      );
    }

    var displayFlexClass = "";
    var paddingClass = "";
    var tabInteriorComponent = null;
    if(p_canMultiSelectTabsFromSelectedDbNamesCommaTF) { //can multiselect tabs, have a checkbox in the topleft corner or each tab
      displayFlexClass = "displayFlexRow";

      tabInteriorComponent = (
        <>
          <div
            className="flex00a displayFlexColumnVc borderR1bbb"
            style={{paddingLeft:"0.4em", paddingRight:"0.3em"}}
            onClick={((p_canEditTF) ? (this.onclick_tab_checkbox_area) : (undefined))}>
            <LibraryReact.CheckBox
              p_u0_s1_p2_du3_ds4={((isSelectedTF) ? (1) : (0))}
              p_sizeEm={1}
            />
          </div>
          <div
            className="flex11a displayFlexRowVc"
            style={{paddingLeft:"0.1em", paddingTop:"0.2em", paddingRight:"0.4em", paddingBottom:"0.2em"}}
            onClick={((p_canEditTF) ? (this.onclick_tab) : (undefined))}>
            {tabTextComponent}
          </div>
        </>
      );
    }
    else { //normal single select tab inside small padding
      displayFlexClass = "displayFlexRowVc";
      paddingClass = "smallFullPad";
      tabInteriorComponent = tabTextComponent;
    }

    return(
      <div
        className={flexClass + " " + displayFlexClass + " border bevelBorderColors " + p_borderRadiusClass + " " + bgClass + " " + paddingClass + " textCenter"}
        style={{width:p_tabWidth, height:p_tabHeight, flexBasis:flexBasis, marginLeft:marginLeft, marginTop:marginTop}}
        onClick={((p_canEditTF && !p_canMultiSelectTabsFromSelectedDbNamesCommaTF) ? (this.onclick_tab) : (undefined))}>
        {tabInteriorComponent}
      </div>
    );
  }
}







//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Multi Input Selection
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export class SelectStartDateAndEndDateButtonWithFlexibleMenu extends Component { //props: p_startDateYmd, p_endDateYmd, f_onChange(i_selectedStartDateYmd, i_selectedEndDateYmd)
  constructor(props) {
    super(props);
    this.state = {
      s_tempStartDateYmd: props.p_startDateYmd,
      s_tempEndDateYmd: props.p_endDateYmd,
      s_selectedQuickRangeLabelOrUndefined: undefined,
      s_pressedPickerButtonKeyOrUndefined: undefined,
      s_pressedDateFieldsArray: []
    };
  }

  componentDidMount() {
    if(typeof window !== "undefined") {
      window.addEventListener("mouseup", this.onmouseup_picker_button);
      window.addEventListener("blur", this.onmouseup_picker_button);
    }
  }

  componentWillUnmount() {
    if(typeof window !== "undefined") {
      window.removeEventListener("mouseup", this.onmouseup_picker_button);
      window.removeEventListener("blur", this.onmouseup_picker_button);
    }
  }

  onmousedown_picker_button = (i_buttonKey, i_dateFieldsArray) => {
    this.setState({
      s_pressedPickerButtonKeyOrUndefined:i_buttonKey,
      s_pressedDateFieldsArray:i_dateFieldsArray
    });
  }

  onmouseup_picker_button = () => {
    if(this.state.s_pressedPickerButtonKeyOrUndefined !== undefined) {
      this.setState({
        s_pressedPickerButtonKeyOrUndefined:undefined,
        s_pressedDateFieldsArray:[]
      });
    }
  }

  componentDidUpdate(i_prevProps) {
    if((i_prevProps.p_startDateYmd !== this.props.p_startDateYmd) || (i_prevProps.p_endDateYmd !== this.props.p_endDateYmd)) {
      const currentSelectionWasSavedTF = ((this.state.s_tempStartDateYmd === this.props.p_startDateYmd) && (this.state.s_tempEndDateYmd === this.props.p_endDateYmd));
      this.setState({
        s_tempStartDateYmd:this.props.p_startDateYmd,
        s_tempEndDateYmd:this.props.p_endDateYmd,
        s_selectedQuickRangeLabelOrUndefined:((currentSelectionWasSavedTF) ? (this.state.s_selectedQuickRangeLabelOrUndefined) : (undefined))
      });
    }
  }

  onclose_menu = () => {
    this.setState({s_tempStartDateYmd:this.props.p_startDateYmd, s_tempEndDateYmd:this.props.p_endDateYmd});
  }

  onchange_start_date = (i_newStartDateYmd) => {
    this.setState({s_tempStartDateYmd:i_newStartDateYmd, s_selectedQuickRangeLabelOrUndefined:undefined});
  }

  onchange_end_date = (i_newEndDateYmd) => {
    this.setState({s_tempEndDateYmd:i_newEndDateYmd, s_selectedQuickRangeLabelOrUndefined:undefined});
  }

  onselect_quick_range = (i_label, i_startDateYmd, i_endDateYmd) => {
    this.setState({
      s_tempStartDateYmd:i_startDateYmd,
      s_tempEndDateYmd:i_endDateYmd,
      s_selectedQuickRangeLabelOrUndefined:i_label
    });
  }

  onadjust_date = (i_dateStateName, i_adjustmentObj) => {
    const currentDateYmd = this.state[i_dateStateName];
    if(!JSFUNC.date_is_filled_out_tf(currentDateYmd)) {
      return;
    }

    const adjustedDateYmd = ((i_adjustmentObj.unit === "days")
      ? JSFUNC.date_add_days(currentDateYmd, i_adjustmentObj.amount)
      : JSFUNC.date_add_months(currentDateYmd, i_adjustmentObj.amount));
    this.setState({
      [i_dateStateName]:adjustedDateYmd,
      s_selectedQuickRangeLabelOrUndefined:undefined
    });
  }

  onconfirm_selection = (i_closeDropdown) => {
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(this.state.s_tempStartDateYmd, this.state.s_tempEndDateYmd);
    }

    if(JSFUNC.is_function(i_closeDropdown)) {
      i_closeDropdown();
    }
  }

  render() {
    const s_tempStartDateYmd = this.state.s_tempStartDateYmd;
    const s_tempEndDateYmd = this.state.s_tempEndDateYmd;
    const s_selectedQuickRangeLabelOrUndefined = this.state.s_selectedQuickRangeLabelOrUndefined;
    const s_pressedPickerButtonKeyOrUndefined = this.state.s_pressedPickerButtonKeyOrUndefined;
    const s_pressedDateFieldsArray = this.state.s_pressedDateFieldsArray;

    const p_startDateYmd = this.props.p_startDateYmd;
    const p_endDateYmd = this.props.p_endDateYmd;

    const blankDate = JSFUNC.blank_date();
    const normalizedTempStartDateYmd = (JSFUNC.date_is_filled_out_tf(s_tempStartDateYmd) ? s_tempStartDateYmd : blankDate);
    const normalizedTempEndDateYmd = (JSFUNC.date_is_filled_out_tf(s_tempEndDateYmd) ? s_tempEndDateYmd : blankDate);

    const startFilledTF = JSFUNC.date_is_filled_out_tf(p_startDateYmd);
    const endFilledTF = JSFUNC.date_is_filled_out_tf(p_endDateYmd);
    var buttonLabel = "Any dates";
    if(startFilledTF && endFilledTF) { buttonLabel = JSFUNC.direct_convert_mysqldate_to_MjY(p_startDateYmd) + " \u2013 " + JSFUNC.direct_convert_mysqldate_to_MjY(p_endDateYmd); }
    else if(startFilledTF) { buttonLabel = "From " + JSFUNC.direct_convert_mysqldate_to_MjY(p_startDateYmd); }
    else if(endFilledTF) { buttonLabel = "Through " + JSFUNC.direct_convert_mysqldate_to_MjY(p_endDateYmd); }

    const todayJsObj = new Date();
    const todayYmd = JSFUNC.get_dateYmd_from_jsDateObj_and_utctf(todayJsObj, false);
    const thisYear = todayJsObj.getFullYear();
    const thisMonthIndex0to11 = todayJsObj.getMonth();
    const thisQuarterIndex0to3 = Math.floor(thisMonthIndex0to11 / 3);
    const currentQuarterStartMonth = thisQuarterIndex0to3 * 3;
    const dateYmd = (i_dateObj) => JSFUNC.get_dateYmd_from_jsDateObj_and_utctf(i_dateObj, false);
    const currentMonthStartYmd = dateYmd(new Date(thisYear, thisMonthIndex0to11, 1));
    const lastMonthStartYmd = dateYmd(new Date(thisYear, thisMonthIndex0to11 - 1, 1));
    const lastMonthEndYmd = dateYmd(new Date(thisYear, thisMonthIndex0to11, 0));
    const currentQuarterStartYmd = dateYmd(new Date(thisYear, currentQuarterStartMonth, 1));
    const lastQuarterStartYmd = dateYmd(new Date(thisYear, currentQuarterStartMonth - 3, 1));
    const lastQuarterEndYmd = dateYmd(new Date(thisYear, currentQuarterStartMonth, 0));
    const nextMonthStartYmd = dateYmd(new Date(thisYear, thisMonthIndex0to11 + 1, 1));
    const nextMonthEndYmd = dateYmd(new Date(thisYear, thisMonthIndex0to11 + 2, 0));

    const quickRangePresetsArray = [
      {label:"Today",             startDateYmd:todayYmd, endDateYmd:todayYmd},
      {label:"Yesterday",         startDateYmd:JSFUNC.date_add_days(todayYmd, -1), endDateYmd:JSFUNC.date_add_days(todayYmd, -1)},
      {label:"Last 7 days",       startDateYmd:JSFUNC.date_add_days(todayYmd, -6), endDateYmd:todayYmd},
      {label:"Last 30 days",      startDateYmd:JSFUNC.date_add_days(todayYmd, -29), endDateYmd:todayYmd},
      {label:"Last 90 days",      startDateYmd:JSFUNC.date_add_days(todayYmd, -89), endDateYmd:todayYmd},
      {label:"Past 12 months",    startDateYmd:JSFUNC.date_add_days(todayYmd, -364), endDateYmd:todayYmd},
      {label:"This month",        startDateYmd:currentMonthStartYmd, endDateYmd:todayYmd},
      {label:"Last month",        startDateYmd:lastMonthStartYmd, endDateYmd:lastMonthEndYmd},
      {label:"This quarter",      startDateYmd:currentQuarterStartYmd, endDateYmd:todayYmd},
      {label:"Last quarter",      startDateYmd:lastQuarterStartYmd, endDateYmd:lastQuarterEndYmd},
      {label:"Year to date",      startDateYmd:dateYmd(new Date(thisYear, 0, 1)), endDateYmd:todayYmd},
      {label:"Last year",         startDateYmd:dateYmd(new Date(thisYear - 1, 0, 1)), endDateYmd:dateYmd(new Date(thisYear - 1, 11, 31))},
      {label:"Next 7 days",       startDateYmd:todayYmd, endDateYmd:JSFUNC.date_add_days(todayYmd, 6)},
      {label:"Next 30 days",      startDateYmd:todayYmd, endDateYmd:JSFUNC.date_add_days(todayYmd, 29)},
      {label:"Next month",        startDateYmd:nextMonthStartYmd, endDateYmd:nextMonthEndYmd},
      {label:"Next year",         startDateYmd:dateYmd(new Date(thisYear + 1, 0, 1)), endDateYmd:dateYmd(new Date(thisYear + 1, 11, 31))},
    ];

    const dateAdjustmentsArray = [
      {label:"-1 year", unit:"months", amount:-12},
      {label:"-1 month", unit:"months", amount:-1},
      {label:"-1 week", unit:"days", amount:-7},
      {label:"-1 day", unit:"days", amount:-1},
      {label:"+1 day", unit:"days", amount:1},
      {label:"+1 week", unit:"days", amount:7},
      {label:"+1 month", unit:"months", amount:1},
      {label:"+1 year", unit:"months", amount:12}
    ];
    const quickDateButtonBaseClass = "flex00a displayFlexColumnHcVc border bevelBorderColors borderRadius05 cursorPointer textCenter font10";
    const tempStartDateFilledTF = JSFUNC.date_is_filled_out_tf(s_tempStartDateYmd);
    const tempEndDateFilledTF = JSFUNC.date_is_filled_out_tf(s_tempEndDateYmd);
    const rangeIsReversedTF = (tempStartDateFilledTF && tempEndDateFilledTF && (s_tempStartDateYmd > s_tempEndDateYmd));
    const selectedQuickRangeMatchesTF = quickRangePresetsArray.some((i_rangeObj) =>
      (i_rangeObj.label === s_selectedQuickRangeLabelOrUndefined) &&
      (normalizedTempStartDateYmd === i_rangeObj.startDateYmd) &&
      (normalizedTempEndDateYmd === i_rangeObj.endDateYmd)
    );
    const matchingQuickRange = quickRangePresetsArray.find((i_rangeObj) =>
      (normalizedTempStartDateYmd === i_rangeObj.startDateYmd) &&
      (normalizedTempEndDateYmd === i_rangeObj.endDateYmd)
    );
    const selectedQuickRangeLabel = (selectedQuickRangeMatchesTF)
      ? s_selectedQuickRangeLabelOrUndefined
      : ((matchingQuickRange !== undefined) ? matchingQuickRange.label : undefined);
    const isPickerButtonPressed = (i_buttonKey) => (s_pressedPickerButtonKeyOrUndefined === i_buttonKey);
    const getPressedButtonStyleObj = (i_buttonKey) => (
      (isPickerButtonPressed(i_buttonKey))
        ? {background:"#edf7ff"}
        : {}
    );
    const startDateInputStyleObj = (s_pressedDateFieldsArray.includes("start"))
      ? {width:"100%", boxSizing:"border-box", backgroundColor:"#edf7ff"}
      : {width:"100%", boxSizing:"border-box"};
    const endDateInputStyleObj = (s_pressedDateFieldsArray.includes("end"))
      ? {width:"100%", boxSizing:"border-box", backgroundColor:"#edf7ff"}
      : {width:"100%", boxSizing:"border-box"};
    const startDateAdjustmentButtonClass = quickDateButtonBaseClass + " " + ((tempStartDateFilledTF) ? ("bgLighterGrayGradient hoverLightestGrayGradient") : ("bgLightGrayGradient cursorNotAllowed fontTextLight"));
    const endDateAdjustmentButtonClass = quickDateButtonBaseClass + " " + ((tempEndDateFilledTF) ? ("bgLighterGrayGradient hoverLightestGrayGradient") : ("bgLightGrayGradient cursorNotAllowed fontTextLight"));
    const formatRangeForTitle = (i_startDateYmd, i_endDateYmd) => {
      if(!JSFUNC.date_is_filled_out_tf(i_startDateYmd) && !JSFUNC.date_is_filled_out_tf(i_endDateYmd)) { return("Show all dates"); }
      if(!JSFUNC.date_is_filled_out_tf(i_startDateYmd)) { return("Through " + JSFUNC.direct_convert_mysqldate_to_MjY(i_endDateYmd)); }
      if(!JSFUNC.date_is_filled_out_tf(i_endDateYmd)) { return("From " + JSFUNC.direct_convert_mysqldate_to_MjY(i_startDateYmd)); }
      return(JSFUNC.direct_convert_mysqldate_to_MjY(i_startDateYmd) + " \u2013 " + JSFUNC.direct_convert_mysqldate_to_MjY(i_endDateYmd));
    };
    const menuMaxWidthEm = 45;
    const menuViewportMarginEm = 1;
    const floatingBoxBorderWidthEm = 0.08;
    const menuEstimatedWidthEm = menuMaxWidthEm + (2 * floatingBoxBorderWidthEm);
    const menuViewportWidthInsetEm = (2 * (menuViewportMarginEm + floatingBoxBorderWidthEm));
    const menuViewportHeightInsetEm = menuViewportWidthInsetEm;

    const inputDateClass = undefined;

    return(
      <LibraryReact.ButtonWithDropdownFloatingBoxKeepWithinScreen
        p_buttonText={buttonLabel}
        p_buttonHeight="2em"
        p_buttonMaxHeight="1.5em"
        p_buttonClass="border bevelBorderColors lrPad textCenter cursorPointer bgLighterGrayGradient hoverLightestGrayGradient"
        p_buttonStyleObj={getPressedButtonStyleObj("dropdown")}
        p_buttonContainerStyleObj={{width:"100%"}}
        f_onButtonMouseDown={() => this.onmousedown_picker_button("dropdown", [])}
        p_menuEstimatedHeightEm={50}
        p_menuEstimatedWidthEm={menuEstimatedWidthEm}
        p_menuViewportMarginEm={menuViewportMarginEm}
        p_floatingBoxBackdropBgOpacity0to1={0}
        p_floatingBoxBorderColor="bbbbbb"
        p_floatingBoxBorderWidthEm={floatingBoxBorderWidthEm}
        p_floatingBoxBorderRadius="0em"
        p_floatingBoxBgColor="ffffff"
        p_floatingBoxShadowColor="aaaaaa"
        f_onCloseDropdown={this.onclose_menu}
        f_renderDropdownContent={(i_closeDropdown) => (
          <div
            className="displayFlexColumn"
            style={{width:"calc(100vw - " + menuViewportWidthInsetEm + "em)", maxWidth:menuMaxWidthEm + "em", maxHeight:"calc(100vh - " + menuViewportHeightInsetEm + "em)", overflowY:"auto", boxSizing:"border-box"}}
            onClick={(event) => {event.stopPropagation();}}>
            <div className="displayFlexColumn medFullPad" style={{gap:"0.9em"}}>
              <div className="displayFlexRowVc flexJustifyBetween flexWrap" style={{gap:"0.5em"}}>
                <div className="flex11a displayFlexColumn">
                  <div className="font13 fontBold">{"Choose date range"}</div>
                </div>
                <div className="flex00a border bevelBorderColors borderRadius05 bgLightestGray smallFullPad font10 textCenter">
                  {formatRangeForTitle(normalizedTempStartDateYmd, normalizedTempEndDateYmd)}
                </div>
              </div>
              <div className="displayFlexColumn">
                <div className="font11 fontBold fontTextLight smallBottomMargin">{"Exact dates"}</div>
                <div className="displayFlexRow flexWrap" style={{gap:"0.8em"}}>
                  <div className="flex11a displayFlexColumn" style={{flexBasis:"15em"}}>
                    <div className="font10 fontBold smallBottomMargin">{"Start date"}</div>
                    <LibraryReact.Date
                      p_value={normalizedTempStartDateYmd}
                      p_class={inputDateClass}
                      p_styleObj={startDateInputStyleObj}
                      f_onChange={this.onchange_start_date}
                    />
                  </div>
                  <div className="flex11a displayFlexColumn" style={{flexBasis:"15em"}}>
                    <div className="font10 fontBold smallBottomMargin">{"End date"}</div>
                    <LibraryReact.Date
                      p_value={normalizedTempEndDateYmd}
                      p_class={inputDateClass}
                      p_styleObj={endDateInputStyleObj}
                      f_onChange={this.onchange_end_date}
                    />
                  </div>
                </div>
              </div>

              <div className="displayFlexColumn">
                <div className="font11 fontBold fontTextLight smallBottomMargin">{"Quick ranges"}</div>
                <div className="displayFlexRow flexWrap" style={{gap:"0.3em"}}>
                  {quickRangePresetsArray.map((m_rangeObj) => {
                    const quickRangeButtonKey = "quickRange_" + m_rangeObj.label;
                    const presetSelectedTF = (selectedQuickRangeLabel === m_rangeObj.label);
                    return(
                      <LibraryReact.Button
                        key={m_rangeObj.label}
                        p_class={quickDateButtonBaseClass + " " + ((presetSelectedTF) ? ("bgGoldGradient fontBold") : ("bgLighterGrayGradient hoverLightestGrayGradient"))}
                        p_styleObj={{minWidth:"6.7em", minHeight:"1.9em", padding:"0.12em 0.35em", ...getPressedButtonStyleObj(quickRangeButtonKey)}}
                        p_hoverText={formatRangeForTitle(m_rangeObj.startDateYmd, m_rangeObj.endDateYmd)}
                        f_onMouseDown={() => this.onmousedown_picker_button(quickRangeButtonKey, ["start", "end"])}
                        f_onClick={() => this.onselect_quick_range(m_rangeObj.label, m_rangeObj.startDateYmd, m_rangeObj.endDateYmd)}>
                        {m_rangeObj.label}
                      </LibraryReact.Button>
                    );
                  })}
                </div>
              </div>

              <div className="displayFlexColumn">
                <div className="font11 fontBold fontTextLight smallBottomMargin">{"Adjust dates"}</div>
                <div className="font09 fontTextLight smallBottomMargin">{"Each click moves that date again."}</div>
                <div className="displayFlexRow flexWrap" style={{gap:"0.7em"}}>
                  <div className="flex11a displayFlexColumn border1eee borderRadius05 bgLightestGray smallFullPad" style={{flexBasis:"15em"}}>
                    <div className="font10 fontBold smallBottomMargin">{"Start date"}</div>
                    <div className="displayFlexRow flexWrap" style={{gap:"0.35em"}}>
                      {dateAdjustmentsArray.map((m_adjustmentObj) => {
                        const adjustmentButtonKey = "start_" + m_adjustmentObj.label;
                        return(
                          <LibraryReact.Button
                            key={m_adjustmentObj.label}
                            p_class={startDateAdjustmentButtonClass}
                            p_styleObj={{minHeight:"1.8em", padding:"0.12em 0.35em", ...getPressedButtonStyleObj(adjustmentButtonKey)}}
                            p_hoverText={(tempStartDateFilledTF) ? ("Move the start date by " + m_adjustmentObj.label) : ("Set a start date first")}
                            f_onMouseDown={(tempStartDateFilledTF) ? (() => this.onmousedown_picker_button(adjustmentButtonKey, ["start"])) : (undefined)}
                            f_onClick={(tempStartDateFilledTF) ? (() => this.onadjust_date("s_tempStartDateYmd", m_adjustmentObj)) : (undefined)}>
                            {m_adjustmentObj.label}
                          </LibraryReact.Button>
                        );
                      })}
                    </div>
                  </div>
                  <div className="flex11a displayFlexColumn border1eee borderRadius05 bgLightestGray smallFullPad" style={{flexBasis:"15em"}}>
                    <div className="font10 fontBold smallBottomMargin">{"End date"}</div>
                    <div className="displayFlexRow flexWrap" style={{gap:"0.35em"}}>
                      {dateAdjustmentsArray.map((m_adjustmentObj) => {
                        const adjustmentButtonKey = "end_" + m_adjustmentObj.label;
                        return(
                          <LibraryReact.Button
                            key={m_adjustmentObj.label}
                            p_class={endDateAdjustmentButtonClass}
                            p_styleObj={{minHeight:"1.8em", padding:"0.12em 0.35em", ...getPressedButtonStyleObj(adjustmentButtonKey)}}
                            p_hoverText={(tempEndDateFilledTF) ? ("Move the end date by " + m_adjustmentObj.label) : ("Set an end date first")}
                            f_onMouseDown={(tempEndDateFilledTF) ? (() => this.onmousedown_picker_button(adjustmentButtonKey, ["end"])) : (undefined)}
                            f_onClick={(tempEndDateFilledTF) ? (() => this.onadjust_date("s_tempEndDateYmd", m_adjustmentObj)) : (undefined)}>
                            {m_adjustmentObj.label}
                          </LibraryReact.Button>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>

              {rangeIsReversedTF &&
                <div className="font10 fontRed">
                  {"Start date must be on or before end date."}
                </div>
              }

              <div className="borderT1ddd" />
              <div className="displayFlexRowHcVc flexJustifyEnd" style={{gap:"0.5em"}}>
                <CEButton
                  p_text="Apply range"
                  p_type={rangeIsReversedTF ? "blueDisabled" : "blue"}
                  p_styleObj={getPressedButtonStyleObj("apply")}
                  f_onMouseDown={rangeIsReversedTF ? undefined : (() => this.onmousedown_picker_button("apply", ["start", "end"]))}
                  f_onClick={rangeIsReversedTF ? undefined : (() => {this.onconfirm_selection(i_closeDropdown);})}
                />
                <div className="flex00a" style={{flexBasis:"1em"}} />
                <CEButton
                  p_text="Cancel"
                  p_type="gray"
                  p_styleObj={getPressedButtonStyleObj("cancel")}
                  f_onMouseDown={() => this.onmousedown_picker_button("cancel", ["start", "end"])}
                  f_onClick={i_closeDropdown}
                />
              </div>
            </div>
          </div>
        )}
      />
    );
  }
}





//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Custom Inputs
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const InputStartDateTimeAndEndDateTimeWithDurationSelect = inject("DatabaseMobx")(observer(
class InputStartDateTimeAndEndDateTimeWithDurationSelect extends Component { //props: p_value, p_tabIndex, p_errorTF, f_onChange(i_updatedStartDateTimeUtcAndEndDateTimeUtcSemicolonSeparated)
  constructor(props) {
    super(props);

    this.state = this.get_state_from_value(this.props.p_value);
  }

  componentDidUpdate(i_prevProps) {
    if(this.props.p_value !== i_prevProps.p_value) {
      this.setState(this.get_state_from_value(this.props.p_value));
    }
  }

  get_duration_select_options_arrayOfObjs = () => {
    var durationMinuteValuesAndDisplaysArrayOfObjs = [];

    var hoursArray = JSFUNC.array_fill_multistep_x_to_y_to_z([0.5, 3, 12], [0.5, 1], 1);
    for(let hours of hoursArray) {
      durationMinuteValuesAndDisplaysArrayOfObjs.push({
        minutes: Math.round(hours * 60),
        display: ((hours === 1) ? ("1 hour") : (hours + " hours"))
      });
    }


    for(let durationDays = 1; durationDays <= 30; durationDays++) {
      durationMinuteValuesAndDisplaysArrayOfObjs.push({
        minutes: Math.round(durationDays * 24 * 60),
        display: durationDays + ((durationDays === 1) ? (" day") : (" days"))
      });
    }
    return(durationMinuteValuesAndDisplaysArrayOfObjs);
  }

  get_blank_datetime_value = () => {
    return(JSFUNC.blank_datetime());
  }

  normalize_datetime_utc_or_blank = (i_value) => {
    if(JSFUNC.datetime_is_filled_out_tf(i_value)) {
      return(String(i_value).trim());
    }

    if(JSFUNC.date_is_filled_out_tf(i_value)) {
      return(String(i_value).trim() + " 00:00:58");
    }

    return(this.get_blank_datetime_value());
  }

  is_datetime_filled_out = (i_value) => {
    return(JSFUNC.datetime_is_filled_out_tf(i_value));
  }

  get_state_from_value = (i_value) => {
    const parsedPairObj = this.get_pair_obj_from_value(i_value);
    return({
      s_tempStartDateTimeUtc: parsedPairObj.startDateTimeUtc,
      s_tempEndDateTimeUtc: parsedPairObj.endDateTimeUtc,
      s_selectedDurationMinutes: parsedPairObj.selectedDurationMinutes,
      s_errorText: parsedPairObj.errorText
    });
  }

  get_pair_obj_from_value = (i_value) => {
    var startDateTimeUtc = this.get_blank_datetime_value();
    var endDateTimeUtc = this.get_blank_datetime_value();

    if(JSFUNC.string_is_filled_out_tf(i_value)) {
      const valuePartsArray = String(i_value).split(";");
      if(JSFUNC.string_is_filled_out_tf(valuePartsArray[0])) {
        startDateTimeUtc = this.normalize_datetime_utc_or_blank(valuePartsArray[0]);
      }
      if(JSFUNC.string_is_filled_out_tf(valuePartsArray[1])) {
        endDateTimeUtc = this.normalize_datetime_utc_or_blank(valuePartsArray[1]);
      }
    }

    const errorText = this.get_error_text_from_start_and_end(startDateTimeUtc, endDateTimeUtc);
    const selectedDurationMinutes = this.get_duration_minutes_from_start_and_end(startDateTimeUtc, endDateTimeUtc);

    return({
      startDateTimeUtc: startDateTimeUtc,
      endDateTimeUtc: endDateTimeUtc,
      selectedDurationMinutes: selectedDurationMinutes,
      errorText: errorText
    });
  }

  get_error_text_from_start_and_end = (i_startDateTimeUtc, i_endDateTimeUtc) => {
    if(this.is_datetime_filled_out(i_startDateTimeUtc) && this.is_datetime_filled_out(i_endDateTimeUtc)) {
      if(JSFUNC.num_seconds_from_dateTimeUtc1_to_dateTimeUtc2(i_startDateTimeUtc, i_endDateTimeUtc) < 0) {
        return("End datetime cannot be earlier than start datetime.");
      }
    }

    return(undefined);
  }

  get_duration_minutes_from_start_and_end = (i_startDateTimeUtc, i_endDateTimeUtc) => {
    if(!(this.is_datetime_filled_out(i_startDateTimeUtc) && this.is_datetime_filled_out(i_endDateTimeUtc))) {
      return(-1);
    }

    const startTimeIsSetTF = JSFUNC.ce_time_is_set_tf_from_YmdHis_datetime(i_startDateTimeUtc);
    const endTimeIsSetTF = JSFUNC.ce_time_is_set_tf_from_YmdHis_datetime(i_endDateTimeUtc);
    if(!startTimeIsSetTF && !endTimeIsSetTF) {
      return(-1);
    }

    const durationSeconds = JSFUNC.num_seconds_from_dateTimeUtc1_to_dateTimeUtc2(i_startDateTimeUtc, i_endDateTimeUtc);
    if(durationSeconds < 0) {
      return(-1);
    }

    const durationMinutes = (durationSeconds / 60);
    if(!Number.isInteger(durationMinutes)) {
      return(-1);
    }

    const durationMinuteValuesAndDisplaysArrayOfObjs = this.get_duration_select_options_arrayOfObjs();
    if(JSFUNC.in_array(durationMinutes, durationMinuteValuesAndDisplaysArrayOfObjs.map((m_durationOptionObj) => m_durationOptionObj.minutes))) {
      return(durationMinutes);
    }

    return(-1);
  }

  get_duration_display_texts_obj_from_start_and_end = (i_startDateTimeUtc, i_endDateTimeUtc) => {
    var numDHShortDisplayText = "--";
    var numDaysHoursDisplayText = "--";
    if(this.is_datetime_filled_out(i_startDateTimeUtc) && this.is_datetime_filled_out(i_endDateTimeUtc)) {
      const startTimeIsSetTF = JSFUNC.ce_time_is_set_tf_from_YmdHis_datetime(i_startDateTimeUtc);
      const endTimeIsSetTF = JSFUNC.ce_time_is_set_tf_from_YmdHis_datetime(i_endDateTimeUtc);
      if(startTimeIsSetTF && endTimeIsSetTF) {
        const durationSeconds = JSFUNC.num_seconds_from_dateTimeUtc1_to_dateTimeUtc2(i_startDateTimeUtc, i_endDateTimeUtc);
        if(durationSeconds >= 0) {
          const totalTenthsHours = Math.round(durationSeconds / 360);
          const durationDays = Math.floor(totalTenthsHours / 240);
          const remainingTenthsHours = (totalTenthsHours - (durationDays * 240));
          const remainingHours = (remainingTenthsHours / 10);
          const remainingHoursDisplay = ((Number.isInteger(remainingHours)) ? (remainingHours.toFixed(0)) : (remainingHours.toFixed(1)));
          numDHShortDisplayText = (durationDays + "d " + remainingHoursDisplay + "h");
          numDaysHoursDisplayText = (durationDays + " " + ((durationDays === 1) ? ("day") : ("days")) + " " + remainingHoursDisplay + " " + ((remainingHours === 1) ? ("hour") : ("hours")));
        }
      }
      else {
        const durationDays = (JSFUNC.num_days_from_ceDateTimeUtc1_to_ceDateTimeUtc2(i_startDateTimeUtc, i_endDateTimeUtc) + 1); //add 1 so that 5/29 to 5/29 (num_days calc as 0) shows as 1 day duration, 5/29-5/30 has a 2 day duration
        if(durationDays >= 1) {
          numDHShortDisplayText = (durationDays + "d");
          numDaysHoursDisplayText = (durationDays + " " + ((durationDays === 1) ? ("day") : ("days")));
        }
      }
    }

    return({
      numDHShortDisplayText: numDHShortDisplayText,
      numDaysHoursDisplayText: numDaysHoursDisplayText
    });
  }

  get_end_datetime_utc_from_start_and_duration_minutes = (i_startDateTimeUtc, i_durationMinutes) => {
    if(!(this.is_datetime_filled_out(i_startDateTimeUtc) && JSFUNC.is_number_not_nan_gte_0(i_durationMinutes))) {
      return(this.get_blank_datetime_value());
    }

    const startDateTimeJsObj = JSFUNC.convert_ce_datetimeutc_to_jsdateobj(i_startDateTimeUtc);
    const updatedEndDateTimeJsObj = new Date(startDateTimeJsObj.getTime() + (i_durationMinutes * 60 * 1000));
    return(JSFUNC.get_naturalDateTimeYmdHis_local_or_utc_from_jsDateObj_and_utctf(updatedEndDateTimeJsObj, true));
  }

  update_temp_values = (i_updatedStartDateTimeUtc, i_updatedEndDateTimeUtc, i_updatedDurationMinutes) => {
    const normalizedStartDateTimeUtc = this.normalize_datetime_utc_or_blank(i_updatedStartDateTimeUtc);
    const normalizedEndDateTimeUtc = this.normalize_datetime_utc_or_blank(i_updatedEndDateTimeUtc);
    const updatedErrorText = this.get_error_text_from_start_and_end(normalizedStartDateTimeUtc, normalizedEndDateTimeUtc);

    this.setState({
      s_tempStartDateTimeUtc:normalizedStartDateTimeUtc,
      s_tempEndDateTimeUtc:normalizedEndDateTimeUtc,
      s_selectedDurationMinutes:i_updatedDurationMinutes,
      s_errorText:updatedErrorText
    });

    //if((updatedErrorText === undefined) && this.is_datetime_filled_out(normalizedStartDateTimeUtc) && this.is_datetime_filled_out(normalizedEndDateTimeUtc)) {
      if(JSFUNC.is_function(this.props.f_onChange)) {
        this.props.f_onChange(normalizedStartDateTimeUtc + ";" + normalizedEndDateTimeUtc);
      }
    //}
  }

  onchange_start_datetime_utc = (i_newStartDateTimeUtc) => {
    const s_selectedDurationMinutes = this.state.s_selectedDurationMinutes;
    const s_tempEndDateTimeUtc = this.state.s_tempEndDateTimeUtc;

    var updatedEndDateTimeUtc = s_tempEndDateTimeUtc;
    var normalizedNewStartDateTimeUtc = this.force_59_seconds_to_58_seconds_for_clearing_time(i_newStartDateTimeUtc);
    if(JSFUNC.is_number_not_nan_gte_0(s_selectedDurationMinutes) && this.is_datetime_filled_out(normalizedNewStartDateTimeUtc)) {
      updatedEndDateTimeUtc = this.get_end_datetime_utc_from_start_and_duration_minutes(normalizedNewStartDateTimeUtc, s_selectedDurationMinutes);
    }

    this.update_temp_values(normalizedNewStartDateTimeUtc, updatedEndDateTimeUtc, s_selectedDurationMinutes);
  }

  onchange_end_datetime_utc = (i_newEndDateTimeUtc) => {
    const s_tempStartDateTimeUtc = this.state.s_tempStartDateTimeUtc;
    var normalizedNewEndDateTimeUtc = this.force_59_seconds_to_58_seconds_for_clearing_time(i_newEndDateTimeUtc);
    this.update_temp_values(s_tempStartDateTimeUtc, normalizedNewEndDateTimeUtc, -1);
  }

  force_59_seconds_to_58_seconds_for_clearing_time = (i_datetimeUtc) => {
    if(JSFUNC.string_is_filled_out_tf(i_datetimeUtc) && (JSFUNC.direct_get_ss_00to59_string_from_YmdHis_datetime(i_datetimeUtc) === "59")) {
      return(i_datetimeUtc.substring(0, 17) + "58"); //force 59 seconds (normal when clearing time so that time is kept under the hood) to be 58 seconds which fully 'clears' the time. This results in a more accurate # days duration count when computing duration
    }
    return(i_datetimeUtc);
  }

  onchange_duration_minutes = (i_newDurationMinutes) => {
    const s_tempStartDateTimeUtc = this.state.s_tempStartDateTimeUtc;
    const s_tempEndDateTimeUtc = this.state.s_tempEndDateTimeUtc;
    
    const updatedDurationMinutes = JSFUNC.str2int(i_newDurationMinutes);
    var updatedEndDateTimeUtc = s_tempEndDateTimeUtc;
    if(JSFUNC.is_number_not_nan_gte_0(updatedDurationMinutes) && this.is_datetime_filled_out(s_tempStartDateTimeUtc)) {
      updatedEndDateTimeUtc = this.get_end_datetime_utc_from_start_and_duration_minutes(s_tempStartDateTimeUtc, updatedDurationMinutes);
    }

    this.update_temp_values(s_tempStartDateTimeUtc, updatedEndDateTimeUtc, updatedDurationMinutes);
  }

  render() {
    const s_tempStartDateTimeUtc = this.state.s_tempStartDateTimeUtc;
    const s_tempEndDateTimeUtc = this.state.s_tempEndDateTimeUtc;
    const s_selectedDurationMinutes = this.state.s_selectedDurationMinutes;
    const s_errorText = this.state.s_errorText;

    const p_value = this.props.p_value;
    const p_tabIndex = JSFUNC.prop_value(this.props.p_tabIndex, 1);
    const p_errorTF = this.props.p_errorTF;
    const f_onChange = this.props.f_onChange;

    const hasErrorTF = JSFUNC.string_is_filled_out_tf(s_errorText);
    const durationDisplayTextsObj = this.get_duration_display_texts_obj_from_start_and_end(s_tempStartDateTimeUtc, s_tempEndDateTimeUtc);

    //duration select
    const durationMinuteValuesAndDisplaysArrayOfObjs = this.get_duration_select_options_arrayOfObjs();
    const swsOptionsObj = undefined;
    const swsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Duration", durationMinuteValuesAndDisplaysArrayOfObjs, "minutes", false, "display", swsOptionsObj);
    const selectDurationFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", swsDataObj);

    return(
      <LibraryReact.InteractiveDiv
        p_class="displayFlexColumn border1bbb smallFullPad"
        p_errorTF={p_errorTF}>
        <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight smallBottomMargin">
          {"Start Date/Time"}
        </LibraryReact.DivFont>
        <div className="flex00a">
          <LibraryReact.DateTime
            p_valueDateTimeUTC={s_tempStartDateTimeUtc}
            p_isSingleLineTF={true}
            p_tabIndex={p_tabIndex}
            p_errorTF={undefined}
            f_onChange={this.onchange_start_datetime_utc}
            f_onKeyDownEnter={this.props.f_onKeyDownEnter}
          />
        </div>
        <div className="displayFlexRowVc medTopMargin">
          <div className="flex00a" style={{flexBasis:"4.5em"}} title={"Duration between Start/End Dates: " + durationDisplayTextsObj.numDaysHoursDisplayText}>
            <LibraryReact.DivFont p_class="" p_fontClass="fontItalic fontTextLight smallBottomMargin">
              {"Duration"}
            </LibraryReact.DivFont>
            <LibraryReact.DivFont p_class="" p_fontClass="font09 fontItalic fontTextLight">
              {durationDisplayTextsObj.numDHShortDisplayText}
            </LibraryReact.DivFont>
          </div>
          <div className="flex11a" style={{maxWidth:"15em"}}>
            <GenericInputOrSelectFromInputType
              p_fieldTypeObj={selectDurationFieldTypeObj}
              p_valueRaw={s_selectedDurationMinutes}
              f_onChangeOrOnSelect={this.onchange_duration_minutes}
            />
          </div>
        </div>
        <LibraryReact.DivFont p_class="medTopMargin microBottomMargin" p_fontClass="fontItalic fontTextLight smallBottomMargin">
          {"End Date/Time"}
        </LibraryReact.DivFont>
        <div className="flex00a">
          <LibraryReact.DateTime
            p_valueDateTimeUTC={s_tempEndDateTimeUtc}
            p_isSingleLineTF={true}
            p_tabIndex={undefined}
            p_errorTF={undefined}
            f_onChange={this.onchange_end_datetime_utc}
            f_onKeyDownEnter={this.props.f_onKeyDownEnter}
          />
        </div>
        {hasErrorTF &&
          <ErrorText p_class="microTopMargin" p_text={s_errorText} />
        }
      </LibraryReact.InteractiveDiv>
    );
  }
}));



export const InputStartDateAndEndDateWithYearsDurationSelect = inject("DatabaseMobx")(observer(
class InputStartDateAndEndDateWithYearsDurationSelect extends Component { //props: p_value, p_tabIndex, p_errorTF, f_onChange(i_updatedStartDateAndEndDateSemicolonSeparated)
  constructor(props) {
    super(props);
    this.state = this.get_state_from_value(this.props.p_value);
  }

  componentDidUpdate(i_prevProps) {
    if(this.props.p_value !== i_prevProps.p_value) {
      this.setState(this.get_state_from_value(this.props.p_value));
    }
  }

  normalize_date_or_blank = (i_value) => {
    return((JSFUNC.date_is_filled_out_tf(i_value)) ? (String(i_value).trim()) : (JSFUNC.blank_date()));
  }

  get_end_date_from_start_and_duration_years = (i_startDateYmd, i_durationYears) => {
    if(!JSFUNC.date_is_filled_out_tf(i_startDateYmd) || !JSFUNC.is_number_not_nan_gte_0(i_durationYears)) {
      return(JSFUNC.blank_date());
    }

    const startDateJsObj = JSFUNC.convert_mysqldate_to_jsdateobj(i_startDateYmd);
    const targetYear = startDateJsObj.getFullYear() + i_durationYears;
    const targetMonthIndex0to11 = startDateJsObj.getMonth();
    const targetDay = Math.min(startDateJsObj.getDate(), new Date(targetYear, targetMonthIndex0to11 + 1, 0).getDate());
    return(JSFUNC.get_dateYmd_from_jsDateObj_and_utctf(new Date(targetYear, targetMonthIndex0to11, targetDay), false));
  }

  get_duration_years_from_start_and_end = (i_startDateYmd, i_endDateYmd) => {
    if(!(JSFUNC.date_is_filled_out_tf(i_startDateYmd) && JSFUNC.date_is_filled_out_tf(i_endDateYmd))) {
      return(-1);
    }

    for(let durationYears = 0; durationYears <= 25; durationYears++) {
      if(this.get_end_date_from_start_and_duration_years(i_startDateYmd, durationYears) === i_endDateYmd) {
        return(durationYears);
      }
    }
    return(-1);
  }

  get_error_text_from_start_and_end = (i_startDateYmd, i_endDateYmd) => {
    if(JSFUNC.date_is_filled_out_tf(i_startDateYmd) && JSFUNC.date_is_filled_out_tf(i_endDateYmd) && (i_endDateYmd < i_startDateYmd)) {
      return("End date cannot be earlier than start date.");
    }
    return(undefined);
  }

  get_state_from_value = (i_value) => {
    var startDateYmd = JSFUNC.blank_date();
    var endDateYmd = JSFUNC.blank_date();
    if(JSFUNC.string_is_filled_out_tf(i_value)) {
      const valuePartsArray = String(i_value).split(";");
      startDateYmd = this.normalize_date_or_blank(valuePartsArray[0]);
      endDateYmd = this.normalize_date_or_blank(valuePartsArray[1]);
    }

    return({
      s_tempStartDateYmd: startDateYmd,
      s_tempEndDateYmd: endDateYmd,
      s_selectedDurationYears: this.get_duration_years_from_start_and_end(startDateYmd, endDateYmd),
      s_errorText: this.get_error_text_from_start_and_end(startDateYmd, endDateYmd)
    });
  }

  update_temp_values = (i_startDateYmd, i_endDateYmd, i_durationYears) => {
    const normalizedStartDateYmd = this.normalize_date_or_blank(i_startDateYmd);
    const normalizedEndDateYmd = this.normalize_date_or_blank(i_endDateYmd);
    this.setState({
      s_tempStartDateYmd: normalizedStartDateYmd,
      s_tempEndDateYmd: normalizedEndDateYmd,
      s_selectedDurationYears: i_durationYears,
      s_errorText: this.get_error_text_from_start_and_end(normalizedStartDateYmd, normalizedEndDateYmd)
    });

    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(normalizedStartDateYmd + ";" + normalizedEndDateYmd);
    }
  }

  onchange_start_date = (i_newStartDateYmd) => {
    const durationYears = this.state.s_selectedDurationYears;
    const normalizedStartDateYmd = this.normalize_date_or_blank(i_newStartDateYmd);
    var updatedEndDateYmd = this.state.s_tempEndDateYmd;
    if(JSFUNC.is_number_not_nan_gte_0(durationYears) && JSFUNC.date_is_filled_out_tf(normalizedStartDateYmd)) {
      updatedEndDateYmd = this.get_end_date_from_start_and_duration_years(normalizedStartDateYmd, durationYears);
    }
    this.update_temp_values(normalizedStartDateYmd, updatedEndDateYmd, durationYears);
  }

  onchange_duration_years = (i_newDurationYears) => {
    const durationYears = JSFUNC.str2int(i_newDurationYears);
    var updatedEndDateYmd = this.state.s_tempEndDateYmd;
    if(JSFUNC.is_number_not_nan_gte_0(durationYears) && JSFUNC.date_is_filled_out_tf(this.state.s_tempStartDateYmd)) {
      updatedEndDateYmd = this.get_end_date_from_start_and_duration_years(this.state.s_tempStartDateYmd, durationYears);
    }
    this.update_temp_values(this.state.s_tempStartDateYmd, updatedEndDateYmd, durationYears);
  }

  onchange_end_date = (i_newEndDateYmd) => {
    const normalizedEndDateYmd = this.normalize_date_or_blank(i_newEndDateYmd);
    const durationYears = this.get_duration_years_from_start_and_end(this.state.s_tempStartDateYmd, normalizedEndDateYmd);
    this.update_temp_values(this.state.s_tempStartDateYmd, normalizedEndDateYmd, durationYears);
  }

  render() {
    const durationYearsArray = JSFUNC.array_fill_incrementing_x_to_y(0, 25, 1);
    const durationDisplayArray = durationYearsArray.map((m_durationYears) => m_durationYears + ((m_durationYears === 1) ? (" year") : (" years")));
    const swsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Duration", durationYearsArray, false, durationDisplayArray, undefined);
    const selectDurationFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", swsDataObj);

    return(
      <LibraryReact.InteractiveDiv p_class="displayFlexColumn border1bbb smallFullPad" p_errorTF={this.props.p_errorTF}>
        <LibraryReact.DivFont p_class="microBottomMargin" p_fontClass="fontItalic fontTextLight smallBottomMargin">
          {"Start Date"}
        </LibraryReact.DivFont>
        <LibraryReact.Date
          p_value={this.state.s_tempStartDateYmd}
          p_tabIndex={JSFUNC.prop_value(this.props.p_tabIndex, 1)}
          f_onChange={this.onchange_start_date}
          f_onKeyDownEnter={this.props.f_onKeyDownEnter}
        />
        <div className="displayFlexRowVc medTopMargin">
          <div className="flex00a" style={{flexBasis:"4.5em"}}>
            <LibraryReact.DivFont p_fontClass="fontItalic fontTextLight smallBottomMargin">
              {"Duration"}
            </LibraryReact.DivFont>
          </div>
          <div className="flex11a" style={{maxWidth:"15em"}}>
            <GenericInputOrSelectFromInputType
              p_fieldTypeObj={selectDurationFieldTypeObj}
              p_valueRaw={this.state.s_selectedDurationYears}
              f_onChangeOrOnSelect={this.onchange_duration_years}
            />
          </div>
        </div>
        <LibraryReact.DivFont p_class="medTopMargin microBottomMargin" p_fontClass="fontItalic fontTextLight smallBottomMargin">
          {"End Date"}
        </LibraryReact.DivFont>
        <LibraryReact.Date
          p_value={this.state.s_tempEndDateYmd}
          p_tabIndex={undefined}
          f_onChange={this.onchange_end_date}
          f_onKeyDownEnter={this.props.f_onKeyDownEnter}
        />
        {JSFUNC.string_is_filled_out_tf(this.state.s_errorText) &&
          <ErrorText p_class="microTopMargin" p_text={this.state.s_errorText} />
        }
      </LibraryReact.InteractiveDiv>
    );
  }
}));






class InputDateLocalFromRawDateTimeUtc extends Component { //props: p_value, p_tabIndex, f_onChange, f_onKeyDownEnter
  constructor(props) {
    super(props);

    const p_value = this.props.p_value; //input in datetime format

    const mysqlDateLocal = JSFUNC.convert_ce_datetimeutc_to_mysqldatelocal(p_value);

    this.state = {
      s_selectedDateYmd: mysqlDateLocal
    };
  }

  onchange_date_ymd = (i_newValueDateYmdOrClearBlankString) => {
    //for edge/chrome, when a date is selected the raw value is "2024-04-15", but when the "Clear" button on the calendar interface is pushed, the raw value is "", not "0000-00-00"
    var newValueDateYmd = JSFUNC.blank_date();
    if(JSFUNC.date_is_filled_out_tf(i_newValueDateYmdOrClearBlankString)) {
      newValueDateYmd = i_newValueDateYmdOrClearBlankString
    }

    this.setState({s_selectedDateYmd:newValueDateYmd});

    if(JSFUNC.is_function(this.props.f_onChange)) {
      var newValueDateTimeUtc = JSFUNC.blank_datetime();
      if(JSFUNC.date_is_filled_out_tf(newValueDateYmd)) {
        newValueDateTimeUtc = newValueDateYmd + " 00:00:58";
      }
      this.props.f_onChange(newValueDateTimeUtc);
    }
  }

  render() {
    const s_selectedDateYmd = this.state.s_selectedDateYmd;

    const p_value = this.props.p_value;
    const p_tabIndex = this.props.p_tabIndex;

    return(
      <LibraryReact.Date
        p_value={s_selectedDateYmd}
        p_tabIndex={p_tabIndex}
        f_onChange={this.onchange_date_ymd}
        f_onKeyDownEnter={this.props.f_onKeyDownEnter}
      />
    );
  }
}


const InputDateWithRelativeDate = inject("DatabaseMobx")(observer(
class InputDateWithRelativeDate extends Component { //props: p_value, p_tabIndex, f_onChange, f_onKeyDownEnter
  constructor(props) {
    super(props);

    const fixedDateObj = JSFUNC.convert_relative_ymd_date_to_fixed_date_obj(this.props.p_value);

    this.state = {
      s_selectedRelativeType: fixedDateObj.relativeType,
      s_selectedRelativeOffset: fixedDateObj.relativeOffset
    }
  }

  componentDidUpdate(i_prevProps) {
    if(this.props.p_value !== i_prevProps.p_value) {
      const fixedDateObj = JSFUNC.convert_relative_ymd_date_to_fixed_date_obj(this.props.p_value);

      this.setState({
        s_selectedRelativeType: fixedDateObj.relativeType,
        s_selectedRelativeOffset: fixedDateObj.relativeOffset
      });
    }
  }

  onselect_relative_or_fixed = (i_newValue) => {
    if(i_newValue !== this.state.s_selectedRelativeType) { //if the value was changed
      this.setState({s_selectedRelativeType: i_newValue});

      var changedYmdDate = JSFUNC.blank_date();
      if(i_newValue === "fixed") { //fixed date
        changedYmdDate = JSFUNC.now_dateYmd(); //today's date in fixed format
      }
      else {
        var changedYmdDate = "9000"; //if switching from fixed, the offset number starts at 0
        if(this.state.s_selectedRelativeType !== "fixed") { //if switching from a different relative type, use the previous offset
          if(JSFUNC.is_string(this.props.p_value)) {
            changedYmdDate = this.props.p_value.substring(0, 4);
          }
        }

        if(i_newValue === "weeks") {
          changedYmdDate += "-01-02";
        }
        else if(i_newValue === "months") {
          changedYmdDate += "-01-03";
        }
        else if(i_newValue === "years") {
          changedYmdDate += "-01-04";
        }
        else { //days
          changedYmdDate += "-01-01";
        }
      }

      if(JSFUNC.is_function(this.props.f_onChange)) {
        this.props.f_onChange(changedYmdDate);
      }
    }
  }

  onchange_fixed_date = (i_newValue) => {
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(i_newValue);
    }
  }

  onchange_offset_days = (i_newValue) => {
    var newOffset = i_newValue;
    if(newOffset > 999) {
      newOffset = 999;
    }
    else if(newOffset < -999) {
      newOffset = -999;
    }

    this.setState({s_selectedRelativeOffset:newOffset});

    if(JSFUNC.is_function(this.props.f_onChange)) {
      const year = ((newOffset >= 0) ? (9000 + newOffset) : (8000 + (-1 * newOffset)));
      var changedYmdDate = year;
      if(JSFUNC.is_string(this.props.p_value)) {
        changedYmdDate += this.props.p_value.substring(4, 10);
      }
      else {
        changedYmdDate += "-01-01";
      }
      this.props.f_onChange(changedYmdDate);
    }
  }

  render() {
    const s_selectedRelativeType = this.state.s_selectedRelativeType;
    const s_selectedRelativeOffset = this.state.s_selectedRelativeOffset;

    const p_value = this.props.p_value;
    const p_tabIndex = this.props.p_tabIndex;

    const c_selectDateWithRelativeDateFixedOrRelativeDurationTypeFieldTypeObj = this.props.DatabaseMobx.c_selectDateWithRelativeDateFixedOrRelativeDurationTypeFieldTypeObj;

    return(
      <div>
        <div className="microBottomMargin">
          <GenericInputOrSelectFromInputType
            p_fieldTypeObj={c_selectDateWithRelativeDateFixedOrRelativeDurationTypeFieldTypeObj}
            p_valueRaw={s_selectedRelativeType}
            f_onChangeOrOnSelect={this.onselect_relative_or_fixed}
          />
        </div>
        <div className="displayFlexRowVc" style={{height:"2em"}}>
          {(s_selectedRelativeType === "fixed") ? (
            <LibraryReact.Date
              p_value={p_value}
              p_tabIndex={p_tabIndex}
              f_onChange={this.onchange_fixed_date}
              f_onKeyDownEnter={this.props.f_onKeyDownEnter}
            />
          ) : (
            <div className="flex00a displayFlexRowVc">
              <div className="flex00a smallRightMargin">
                {"[Today's Date] + "}
              </div>
              <div className="flex00a smallRightMargin">
                <LibraryReact.Integer
                  p_value={s_selectedRelativeOffset}
                  p_styleObj={{width:"4.5em"}}
                  p_title="Enter the number of days (positive, negative, or 0) to offset from the computed [Today's Date] for this relative date field"
                  p_tabIndex={p_tabIndex}
                  f_onChange={this.onchange_offset_days}
                  f_onKeyDownEnter={this.props.f_onKeyDownEnter}
                />
              </div>
              <div className="flex11a">
                {s_selectedRelativeType}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}));



const InputDateWithDuration = inject("DatabaseMobx")(observer(
class InputDateWithDuration extends Component { //props: p_value, p_tabIndex, f_onChange, f_onKeyDownEnter
  constructor(props) {
    super(props);

    const inputDateWithDurationObj = JSFUNC.convert_date_with_duration_raw_datetime_to_date_with_duration_obj(this.props.p_value);

    this.state = {
      s_selectedDateYmd: inputDateWithDurationObj.dateYmd,
      s_numDaysWeeksMonthsYearsInt: inputDateWithDurationObj.numDaysWeeksMonthsYearsInt,
      s_days1Weeks2Months3Years4Int: inputDateWithDurationObj.days1Weeks2Months3Years4Int
    };
  }

  onchange_date_ymd = (i_newValueDateYmd) => {
    this.setState({s_selectedDateYmd:i_newValueDateYmd});

    const updatedDateWithDurationRawDateTime = JSFUNC.convert_date_with_duration_date_ymd_and_num_and_type1234_to_date_with_duration_raw_datetime(i_newValueDateYmd, this.state.s_numDaysWeeksMonthsYearsInt, this.state.s_days1Weeks2Months3Years4Int);
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(updatedDateWithDurationRawDateTime);
    }
  }

  onchange_num_daysweeksmonthsyears_int = (i_newValueInt) => {
    this.setState({s_numDaysWeeksMonthsYearsInt:i_newValueInt});

    const updatedDateWithDurationRawDateTime = JSFUNC.convert_date_with_duration_date_ymd_and_num_and_type1234_to_date_with_duration_raw_datetime(this.state.s_selectedDateYmd, i_newValueInt, this.state.s_days1Weeks2Months3Years4Int);
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(updatedDateWithDurationRawDateTime);
    }
  }

  onselect_duration_type_1234 = (i_newValueInt) => {
    this.setState({s_days1Weeks2Months3Years4Int:i_newValueInt});

    const updatedDateWithDurationRawDateTime = JSFUNC.convert_date_with_duration_date_ymd_and_num_and_type1234_to_date_with_duration_raw_datetime(this.state.s_selectedDateYmd, this.state.s_numDaysWeeksMonthsYearsInt, i_newValueInt);
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(updatedDateWithDurationRawDateTime);
    }
  }

  render() {
    const s_selectedDateYmd = this.state.s_selectedDateYmd;
    const s_numDaysWeeksMonthsYearsInt = this.state.s_numDaysWeeksMonthsYearsInt;
    const s_days1Weeks2Months3Years4Int = this.state.s_days1Weeks2Months3Years4Int;

    const p_value = this.props.p_value;
    const p_tabIndex = this.props.p_tabIndex;

    const c_selectDurationType1234DaysWeeksMonthsYearsFieldTypeObj = this.props.DatabaseMobx.c_selectDurationType1234DaysWeeksMonthsYearsFieldTypeObj;

    return(
      <div>
        <div className="microBottomMargin">
          <LibraryReact.Date
            p_value={s_selectedDateYmd}
            p_tabIndex={p_tabIndex}
            f_onChange={this.onchange_date_ymd}
            f_onKeyDownEnter={this.props.f_onKeyDownEnter}
          />
        </div>
        <div className="displayFlexRowVc flexWrap">
          <div className="flex00a" style={{flexBasis:"4.5em"}}>
            <font className="fontItalic fontTextLight">
              {"Duration:"}
            </font>
          </div>
          <div className="flex00a" style={{flexBasis:"4em"}}>
            <LibraryReact.Integer
              p_value={s_numDaysWeeksMonthsYearsInt}
              p_min={0}
              p_max={5999}
              p_styleObj={{width:"100%"}}
              f_onChange={this.onchange_num_daysweeksmonthsyears_int}
              f_onKeyDownEnter={this.props.f_onKeyDownEnter}
            />
          </div>
          <div className="flex00a" style={{flexBasis:"0.5em"}} />
          <div className="flex00a" style={{flexBasis:"7em"}}>
            <GenericInputOrSelectFromInputType
              p_fieldTypeObj={c_selectDurationType1234DaysWeeksMonthsYearsFieldTypeObj}
              p_valueRaw={s_days1Weeks2Months3Years4Int}
              f_onChangeOrOnSelect={this.onselect_duration_type_1234}
            />
          </div>
          <div className="flex11a" />
        </div>
      </div>
    );
  }
}));

class InputColorWithNoneOption extends Component { //props: p_value, p_class, p_styleObj, p_tabIndex, p_title, p_errorTF, f_onChange, f_onKeyDownEnter
  onclick_none_or_color_switch = () => {
    const p_value = this.props.p_value;
    const f_onChange = this.props.f_onChange;

    if(JSFUNC.is_function(f_onChange)) {
      const updatedValue = ((p_value === "") ? ("000000") : (""));
      f_onChange(updatedValue);
    }
  }

  render() {
    const p_value = this.props.p_value; //value is always 6 digit hex string for a color, except "" is a valid input/output meaning no color is selected
    const p_class = this.props.p_class;
    const p_styleObj = this.props.p_styleObj;
    const p_tabIndex = this.props.p_tabIndex;
    const p_title = this.props.p_title;
    const p_errorTF = this.props.p_errorTF;
    const f_onChange = this.props.f_onChange;
    const f_onKeyDownEnter = this.props.f_onKeyDownEnter;

    const noneColorSwitchIsColorTrueNoneFalse = (p_value !== "");
    
    var noneColorSwitchHoverText = "Use this 'None'/'Color' switch to change the mode of this selection:";
    noneColorSwitchHoverText += "\n" + " - None: no color is selected"
    noneColorSwitchHoverText += "\n" + " - Color: select a color from the color picker"

    return(
      <div className="flex11a displayFlexRowVc">
        <div
          className="flex00a displayFlexColumn cursorPointer"
          style={{marginRight:"0.8em"}}
          title={noneColorSwitchHoverText}
          onClick={this.onclick_none_or_color_switch}>
          <div className="flex00a displayFlexColumnHcVc" style={{marginBottom:"0.05em"}}>
            <SwitchWithTextAndConfirmBox
              p_isOnTF={noneColorSwitchIsColorTrueNoneFalse}
              p_sizeEm={2.2}
              p_onColor="005da3"
              p_offColor="666666"
            />
          </div>
          <div className="flex00a displayFlexColumnHcVc textCenter">
            <font className={"font08 fontBold " + ((noneColorSwitchIsColorTrueNoneFalse) ? ("fontBlue") : ("fontGray"))}>
              {((noneColorSwitchIsColorTrueNoneFalse) ? ("Color") : ("None"))}
            </font>
          </div>
        </div>
        <div className="flex11a">
          {((noneColorSwitchIsColorTrueNoneFalse) ? (
            <LibraryReact.Color
              p_value={p_value}
              p_class={p_class}
              p_styleObj={p_styleObj}
              p_tabIndex={p_tabIndex}
              p_title={p_title}
              p_errorTF={p_errorTF}
              f_onChange={f_onChange}
              f_onKeyDownEnter={f_onKeyDownEnter}
            />
          ) : (
            <font className="">
              {"--No Color Entered--"}
            </font>
          ))}
        </div>
      </div>
    );
  }
}





export class SearchInputTextWithClearX extends Component { //props: p_inputText, p_placeholderText, p_includeSearchIconTF, p_heightEm, p_bgHashColor, p_tabIndex, f_onChange, f_onClick, f_onKeyDownEnter, f_onKeyDownEsc
  //p_placeholderText is required to be filled out to make the magnifying glass icon work stylistically

  onclick_clear_capture_search_text = () => {
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange("");
    }
  }

  render() {
    const p_inputText = this.props.p_inputText;
    const p_placeholderText = this.props.p_placeholderText;
    const p_includeSearchIconTF = JSFUNC.prop_value(this.props.p_includeSearchIconTF, false);
    const p_heightEm = JSFUNC.prop_value(this.props.p_heightEm, 2.1);
    const p_bgHashColor = this.props.p_bgHashColor;
    const p_tabIndex = this.props.p_tabIndex;

    return(
      <div className="displayFlexColumnVc positionRelative">
        <LibraryReact.Text
          p_value={p_inputText}
          p_class="borderRadius10 lrBigPad"
          p_styleObj={{width:"100%", height:p_heightEm + "em", background:p_bgHashColor, paddingRight:"3em"}}
          p_tabIndex={p_tabIndex}
          p_placeholder={((p_includeSearchIconTF) ? ("\uD83D\uDD0D ") : ("")) + p_placeholderText}
          f_onChange={this.props.f_onChange}
          f_onClick={this.props.f_onClick}
          f_onKeyDownEnter={this.props.f_onKeyDownEnter}
          f_onKeyDownEsc={this.props.f_onKeyDownEsc}
        />
        <div
          className="positionAbsolute textCenter cursorPointer"
          style={{right:"1em", height:"1.4em", width:"1.4em"}}
          onClick={this.onclick_clear_capture_search_text}>
          <font className="fontDarkBlue">
            {"\u2715"}
          </font>
        </div>
      </div>
    );
  }
}







//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Floating Confirm Box
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export const ConfirmBox = inject("CaptureExecMobx", "DatabaseMobx")(observer(
class ConfirmBox extends Component { //props: p_type, p_title, p_button1Name, p_button1Type, p_button2Name, p_boxShadowColor, p_textareaHeight, p_textInitialValue, p_textMustBeFilledOutTF, p_textMustBeChangedForSaveTFU, f_onClickConfirm, f_onClickCancel, children
  //p_type: "ok", "confirm", "confirmDelete", "cancel", "inputText", "inputTextarea", "loading", "error"
  //p_textMustBeChangedForSaveTFU (used for inputText and inputTextarea confirm types)
  //  undefined [default]   (used for edit item name) if text is unchanged the confirm box is closed but f_onClickConfirm is not called to perform a database change
  //  true                  (used for copy item where name can't be the same) prevents save when text is unchanged with error message
  //  false                 (used for create new item) always calls f_onClickConfirm even if text is unchanged

  constructor(props) {
    super(props);
    this.state = {
      s_inputTextInitialValue: this.props.p_textInitialValue,
      s_inputTextValue: JSFUNC.prop_value(this.props.p_textInitialValue, ""), //this way, if an initial value is not provided, the state initial value is undefined and the current value is "", which would call onClickConfirm with a new value of "" if confirmed to save
      s_inputTextErrorMessage: undefined
    };
  }

  onchange_input_text = (i_newValue) => {
    this.setState({
      s_inputTextValue: i_newValue,
      s_inputTextErrorMessage: undefined
    });
  }

  onclick_confirm = () => {
    const s_inputTextInitialValue = this.state.s_inputTextInitialValue;
    const s_inputTextValue = this.state.s_inputTextValue;
    const s_inputTextErrorMessage = this.state.s_inputTextErrorMessage;

    const p_type = this.props.p_type;
    const p_textMustBeFilledOutTF = JSFUNC.prop_value(this.props.p_textMustBeFilledOutTF, true);
    const p_textMustBeChangedForSaveTFU = this.props.p_textMustBeChangedForSaveTFU;

    if(JSFUNC.is_function(this.props.f_onClickConfirm)) {
      if(p_type === "inputText" || p_type === "inputTextarea") {
        if(p_textMustBeFilledOutTF && (s_inputTextValue.length === 0)) {
          this.setState({s_inputTextErrorMessage:"New name cannot be blank"});
        }
        else {
          if(p_textMustBeChangedForSaveTFU === true) { //usually for a 'create copy and give new name' operation (like for folders) where the new copy name shouldn't be the same
            if(s_inputTextValue !== s_inputTextInitialValue) {
              this.props.f_onClickConfirm(s_inputTextValue);
            }
            else {
              this.setState({s_inputTextErrorMessage:"New name must be different from the old name"});
            }
          }
          else if(p_textMustBeChangedForSaveTFU === undefined) { //usually for an 'edit existing name' operation
            if(s_inputTextValue !== s_inputTextInitialValue) { //if the new value has been changed from the initial value
              this.props.f_onClickConfirm(s_inputTextValue);
            }
            else { //otherwise call a cancel since the value was not changed, doesn't need to update the local or database value
              this.onclick_cancel();
            }
          }
          else if(p_textMustBeChangedForSaveTFU === false) { //usually for an 'create new item' operation where default given name is allowed to be unchanged
            this.props.f_onClickConfirm(s_inputTextValue);
          }
        }
      }
      else {
        this.props.f_onClickConfirm("--Confirm--");
      }
    }
  }

  onclick_cancel = () => {
    if(JSFUNC.is_function(this.props.f_onClickCancel)) {
      this.props.f_onClickCancel();
    }
  }

  render() {
    const s_inputTextInitialValue = this.state.s_inputTextInitialValue;
    const s_inputTextValue = this.state.s_inputTextValue;
    const s_inputTextErrorMessage = this.state.s_inputTextErrorMessage;

    const p_type = JSFUNC.prop_value(this.props.p_type, "ok");
    const p_title = this.props.p_title;
    const p_button1Name = this.props.p_button1Name;
    const p_button1Type = this.props.p_button1Type;
    const p_button2Name = this.props.p_button2Name;
    const p_boxShadowColor = this.props.p_boxShadowColor;
    const p_textareaHeight = this.props.p_textareaHeight;
    const p_textInitialValue = this.props.p_textInitialValue;
    const p_textMustBeFilledOutTF = this.props.p_textMustBeFilledOutTF;
    const p_textMustBeChangedForSaveTFU = this.props.p_textMustBeChangedForSaveTFU;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;

    const inputTextErrorTF = (s_inputTextErrorMessage !== undefined);

    var trblFlag = "confirmBox";
    var floatingBoxContentMaxHeight = "50vh";
    var title = "--Title--";
    var boxShadowColor = "005da3";
    var hasButton1TF = true; //blue button that activates confirm function
    var button1Type = "blue";
    var button1Name = "OK";
    var button2Name = "Cancel";
    var textareaHeight = "30vh";
    var hasCancelButtonTF = false; //gray cancel button that activates cancel function
    var hasInputTextTF = false;
    var hasInputTextareaTF = false;
    var hasInputContactCompanyTF = false;
    var hasLoadingAnimationTF = false;
    if(p_type === "ok") {
      title = c_productStylingObj.productName + " Message";
      button1Name = "OK";
    }
    else if(p_type === "confirm") {
      title = c_productStylingObj.productName + " Confirmation";
      button1Name = "Confirm";
      hasCancelButtonTF = true;
    }
    else if(p_type === "confirmDelete") {
      title = c_productStylingObj.productName + " Delete Confirmation";
      boxShadowColor = "bd2326";
      button1Type = "red";
      button1Name = "Confirm";
      hasCancelButtonTF = true;
    }
    else if(p_type === "cancel") {
      title = c_productStylingObj.productName + " Confirmation";
      hasButton1TF = false;
      hasCancelButtonTF = true;
    }
    else if(p_type === "inputText") {
      title = "Input Text";
      button1Name = "Create";
      hasCancelButtonTF = true;
      hasInputTextTF = true;
    }
    else if(p_type === "inputTextarea") {
      title = "Input Textarea";
      button1Name = "Create";
      hasCancelButtonTF = true;
      hasInputTextareaTF = true;
    }
    else if(p_type === "loading") {
      title = "Loading";
      boxShadowColor = "bdbc26";
      hasButton1TF = false;
      hasLoadingAnimationTF = true;
    }
    else if(p_type === "error") {
      title = "Error";
      boxShadowColor = "bd8c26";
      button1Type = "gray";
      button1Name = "OK";
    }

    if(p_title !== undefined) {
      title = p_title;
    }

    if(p_button1Name !== undefined) {
      button1Name = p_button1Name;
    }

    if(p_button1Type !== undefined) {
      button1Type = p_button1Type;
    }

    if(p_button2Name !== undefined) {
      button2Name = p_button2Name;
    }

    if(p_boxShadowColor !== undefined) {
      boxShadowColor = p_boxShadowColor;
    }

    if(p_textareaHeight !== undefined) {
      textareaHeight = p_textareaHeight;
    }

    return(
      <FloatingBoxWithSaveCancel
        p_backdropBgOpacity0to1={0.6}
        p_trblFlag={trblFlag}
        p_title={title}
        p_shadowColor={boxShadowColor}
        f_onClickCancel={this.props.f_onClickCancel}>
        <div className="flex11a yScroll smallTopPad lrPad hugeBottomPad" style={{maxHeight:floatingBoxContentMaxHeight}}>
          {this.props.children}
          {(hasInputTextTF) &&
            <div className="medTopMargin">
              <LibraryReact.Text
                p_value={s_inputTextValue}
                p_class=""
                p_styleObj={{width:"100%"}}
                p_tabIndex={1}
                p_errorTF={inputTextErrorTF}
                f_onChange={this.onchange_input_text}
                f_onKeyDownEnter={this.onclick_confirm}
              />
            </div>
          }
          {(hasInputTextareaTF) &&
            <div className="medTopMargin">
              <LibraryReact.Textarea
                p_value={s_inputTextValue}
                p_class=""
                p_styleObj={{width:"100%", height:textareaHeight}}
                p_tabIndex={1}
                p_errorTF={inputTextErrorTF}
                f_onChange={this.onchange_input_text}
                f_onKeyDownEnter={this.onclick_confirm}
              />
            </div>
          }
          {(inputTextErrorTF) &&
            <ErrorText
              p_class="tbMicroMargin"
              p_text={s_inputTextErrorMessage}
            />
          }
          {(hasLoadingAnimationTF) &&
            <div className="displayFlexColumnHcVc medTopMargin">
              <LoadingAnimation />
            </div>
          }
        </div>
        <div className="flex00a displayFlexRowHcVc tbMedPad">
          {(hasButton1TF) &&
            <div className="flex00a lrMedMargin">
              <CEButton
                p_type={button1Type}
                p_text={button1Name}
                p_tabIndex={((hasInputTextTF || hasInputTextareaTF) ? (2) : (1))}
                f_onClick={this.onclick_confirm}
              />
            </div>
          }
          {(hasCancelButtonTF) &&
            <div className="flex00a lrMedMargin">
              <CEButton
                p_type="gray"
                p_text={button2Name}
                p_tabIndex={3}
                f_onClick={this.onclick_cancel}
              />
            </div>
          }
        </div>
      </FloatingBoxWithSaveCancel>
    );
  }
}));


export class ButtonWithConfirmBox extends Component { //props: p_buttonType, p_buttonText, p_buttonFontClass, p_tabIndex, p_title, p_confirmType, p_confirmTitle, p_confirmMessage, p_button1Name, p_textMustBeFilledOutTF, f_onClickConfirm
  //p_confirmType (ConfirmBox p_type): "ok", "confirm", "confirmDelete", "cancel", "inputText", "inputTextarea", "loading", "error"
  constructor(props) {
    super(props);
    this.state = {
      s_isConfirmingButtonPushTF: false
    }
  }

  onclick_button = () => {
    this.setState({s_isConfirmingButtonPushTF:true});
  }

  onclick_confirm = (i_enteredValue) => {
    this.setState({s_isConfirmingButtonPushTF:false}); //confirming closes the confirm box and fires the confirm function
    if(JSFUNC.is_function(this.props.f_onClickConfirm)) {
      this.props.f_onClickConfirm(i_enteredValue);
    }
  }

  onclick_cancel = () => {
    this.setState({s_isConfirmingButtonPushTF:false}); //cancelling the confirmation closes the floating confirm box without firing any action
  }

  render() {
    const s_isConfirmingButtonPushTF = this.state.s_isConfirmingButtonPushTF;

    const p_confirmMessage = this.props.p_confirmMessage;

    var confirmMessageComponent = p_confirmMessage; //message as a single line string
    if(JSFUNC.is_array(p_confirmMessage)) { //message as a multi line array of strings
      confirmMessageComponent = p_confirmMessage.map((m_messageLine) =>
        <div className="smallBottomMargin">
          <font>
            {m_messageLine}
          </font>
        </div>
      )
    }

    return(
      <>
        <CEButton
          p_type={this.props.p_buttonType}
          p_text={this.props.p_buttonText}
          p_fontClass={this.props.p_buttonFontClass}
          p_tabIndex={this.props.p_tabIndex}
          p_title={this.props.p_title}
          f_onClick={this.onclick_button}
        />
        {(s_isConfirmingButtonPushTF) &&
          <ConfirmBox
            p_type={this.props.p_confirmType}
            p_title={this.props.p_confirmTitle}
            p_button1Name={this.props.p_button1Name}
            p_textMustBeFilledOutTF={this.props.p_textMustBeFilledOutTF}
            f_onClickConfirm={this.onclick_confirm}
            f_onClickCancel={this.onclick_cancel}>
            {confirmMessageComponent}
          </ConfirmBox>
        }
      </>
    );
  }
}








//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Vertical Dots Menus
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export function DeleteMenu(props) { //props: p_message, p_menuItemText, p_noDeleteTF, p_dotsHeightEm, p_dotsFontColor, p_tabIndex, f_onDelete
  //p_noDeleteTF
  //  - true: an "ok" floating box that shows the message with only a cancel button (delete is not possible in this case)
  //  - false (default): a "confirmDelete" floating box with two choices (confirm and cancel), where confirm calls the f_onDelete function

  const p_message = props.p_message;
  const p_menuItemText = JSFUNC.prop_value(props.p_menuItemText, "Delete");
  const p_noDeleteTF = JSFUNC.prop_value(props.p_noDeleteTF, false);
  const p_dotsHeightEm = props.p_dotsHeightEm;
  const p_dotsFontColor = props.p_dotsFontColor;
  const p_tabIndex = props.p_tabIndex;

  const menuItemsArrayOfObjs = [{
    displayName: p_menuItemText,
    confirmType: ((p_noDeleteTF) ? ("cancel") : ("confirmDelete")),
    confirmMessage: p_message,
    functionOnClickConfirmButton: props.f_onDelete
  }];

  return(
    <VerticalDotsMenu
      p_menuItemsArrayOfObjs={menuItemsArrayOfObjs}
      p_dotsHeightEm={p_dotsHeightEm}
      p_dotsFontColor={p_dotsFontColor}
      p_tabIndex={p_tabIndex}
    />
  );
}


export class VerticalDotsMenu extends Component { //props: p_menuItemsArrayOfObjs, p_dotsHeightEm, p_dotsFontColor, p_tabIndex
  //menuItemObj
  //  - displayName                           text for item within opened vertical dots menu
  //  - confirmType
  //        undefined (no floating box)
  //        "ok"
  //        "confirm"
  //        "confirmDelete"
  //        "cancel"
  //        "inputText"
  //        "inputTextarea"
  //        "loading"
  //        "error"
  //  - confirmTitle                          title in top of floating box
  //  - confirmButton1Name                    [default: "Create"]
  //  - confirmButton1Type                    [default: "blue"]
  //  - button2Name                           [default: "Cancel"]
  //  - boxShadowColor
  //  - textareaHeight
  //  - confirmTextInitialValue               initial value in text input for "inputText" and "inputTextarea" types
  //  - confirmTextMustBeFilledOutTF          [default: true]
  //  - confirmTextMustBeChangedForSaveTFU
  //        undefined [default]               (used for edit text) allows you to save without changing text, but doesn't call functionOnClickConfirmButton
  //        true                              (used for edit text) wont allow you to save without changing text displaying red error message
  //        false                             (used for create new item) will allow you to save without changing text and calls functionOnClickConfirmButton even if text is unchanged
  //  - confirmMessage                        instructions text above the input text/textarea
  //  - functionOnClickMenuItem               when the item in the opened vertical dots menu is clicked (whether a floating box will be opened next or not)
  //  - functionOnClickConfirmButton(i_enteredValue)

  constructor(props) {
    super(props);
    this.menuLauncherRef = React.createRef();
    this.state = {
      s_menuOpenTF: false,
      s_confirmingMenuItemObj: undefined
    }
  }

  onclose_menu = () => {
    this.setState({s_menuOpenTF:false});
  }

  ontoggle_menu_open_closed = (event) => {
    this.setState((i_state, i_props) => ({
      s_menuOpenTF: (!i_state.s_menuOpenTF)
    }));
  }

  onselect_menu_item = (i_menuItemObj) => {
    if(i_menuItemObj !== undefined) {
      //execute function when the menu item is clicked if provided
      if(JSFUNC.is_function(i_menuItemObj.functionOnClickMenuItem)) {
        i_menuItemObj.functionOnClickMenuItem();
      }

      this.onclose_menu();

      if(i_menuItemObj.confirmType === undefined) { //no confirmation box required for this menu item
        this.onclose_confirm_box();
      }
      else { //this menu items requires a specified confirm floating box to be presented
        this.setState({s_confirmingMenuItemObj:i_menuItemObj});
      }
    }
  }

  onclick_confirm_button_in_floating_box = (i_enteredValue) => {
    const s_confirmingMenuItemObj = this.state.s_confirmingMenuItemObj;

    this.onclose_confirm_box();
    this.onclose_menu();

    if(s_confirmingMenuItemObj !== undefined) {
      if(JSFUNC.is_function(s_confirmingMenuItemObj.functionOnClickConfirmButton)) {
        s_confirmingMenuItemObj.functionOnClickConfirmButton(i_enteredValue);
      }
    }
  }

  onclose_confirm_box = () => {
    this.setState({s_confirmingMenuItemObj:undefined});
  }

  render() {
    const s_menuOpenTF = this.state.s_menuOpenTF;
    const s_confirmingMenuItemObj = this.state.s_confirmingMenuItemObj;

    const p_menuItemsArrayOfObjs = this.props.p_menuItemsArrayOfObjs;
    const p_dotsHeightEm = JSFUNC.prop_value(this.props.p_dotsHeightEm, 1);
    const p_dotsFontColor = this.props.p_dotsFontColor;
    const p_tabIndex = this.props.p_tabIndex;

    const confirmFloatingBoxIsOpenTF = (s_confirmingMenuItemObj !== undefined);

    var dotsContainerHeightEm = 2.4;
    var dotsContainerWidthEm = 1.2;
    if(JSFUNC.is_number_not_nan_gt_0(p_dotsHeightEm)) {
      dotsContainerHeightEm *= p_dotsHeightEm;
      dotsContainerWidthEm *= p_dotsHeightEm;
    }

    //determine the width of the menu that opens based on the longest menu item name
    var menuWidth = undefined;
    if(s_menuOpenTF) { //only need to determine this if the menu is opened
      var longestMenuItemLength = 5; //5 characters is a starting minimum width of the menu
      for(let menuItemObj of p_menuItemsArrayOfObjs) {
        if(JSFUNC.is_string(menuItemObj.displayName)) {
          var menuItemNameLength = menuItemObj.displayName.length;
          if(menuItemNameLength > longestMenuItemLength) {
            longestMenuItemLength = menuItemNameLength;
          }
        }
      }
      menuWidth = ((longestMenuItemLength / 2.75) + 5) + "em";
    }

    var menuPositionTop = "3em";
    var menuPositionRight = 0;
    const canPositionMenuFixedTF = (s_menuOpenTF && (typeof document !== "undefined") && !JSFUNC.is_undefined(document.body) && !JSFUNC.is_undefined(this.menuLauncherRef) && !JSFUNC.is_undefined(this.menuLauncherRef.current));
    if(canPositionMenuFixedTF) {
      const menuLauncherRectObj = this.menuLauncherRef.current.getBoundingClientRect();
      menuPositionTop = menuLauncherRectObj.bottom + "px";
      menuPositionRight = (window.innerWidth - menuLauncherRectObj.right) + "px";
    }

    var confirmMessageWithSpacingFromArray = "";
    if(confirmFloatingBoxIsOpenTF) {
      if(JSFUNC.is_array(s_confirmingMenuItemObj.confirmMessage)) {
        confirmMessageWithSpacingFromArray = s_confirmingMenuItemObj.confirmMessage.map((m_messageLine) => (
          <div className="medBottomMargin">
            {m_messageLine}
          </div>
        ));
      }
      else {
        confirmMessageWithSpacingFromArray = (
          <div>
            {s_confirmingMenuItemObj.confirmMessage}
          </div>
        );
      }
    }

    return(
      <>
        <div className="positionRelative" ref={this.menuLauncherRef}>
          <LibraryReact.InteractiveDiv
            p_class="flex00a displayFlexColumnHcVc deleteMenuLauncherHover overflowHidden cursorPointer"
            p_styleObj={{height:dotsContainerHeightEm + "em", width:dotsContainerWidthEm + "em", borderRadius:"1em"}}
            p_tabIndex={p_tabIndex}
            f_onClick={((confirmFloatingBoxIsOpenTF) ? (undefined) : (this.ontoggle_menu_open_closed))}
            f_onKeyDownEnter={((confirmFloatingBoxIsOpenTF) ? (undefined) : (this.ontoggle_menu_open_closed))}
            f_onKeyDownEsc={((confirmFloatingBoxIsOpenTF) ? (undefined) : (this.onclose_menu))}>
            <CEIconsReact.SvgVertical3Dots p_sizeEm={p_dotsHeightEm} p_color={p_dotsFontColor} />
          </LibraryReact.InteractiveDiv>
        </div>
        {(s_menuOpenTF) &&
          <LibraryReact.FloatingBox
            p_forceToZIndexFrontWithPortalTF={true}
            p_backdropBgOpacity0to1={0}
            p_top={menuPositionTop}
            p_right={menuPositionRight}
            p_borderColor="bbbbbb"
            p_borderRadius="0.3em"
            p_bgColor="ffffff"
            f_onClickBackdrop={this.onclose_menu}
            f_onKeyDownEsc={this.onclose_menu}>
            <div className="displayFlexColumn" style={{width:menuWidth}}>
              {p_menuItemsArrayOfObjs.map((m_menuItemObj, m_index) =>
                <VerticalDotsMenuItem
                  key={m_menuItemObj.displayName + m_index}
                  p_menuItemObj={m_menuItemObj}
                  f_onSelectMenuItem={this.onselect_menu_item}
                />
              )}
            </div>
          </LibraryReact.FloatingBox>
        }
        {(confirmFloatingBoxIsOpenTF) &&
          <ConfirmBox
            p_type={s_confirmingMenuItemObj.confirmType}
            p_title={s_confirmingMenuItemObj.confirmTitle}
            p_button1Name={s_confirmingMenuItemObj.confirmButton1Name}
            p_button1Type={s_confirmingMenuItemObj.confirmButton1Type}
            p_button2Name={s_confirmingMenuItemObj.button2Name}
            p_boxShadowColor={s_confirmingMenuItemObj.boxShadowColor}
            p_textareaHeight={s_confirmingMenuItemObj.textareaHeight}
            p_textInitialValue={s_confirmingMenuItemObj.confirmTextInitialValue}
            p_textMustBeFilledOutTF={s_confirmingMenuItemObj.confirmTextMustBeFilledOutTF}
            p_textMustBeChangedForSaveTFU={s_confirmingMenuItemObj.confirmTextMustBeChangedForSaveTFU}
            f_onClickConfirm={this.onclick_confirm_button_in_floating_box}
            f_onClickCancel={this.onclose_confirm_box}>
            {confirmMessageWithSpacingFromArray}
          </ConfirmBox>
        }
      </>
    );
  }
}


class VerticalDotsMenuItem extends Component { //props: p_menuItemObj, f_onSelectMenuItem
  onclick_menu_item = () => {
    if(JSFUNC.is_function(this.props.f_onSelectMenuItem)) {
      this.props.f_onSelectMenuItem(this.props.p_menuItemObj);
    }
  }

  render() {
    const menuItemObj = this.props.p_menuItemObj;
    const onClickMenuItemOrConfirmButtonFunctionIsValidTF = (JSFUNC.is_function(menuItemObj.functionOnClickMenuItem) || JSFUNC.is_function(menuItemObj.functionOnClickConfirmButton));
    return(
      <LibraryReact.InteractiveDiv
        p_class={"smallFullPad " + ((onClickMenuItemOrConfirmButtonFunctionIsValidTF) ? ("hoverRed cursorPointer") : ("fontItalic fontTextLighter cursorNotAllowed"))}
        f_onClick={((onClickMenuItemOrConfirmButtonFunctionIsValidTF) ? (this.onclick_menu_item) : (undefined))}>
        {menuItemObj.displayName}
      </LibraryReact.InteractiveDiv>
    );
  }
}











//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
//Drag/Drop to reorder for a table with rows of items
//------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
export class CEDragToResortItemWithinDbTbl extends Component { //props:
  //p_canResortTF, p_uniqueString, p_itemID, p_itemSort, p_itemSortColumnWidth, p_itemSortNumberContainerClass, p_itemSortNumberFontClass, p_isOnlyItemTF, p_isLastItemTF, 
  //p_outerPadClass, p_itemClass, p_itemStyleObj, p_lastItemExtraDropZoneHeight, p_dragEntireItemTrueOnlySortNumberFalse, 
  //p_tblName, p_tblSortFieldDbName, p_filterFieldNamesArray, p_filterValuesArray,
  //f_onDropForeignItem, children
  ondrop_item_resort_items_in_tbl = (i_draggedItemID, i_droppedOnItemID) => {
    const p_tblName = this.props.p_tblName;
    const p_tblSortFieldDbName = this.props.p_tblSortFieldDbName;
    const p_filterFieldNamesArray = JSFUNC.prop_value(this.props.p_filterFieldNamesArray, []);
    const p_filterValuesArray = JSFUNC.prop_value(this.props.p_filterValuesArray, []);

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - CEDragToResortItemWithinDbTbl", "ondrop_item_resort_items_in_tbl", ["i_draggedItemID", "i_droppedOnItemID"], [i_draggedItemID, i_droppedOnItemID]);
    const C_CallPhpTblUIDInsertFfsRecord = new JSPHP.ClassCallPhpTblUID(jsDescription);
    C_CallPhpTblUIDInsertFfsRecord.add_resort(p_tblName, p_tblSortFieldDbName, p_filterFieldNamesArray, p_filterValuesArray, i_draggedItemID, i_droppedOnItemID);
    C_CallPhpTblUIDInsertFfsRecord.execute();
  }

  render() {
    return(
      <CEDragToResortItem
        p_canResortTF={this.props.p_canResortTF}
        p_uniqueString={this.props.p_uniqueString}
        p_itemID={this.props.p_itemID}
        p_itemSort={this.props.p_itemSort}
        p_itemSortColumnWidth={this.props.p_itemSortColumnWidth}
        p_itemSortNumberContainerClass={this.props.p_itemSortNumberContainerClass}
        p_itemSortNumberFontClass={this.props.p_itemSortNumberFontClass}
        p_isOnlyItemTF={this.props.p_isOnlyItemTF}
        p_isLastItemTF={this.props.p_isLastItemTF}
        p_outerPadClass={this.props.p_outerPadClass}
        p_itemClass={this.props.p_itemClass}
        p_itemStyleObj={this.props.p_itemStyleObj}
        p_lastItemExtraDropZoneHeight={this.props.p_lastItemExtraDropZoneHeight}
        p_dragEntireItemTrueOnlySortNumberFalse={this.props.p_dragEntireItemTrueOnlySortNumberFalse}
        f_onDropResortMatchingItem={this.ondrop_item_resort_items_in_tbl}
        f_onDropResortForeignItem={this.props.f_onDropForeignItem}>
        {this.props.children}
      </CEDragToResortItem>
    );
  }
}



export class CEDragToResortItemWithinCommaListWithinDbTbl extends Component { ////props:
  //p_canResortTF, p_uniqueString, p_itemIndex, p_itemID, p_itemSortColumnWidth, p_itemSortNumberContainerClass, p_itemSortNumberFontClass, p_isOnlyItemTF, p_isLastItemTF,
  //p_outerPadClass, p_itemClass, p_itemStyleObj, p_lastItemExtraDropZoneHeight, p_dragEntireItemTrueOnlySortNumberFalse, 
  //p_tblName, p_tblRowID, p_tblCommaListColumnName, p_commaList, children
  ondrop_item_resort_items_in_comma_list_within_tbl = (i_draggedItemIndexPlus1, i_droppedOnItemIndexPlus1) => {
    const p_tblName = this.props.p_tblName;
    const p_tblRowID = this.props.p_tblRowID;
    const p_tblCommaListColumnName = this.props.p_tblCommaListColumnName;
    const p_commaList = this.props.p_commaList;

    const idsArray = JSFUNC.convert_comma_list_to_int_array(p_commaList);
    const numInputIDs = idsArray.length;

    //if the input i_idsComma is "" or a single value like "15", return that input comma list, as there is nothing that can be resorted differently
    if(numInputIDs >= 2) {
      var arrayOfObjsWithIDAndSort = [];
      for(let i = 0; i < numInputIDs; i++) {
        arrayOfObjsWithIDAndSort.push({
          id: (i + 1),
          sort: (i + 1)
        });
      }

      //the last item in a library resort list has a blank droppable space below it that always has an id value of -1, if -1 is the droppedOnItemID, then this dragged item is to be placed at the very bottom of the list
      const resortAboveTrueBottomFalseNoneUndefined = (i_droppedOnItemIndexPlus1 > 0);

      const resortArrayOfObjs = JSFUNC.drag_drop_resort_arrayOfObjs(arrayOfObjsWithIDAndSort, "id", "sort", i_draggedItemIndexPlus1, i_droppedOnItemIndexPlus1, resortAboveTrueBottomFalseNoneUndefined);
      const resortItemIndicesPlus1Array = JSFUNC.get_column_vector_from_arrayOfObjs(resortArrayOfObjs, "id");

      var resortIDsArray = [];
      for(let i = 0; i < numInputIDs; i++) {
        var resortItemIndexPlus1 = resortItemIndicesPlus1Array[i];
        var resortItemIndex = (resortItemIndexPlus1 - 1);
        var resortID = idsArray[resortItemIndex];
        resortIDsArray.push(resortID);
      }
      const resortIDsComma = JSFUNC.convert_array_to_comma_list(resortIDsArray);

      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - CEDragToResortItemWithinCommaListWithinDbTbl", "ondrop_item_resort_items_in_comma_list_within_tbl", ["i_draggedItemIndexPlus1", "i_droppedOnItemIndexPlus1"], [i_draggedItemIndexPlus1, i_droppedOnItemIndexPlus1]);
      const C_CallPhpTblUIDInsertFfsRecord = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUIDInsertFfsRecord.add_update(p_tblName, p_tblRowID, p_tblCommaListColumnName, resortIDsComma, "s");
      C_CallPhpTblUIDInsertFfsRecord.execute();
    }
  }

  render() {
    const itemIndexPlus1 = (this.props.p_itemIndex + 1); //create a fake 1-N id for the comma list using the itemIndex + 1

    return(
      <CEDragToResortItem
        p_canResortTF={this.props.p_canResortTF}
        p_uniqueString={this.props.p_uniqueString}
        p_itemID={itemIndexPlus1}
        p_itemSort={itemIndexPlus1}
        p_itemSortColumnWidth={this.props.p_itemSortColumnWidth}
        p_itemSortNumberContainerClass={this.props.p_itemSortNumberContainerClass}
        p_itemSortNumberFontClass={this.props.p_itemSortNumberFontClass}
        p_isOnlyItemTF={this.props.p_isOnlyItemTF}
        p_isLastItemTF={this.props.p_isLastItemTF}
        p_outerPadClass={this.props.p_outerPadClass}
        p_itemClass={this.props.p_itemClass}
        p_itemStyleObj={this.props.p_itemStyleObj}
        p_lastItemExtraDropZoneHeight={this.props.p_lastItemExtraDropZoneHeight}
        p_dragEntireItemTrueOnlySortNumberFalse={this.props.p_dragEntireItemTrueOnlySortNumberFalse}
        f_onDropResortMatchingItem={this.ondrop_item_resort_items_in_comma_list_within_tbl}>
        {this.props.children}
      </CEDragToResortItem>
    );
  }
}



export class CEDragToResortItem extends Component { //props: 
  //p_canResortTF, p_uniqueString, p_itemID, p_itemSort, p_itemSortColumnWidth, p_itemSortNumberContainerClass, p_itemSortNumberFontClass, p_isOnlyItemTF, p_isLastItemTF, 
  //p_outerPadClass, p_itemClass, p_itemStyleObj, p_lastItemExtraDropZoneHeight, p_dragEntireItemTrueOnlySortNumberFalse
  //f_onDropResortMatchingItem(i_draggedItemID, i_droppedOnItemID), 
  //f_onDropResortForeignItem(i_foreignUniqueString, i_foreignDraggedItemID, i_droppedOnItemID), 
  //children
  //
  //two drag/drop shells are nested so that the outer drop shell with padding only is an entire drop zone (otherwise the gaps between the items would not be droppable)
  //p_canResortTF
  //  - true (default)  sort number area on left side of item is grabbable and can be dragged/dropped onto other rows to resort them among the list (if p_itemSort is undefined, there is no area to grab and the item cannot be resorted)
  //  - false           sort number area on left side is not grabbable so item cannot be resorted
  //p_itemSort
  //  - 1-N             sort number displayed in a special area on the left side of the item that is grabbable to resort
  //  - undefined       this left side area is not drawn, the item is basically a regular div containing the passed children
  //f_onDropResortMatchingItem has 2 inputs when an onDrop occurs f_onDropResortMatchingItem(i_draggedItemID, i_droppedOnItemID)   i_droppedOnItemID is -1 if the item was dropped in the very bottom 'extra' row to sort the item to the bottom of the list, all other drops assume the dragged item will be placed above the dropped on item

  ondrop_matching_item = (i_draggedItemID, event) => {
    const p_itemID = this.props.p_itemID;
    if(JSFUNC.is_function(this.props.f_onDropResortMatchingItem)) {
      this.props.f_onDropResortMatchingItem(i_draggedItemID, p_itemID);
    }
  }

  ondrop_foreign_item = (i_foreignUniqueString, i_foreignDraggedItemID, event) => {
    const p_itemID = this.props.p_itemID;
    if(JSFUNC.is_function(this.props.f_onDropResortForeignItem)) {
      this.props.f_onDropResortForeignItem(i_foreignUniqueString, i_foreignDraggedItemID, p_itemID);
    }
  }

  ondrop_matching_item_in_last_item_extra_drop_zone = (i_draggedItemID, event) => {
    if(JSFUNC.is_function(this.props.f_onDropResortMatchingItem)) {
      this.props.f_onDropResortMatchingItem(i_draggedItemID, -1); //pass -1 for the droppedOnItemID to resort where the dragged item becomes the bottom item
    }
  }

  ondrop_foreign_item_in_last_item_extra_drop_zone = (i_foreignUniqueString, i_foreignDraggedItemID, event) => {
    if(JSFUNC.is_function(this.props.f_onDropResortForeignItem)) {
      this.props.f_onDropResortForeignItem(i_foreignUniqueString, i_foreignDraggedItemID, -1); //pass -1 for the droppedOnItemID to resort where the dragged item becomes the bottom item
    }
  }

  render() {
    const p_canResortTF = JSFUNC.prop_value(this.props.p_canResortTF, true);
    const p_uniqueString = JSFUNC.prop_value(this.props.p_uniqueString, "dragtoresortitem");
    const p_itemID = this.props.p_itemID;
    const p_itemSort = this.props.p_itemSort;
    const p_itemSortColumnWidth = JSFUNC.prop_value(this.props.p_itemSortColumnWidth, "2.5em");
    const p_itemSortNumberContainerClass = JSFUNC.prop_value(this.props.p_itemSortNumberContainerClass, "");
    const p_itemSortNumberFontClass = this.props.p_itemSortNumberFontClass;
    const p_isOnlyItemTF = JSFUNC.prop_value(this.props.p_isOnlyItemTF, false); //not able to drag or drop when this is the only item in the list
    const p_isLastItemTF = JSFUNC.prop_value(this.props.p_isLastItemTF, false); //if this is the last item, provide a drop zone below the item to drag another item below this last one (default drag onto an item places it above it, so placing an item last would be impossible without this)
    const p_outerPadClass = JSFUNC.prop_value(this.props.p_outerPadClass, "");
    const p_itemClass = JSFUNC.prop_value(this.props.p_itemClass, "");
    const p_itemStyleObj = this.props.p_itemStyleObj;
    const p_lastItemExtraDropZoneHeight = this.props.p_lastItemExtraDropZoneHeight;
    const p_dragEntireItemTrueOnlySortNumberFalse = JSFUNC.prop_value(this.props.p_dragEntireItemTrueOnlySortNumberFalse, true);

    const itemHasSortNumberTF = (p_itemSort !== undefined);
    const canDragDropItemTF = (p_canResortTF && itemHasSortNumberTF && !p_isOnlyItemTF);

    const resortRowDragOverStyleObj = {border:"solid 2px #0ae", background:"rgba(0,0,0,0.3)"};

    var belowLastItemDropZoneComponent = null;
    if(p_canResortTF && itemHasSortNumberTF && p_isLastItemTF && (p_lastItemExtraDropZoneHeight !== undefined)) {
      belowLastItemDropZoneComponent = (
        <CE3Drag3Drop3Shell3
          p_uniqueString={p_uniqueString}
          p_itemID={-1}
          p_draggableTF={false}
          p_droppableTF={true}
          p_dropZoneIsInvisibleOverlayTF={true}
          p_dropZoneOversizeWidthEm={undefined}
          p_class={p_outerPadClass}
          p_dragOverStyleObj={resortRowDragOverStyleObj}
          f_onDropMatchingItem={this.ondrop_matching_item_in_last_item_extra_drop_zone}
          f_onDropForeignItem={this.ondrop_foreign_item_in_last_item_extra_drop_zone}>
          <div style={{height:p_lastItemExtraDropZoneHeight}} />
        </CE3Drag3Drop3Shell3>
      );
    }
    
    //drag grab is in sort number box, but visuals and drop zones are full size of the item container
    if(p_dragEntireItemTrueOnlySortNumberFalse) {
      return(
        <>
          <CE3Drag3Drop3Shell3
            p_uniqueString={p_uniqueString}
            p_itemID={p_itemID}
            p_draggableTF={canDragDropItemTF}
            p_droppableTF={canDragDropItemTF}
            p_dropZoneIsInvisibleOverlayTF={true}
            p_dropZoneOversizeWidthEm={undefined}
            p_class={p_outerPadClass}
            p_styleObj={undefined}
            p_title={undefined}
            p_dragOverClass={undefined}
            p_dragOverStyleObj={resortRowDragOverStyleObj}
            p_fileUploadIsProcessingTF={false}
            f_isDragOverTF={undefined}
            f_onDropMatchingItem={this.ondrop_matching_item}
            f_onDropForeignItem={this.ondrop_foreign_item}
            f_onDropFiles={undefined}
            f_onClick={undefined}>
            <div
              className={"displayFlexRow " + p_itemClass}
              style={p_itemStyleObj}>
              {(itemHasSortNumberTF) &&
                <div className={"flex00a displayFlexColumnHcVc " + p_itemSortNumberContainerClass + " " + ((canDragDropItemTF) ? ("cursorGrab") : (""))} style={{flexBasis:p_itemSortColumnWidth, borderRight:"solid 1px #ccc"}}>
                  <font className={p_itemSortNumberFontClass}>
                    {p_itemSort}
                  </font>
                </div>
              }
              {this.props.children}
            </div>
          </CE3Drag3Drop3Shell3>
          {belowLastItemDropZoneComponent}
        </>
      );
    }
    
    //drag/drop zones and visuals restricted to only sort number box on left side of item (this allows further drag items to be inside of the 'children' of this item and still work)
    return(
      <>
        <div className={p_outerPadClass}>
          <div className={"displayFlexRow " + p_itemClass} style={p_itemStyleObj}>
            <div className="flex00a displayFlexColumn" style={{flexBasis:p_itemSortColumnWidth, borderRight:"solid 1px #ccc"}}>
              <CE3Drag3Drop3Shell3
                p_uniqueString={p_uniqueString}
                p_itemID={p_itemID}
                p_draggableTF={canDragDropItemTF}
                p_droppableTF={canDragDropItemTF}
                p_dropZoneIsInvisibleOverlayTF={true}
                p_dropZoneOversizeWidthEm={undefined}
                p_class="flex11a displayFlexColumn"
                p_styleObj={undefined}
                p_title={undefined}
                p_dragOverClass={undefined}
                p_dragOverStyleObj={resortRowDragOverStyleObj}
                p_fileUploadIsProcessingTF={false}
                f_isDragOverTF={undefined}
                f_onDropMatchingItem={this.ondrop_matching_item}
                f_onDropForeignItem={this.ondrop_foreign_item}
                f_onDropFiles={undefined}
                f_onClick={undefined}>
                {(itemHasSortNumberTF) &&
                  <div className={"flex11a displayFlexColumnHcVc " + p_itemSortNumberContainerClass + " " + ((canDragDropItemTF) ? ("cursorGrab") : (""))}>
                    <font className={p_itemSortNumberFontClass}>
                      {p_itemSort}
                    </font>
                  </div>
                }
              </CE3Drag3Drop3Shell3>
            </div>
            {this.props.children}
          </div>
        </div>
        {belowLastItemDropZoneComponent}
      </>
    );

    //overlay sibling elements solutions
    /*return(
      <>
        <div className={p_outerPadClass}>
          <div className={"positionRelative displayFlexRow " + p_itemClass} style={p_itemStyleObj}>
            <div className="flex00a" style={{flexBasis:p_itemSortColumnWidth}} />
            {this.props.children}
            <CE3Drag3Drop3Shell3
              p_uniqueString={p_uniqueString}
              p_itemID={p_itemID}
              p_draggableTF={canDragDropItemTF}
              p_droppableTF={canDragDropItemTF}
              p_dropZoneIsInvisibleOverlayTF={true}
              p_dropZoneOversizeWidthEm={undefined}
              p_class="positionAbsolute displayFlexRow"
              p_styleObj={{width:"100%", height:"100%"}}
              p_title={undefined}
              p_dragOverClass={undefined}
              p_dragOverStyleObj={resortRowDragOverStyleObj}
              p_fileUploadIsProcessingTF={false}
              f_isDragOverTF={undefined}
              f_onDropMatchingItem={this.ondrop_matching_item}
              f_onDropForeignItem={this.ondrop_foreign_item}
              f_onDropFiles={undefined}
              f_onClick={undefined}>
              {(itemHasSortNumberTF) &&
                <div
                  className={"flex00a displayFlexColumnHcVc " + p_itemSortNumberContainerClass + " " + ((canDragDropItemTF) ? ("cursorGrab") : (""))}
                  style={{flexBasis:p_itemSortColumnWidth, borderRight:"solid 1px #ccc"}}>
                  <font className={p_itemSortNumberFontClass}>
                    {p_itemSort}
                  </font>
                </div>
              }
              <div className="flex11a" />
            </CE3Drag3Drop3Shell3>
          </div>
        </div>
        {(p_canResortTF && itemHasSortNumberTF && p_isLastItemTF && (p_lastItemExtraDropZoneHeight !== undefined)) &&
          <CE3Drag3Drop3Shell3
            p_uniqueString={p_uniqueString}
            p_itemID={-1}
            p_draggableTF={false}
            p_droppableTF={true}
            p_dropZoneIsInvisibleOverlayTF={true}
            p_dropZoneOversizeWidthEm={undefined}
            p_class={p_outerPadClass}
            p_dragOverStyleObj={resortRowDragOverStyleObj}
            f_onDropMatchingItem={this.ondrop_matching_item_in_last_item_extra_drop_zone}
            f_onDropForeignItem={this.ondrop_foreign_item_in_last_item_extra_drop_zone}>
            <div style={{height:p_lastItemExtraDropZoneHeight}} />
          </CE3Drag3Drop3Shell3>
        }
      </>
    );*/
  }
}



export const CE3Drag3Drop3Shell3 = inject("CaptureExecMobx")(observer(
class CE3Drag3Drop3Shell3 extends Component { //props: 
  //p_uniqueString, p_itemID, p_draggableTF, p_droppableTF, p_dropZoneIsInvisibleOverlayTF, p_dropZoneOversizeWidthEm, p_class, p_styleObj, p_title, p_dragOverClass, p_dragOverStyleObj, p_fileUploadIsProcessingTF, 
  //f_isDragOverTF(i_isDragOverTF), 
  //f_onDropMatchingItem(i_droppedItemID, event), 
  //f_onDropForeignItem(i_droppedItemUniqueString, i_droppedItemID, event), 
  //f_onDropFiles(i_dataTransferFilesArray, event), 
  //f_onClick(event), 
  //children

  //intercept drag start and end functions to add to the process updating the CaptureExec 'dragger' ids, indicating that any item on the entire website is currently being dragged by the user's mouse
  ondragstart_item = (i_uniqueString, i_itemID, event) => {
    this.props.CaptureExecMobx.a_set_captureexec_dragged_item_obj(i_uniqueString, i_itemID, event.clientX, event.clientY);
  }

  ondragend_item = (i_uniqueString, i_itemID, event) => {
    this.props.CaptureExecMobx.a_unset_captureexec_dragged_item_obj();
  }

  ondragenter_dropzone = (i_dropZoneUniqueString, i_dropZoneItemID, event) => {
    this.props.CaptureExecMobx.a_set_captureexec_dragged_item_currently_over_dropzone_obj(i_dropZoneUniqueString, i_dropZoneItemID);
  }

  ondrop_matching_item = (i_droppedItemID, event) => {
    this.props.f_onDropMatchingItem(i_droppedItemID, event);
  }

  ondrop_foreign_item = (i_droppedItemUniqueString, i_droppedItemID, event) => {
    this.props.f_onDropForeignItem(i_droppedItemUniqueString, i_droppedItemID, event);
  }

  ondrop_files = (i_dataTransferFilesArray, event) => {
    this.props.f_onDropFiles(i_dataTransferFilesArray, event);
  }

  ondrop_html_or_computer_file_onto_ce_drag_drop_shell = () => {
    this.props.CaptureExecMobx.a_unset_captureexec_dragged_item_currently_over_dropzone_obj();
    this.props.CaptureExecMobx.a_set_any_file_or_ce_item_dragged_over_any_part_of_website_tf(false);
  }

  render() {
    const p_uniqueString = this.props.p_uniqueString;
    const p_itemID = this.props.p_itemID;
    const p_draggableTF = this.props.p_draggableTF;
    const p_droppableTF = this.props.p_droppableTF;
    const p_dropZoneIsInvisibleOverlayTF = this.props.p_dropZoneIsInvisibleOverlayTF;
    const p_dropZoneOversizeWidthEm = this.props.p_dropZoneOversizeWidthEm;
    const p_class = this.props.p_class;
    const p_styleObj = this.props.p_styleObj;
    const p_title = this.props.p_title;
    const p_dragOverClass = this.props.p_dragOverClass;
    const p_dragOverStyleObj = this.props.p_dragOverStyleObj;
    const p_fileUploadIsProcessingTF = this.props.p_fileUploadIsProcessingTF;
    
    const o_ceDraggedItemObjOrUndefined = this.props.CaptureExecMobx.o_ceDraggedItemObjOrUndefined;
    const o_ceDraggedItemCurrentlyOverDropZoneObjOrUndefined = this.props.CaptureExecMobx.o_ceDraggedItemCurrentlyOverDropZoneObjOrUndefined;

    const fOnDropMatchingItemIsFunctionTF = JSFUNC.is_function(this.props.f_onDropMatchingItem);
    const fOnDropForeignItemIsFunctionTF = JSFUNC.is_function(this.props.f_onDropForeignItem);
    const fOnDropFilesIsFunctionTF = JSFUNC.is_function(this.props.f_onDropFiles);

    var userCurrentlyDraggingItemUniqueStringOrUndefined = undefined;
    if(o_ceDraggedItemObjOrUndefined !== undefined) {
      userCurrentlyDraggingItemUniqueStringOrUndefined = o_ceDraggedItemObjOrUndefined.uniqueString;
    }

    return(
      <LibraryReact.Drag2Drop2Shell2
        p_uniqueString={p_uniqueString}
        p_itemID={p_itemID}
        p_userCurrentlyDraggingItemUniqueStringOrUndefined={userCurrentlyDraggingItemUniqueStringOrUndefined}
        p_userCurrentlyDraggingItemOverDropZoneObjOrUndefined={o_ceDraggedItemCurrentlyOverDropZoneObjOrUndefined}
        p_draggableTF={p_draggableTF}
        p_droppableTF={p_droppableTF}
        p_dropZoneIsInvisibleOverlayTF={p_dropZoneIsInvisibleOverlayTF}
        p_dropZoneOversizeWidthEm={p_dropZoneOversizeWidthEm}
        p_class={p_class}
        p_styleObj={p_styleObj}
        p_title={p_title}
        p_dragOverClass={p_dragOverClass}
        p_dragOverStyleObj={p_dragOverStyleObj}
        p_fileUploadIsProcessingTF={p_fileUploadIsProcessingTF}
        f_onDragStart={this.ondragstart_item}
        f_onDragEnd={this.ondragend_item}
        f_onDragEnterDropZone={this.ondragenter_dropzone}
        f_isDragOverTF={this.props.f_isDragOverTF}
        f_onDropMatchingItem={((fOnDropMatchingItemIsFunctionTF) ? (this.ondrop_matching_item) : (undefined))}
        f_onDropForeignItem={((fOnDropForeignItemIsFunctionTF) ? (this.ondrop_foreign_item) : (undefined))}
        f_onDropFiles={((fOnDropFilesIsFunctionTF) ? (this.ondrop_files) : (undefined))}
        f_onDrop={this.ondrop_html_or_computer_file_onto_ce_drag_drop_shell}
        f_onClick={this.props.f_onClick}>
        {this.props.children}
      </LibraryReact.Drag2Drop2Shell2>
    );
  }
}));



export const CEResortItemWithinDbTblFromEditSaveCancelSelectSortNumber = inject("DatabaseMobx")(observer(
class CEResortItemWithinDbTblFromEditSaveCancelSelectSortNumber extends Component { //props: p_itemID, p_allItemsArrayOfObjs, p_tblName, p_tblSortFieldDbName, p_filterFieldNamesArray, p_filterValuesArray, p_ceEditItemString, p_fieldDisplayName, p_containerClass, p_fieldClass, p_fieldWidth
  onsave_changed_new_sort_number = (i_selectedSortNumber) => {
    const p_itemID = this.props.p_itemID;
    const p_allItemsArrayOfObjs = this.props.p_allItemsArrayOfObjs;
    const p_tblName = this.props.p_tblName;
    const p_tblSortFieldDbName = this.props.p_tblSortFieldDbName;
    const p_filterFieldNamesArray = JSFUNC.prop_value(this.props.p_filterFieldNamesArray, []);
    const p_filterValuesArray = JSFUNC.prop_value(this.props.p_filterValuesArray, []);

    var oldItemSort = undefined;
    var selectedSortPositionItemID = undefined;
    for(let itemObj of p_allItemsArrayOfObjs) {
      if(itemObj.id === p_itemID) {
        oldItemSort = itemObj[p_tblSortFieldDbName];
      }

      if(itemObj[p_tblSortFieldDbName] === i_selectedSortNumber) {
        selectedSortPositionItemID = itemObj.id;
      }
    }

    if(i_selectedSortNumber !== oldItemSort) { //no need to update the database if the same sort position was chosen for the item in question
      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - CEResortItemWithinDbTblFromEditSaveCancelSelectSortNumber", "onsave_changed_new_sort_number", ["i_selectedSortNumber"], [i_selectedSortNumber]);
      const C_CallPhpTblUIDInsertFfsRecord = new JSPHP.ClassCallPhpTblUID(jsDescription);

      const draggedItemID = p_itemID;
      const droppedOnItemID = selectedSortPositionItemID;
      C_CallPhpTblUIDInsertFfsRecord.add_resort(p_tblName, p_tblSortFieldDbName, p_filterFieldNamesArray, p_filterValuesArray, draggedItemID, droppedOnItemID);

      C_CallPhpTblUIDInsertFfsRecord.execute();
    }
  }

  render() {
    const p_itemID = this.props.p_itemID;
    const p_allItemsArrayOfObjs = this.props.p_allItemsArrayOfObjs;
    const p_tblName = this.props.p_tblName;
    const p_tblSortFieldDbName = this.props.p_tblSortFieldDbName;
    const p_filterFieldNamesArray = this.props.p_filterFieldNamesArray;
    const p_filterValuesArray = this.props.p_filterValuesArray;
    const p_ceEditItemString = this.props.p_ceEditItemString;
    const p_fieldDisplayName = this.props.p_fieldDisplayName;
    const p_containerClass = this.props.p_containerClass;
    const p_fieldClass = this.props.p_fieldClass;
    const p_fieldWidth = this.props.p_fieldWidth;

    var valueArray = [];
    var displayArray = [];
    for(let itemObj of p_allItemsArrayOfObjs) {
      valueArray.push(itemObj.id);
      displayArray.push(itemObj[p_tblSortFieldDbName]);
    }
    const swsOptionsObj = undefined;
    const selectWithSearchDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_value_array_and_display_array("Sort Number", valueArray, false, displayArray, swsOptionsObj);
    const selectNewSortNumberFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectWithSearchDataObj);

    return(
      <CaptureExecFieldEditSaveCancel
        p_ceEditItemString={p_ceEditItemString}
        p_fieldDisplayName={p_fieldDisplayName}
        p_fieldTypeObj={selectNewSortNumberFieldTypeObj}
        p_valueRaw={p_itemID}
        p_valueIsEditableTFU={true}
        p_containerClass={p_containerClass}
        p_fieldClass={p_fieldClass}
        p_fieldWidth={p_fieldWidth}
        f_onSaveChanged={this.onsave_changed_new_sort_number}
      />
    );
  }
}));





export const CEDropZone = inject("CaptureExecMobx")(observer(
class CEDropZone extends Component {//props: p_width, p_heightEm, p_allowDropTF, p_uniqueString, p_fileUploadIsProcessingTF, p_message, p_dragOverMatchingItemMessage, f_onDropMatchingItem, f_onDropFiles
  constructor(props) {
    super(props);
    this.state = {
      s_isDragOverTF: false
    };
  }

  ondragover_drop_zone = (i_isDragOverTF) => {
    this.setState({s_isDragOverTF:i_isDragOverTF});
  }

  render() {
    const s_isDragOverTF = this.state.s_isDragOverTF;

    const p_width = this.props.p_width;
    const p_heightEm = JSFUNC.prop_value(this.props.p_heightEm, 1.5);
    const p_allowDropTF = JSFUNC.prop_value(this.props.p_allowDropTF, true);
    const p_uniqueString = this.props.p_uniqueString;
    const p_fileUploadIsProcessingTF = JSFUNC.prop_value(this.props.p_fileUploadIsProcessingTF, false);
    const p_message = this.props.p_message;
    const p_dragOverMatchingItemMessage = this.props.p_dragOverMatchingItemMessage;

    const o_ceDraggedItemObjOrUndefined = this.props.CaptureExecMobx.o_ceDraggedItemObjOrUndefined;
    const c_computerFileIsCurrentlyBeingDraggedAcrossWebsiteTF = this.props.CaptureExecMobx.c_computerFileIsCurrentlyBeingDraggedAcrossWebsiteTF;

    const fOnDropFilesIsFunctionTF = JSFUNC.is_function(this.props.f_onDropFiles);
    const fOnDropMatchingItemIsFunctionTF = JSFUNC.is_function(this.props.f_onDropMatchingItem);

    //dropzone styling
    var bgColor = "e3e8ff"; //initial state blue
    var borderColor = "005da3";
    var message = p_message;
    if(p_fileUploadIsProcessingTF) {
      bgColor = "ddd"; //processing upload gray
      borderColor = "888";
      message = p_message;
    }
    else if(s_isDragOverTF) { //something just dragged over this dropzone
      var allowDropTF = false;
      if(p_allowDropTF) { //if drop is allowed here for any item/file
        if(o_ceDraggedItemObjOrUndefined === undefined) { //if files are being dragged (this o_ceDraggedItemObjOrUndefined would be filled out if a CE html item was currently being dragged)
          allowDropTF = fOnDropFilesIsFunctionTF; //allow file drop if the f_onDropFiles handling function is defined
        }
        else {
          if(fOnDropMatchingItemIsFunctionTF) { //if the f_onDropMatchingItem function is defined for handling drag/drop of html items in CE
            allowDropTF = (o_ceDraggedItemObjOrUndefined.uniqueString === p_uniqueString); //allow drop if the drag and drop unique strings match
          }
        }
      }

      if(allowDropTF) {
        bgColor = "b0f0b0"; //dragover allowed green
        borderColor = "5a5";
        message = p_dragOverMatchingItemMessage;
      }
      else {
        bgColor = "f0b0b0"; //dragover not allowed red
        borderColor = "a55";
        const allowedDropPreventedDueToForeignDraggedItemMessage = "This item cannot be dropped here"; //if drop allowed but it's a foreign item, show this message
        message = ((p_allowDropTF) ? (allowedDropPreventedDueToForeignDraggedItemMessage) : (p_dragOverMatchingItemMessage)); //otherwise if drop not allowed by input tf, display user message from p_dragOverMatchingItemMessage
      }
    }

    return(
      <CE3Drag3Drop3Shell3
        p_uniqueString={p_uniqueString}
        p_itemID={undefined}
        p_draggableTF={false}
        p_droppableTF={true}
        p_dropZoneIsInvisibleOverlayTF={true}
        p_dropZoneOversizeWidthEm={((c_computerFileIsCurrentlyBeingDraggedAcrossWebsiteTF) ? (3) : (undefined))}
        p_class={"positionRelative displayFlexRowVc lrMedPad textCenter " + ((fOnDropFilesIsFunctionTF) ? ("hoverLightestBlueGradient"): (""))}
        p_styleObj={{height:p_heightEm + "em", width:p_width, float:"left", backgroundColor:"#" + bgColor, border:"dashed 2px #" + borderColor, borderRadius:"0.4em"}}
        p_title="Click or drag/drop files here to upload"
        p_dragOverClass={undefined}
        p_dragOverStyleObj={undefined}
        p_fileUploadIsProcessingTF={p_fileUploadIsProcessingTF}
        f_isDragOverTF={this.ondragover_drop_zone}
        f_onDropMatchingItem={this.props.f_onDropMatchingItem}
        f_onDropForeignItem={undefined}
        f_onDropFiles={this.props.f_onDropFiles}
        f_onClick={undefined}>
        <LibraryReact.MaxHeightWrap p_maxHeight={(p_heightEm - 0.5) + "em"} p_fontClass="fontBold fontItalic fontTextLighter">
          {message}
          {(p_fileUploadIsProcessingTF) &&
            <div className="displayFlexColumnHcVc">
              <LoadingAnimation p_frameDelay={0} />
            </div>
          }
        </LibraryReact.MaxHeightWrap>
      </CE3Drag3Drop3Shell3>
    );
  }
}));















//========================================================================================================================================================================================================================================
//On Premise Authentication File Upload area (for Login and On Premise Admin subtab)
//========================================================================================================================================================================================================================================
export class OnPremiseUploadNewAuthenticationFile extends Component { //f_onUploadFile
  constructor(props) {
    super(props);
    this.state = {
      s_uploadIsWorkingTF: false
    };
  }

  ondrop_authentication_file = (i_dataTransferFilesArray) => {
    if(i_dataTransferFilesArray.length !== 1) {
      alert("Upload 1 CaptureExec On-Premise Authentication .txt File");
    }
    else {
      this.setState({s_uploadIsWorkingTF:true});
      const dataTransferFileObj = i_dataTransferFilesArray[0];

      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - OnPremiseUploadNewAuthenticationFile", "ondrop_authentication_file", [], []);
      const C_CallPhpScript = new JSPHP.ClassCallPhpScript("uploadNewOnPremiseCustomerAuthenticationQuarterlyPasscodeFile", jsDescription);
      C_CallPhpScript.add_post_var("i_dataTransferFileObj", dataTransferFileObj);
      C_CallPhpScript.add_return_vars("success01String");

      const functionOnSuccess = (i_parseResponse) => {
        this.setState({s_uploadIsWorkingTF:false});

        if(i_parseResponse.success01String === "1") {
          if(JSFUNC.is_function(this.props.f_onUploadFile)) {
            this.props.f_onUploadFile();
          }
        }
        else {
          alert("New On-Premise Authentication File '" + dataTransferFileObj.name + "' did not upload successfully");
        }
      }
      C_CallPhpScript.add_function("onSuccess", functionOnSuccess);

      const functionOnError = () => {
        this.setState({s_uploadIsWorkingTF:false});
        alert("New On-Premise Authentication File '" + dataTransferFileObj.name + "' did not upload successfully");
      }
      C_CallPhpScript.add_function("onError", functionOnError);

      C_CallPhpScript.execute();
    }
  }

  render() {
    const s_uploadIsWorkingTF = this.state.s_uploadIsWorkingTF;

    return(
      <CEDropZone
        p_width="20em"
        p_heightEm={3}
        p_allowDropTF={true}
        p_uniqueString="onPremiseAuthenticationFileUpload"
        p_fileUploadIsProcessingTF={s_uploadIsWorkingTF}
        p_message="Click or Drag a new Authentication Passcode File to Upload"
        p_dragOverMatchingItemMessage="Drop Authentication File Here"
        f_onDropFiles={this.ondrop_authentication_file}
      />
    );
  }
}











//========================================================================================================================================================================================================================================
//CaptureExec Components that handle edit and selection from every possible fieldInputType (generic inputs, selects, contacts, shared percents)  deal shaping questions are broken down as selects, and generic scoredText and scoredTextarea types
//========================================================================================================================================================================================================================================
export function CaptureExecFieldEditSaveCancelFromValueMaskSortIfoObj(props) {
  //props: p_ceEditItemString, p_isContactFieldTF, p_fieldDisplayName, p_fieldTypeObj, p_valueMaskSortIfoObj, p_valueIsEditableTFU, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray
  //p_containerClass, p_fieldClass, p_fieldWidth, p_fieldNowrapTF, p_fieldHoverText, p_fieldDashedUnderlineTF, p_valueClass, p_valueMaxHeight, p_valueHoverTextTF, p_fieldValueVerticallyAlignedTF, p_floatingBoxTitle,
  //f_onSaveChanged
  return(
    <CaptureExecFieldEditSaveCancel
      p_ceEditItemString={props.p_ceEditItemString}
      p_isContactFieldTF={props.p_isContactFieldTF}
      p_fieldDisplayName={props.p_fieldDisplayName}
      p_fieldTypeObj={props.p_fieldTypeObj}
      p_valueRaw={props.p_valueMaskSortIfoObj.valueRaw}
      p_valueMask={props.p_valueMaskSortIfoObj.valueMask}
      p_valueMaskPlainText={props.p_valueMaskSortIfoObj.valueMaskPlainText}
      p_valueIsEditableTFU={props.p_valueIsEditableTFU}
      p_valuesToOnlyIncludeArray={props.p_valuesToOnlyIncludeArray}
      p_valuesToNotIncludeArray={props.p_valuesToNotIncludeArray}
      p_containerClass={props.p_containerClass}
      p_fieldClass={props.p_fieldClass}
      p_fieldWidth={props.p_fieldWidth}
      p_fieldNowrapTF={props.p_fieldNowrapTF}
      p_fieldHoverText={props.p_fieldHoverText}
      p_fieldDashedUnderlineTF={props.p_fieldDashedUnderlineTF}
      p_valueClass={props.p_valueClass}
      p_valueMaxHeight={props.p_valueMaxHeight}
      p_valueHoverTextTF={props.p_valueHoverTextTF}
      p_fieldValueVerticallyAlignedTF={props.p_fieldValueVerticallyAlignedTF}
      p_floatingBoxTitle={props.p_floatingBoxTitle}
      f_onSaveChanged={props.f_onSaveChanged}
    />
  );
}

export const CaptureExecFieldEditSaveCancel = inject("CaptureExecMobx", "DatabaseMobx")(observer(
class CaptureExecFieldEditSaveCancel extends Component {
  //props: p_ceEditItemString, p_modeEditSaveCancelTrueInputFalse, p_isContactFieldTF, p_fieldDisplayName, p_fieldTypeObj, p_valueRaw, p_valueMask, p_valueMaskPlainText, p_valueIsEditableTFU, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray
  //p_containerClass, p_containerHeight, p_fieldClass, p_fieldFontColor, p_fieldHighlightColor, p_fieldBorderColor, p_fieldWidth, p_fieldNowrapTF, p_fieldHoverText, p_fieldDashedUnderlineTF, p_valueClass, p_valueMaxHeight, p_valueHoverTextTF, p_fieldValueVerticallyAlignedTF, p_floatingBoxTitle, p_errorTF, p_errorText, p_tabIndex, 
  //f_onSaveChanged
  //
  //p_modeEditSaveCancelTrueInputFalse: true
  //    draws (when value is editable):                                   [ Field Display Name       (edit) Masked Value                        ]
  //    draws (when value is not editable):                               [ Field Display Name       Masked Value                               ]
  //    when edit is pushed with inline edit field type:                  [ Field Display Name       (save) (cancel) [Inline Input Mechanism]   ]
  //    when edit is pushed with floating box edit field type (textarea): [ Field Display Name       (edit) Masked Value                        ]   [  Floating Box Edit (save) (cancel)   ]
  //p_modeEditSaveCancelTrueInputFalse: false
  //    draws (when value is editable):                                   [ Field Display Name       [Inline Input Mechanism]                   ]
  //    draws (when value is not editable):                               [ Field Display Name       Masked Value                               ]
  //
  //when save is pushed:
  //  - if the value/values were changed, it is sent out through f_onSaveChanged
  //  - otherwise this function closes its edit state internally without sending any outbound functions
  //
  //
  //  p_ceEditItemString [required]
  //      string used for the shared edit field in CaptureExecMobx "o_itemEditingCaptureDashCardDashItemID" to only allow 1 field in the entire system to be edited at any one time, if another is opened, it shuts the currently open one
  //      p_captureID, p_cardID, p_fieldID are used together to make this shared field unique for various capture card fields
  //  p_modeEditSaveCancelTrueInputFalse
  //      - true (default)        "edit mode" (must click edit icon to edit then save/cancel, used when editing single field value that is 'closed' on the page)
  //      - false                 "create new mode" (value always 'open' for edit, used in create new or insert forms of multiple fields where all data is entered then saved all at once outside of this component)
  //  p_isContactFieldTF
  //      - false (default)       not a contact edit field (specifies together with p_ceEditItemString if the item being edited is a general item or an item within the Contacts system)
  //      - true                  is a contact field
  //  p_fieldDisplayName
  //      - undefined (default)   will not draw a field display name, leaving just the edit icon and value
  //      - "Field Name"          string will place a field name to the left of the edit icon, underlined when the edit icon is hovered over
  //  p_fieldTypeObj [required]
  //      large obj containing many true/false flags (created using DatabaseMobx.create_field_type_obj()), informs masking function for p_valueMask and input function for creating editing component
  //      also contains the "selectWithSearchDataObj" field which provides all flags and input data to draw the correct select/multiselect/sharedpercent input component
  //  p_valueRaw [required]
  //      the raw value used as the input to the editing component
  //  p_valueMask
  //      - undefined (default)   if no p_valueMask is provided, this function will call DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj() to create the mask using the provided p_valueRaw and p_fieldTypeObj
  //      - "Masked Value"        string or int or html displayed next to the p_fieldDisplayName and edit icon before editing it
  //  p_valueMaskPlainText
  //      - undefined (default)   if no valueMaskPlainText is provided, if p_valueHoverTextTF is true, then this function calls DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj() to compute the plaintext mask using the provided p_valueRaw and p_fieldTypeObj
  //      - "PlainText Value"     string displayed in value hover title if p_valueHoverTextTF is true
  //  p_valueIsEditableTFU
  //      - undefined (default)   no edit icon and no gap where it would be (used in snapshot views)
  //      - false                 no edit icon, but leaves a gap the same size as if it were there
  //      - true                  edit icon displayed
  //  p_valuesToOnlyIncludeArray
  //      - undefined (default)   no edit components are affected
  //      - [3,1,7,22]            for select or sharedpercent fieldTypes, only the listed values in this array will be included in the full list of choices in the select
  //  p_valuesToNotIncludeArray
  //      - undefined (default)   no edit components are affected
  //      - [3,1,7,22]            for select or sharedpercent fieldTypes, all listed values in this array will be removed from the full list of choices in the select
  //  p_forceSaveCallEvenIfValueNotChangedTF
  //      - false (default)       default behavior when clicking the green save icon is to first check if the updated value is changed from the initial value, only if changed is the f_save function called, otherwise f_cancel is called to prevent unnecessary database calls of the same value already in there
  //      - true                  forces a save call even if the value has not changed
  //  p_containerClass
  //      - undefined (default)   container is a div with no outer margins or padding
  //      - "cssClass cssClass2"  container div applies these styles
  //  p_containerHeight
  //      - undefined (default)   container can grow to fit the height of the field/value content
  //      - "5em"                 container is a fixed height, forces p_valueMaxHeight to be same value
  //  p_fieldClass
  //      - "" (default)          p_fieldDisplayName has standard text color/size
  //      - "cssClass cssClass2"  p_fieldDisplayName text has these styles
  //  p_fieldFontColor
  //      - undefined (default)   p_fieldDisplayName no extra font color applied
  //      - "ff0000"              p_fieldDisplayName has font color that overrides p_fieldClass colors
  //  p_fieldHighlightColor
  //      - undefined (default)   p_fieldDisplayName no highlight color applied around text
  //      - "ff0000"              p_fieldDisplayName has highlight color
  //  p_fieldBorderColor
  //      - undefined (default)   p_fieldDisplayName no border color applied around text
  //      - "ff0000"              p_fieldDisplayName has 1px width border with color
  //  p_fieldWidth
  //      - "max" (default)       max width as a flex11a (value is a flex00a pushed to the far right)
  //      - "45%"                 percent as a flex00a (value is a flex11a taking up the remaining right side)
  //      - "16em"                fixed width as a flex00a (value is a flex11a taking up the remaining right side)
  //  p_fieldNowrapTF
  //      - false (default)       field display wraps an unlimited number of lines to fit the whole string in its flex container
  //      - true                  the field cuts off in a single line <NowrapEllipsis>
  //  p_fieldHoverText
  //      - undefined (default)   no hover title over the field display name
  //      - "Hover Text"          written title will display when hovering over only the field part of this field/value pairing
  //  p_fieldDashedUnderlineTF
  //      - false (default)       normal field font display
  //      - true                  field has dashed underline (this is used on Details card for custom explanation of field purpose)
  //  p_valueClass
  //      - "" (default)          p_valueMask has standard text color/size
  //      - "cssClass cssClass2"  p_valueMask text has these styles
  //  p_valueMaxHeight
  //      - "wrap" (default)      no limit to how many lines tall the field can be with all text included
  //      - "nowrap"              gives one line with ... cutoff in a Nowrap component
  //      - "4em"                 custom height value uses a MaxHeightWrap component to cut off the text at 4em high
  //  p_valueHoverTextTF
  //      - false (default)       no hover title when hovering over the value part of the field value pair when not editing
  //      - true                  hover over the value shows a hover title of the full valueMaskPlainText of the value
  //  p_fieldValueVerticallyAlignedTF
  //      - true (default)        field and edit/save/cancel and value are vertically centered with each other
  //      - false                 field and edit/save/cancel and value are at the top of their containers
  //  p_floatingBoxTitle
  //      - "" (default)          floating box edit has no title at the top
  //      - "Edit Box Title"      floating box edit this title
  //  p_errorTF
  //      - false (default)       no error, normal field and value display
  //      - true                  error state, field and value display with red font color and errorText is shown in a hover title over the value
  //  p_errorText
  //      - undefined (default)   if p_errorTF is true but no p_errorText is provided, hover title over the value will say "Error"
  //      - "Error Text"          if p_errorTF is true, this text is shown in a hover title over the value
  //  p_tabIndex
  //      - undefined (default)   no tab index for the input component
  //      - 1                     tab index set for input component (only used for p_modeEditSaveCancelTrueInputFalse false input mode where multiple inputs are meant to be open on a 'create new' form)
  //  f_onSaveChanged(i_newValue)
  //      - undefined (default)   if the value was changed and the user clicks save, the edit box just closes with no other actions
  //      - function              this function is called on save with the new value from the edit component, if the value was changed

  onclick_edit_icon = () => {
    const p_ceEditItemString = this.props.p_ceEditItemString;
    const p_isContactFieldTF = JSFUNC.prop_value(this.props.p_isContactFieldTF, false);
    this.props.CaptureExecMobx.a_set_item_editing_capture_dash_card_dash_item_id(p_ceEditItemString, p_isContactFieldTF);
  }

  onsave_changed_input = (i_newValue) => {
    const f_onsSaveChanged = this.props.f_onSaveChanged;
    if(JSFUNC.is_function(f_onsSaveChanged)) {
      f_onsSaveChanged(i_newValue);
    }
    this.oncancel_close_item_editing();
  }

  oncancel_close_item_editing = () => {
    const p_isContactFieldTF = JSFUNC.prop_value(this.props.p_isContactFieldTF, false);
    this.props.CaptureExecMobx.a_close_item_editing(p_isContactFieldTF);
  }

  onclick_prevent_click = (event) => {
    event.stopPropagation();
  }

  render() {
    const p_ceEditItemString = this.props.p_ceEditItemString;
    const p_modeEditSaveCancelTrueInputFalse = JSFUNC.prop_value(this.props.p_modeEditSaveCancelTrueInputFalse, true);
    const p_isContactFieldTF = JSFUNC.prop_value(this.props.p_isContactFieldTF, false);
    const p_fieldDisplayName = this.props.p_fieldDisplayName;
    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valueRaw = this.props.p_valueRaw;
    const p_valueMask = this.props.p_valueMask;
    const p_valueMaskPlainText = this.props.p_valueMaskPlainText;
    const p_valueIsEditableTFU = this.props.p_valueIsEditableTFU;
    const p_valuesToOnlyIncludeArray = this.props.p_valuesToOnlyIncludeArray;
    const p_valuesToNotIncludeArray = this.props.p_valuesToNotIncludeArray;
    const p_forceSaveCallEvenIfValueNotChangedTF = JSFUNC.prop_value(this.props.p_forceSaveCallEvenIfValueNotChangedTF, false);
    const p_containerClass = JSFUNC.prop_value(this.props.p_containerClass, "");
    const p_containerHeight = this.props.p_containerHeight;
    const p_fieldClass = this.props.p_fieldClass;
    const p_fieldFontColor = this.props.p_fieldFontColor;
    const p_fieldHighlightColor = this.props.p_fieldHighlightColor;
    const p_fieldBorderColor = this.props.p_fieldBorderColor;
    const p_fieldWidth = JSFUNC.prop_value(this.props.p_fieldWidth, "max");
    const p_fieldNowrapTF = JSFUNC.prop_value(this.props.p_fieldNowrapTF, false);
    const p_fieldHoverText = this.props.p_fieldHoverText;
    const p_fieldDashedUnderlineTF = JSFUNC.prop_value(this.props.p_fieldDashedUnderlineTF, false);
    const p_valueClass = JSFUNC.prop_value(this.props.p_valueClass, "");
    const p_valueMaxHeight = this.props.p_valueMaxHeight;
    const p_valueHoverTextTF = JSFUNC.prop_value(this.props.p_valueHoverTextTF, false);
    const p_fieldValueVerticallyAlignedTF = JSFUNC.prop_value(this.props.p_fieldValueVerticallyAlignedTF, true);
    const p_floatingBoxTitle = JSFUNC.prop_value(this.props.p_floatingBoxTitle, "");
    const p_errorTF = JSFUNC.prop_value(this.props.p_errorTF, false);
    const p_errorText = this.props.p_errorText;
    const p_tabIndex = this.props.p_tabIndex;

    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;

    //verify the p_fieldTypeObj/selectWithSearchDataObj inputs are valid
    if((p_fieldTypeObj === undefined) || (p_fieldTypeObj.requiresSelectWithSearchDataObjTF && (p_fieldTypeObj.selectWithSearchDataObj === undefined))) {
      var inputErrorString = "CEGeneralReact - CaptureExecFieldEditSaveCancel - render()\n";
      if(p_fieldTypeObj === undefined) { inputErrorString += "p_fieldTypeObj undefined\n" }
      else { inputErrorString += "selectWithSearchDataObj undefined for a '" + p_fieldTypeObj.fieldInputType + "' p_fieldTypeObj\n"; }
      inputErrorString += " - p_ceEditItemString: " + p_ceEditItemString + "\n - p_fieldDisplayName: " + p_fieldDisplayName + "\n - p_valueRaw: " + p_valueRaw + "\n - p_valueMask: " + p_valueMask;
      alert(inputErrorString);
      return(inputErrorString);
    }

    //determine which parts are visible depending on the editing state and the fieldInputType
    const fieldDisplayNameIsVisibleTF = JSFUNC.text_or_number_is_filled_out_tf(p_fieldDisplayName); //if a p_fieldDisplayName was provided

    var isEditingTF = false;
    var editInFloatingBoxTF = false;
    var displayValueMaskTF = false;
    var valueIsEditableTFU = undefined;
    var useFieldDisplayNameVAlignFakeTopPaddingTF = false;
    if(p_modeEditSaveCancelTrueInputFalse) { //edit/save/cancel mode
      isEditingTF = this.props.CaptureExecMobx.is_editing_item_tf(p_ceEditItemString, p_isContactFieldTF); //determine from the shared CaptureExec editing item variable if this is currently being edited
      editInFloatingBoxTF = (p_fieldTypeObj.textareaTF || p_fieldTypeObj.scoredTextareaTF || (p_fieldTypeObj.scoredTextTF && c_isMobileTF)); //determine which field input types require a floating box edit vs inline edit (determines if the edit icon and p_valueMask should remain under the floating box, or if they should be replaced by the save/cancel and input component)
      displayValueMaskTF = (!isEditingTF || editInFloatingBoxTF); //masked value is not shown when editing unless the edit is in a floating box, also never display the masked value in 'input' mode (edit always open)
      valueIsEditableTFU = p_valueIsEditableTFU;
      useFieldDisplayNameVAlignFakeTopPaddingTF = (!p_fieldValueVerticallyAlignedTF && (p_valueIsEditableTFU !== undefined)); //when vertically aligned, don't need fake spacing. otherwise both field/value are at top, if there's an edit icon, need the fake space, otherwise do not
    }
    else { //input mode
      isEditingTF = false; //do not draw background edit color or edit icon
      editInFloatingBoxTF = false; //all edits are inline edits in input mode, so never use the floating box
      displayValueMaskTF = false; //always drawing input mechanism in input mode, so never show the value mask
      valueIsEditableTFU = undefined; //do not draw space for an edit icon
      useFieldDisplayNameVAlignFakeTopPaddingTF = (!p_fieldValueVerticallyAlignedTF); //all input components are about 1.2em tall, when not vertically aligned, the fake field top spacing is needed to pseudo center it to text/select/date inputs
    }

    //container class for field/icons/value
    const containerFlexRowClass = ((p_fieldValueVerticallyAlignedTF) ? ("displayFlexRowVc") : ("displayFlexRow")); //vertical alignment of field display name, edit/save/cancel buttons, and value mask or inline edit
    const containerEditingClass = ((isEditingTF) ? ("bgCaptureItemEditing tbMedPad lrPad") : ("")); //add background color and padding when editing the field

    //field/value widths
    var fieldFlexClass = "flex00a";
    var fieldFlexBasis = p_fieldWidth;
    var valueFlexClass = "flex11a";
    if((p_fieldWidth === "max") && fieldDisplayNameIsVisibleTF) {
      fieldFlexClass = "flex11a";
      fieldFlexBasis = "auto";
      valueFlexClass = "flex00a";
    }

    //masked value when not editing
    var valueMaskedFontComponent = null;
    var valueIsFilledOutTFU = undefined; //undefined means this variable wasn't computed within this part when getting the valueMask for display, need it computed for select contacts value display for fake top padding
    if(displayValueMaskTF) {
      //mask the capture raw value if an override mask was not provided
      var valueMask = p_valueMask;
      var valueMaskPlainText = p_valueMaskPlainText;
      var valueClass = p_valueClass;
      if(p_valueMask === undefined) { //need to compute the valueMask from the valueRaw
        const valueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(p_valueRaw, p_fieldTypeObj);
        valueMask = valueMaskSortIfoObj.valueMask;
        valueMaskPlainText = valueMaskSortIfoObj.valueMaskPlainText;
        valueIsFilledOutTFU = valueMaskSortIfoObj.isFilledOutTF;
      }

      //put the valueMaskPlainText as the hover title for the value if specified by the p_valueHoverTextTF input being true
      var valueTitle = undefined;
      if(p_valueHoverTextTF) {
        valueTitle = valueMaskPlainText;
      }

      //frame the masked value using the specified wrap and max height settings
      if(p_valueMaxHeight === undefined) {
        valueMaskedFontComponent = (
          <font className={"breakWord " + valueClass}>
            {valueMask}
          </font>
        );
      }
      else if(p_valueMaxHeight === "nowrap") {
        valueMaskedFontComponent = (
          <LibraryReact.NowrapEllipsis p_fontClass={valueClass}>
            {valueMask}
          </LibraryReact.NowrapEllipsis>
        );
      }
      else { //custom defined max height wrap
        valueMaskedFontComponent = (
          <LibraryReact.MaxHeightWrap p_maxHeight={p_valueMaxHeight} p_fontClass={"breakWord " + valueClass}>
            {valueMask}
          </LibraryReact.MaxHeightWrap>
        );
      }
    }

    //when p_fieldValueVerticallyAlignedTF is false, the text for the field and the value (1.2em tall) are at the top of the container, the edit button (1.6em tall) also at the top makes this look jumbled, to vertically center this (if the value is 1 line) apply a pad above the field/value from the top
    var fieldDisplayNameVAlignFakeTopPadding = undefined;
    var valueMaskVAlignFakeTopPadding = undefined;
    if(useFieldDisplayNameVAlignFakeTopPaddingTF) {
      fieldDisplayNameVAlignFakeTopPadding = "0.2em";
      valueMaskVAlignFakeTopPadding = "0.2em";
      if(p_fieldTypeObj.selectContactCompanyTF || p_fieldTypeObj.selectContactPersonTF) { //don't include the spacing over the (confirmed filled out) valueMask for select contacts to give more space for the larger contact bubbles
        if(valueIsFilledOutTFU === undefined) { //if this filled out tf hasn't been calculated yet, calculate it here
          valueIsFilledOutTFU = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(p_valueRaw, p_fieldTypeObj);
          if(valueIsFilledOutTFU) {
            valueMaskVAlignFakeTopPadding = undefined; //no fake spacing over the contact bubble valueMask
          }
        }
      }
    }

    return(
      <div
        className={containerFlexRowClass + " " + containerEditingClass + " " + p_containerClass}
        style={{height:p_containerHeight}}
        onClick={((isEditingTF) ? (this.onclick_prevent_click) : (undefined))}>
        <CaptureExecFieldEditSaveCancelFieldAndEditIcon
          p_fieldDisplayNameIsVisibleTF={fieldDisplayNameIsVisibleTF}
          p_fieldFlexClass={fieldFlexClass}
          p_fieldFlexBasis={fieldFlexBasis}
          p_fieldHoverText={p_fieldHoverText}
          p_fieldDashedUnderlineTF={p_fieldDashedUnderlineTF}
          p_fieldClass={p_fieldClass}
          p_fieldFontColor={p_fieldFontColor}
          p_fieldHighlightColor={p_fieldHighlightColor}
          p_fieldBorderColor={p_fieldBorderColor}
          p_fieldNowrapTF={p_fieldNowrapTF}
          p_fieldDisplayName={p_fieldDisplayName}
          p_valueIsEditableTFU={valueIsEditableTFU}
          p_isEditingTF={isEditingTF}
          p_editInFloatingBoxTF={editInFloatingBoxTF}
          p_vAlignFakeTopPadding={fieldDisplayNameVAlignFakeTopPadding}
          f_onClickEditIcon={this.onclick_edit_icon}
        />
        {(displayValueMaskTF) &&
          <div
            className={valueFlexClass + " breakWord"}
            style={{paddingTop:valueMaskVAlignFakeTopPadding}}
            title={valueTitle}>
            {valueMaskedFontComponent}
          </div>
        }
        {(isEditingTF) &&
          <CaptureExecInputInlineOrFloatingWithSaveCancel
            p_fieldDisplayName={p_fieldDisplayName}
            p_fieldTypeObj={p_fieldTypeObj}
            p_valueRaw={p_valueRaw}
            p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
            p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
            p_selectInitOptionsBoxOpenTF={true}
            p_fieldValueVerticallyAlignedTF={p_fieldValueVerticallyAlignedTF}
            p_editInFloatingBoxTF={editInFloatingBoxTF}
            p_floatingBoxTitle={p_floatingBoxTitle}
            p_initialValueIsBlankValueTF={false}
            p_forceSaveCallEvenIfValueNotChangedTF={p_forceSaveCallEvenIfValueNotChangedTF}
            f_onSaveChanged={this.onsave_changed_input}
            f_onCancel={this.oncancel_close_item_editing}
          />
        }
        {(!p_modeEditSaveCancelTrueInputFalse) &&
          <div className={"flex11a " + ((p_fieldValueVerticallyAlignedTF) ? ("displayFlexColumnVc") : ("displayFlexColumn"))}>
            <GenericInputOrSelectFromInputType
              p_fieldTypeObj={p_fieldTypeObj}
              p_valueRaw={p_valueRaw}
              p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
              p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
              p_selectDisplayMaskOverwrite={undefined}
              p_selectInitOptionsBoxOpenTF={undefined}
              p_selectedDisplayFocusOnKeyDownEnterOpensSelectTF={undefined}
              p_forceTextareaToTextTF={undefined}
              p_tabIndex={p_tabIndex}
              p_title={undefined}
              p_errorTF={p_errorTF}
              p_focusTF={undefined}
              f_onChangeOrOnSelect={this.onsave_changed_input}
              f_onKeyDownEnter={undefined}
            />
            {(p_errorTF && JSFUNC.is_string_not_empty(p_errorText)) &&
              <ErrorText p_class="microTopMargin" p_text={p_errorText} />
            }
          </div>
        }
      </div>
    );
  }
}));

class CaptureExecFieldEditSaveCancelFieldAndEditIcon extends Component { //props: p_fieldDisplayNameIsVisibleTF, p_fieldFlexClass, p_fieldFlexBasis, p_fieldHoverText, p_fieldDashedUnderlineTF, p_fieldClass, p_fieldFontColor, p_fieldHighlightColor, p_fieldBorderColor, p_fieldNowrapTF, p_fieldDisplayName, p_valueIsEditableTFU, p_isEditingTF, p_editInFloatingBoxTF, p_vAlignFakeTopPadding, f_onClickEditIcon
  constructor(props) {
    super(props);
    this.state = {
      s_hoverEditIconTF: false
    };
  }

  componentDidUpdate(prevProps) {
    if(this.props.p_isEditingTF !== prevProps.p_isEditingTF) {
      this.setState({s_hoverEditIconTF:false});
    }
  }

  onhover_edit_icon = (i_hoverTF) => {
    this.setState({s_hoverEditIconTF:i_hoverTF});
  }

  render() {
    const s_hoverEditIconTF = this.state.s_hoverEditIconTF;

    const p_fieldDisplayNameIsVisibleTF = this.props.p_fieldDisplayNameIsVisibleTF;
    const p_fieldFlexClass = this.props.p_fieldFlexClass;
    const p_fieldFlexBasis = this.props.p_fieldFlexBasis;
    const p_fieldHoverText = this.props.p_fieldHoverText;
    const p_fieldDashedUnderlineTF = this.props.p_fieldDashedUnderlineTF;
    const p_fieldClass = this.props.p_fieldClass;
    const p_fieldFontColor = this.props.p_fieldFontColor;
    const p_fieldHighlightColor = this.props.p_fieldHighlightColor;
    const p_fieldBorderColor = this.props.p_fieldBorderColor;
    const p_fieldNowrapTF = this.props.p_fieldNowrapTF;
    const p_fieldDisplayName = this.props.p_fieldDisplayName;
    const p_valueIsEditableTFU = this.props.p_valueIsEditableTFU;
    const p_isEditingTF = this.props.p_isEditingTF;
    const p_editInFloatingBoxTF = this.props.p_editInFloatingBoxTF;
    const p_vAlignFakeTopPadding = this.props.p_vAlignFakeTopPadding;

    const currentlyEditingAnInlineEditTF = (p_isEditingTF && !p_editInFloatingBoxTF);

    //field display component (not drawn if not display name is provided)
    var fieldDisplayNameComponent = null;
    if(p_fieldDisplayNameIsVisibleTF) {
      const fieldHoverTextTF = JSFUNC.text_or_number_is_filled_out_tf(p_fieldHoverText);
      const fieldContainerTextDecoration = ((s_hoverEditIconTF) ? ("underline") : ("none"));

      var usingFieldClassTF = false;
      var fieldClassStringOrUndefined = undefined;
      if(p_fieldClass !== undefined) {
        usingFieldClassTF = true;
        fieldClassStringOrUndefined = p_fieldClass;
        if(p_fieldDashedUnderlineTF) {
          fieldClassStringOrUndefined += " fontUnderlineDotted";
        }
      }
      else if(p_fieldDashedUnderlineTF) { //no class, but has a hover text title
        usingFieldClassTF = true;
        fieldClassStringOrUndefined = "fontUnderlineDotted";
      }

      var usingFieldFontColorTF = false;
      var fieldFontHashColorOrUndefined = undefined;
      if(p_fieldFontColor !== undefined) {
        usingFieldFontColorTF = true;
        fieldFontHashColorOrUndefined = "#" + p_fieldFontColor;
      }

      var fieldDisplayNameFontComponent = undefined;
      if(p_fieldNowrapTF) {
        fieldDisplayNameFontComponent = (
          <LibraryReact.NowrapEllipsis p_fontClass={fieldClassStringOrUndefined} p_fontStyleObj={{color:fieldFontHashColorOrUndefined}}>
            {p_fieldDisplayName}
          </LibraryReact.NowrapEllipsis>
        );
      }
      else if(usingFieldClassTF || usingFieldFontColorTF) {
        fieldDisplayNameFontComponent = (
          <span className={fieldClassStringOrUndefined} style={{color:fieldFontHashColorOrUndefined}}>
            {p_fieldDisplayName}
          </span>
        );
      }
      else {
        fieldDisplayNameFontComponent = p_fieldDisplayName;
      }

      if((p_fieldHighlightColor !== undefined) || (p_fieldBorderColor !== undefined)) {
        fieldDisplayNameFontComponent = (
          <div style={{border:"1px solid #" + p_fieldBorderColor, background:"#" + p_fieldHighlightColor}}>
            {fieldDisplayNameFontComponent}
          </div>
        );
      }

      fieldDisplayNameComponent = (
        <div
          className={p_fieldFlexClass + " breakWord"}
          style={{flexBasis:p_fieldFlexBasis, textDecoration:fieldContainerTextDecoration, paddingTop:p_vAlignFakeTopPadding}}
          title={((fieldHoverTextTF) ? (p_fieldHoverText) : (undefined))}>
          {fieldDisplayNameFontComponent}
        </div>
      );
    }

    return(
      <>
        {fieldDisplayNameComponent}
        {((p_valueIsEditableTFU !== undefined) && !currentlyEditingAnInlineEditTF) &&
          <div className="flex00a" style={{height:"1.6em"}}>
            <EditSaveCancelIcon
              p_iconType={((p_valueIsEditableTFU) ? ("edit") : ("blank"))}
              f_onClick={((p_valueIsEditableTFU) ? (this.props.f_onClickEditIcon) : (undefined))}
              f_onHover={((p_valueIsEditableTFU && p_fieldDisplayNameIsVisibleTF) ? (this.onhover_edit_icon) : (undefined))}
            />
          </div>
        }
      </>
    );
  }
}



export const CaptureExecFieldAddNewItemsButton = inject("DatabaseMobx")(observer(
class CaptureExecFieldAddNewItemsButton extends Component { //props: p_buttonType, p_buttonText, p_addInstructions, p_addInstructionsNowrapTF, p_fieldTypeObj, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray, p_forceSaveCallEvenIfValueNotChangedTF, p_contactsZoomedCompanyID, p_tabIndex, f_onAddSelectedItems
  //displays an add button
  //  1. when the button is clicked, the button is replaced by an inline input with save/cancel, or by a floating box input with save/cancel
  //  2. item(s) are selected, then save is pushed
  //  3. the selected item id/idsComma is passed out of the function, or a cancel command

  constructor(props) {
    super(props);
    this.state = {
      s_isAddingTF: false
    };
  }

  onclick_add_button = () => {
    this.setState({s_isAddingTF:true});
  }

  onclick_save_add_selected_items = (i_newValue) => {
    const p_fieldTypeObj = this.props.p_fieldTypeObj;

    if(JSFUNC.is_function(this.props.f_onAddSelectedItems)) {
      const selectedItemsValueIsFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(i_newValue, p_fieldTypeObj); //determine if something was selected (if newValue is considered "filled out" for this fieldTypeObj)
      if(selectedItemsValueIsFilledOutTF) { //only save if the field is filled out, otherwise cancel
        this.props.f_onAddSelectedItems(i_newValue); //returns a value in the format based on the fieldTypeObj (single int for select, string comma list for selectmulti, etc)
      }
    }
    this.setState({s_isAddingTF:false});
  }

  onclick_cancel = () => {
    this.setState({s_isAddingTF:false});
  }

  render() {
    const s_isAddingTF = this.state.s_isAddingTF;

    const p_buttonType = this.props.p_buttonType;
    const p_buttonText = this.props.p_buttonText;
    const p_addInstructions = this.props.p_addInstructions; //instructions to put above the inline input or as the floating box title
    const p_addInstructionsNowrapTF = JSFUNC.prop_value(this.props.p_addInstructionsNowrapTF);
    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valuesToOnlyIncludeArray = this.props.p_valuesToOnlyIncludeArray;
    const p_valuesToNotIncludeArray = this.props.p_valuesToNotIncludeArray;
    const p_forceSaveCallEvenIfValueNotChangedTF = JSFUNC.prop_value(this.props.p_forceSaveCallEvenIfValueNotChangedTF, false);
    const p_contactsZoomedCompanyID = this.props.p_contactsZoomedCompanyID;
    const p_tabIndex = this.props.p_tabIndex;

    const editInFloatingBoxTF = (p_fieldTypeObj.textareaTF);

    //add button
    const buttonComponent = (
      <CEButton
        p_type={p_buttonType}
        p_text={p_buttonText}
        p_tabIndex={p_tabIndex}
        f_onClick={this.onclick_add_button}
      />
    );

    //input component when editing the field
    var inputWithSaveCancelComponent = null;
    if(s_isAddingTF) {
      inputWithSaveCancelComponent = (
        <CaptureExecInputInlineOrFloatingWithSaveCancel
          p_fieldDisplayName={undefined}
          p_fieldTypeObj={p_fieldTypeObj}
          p_valueRaw={p_fieldTypeObj.blankValue} //edit component initializes with nothing filled out or selected
          p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
          p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
          p_contactsZoomedCompanyID={p_contactsZoomedCompanyID}
          p_selectInitOptionsBoxOpenTF={true}
          p_fieldValueVerticallyAlignedTF={true}
          p_editInFloatingBoxTF={editInFloatingBoxTF}
          p_floatingBoxTitle={p_addInstructions}
          p_initialValueIsBlankValueTF={true}
          p_forceSaveCallEvenIfValueNotChangedTF={p_forceSaveCallEvenIfValueNotChangedTF}
          f_onSaveChanged={this.onclick_save_add_selected_items}
          f_onCancel={this.onclick_cancel}
        />
      );
    }

    //floating box always shows button, input in floating box drawn when adding
    if(editInFloatingBoxTF) {
      return(
        <div className="displayFlexColumnHcVc">
          {buttonComponent}
          {inputWithSaveCancelComponent}
        </div>
      );
    }

    //inline edit with instructions above when adding
    if(s_isAddingTF) {
      return(
        <div className="medFullPad bgCaptureItemEditing">
          {(p_addInstructions !== undefined) &&
            <div
              className="smallBottomMargin textCenter"
              title={((p_addInstructionsNowrapTF) ? (p_addInstructions) : (undefined))}>
              {(p_addInstructionsNowrapTF) ? (
                <LibraryReact.NowrapEllipsis p_fontClass="fontBold fontItalic">
                  {p_addInstructions}
                </LibraryReact.NowrapEllipsis>
              ) : (
                <font className="fontBold fontItalic">
                  {p_addInstructions}
                </font>
              )}
            </div>
          }
          {inputWithSaveCancelComponent}
        </div>
      );
    }

    //inline edit before adding, just the button
    return(
      <div className="displayFlexColumnHcVc">
        {buttonComponent}
      </div>
    );
  }
}));



//=========================================================================================================================================================
//Components that access each of the individual input types based on fieldInputType (A Master Component that picks from: 1. Generic Inputs And Selects, 2. Contact Persons and Companies, 3. Shared Percents [owners and reasons won/lost where total share must add up to 100% before saving])
//=========================================================================================================================================================
function CaptureExecInputInlineOrFloatingWithSaveCancel(props) { //props: 
  //p_fieldDisplayName, p_fieldTypeObj, p_valueRaw, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray, p_contactsZoomedCompanyID, p_selectInitOptionsBoxOpenTF, p_fieldValueVerticallyAlignedTF, p_editInFloatingBoxTF, p_floatingBoxTitle, p_initialValueIsBlankValueTF, p_forceSaveCallEvenIfValueNotChangedTF, 
  //f_onSaveChanged, f_onCancel
  
  const p_fieldDisplayName = props.p_fieldDisplayName; //only used for scored_text/scored_textarea for deal shaping questions to rewrite the question above the inputs
  const p_fieldTypeObj = props.p_fieldTypeObj;
  const p_valueRaw = props.p_valueRaw;
  const p_valuesToOnlyIncludeArray = props.p_valuesToOnlyIncludeArray;
  const p_valuesToNotIncludeArray = props.p_valuesToNotIncludeArray;
  const p_contactsZoomedCompanyID = props.p_contactsZoomedCompanyID;
  const p_selectInitOptionsBoxOpenTF = props.p_selectInitOptionsBoxOpenTF;
  const p_fieldValueVerticallyAlignedTF = props.p_fieldValueVerticallyAlignedTF;
  const p_editInFloatingBoxTF = props.p_editInFloatingBoxTF;
  const p_floatingBoxTitle = props.p_floatingBoxTitle;
  const p_initialValueIsBlankValueTF = props.p_initialValueIsBlankValueTF; //only true when using an Add Button setup so that saving the initial value actually fires the onSaveChanged function
  const p_forceSaveCallEvenIfValueNotChangedTF = props.p_forceSaveCallEvenIfValueNotChangedTF;

  //select from contacts system floating box (but not a contacts sharedpercent)
  if((p_fieldTypeObj.selectContactCompanyTF || p_fieldTypeObj.selectContactPersonTF) && !p_fieldTypeObj.sharedPercentTF) {
    return(
      <SelectOrSelectMultiContactsFloatingBoxFromFieldTypeObj
        p_fieldTypeObj={p_fieldTypeObj}
        p_valueRaw={p_valueRaw}
        p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
        p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
        p_contactsZoomedCompanyID={p_contactsZoomedCompanyID}
        p_floatingBoxTitle={p_floatingBoxTitle}
        f_onSaveChanged={props.f_onSaveChanged}
        f_onCancel={props.f_onCancel}
      />
    );
  }

  //separate scored text/textarea components for deal shaping text answers, separate with their own save/cancel to prevent save when incomplete with error message
  if(p_fieldTypeObj.scoredTextTF || p_fieldTypeObj.scoredTextareaTF) {
    return(
      <TextWithScoreInlineOrFloatingWithSaveCancel
        p_textTrueTextareaFalse={p_fieldTypeObj.scoredTextTF}
        p_includeScoringTF={p_fieldTypeObj.scoredTextOrTextareaIncludeScoringTF}
        p_fieldDisplayName={p_fieldDisplayName}
        p_textareaScore0to100Obj={p_valueRaw}
        p_editInFloatingBoxTF={p_editInFloatingBoxTF}
        p_floatingBoxTitle={p_floatingBoxTitle}
        f_onSaveChanged={props.f_onSaveChanged}
        f_onCancel={props.f_onCancel}
      />
    );
  }

  return(
    <GenericInputOrSelectInlineOrFloatingWithSaveCancel
      p_fieldTypeObj={p_fieldTypeObj}
      p_valueRaw={p_valueRaw}
      p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
      p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
      p_selectInitOptionsBoxOpenTF={p_selectInitOptionsBoxOpenTF}
      p_fieldValueVerticallyAlignedTF={p_fieldValueVerticallyAlignedTF}
      p_editInFloatingBoxTF={p_editInFloatingBoxTF}
      p_floatingBoxTitle={p_floatingBoxTitle}
      p_initialValueIsBlankValueTF={p_initialValueIsBlankValueTF}
      p_forceSaveCallEvenIfValueNotChangedTF={p_forceSaveCallEvenIfValueNotChangedTF}
      f_onSaveChanged={props.f_onSaveChanged}
      f_onCancel={props.f_onCancel}
    />
  );
}



export function SelectOrSelectMultiContactsFloatingBoxFromFieldTypeObj(props) {
  //p_fieldTypeObj, p_valueRaw, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray, p_contactsZoomedCompanyID, p_floatingBoxTitle, f_onSaveChanged, f_onCancel
  const p_fieldTypeObj = props.p_fieldTypeObj;
  const p_valueRaw = props.p_valueRaw;
  const p_valuesToOnlyIncludeArray = props.p_valuesToOnlyIncludeArray;
  const p_valuesToNotIncludeArray = props.p_valuesToNotIncludeArray;
  const p_contactsZoomedCompanyID = props.p_contactsZoomedCompanyID;
  const p_floatingBoxTitle = props.p_floatingBoxTitle;
 
  var isPersonTF = false;
  var isMultiSelectTF = false;
  if(p_fieldTypeObj !== undefined) {
    isPersonTF = (!(p_fieldTypeObj.selectContactCompanyTF === true));
    if(p_fieldTypeObj.selectWithSearchDataObj !== undefined) {
      isMultiSelectTF = p_fieldTypeObj.selectWithSearchDataObj.isMultiSelectTF;
    }
  }

  //determine select mode
  var contactsSelectMode = undefined;
  if(isPersonTF) {
    contactsSelectMode = ((isMultiSelectTF) ? ("selectmulti_contact_persons") : ("select_contact_person"));
  }
  else {
    contactsSelectMode = ((isMultiSelectTF) ? ("selectmulti_contact_companies") : ("select_contact_company"));
  }

  //if at least 1 contact is selected in p_valueRaw, set it to be initialized as open on the right side in the contact system
  var initialOpenContactID = undefined;
  if(isMultiSelectTF) {
    if(JSFUNC.selectmulti_is_filled_out_tf(p_valueRaw)) {
      const selectedContactIDsArray = JSFUNC.convert_comma_list_to_int_array(p_valueRaw);
      if(selectedContactIDsArray.length > 0) {
        initialOpenContactID = selectedContactIDsArray[0]; //use the first contact selected in the multiselect
      }
    }
  }
  else {
    if(JSFUNC.select_int_is_filled_out_tf(p_valueRaw)) {
      initialOpenContactID = p_valueRaw;
    }
  }

  return(
    <ContactsReact.SelectOrSelectMultiContactsFloatingBox
      p_selectMode={contactsSelectMode}
      p_selectedContactIDOrContactIDsComma={p_valueRaw}
      p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
      p_contactIDsAlreadyAddedArray={p_valuesToNotIncludeArray}
      p_title={p_floatingBoxTitle}
      p_openContactIsPersonTF={isPersonTF}
      p_openContactID={initialOpenContactID}
      p_initialZoomedCompanyID={p_contactsZoomedCompanyID}
      f_onSaveChanged={props.f_onSaveChanged}
      f_onCancel={props.f_onCancel}
    />
  );
}





const TextWithScoreInlineOrFloatingWithSaveCancel = inject("CaptureExecMobx")(observer(
class TextWithScoreInlineOrFloatingWithSaveCancel extends Component { //props: p_textTrueTextareaFalse, p_includeScoringTF, p_fieldDisplayName, p_textareaScore0to100Obj, p_editInFloatingBoxTF, p_floatingBoxTitle, f_onSaveChanged, f_onCancel
  constructor(props) {
    super(props);

    this.state = {
      s_initialRawValueObj: this.props.p_textareaScore0to100Obj,
      s_currentRawValueObj: this.props.p_textareaScore0to100Obj
    };
  }

  onselect_option = (i_newValue) => {
    this.setState({s_currentValue: i_newValue});
  }

  onchange_text = (i_newValue) => {
    this.setState({
      s_currentRawValueObj: {textarea:i_newValue, score0to100:this.state.s_currentRawValueObj.score0to100}
    });
  }

  onchange_score = (i_newValue) => {
    const newScoreInt = Math.round(i_newValue);
    this.setState({
      s_currentRawValueObj: {textarea:this.state.s_currentRawValueObj.textarea, score0to100:newScoreInt}
    });
  }

  onclick_save_icon = () => {
    const iObj = this.state.s_initialRawValueObj;
    const cObj = this.state.s_currentRawValueObj;
    const [textErrorTF, scoreErrorTF, redTextWarningMessage] = this.check_text_and_score_for_errors(cObj);
    if(!textErrorTF && !scoreErrorTF) { //only save with no red text errors, otherwise do not send the onSaveChanged or onCancel
      if(JSFUNC.is_function(this.props.f_onSaveChanged) && ((iObj.textarea !== cObj.textarea) || (iObj.score0to100 !== cObj.score0to100))) { //save if either text or score changed
        this.props.f_onSaveChanged(cObj);
      }
      else if(JSFUNC.is_function(this.props.f_onCancel)) {
        this.props.f_onCancel();
      }
    }
  }

  check_text_and_score_for_errors(i_textareaScore0to100Obj) {
    const p_includeScoringTF = JSFUNC.prop_value(this.props.p_includeScoringTF, true);

    var textErrorTF = false;
    var scoreErrorTF = false
    var redTextWarningMessage = undefined;

    //check score/text for errors (only if score is included, no need to check otherwise)
    if(p_includeScoringTF) {
      const text = i_textareaScore0to100Obj.textarea;
      const score0to100 = i_textareaScore0to100Obj.score0to100;

      if((score0to100 <= 0) && JSFUNC.text_or_number_is_filled_out_tf(text)) { //can't save a scored textarea that has something typed if the percent score is 0%, shows an error and highlights the input range slider
        redTextWarningMessage = "Any entered answer must be scored higher than 0%";
        scoreErrorTF = true;
      }
      else if((score0to100 > 0) && !JSFUNC.text_or_number_is_filled_out_tf(text)) { //can't save if scored textarea has no text and a score > 0%
        redTextWarningMessage = "A blank answer cannot be saved with a score higher than 0%";
        textErrorTF = true;
      }
    }

    return([textErrorTF, scoreErrorTF, redTextWarningMessage]);
  }

  render() {
    const s_initialRawValueObj = this.state.s_initialRawValueObj;
    const s_currentRawValueObj = this.state.s_currentRawValueObj;

    const p_textTrueTextareaFalse = JSFUNC.prop_value(this.props.p_textTrueTextareaFalse, false);
    const p_includeScoringTF = JSFUNC.prop_value(this.props.p_includeScoringTF, true);
    const p_fieldDisplayName = this.props.p_fieldDisplayName;
    const p_editInFloatingBoxTF = this.props.p_editInFloatingBoxTF;
    const p_floatingBoxTitle = this.props.p_floatingBoxTitle;

    const answerIsChangedTF = ((s_initialRawValueObj.textarea !== s_currentRawValueObj.textarea) || (s_initialRawValueObj.score0to100 !== s_currentRawValueObj.score0to100));
    const cancelConfirmationMessage = ((answerIsChangedTF) ? ("Are you sure you want to cancel editing this Deal Shaping Question? Any entered data will be lost.") : (undefined));

    //verify input is in correct obj format
    var errorMessage = undefined;
    if(!JSFUNC.is_obj(s_currentRawValueObj)) {
      errorMessage = "s_currentRawValueObj is not an obj (" + JSFUNC.print(s_currentRawValueObj) + ")";
    }
    else if(!s_currentRawValueObj.hasOwnProperty("textarea") || !s_currentRawValueObj.hasOwnProperty("score0to100")) {
      errorMessage = "s_currentRawValueObj does not contain 'textarea' and 'score0to100' (" + JSFUNC.print(s_currentRawValueObj) + ")";
    }

    if(errorMessage !== undefined) {
      const jsDescription = JSFUNC.js_description_from_action("Inputs - TextWithScoreInlineOrFloatingWithSaveCancel", "render", [], []);
      JSPHP.record_z_error(jsDescription, errorMessage);
      return(
        <EditInlineWithSaveCancel f_onClickSave={this.props.f_onCancel} f_onClickCancel={this.props.f_onCancel}>
          <font className="fontItalic fontTextLighter">
            {errorMessage}
          </font>
        </EditInlineWithSaveCancel>
      );
    }

    //draw the score and text input components
    const text = s_currentRawValueObj.textarea;
    const score0to100 = s_currentRawValueObj.score0to100;

    const [textErrorTF, scoreErrorTF, redTextWarningMessage] = this.check_text_and_score_for_errors(s_currentRawValueObj);

    //input score0to100 range component
    var scoreRangeInputComponent = null;
    if(p_includeScoringTF) {
      scoreRangeInputComponent = (
        <div className="flex00a smallBottomMargin">
          <div className="displayFlexRowVc flexWrap">
            <div className="flex00a smallRightMargin" style={{flexBasis:"20em"}}>
              <LibraryReact.RangeWithPercentInt0to100
                p_value={score0to100}
                p_tabIndex={2}
                p_errorTF={scoreErrorTF}
                f_onChange={this.onchange_score}
              />
            </div>
            <div className="flex11a fontItalic fontTextLighter">
              {"Self-assessed completeness score (0-100%) for this answer"}
            </div>
          </div>
          {(textErrorTF || scoreErrorTF) && (
            <div className="microTopMargin">
              <font className="fontItalic font09 fontRed">
                {redTextWarningMessage}
              </font>
            </div>
          )}
        </div>
      );
    }

    //input text/textarea component
    var inputTextTextareaComponent = null;
    if(p_textTrueTextareaFalse) {
      inputTextTextareaComponent = (
        <LibraryReact.Text
          p_value={text}
          p_styleObj={{width:"100%"}}
          p_tabIndex={1}
          p_errorTF={textErrorTF}
          f_onChange={this.onchange_text}
          f_onKeyDownEnter={this.onclick_save_icon}
        />
      );
    }
    else {
      inputTextTextareaComponent = (
        <LibraryReact.Textarea
          p_value={text}
          p_class="flex11a"
          p_tabIndex={1}
          p_errorTF={textErrorTF}
          f_onChange={this.onchange_text}
        />
      );
    }


    if(p_editInFloatingBoxTF) { //textareas launch a full screen edit with save/close in the upper right corner
      return(
        <FloatingBoxWithSaveCancel
          p_title={p_floatingBoxTitle}
          p_cancelConfirmationMessage={cancelConfirmationMessage}
          f_onClickSave={this.onclick_save_icon}
          f_onClickCancel={this.props.f_onCancel}>
          <div className="flex11a displayFlexColumn lrMedMargin medBottomMargin">
            <div className="flex00a smallTopMargin smallBottomMargin">
              <div className="font11 fontBlue">
                {p_fieldDisplayName}
              </div>
            </div>
            {scoreRangeInputComponent}
            {inputTextTextareaComponent}
          </div>
        </FloatingBoxWithSaveCancel>
      );
    }

    //text is inline (unless the screen is mobile, then it is placed in a floating box)
    return(
      <EditInlineWithSaveCancel
        p_cancelConfirmationMessage={cancelConfirmationMessage}
        f_onClickSave={this.onclick_save_icon}
        f_onClickCancel={this.props.f_onCancel}>
        {scoreRangeInputComponent}
        <div className="flex11a displayFlexColumn">
          {inputTextTextareaComponent}
        </div>
      </EditInlineWithSaveCancel>
    );
  }
}));







class GenericInputOrSelectInlineOrFloatingWithSaveCancel extends Component { //props:
  //p_fieldTypeObj, p_valueRaw, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray, p_selectInitOptionsBoxOpenTF, p_fieldValueVerticallyAlignedTF, p_editInFloatingBoxTF, p_floatingBoxTitle, p_initialValueIsBlankValueTF, p_forceSaveCallEvenIfValueNotChangedTF, 
  //f_onSaveChanged, f_onCancel
  constructor(props) {
    super(props);

    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valueRaw = this.props.p_valueRaw;
    const p_initialValueIsBlankValueTF = JSFUNC.prop_value(this.props.p_initialValueIsBlankValueTF, false); //add new item button requires the s_initialValueRaw to be undefined so that the first save operation (if the value is not changed from its initial value) actually calls onSaveChanged (otherwise the logic is to skip it if initial===current)

    //determine the initial valueRaw (different for sharedpercent)
    var initialRawValue = undefined;
    if(p_initialValueIsBlankValueTF) {
      initialRawValue = p_fieldTypeObj.blankValue;
    }
    else {
      initialRawValue = p_valueRaw;
      if(p_fieldTypeObj.sharedPercentTF) { //if the input is a sharedpercent, first sort the colon comma list by percent decreasing, the actual input interface does not change order while editing so that the items do not swap places while changing the valus
        initialRawValue = JSFUNC.sort_colon_comma_list(initialRawValue, 2, false);
      }
    }

    this.state = {
      s_initialValueRaw: initialRawValue,
      s_currentValueRaw: initialRawValue,
      s_triedFirstSaveTF: false
    };
  }

  onchange_value_or_onselect_option = (i_newValue) => {
    this.setState({s_currentValueRaw:i_newValue});
  }

  onclick_save_icon = () => {
    const s_initialValueRaw = this.state.s_initialValueRaw;
    const s_currentValueRaw = this.state.s_currentValueRaw;

    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_forceSaveCallEvenIfValueNotChangedTF = JSFUNC.prop_value(this.props.p_forceSaveCallEvenIfValueNotChangedTF, false);

    var allowSaveTF = true;
    if(p_fieldTypeObj.emailTF) { //if trying to save an email field, don't allow save if the email is not valid (even if the current value wasn't changed from the initial value)
      if(s_currentValueRaw !== "") { //allow completely blank field to be saved (even though that's not a valid email, user might not know it)
        const emailErrorMessage = JSFUNC.valid_email_address_undefined_or_invalid_email_error_message_string(s_currentValueRaw);
        allowSaveTF = (emailErrorMessage === undefined); //only allow saving if this filled in email field is a valid email
      }
    }
    else if(p_fieldTypeObj.sharedPercentTF) { //for a sharedpercent, save can only be pushed if the percents total 100%
      const sumOfCurrentSharedPercents = JSFUNC.sum_of_colon_comma_list_int2(s_currentValueRaw, 100, -1, 8);
      allowSaveTF = (sumOfCurrentSharedPercents === 100);
    }

    if(allowSaveTF) { //save if allowed to save
      if(p_forceSaveCallEvenIfValueNotChangedTF || (s_currentValueRaw !== s_initialValueRaw)) { //current value has changed (or forcing a save call even if the value was not changed from its initial value)
        this.call_onsave_with_current_value_raw();
      }
      else { //current value is still the initial value, no need to save data and can simply cancel (prevents unnecessary database updates with the same value)
        if(JSFUNC.is_function(this.props.f_onCancel)) {
          this.props.f_onCancel();
        }
      }
    }
    else { //if not allowed to save, set the flag that the user tried to save for the first time unsuccessfully to true
      this.setState({s_triedFirstSaveTF:true});
    }
  }

  call_onsave_with_current_value_raw = () => {
    //cancel button is optional for this component, save button always shows up because of this onclick_save_icon function, if the save function is not defined, the single save button acts like a cancel
    if(JSFUNC.is_function(this.props.f_onSaveChanged)) {
      this.props.f_onSaveChanged(this.state.s_currentValueRaw);
    }
    else if(JSFUNC.is_function(this.props.f_onCancel)) {
      this.props.f_onCancel();
    }
  }

  render() {
    const s_initialValueRaw = this.state.s_initialValueRaw;
    const s_currentValueRaw = this.state.s_currentValueRaw;
    const s_triedFirstSaveTF = this.state.s_triedFirstSaveTF;

    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valueRaw = this.props.p_valueRaw;
    const p_valuesToOnlyIncludeArray = this.props.p_valuesToOnlyIncludeArray;
    const p_valuesToNotIncludeArray = this.props.p_valuesToNotIncludeArray;
    const p_selectInitOptionsBoxOpenTF = this.props.p_selectInitOptionsBoxOpenTF;
    const p_fieldValueVerticallyAlignedTF = this.props.p_fieldValueVerticallyAlignedTF;
    const p_editInFloatingBoxTF = this.props.p_editInFloatingBoxTF;
    const p_floatingBoxTitle = this.props.p_floatingBoxTitle;
    const p_initialValueIsBlankValueTF = this.props.p_initialValueIsBlankValueTF;
    const p_forceSaveCallEvenIfValueNotChangedTF = JSFUNC.prop_value(this.props.p_forceSaveCallEvenIfValueNotChangedTF, false);

    if(p_fieldTypeObj === undefined) {
      return("--GenericInputOrSelectInlineOrFloatingWithSaveCancel p_fieldTypeObj is undefined (s_currentValueRaw: " + s_currentValueRaw + ")--")
    }

    var inputErrorMessage = undefined;
    if(s_triedFirstSaveTF) {
      if(p_fieldTypeObj.emailTF && JSFUNC.string_is_filled_out_tf(s_currentValueRaw)) {
        inputErrorMessage = JSFUNC.valid_email_address_undefined_or_invalid_email_error_message_string(s_currentValueRaw);
      }
    }

    var cancelConfirmationMessage = undefined;
    if(s_initialValueRaw !== s_currentValueRaw) { //if the current value is different from the initial value
      cancelConfirmationMessage = "Are you sure you want to cancel editing this field? Any entered data will be lost.";
    }

    const inputComponent = (
      <>
        <GenericInputOrSelectFromInputType
          p_fieldTypeObj={p_fieldTypeObj}
          p_valueRaw={s_currentValueRaw}
          p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
          p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
          p_selectInitOptionsBoxOpenTF={p_selectInitOptionsBoxOpenTF}
          p_selectedDisplayFocusOnKeyDownEnterOpensSelectTF={true}
          p_forceTextareaToTextTF={false}
          p_tabIndex={1}
          p_title={undefined}
          p_errorTF={(inputErrorMessage !== undefined)}
          f_onChangeOrOnSelect={this.onchange_value_or_onselect_option}
          f_onKeyDownEnter={this.onclick_save_icon}
        />
        {(inputErrorMessage !== undefined) &&
          <ErrorText
            p_class="microTopMargin"
            p_text={inputErrorMessage}
          />
        }
      </>
    );

    //floating box save/cancel is a position fixed fullscreen no click area with a position fixed smaller centered box on top
    if(p_editInFloatingBoxTF) { //textareas launch a full screen edit with save/close in the upper right corner
      return(
        <FloatingBoxWithSaveCancel
          p_trblFlag="textareaEdit"
          p_title={p_floatingBoxTitle}
          p_cancelConfirmationMessage={cancelConfirmationMessage}
          f_onClickSave={this.onclick_save_icon}
          f_onClickCancel={this.props.f_onCancel}>
          <div className="flex11a displayFlexColumn lrMedMargin medBottomMargin medTopMargin">
            {inputComponent}
          </div>
        </FloatingBoxWithSaveCancel>
      );
    }

    //inline save/cancel component is a div with flex11a
    return(
      <EditInlineWithSaveCancel
        p_fieldValueVerticallyAlignedTF={p_fieldValueVerticallyAlignedTF}
        p_cancelConfirmationMessage={cancelConfirmationMessage}
        f_onClickSave={this.onclick_save_icon}
        f_onClickCancel={this.props.f_onCancel}>
        {inputComponent}
      </EditInlineWithSaveCancel>
    );
  }
}






export function GenericInputOrSelectFromInputType(props) { //props:
  //p_fieldTypeObj, p_valueRaw, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray, p_selectDisplayMaskOverwrite, p_selectInitOptionsBoxOpenTF, p_selectedDisplayFocusOnKeyDownEnterOpensSelectTF, p_forceTextareaToTextTF, 
  //p_tabIndex, p_title, p_errorTF, p_focusTF
  //f_onChangeOrOnSelect, f_onKeyDownEnter
  const p_fieldTypeObj = props.p_fieldTypeObj;
  const p_valueRaw = props.p_valueRaw;
  const p_valuesToOnlyIncludeArray = props.p_valuesToOnlyIncludeArray;
  const p_valuesToNotIncludeArray = props.p_valuesToNotIncludeArray;
  const p_selectDisplayMaskOverwrite = props.p_selectDisplayMaskOverwrite;
  const p_selectInitOptionsBoxOpenTF = props.p_selectInitOptionsBoxOpenTF;
  const p_selectSelectedDisplayFocusOnKeyDownEnterOpensSelectTF = props.p_selectedDisplayFocusOnKeyDownEnterOpensSelectTF;
  const p_forceTextareaToTextTF = JSFUNC.prop_value(props.p_forceTextareaToTextTF, false);
  const p_tabIndex = props.p_tabIndex;
  const p_title = props.p_title;
  const p_errorTF = props.p_errorTF;
  const p_focusTF = props.p_focusTF;

  if(p_fieldTypeObj === undefined) {
    return("--GenericInputOrSelectFromInputType p_fieldTypeObj is undefined (valueRaw: " + p_valueRaw + ")--")
  }
  else if(p_fieldTypeObj.textTF || p_fieldTypeObj.emailTF || p_fieldTypeObj.phoneTF || (p_forceTextareaToTextTF && p_fieldTypeObj.textareaTF)) {
    return(
      <LibraryReact.Text
        p_value={p_valueRaw}
        p_isPasswordTF={false}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_placeholder={undefined}
        p_autocompleteName={undefined}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.textareaTF) {
    return(
      <LibraryReact.Textarea
        p_value={p_valueRaw}
        p_class="flex11a" //requires the container div to be displayFlexColumn class to stretch this textarea to 100% height
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_placeholder={undefined}
        p_autocompleteName={undefined}
        p_errorTF={p_errorTF}
        p_focusTF={p_focusTF}
        f_onChange={props.f_onChangeOrOnSelect}
      />
    );
  }
  else if(p_fieldTypeObj.intTF) {
    var min = undefined;
    var max = undefined;
    if(p_fieldTypeObj.editNumberOnly0to9TF) {
      min = 0;
      max = 9;
    }
    else {
      min = ((p_fieldTypeObj.editNumberOnlyPositiveTF) ? (0) : (-1 * JSFUNC.sort_max_mysqli_bigint()));
      max = JSFUNC.sort_max_mysqli_bigint();
    }

    return(
      <LibraryReact.Integer
        p_value={p_valueRaw}
        p_min={min}
        p_max={max}
        p_numZeroPad={undefined}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_placeholder={undefined}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.decimalTF) {
    const minValue = ((p_fieldTypeObj.editNumberOnlyPositiveTF) ? (0) : (-1 * JSFUNC.sort_max_mysqli_decimal_18_9()));
    const maxValue = JSFUNC.sort_max_mysqli_decimal_18_9();
    return(
      <LibraryReact.Decimal
        p_value={p_valueRaw}
        p_min={minValue}
        p_max={maxValue}
        p_blankValue={undefined}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.percentTF) {
    const decimalsTF = p_fieldTypeObj.editPercentHasDecimalsTF;
    const intDecimalMaxValue = ((decimalsTF) ? (JSFUNC.sort_max_mysqli_decimal_18_9()) : (JSFUNC.sort_max_mysqli_bigint()));

    var min = undefined;
    var max = undefined;
    var blankValue = undefined;
    if(p_fieldTypeObj.editNumberOnly0to100TF) {
      min = 0;
      max = 100;
      blankValue = 0; //percent_int_0to100 and percent_decimal_0to100 force a number to be typed, cannot be blank
    }
    else if(p_fieldTypeObj.editNumberOnlym1000to100TF) {
      min = -1000;
      max = 100;
      blankValue = 0;
    }
    else {
      min = (-1 * intDecimalMaxValue);
      max = intDecimalMaxValue;
      blankValue = undefined;
    }

    return(
      <LibraryReact.Percent
        p_value={p_valueRaw}
        p_min={min}
        p_max={max}
        p_decimalsTF={decimalsTF}
        p_blankValue={blankValue}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.moneyTF) {
    const includeCentsTF = p_fieldTypeObj.moneyIncludeCentsTF;
    return(
      <LibraryReact.Money
        p_value={p_valueRaw}
        p_centsTF={includeCentsTF}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_placeholder={undefined}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.websiteTF) {
    return(
      <LibraryReact.Website
        p_value={p_valueRaw}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.colorTF) {
    return(
      <LibraryReact.Color
        p_value={p_valueRaw}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.colorWithNoneOptionTF) {
    return(
      <InputColorWithNoneOption
        p_value={p_valueRaw}
        p_class={undefined}
        p_styleObj={{width:"100%"}}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.dateTF) {
    return(
      <LibraryReact.Date
        p_value={p_valueRaw}
        p_class={undefined}
        p_styleObj={undefined}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.dateLocalFromRawDateTimeUtcTF) {
    return(
      <InputDateLocalFromRawDateTimeUtc
        p_value={p_valueRaw}
        p_tabIndex={p_tabIndex}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.dateWithRelativeDateTF) {
    return(
      <InputDateWithRelativeDate
        p_value={p_valueRaw}
        p_tabIndex={p_tabIndex}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.dateWithDurationTF) {
    return(
      <InputDateWithDuration
        p_value={p_valueRaw}
        p_tabIndex={p_tabIndex}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.dateTimeTF) {
    return(
      <LibraryReact.DateTime
        p_valueDateTimeUTC={p_valueRaw}
        p_isSingleLineTF={false}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.startAndEndDateTimesWithDurationTF) {
    return(
      <InputStartDateTimeAndEndDateTimeWithDurationSelect
        p_value={p_valueRaw}
        p_tabIndex={p_tabIndex}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
      />
    );
  }
  else if(p_fieldTypeObj.startAndEndDatesWithYearsDurationTF) {
    return(
      <InputStartDateAndEndDateWithYearsDurationSelect
        p_value={p_valueRaw}
        p_tabIndex={p_tabIndex}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.selectTF) {
    return(
      <InputSelectFromFieldTypeObj
        p_fieldTypeObj={p_fieldTypeObj}
        p_valueRaw={p_valueRaw}
        p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
        p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
        p_selectDisplayMaskOverwrite={p_selectDisplayMaskOverwrite}
        p_selectInitOptionsBoxOpenTF={p_selectInitOptionsBoxOpenTF}
        p_selectSelectedDisplayFocusOnKeyDownEnterOpensSelectTF={p_selectSelectedDisplayFocusOnKeyDownEnterOpensSelectTF}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onSelect={props.f_onChangeOrOnSelect}
        f_onKeyDownEnterWhenSelectIsClosed={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.sharedPercentTF) {
    return(
      <InputSharedPercentWithMultiSelectAddItems
        p_fieldTypeObj={p_fieldTypeObj}
        p_valueRaw={p_valueRaw}
        p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
        p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
        p_forceSaveCallEvenIfValueNotChangedTF={false}
        p_tabIndex={p_tabIndex}
        p_errorTF={p_errorTF}
        f_onChange={props.f_onChangeOrOnSelect}
      />
    );
  }
  else if(p_fieldTypeObj.verticalSwitchTF) {
    var verticalSwitchValueArray = [];
    var verticalSwitchDisplayArray = [];
    var verticalSwitchRowHeightEm = 1.7;
    if(p_fieldTypeObj.selectWithSearchDataObj !== undefined) {
      if(JSFUNC.is_array(p_fieldTypeObj.selectWithSearchDataObj.valueArray) && JSFUNC.is_array(p_fieldTypeObj.selectWithSearchDataObj.displayArray)) {
        verticalSwitchValueArray = p_fieldTypeObj.selectWithSearchDataObj.valueArray;
        verticalSwitchDisplayArray = p_fieldTypeObj.selectWithSearchDataObj.displayArray;
        if(JSFUNC.is_number_not_nan_gt_0(p_fieldTypeObj.selectWithSearchDataObj.optionsHeightEm)) {
          verticalSwitchRowHeightEm = Math.max(p_fieldTypeObj.selectWithSearchDataObj.optionsHeightEm, 1.7);
        }
      }
    }

    return(
      <VerticalSwitch
        p_valueArray={verticalSwitchValueArray}
        p_displayArray={verticalSwitchDisplayArray}
        p_switchToMessageArray={undefined}
        p_switchToMessageButtonNamesArray={undefined}
        p_selectedValue={p_valueRaw}
        p_rowHeightEm={verticalSwitchRowHeightEm}
        p_sizeMultiplier={undefined}
        p_onColor={undefined}
        p_offColor={undefined}
        p_onTextFontClass={undefined}
        p_offTextFontClass={undefined}
        p_tabIndex={p_tabIndex}
        f_onSelect={props.f_onChangeOrOnSelect}
        f_onKeyDownEnter={props.f_onKeyDownEnter}
      />
    );
  }
  else if(p_fieldTypeObj.captureFavoritesTF) {
    return(
      <InputCaptureFavorite
        p_favoriteTF={p_valueRaw}
        p_standardSizeTrueCSTCellSizeFalse={true}
        f_onClick={props.f_onChangeOrOnSelect}
      />
    );
  }
  else if(p_fieldTypeObj.capturePriorityLevelTF) {
    return(
      <InputCapturePriorityLevel
        p_valueRaw={p_valueRaw}
        f_onSelect={props.f_onChangeOrOnSelect}
      />
    );
  }
  else if(p_fieldTypeObj.stylingStringTF) {
    return(
      <InputStylingStringOptions
        p_fieldTypeObj={p_fieldTypeObj}
        p_valueRaw={p_valueRaw}
        p_tabIndex={p_tabIndex}
        f_onChange={props.f_onChangeOrOnSelect}
      />
    );
  }

  return(
    <div>
      {"--Invalid Input Type: " + p_fieldTypeObj.fieldInputType + " (p_valueRaw: " + p_valueRaw + ")--"}
    </div>
  );
}





const InputSelectFromFieldTypeObj = inject("CaptureExecMobx", "DatabaseMobx")(observer(
class InputSelectFromFieldTypeObj extends Component { //props: p_fieldTypeObj, p_valueRaw, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray, p_selectDisplayMaskOverwrite, p_selectInitOptionsBoxOpenTF, p_selectSelectedDisplayFocusOnKeyDownEnterOpensSelectTF, p_tabIndex, p_title, p_errorTF, f_onSelect, f_onKeyDownEnterWhenSelectIsClosed
  onadd_new_admin_table_entry = (i_newEntryName) => {
    //manually determine which tbl to update
    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valueRaw = this.props.p_valueRaw;

    const selectWithSearchDataObj = p_fieldTypeObj.selectWithSearchDataObj;
    const isMultiSelectTF = selectWithSearchDataObj.isMultiSelectTF;
    const selectAddTblName = selectWithSearchDataObj.selectAddTblName;
    const selectAddNameFieldDbName = selectWithSearchDataObj.selectAddNameFieldDbName;
    const selectAddSortFieldDbName = selectWithSearchDataObj.selectAddSortFieldDbName; //undefined means there's no sort column

    //insert a new entry in that table (only inserts name field, thus id is auto increment and sort will be 0)
    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - InputSelectFromFieldTypeObj", "onadd_new_admin_table_entry", ["i_newEntryName"], [i_newEntryName]);
    const C_CallPhpTblUIDInsertFfsRecord = new JSPHP.ClassCallPhpTblUID(jsDescription);

    var fieldNamesArray = [selectAddNameFieldDbName];
    var valuesArray = [i_newEntryName];
    var idsbArray = ["s"];
    var resortSortColumnName = undefined;
    var resortFilterFieldNameOrFieldNamesArray = undefined;
    var resortFilterValueOrValuesArray = undefined;
    if(JSFUNC.is_string(selectAddSortFieldDbName)) {
      fieldNamesArray.push(selectAddSortFieldDbName);
      valuesArray.push(JSFUNC.sort_max_mysqli_int());
      idsbArray.push("i");
      resortSortColumnName = selectAddSortFieldDbName;
      resortFilterFieldNameOrFieldNamesArray = [];
      resortFilterValueOrValuesArray = [];
    }
    C_CallPhpTblUIDInsertFfsRecord.add_insert(selectAddTblName, fieldNamesArray, valuesArray, idsbArray, resortSortColumnName, resortFilterFieldNameOrFieldNamesArray, resortFilterValueOrValuesArray);

    const functionOnSuccess = (i_parseResponse) => {
      const newlyInsertedEntryID = i_parseResponse.outputObj.i0;
      if(JSFUNC.is_function(this.props.f_onSelect)) {
        //if this is a multiselect, merge the newly created id with the ids that were previously selected as a comma list
        var selectedIDOrIDsComma = undefined;
        if(isMultiSelectTF) { //merge the new id into the comma list of already selected ids
          selectedIDOrIDsComma = JSFUNC.add_value_to_comma_list(newlyInsertedEntryID, p_valueRaw);
        }
        else { //single select type, choose the single new itemID as an int to pass as selected output
          selectedIDOrIDsComma = newlyInsertedEntryID;
        }

        this.props.f_onSelect(selectedIDOrIDsComma);
      }
    }
    C_CallPhpTblUIDInsertFfsRecord.add_function("onSuccess", functionOnSuccess);

    C_CallPhpTblUIDInsertFfsRecord.execute();
  }

  onclick_multiselect_all_or_select_switch = () => {
    const p_valueRaw = this.props.p_valueRaw;

    if(JSFUNC.is_function(this.props.f_onSelect)) {
      var updatedSelectedIDsCommaOrAllString = "";
      if(p_valueRaw !== "all") {
        updatedSelectedIDsCommaOrAllString = "all";
      }

      this.props.f_onSelect(updatedSelectedIDsCommaOrAllString);
    }
  }

  render() {
    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valueRaw = this.props.p_valueRaw;
    const p_valuesToOnlyIncludeArray = this.props.p_valuesToOnlyIncludeArray;
    const p_valuesToNotIncludeArray = this.props.p_valuesToNotIncludeArray;
    const p_selectDisplayMaskOverwrite = this.props.p_selectDisplayMaskOverwrite;
    const p_selectInitOptionsBoxOpenTF = this.props.p_selectInitOptionsBoxOpenTF;
    const p_selectSelectedDisplayFocusOnKeyDownEnterOpensSelectTF = this.props.p_selectSelectedDisplayFocusOnKeyDownEnterOpensSelectTF;
    const p_tabIndex = this.props.p_tabIndex;
    const p_title = this.props.p_title;
    const p_errorTF = this.props.p_errorTF;

    const c_isMobileTF = this.props.CaptureExecMobx.c_isMobileTF;

    const selectWithSearchDataObj = p_fieldTypeObj.selectWithSearchDataObj;

    var valueMaskPlainText = "";
    if(p_selectDisplayMaskOverwrite !== undefined) {
      valueMaskPlainText = p_selectDisplayMaskOverwrite;
    }
    else { //masking for selects uses the swsDataObj unselectedDisplay when the p_valueRaw is not found in the valueArray
      const valueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(p_valueRaw, p_fieldTypeObj);
      if(valueMaskSortIfoObj.isFilledOutTF) { //when the select has a valid option selected, use the valueMaskPlainText (so that clickable links for html buttons/progress are not drawn in the display of the Select)
        valueMaskPlainText = valueMaskSortIfoObj.valueMaskPlainText;
      }
      else { //if the Select is not filled out, display the valueMask italic/gray text (usually has the text '--No [Item] Selected--')
        valueMaskPlainText = valueMaskSortIfoObj.valueMask;
      }
    }

    const canAddToAdminTableTF = (JSFUNC.is_string(selectWithSearchDataObj.selectAddTblName) && JSFUNC.is_string(selectWithSearchDataObj.selectAddNameFieldDbName));

    const selectComponent = (
      <LibraryReact.SelectWithSearch
        p_valueArray={selectWithSearchDataObj.valueArray}
        p_displayArray={selectWithSearchDataObj.displayArray}
        p_treeIDArray={selectWithSearchDataObj.treeIDArray}
        p_colorArray={selectWithSearchDataObj.colorArray}
        p_bgColorArray={selectWithSearchDataObj.bgColorArray}
        p_hiddenUnlessCheckedTFArray={selectWithSearchDataObj.hiddenUnlessCheckedTFArray}
        p_unableToHighlightOrClickTFArray={selectWithSearchDataObj.unableToHighlightOrClickTFArray}
        p_optionDisplayOverwriteStringsArray={selectWithSearchDataObj.optionDisplayOverwriteStringsArray}
        p_multiIDsCheckedWhenCheckedArrayOfArrays={selectWithSearchDataObj.multiIDsCheckedWhenCheckedArrayOfArrays}
        p_selectedValue={p_valueRaw}
        p_selectedDisplay={valueMaskPlainText}
        p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
        p_valuesToNotIncludeArray={p_valuesToNotIncludeArray}
        p_valuesAreStringsTF={selectWithSearchDataObj.valuesAreStringsTF}
        p_isMultiSelectTF={selectWithSearchDataObj.isMultiSelectTF}
        p_hasClearSelectionTF={selectWithSearchDataObj.hasClearSelectionTF}
        p_searchTF={selectWithSearchDataObj.hasSearchTF}
        p_initOptionsBoxOpenTF={p_selectInitOptionsBoxOpenTF}
        p_selectedDisplayFocusOnKeyDownEnterOpensSelectTF={p_selectSelectedDisplayFocusOnKeyDownEnterOpensSelectTF}
        p_optionsBoxForMobileTF={c_isMobileTF}
        p_width="100%" //this width 100% requires that the containing element for InputFromInputTypeAndDbName must be positionRelative so that the options list is also 100% width, otherwise options list is 100% width of the browser
        p_highlightColor={undefined}
        p_tabIndex={p_tabIndex}
        p_title={p_title}
        p_errorTF={p_errorTF}
        f_onOptionSelect={this.props.f_onSelect}
        f_onSaveNewEntryName={((canAddToAdminTableTF) ? (this.onadd_new_admin_table_entry) : (undefined))}
        f_onKeyDownEnterWhenSelectIsClosed={this.props.f_onKeyDownEnterWhenSelectIsClosed}
      />
    );

    //sws option 'multiSelectHasAllSwitchTF' can be set to true to put a switch ['All'/'Select'] to the left of the multiselect, when switched to the left, the raw value is "all", which code outside of this can use as a flag that all possible options are selected
    //(if picking CE divisions as an example, if the admin creates new divisions, they would be included if 'all' was selected here with the switch to the left. if ever division was checked off, then a new division was created by the admin, that new one wouldn't be included until this list was edited again with the new one also checked off)
    if(selectWithSearchDataObj.multiSelectHasAllSwitchTF) {
      const multiSelectAllSwitchAllFalseSelectCustomTrue = (p_valueRaw !== "all");

      var allSelectSwitchHoverText = "Use this 'All'/'Select' switch to change the mode of this selection:";
      allSelectSwitchHoverText += "\n" + " - All: system will automatically use all options in this list, even if the Admin adds more options in the future"
      allSelectSwitchHoverText += "\n" + " - Select: you can use the normal Select to manually select options in the list"

      return(
        <div className="flex11a displayFlexRowVc">
          <div
            className="flex00a displayFlexColumn cursorPointer"
            style={{marginRight:"0.4em"}}
            title={allSelectSwitchHoverText}
            onClick={this.onclick_multiselect_all_or_select_switch}>
            <div className="flex00a displayFlexColumnHcVc" style={{marginBottom:"0.05em"}}>
              <SwitchWithTextAndConfirmBox
                p_isOnTF={multiSelectAllSwitchAllFalseSelectCustomTrue}
                p_sizeEm={2.2}
                p_onColor="005da3"
                p_offColor="18305a"
              />
            </div>
            <div className="flex00a displayFlexColumnHcVc textCenter">
              <font className={"font08 fontBold " + ((multiSelectAllSwitchAllFalseSelectCustomTrue) ? ("fontBlue") : ("fontDarkBlue"))}>
                {((multiSelectAllSwitchAllFalseSelectCustomTrue) ? ("Select") : ("All"))}
              </font>
            </div>
          </div>
          <div className="flex11a">
            {((multiSelectAllSwitchAllFalseSelectCustomTrue) ? (
              selectComponent
            ) : (
              <font className="">
                {"[All " + selectWithSearchDataObj.itemName + " Options Selected]"}
              </font>
            ))}
          </div>
        </div>
      );
    }

    return(
      selectComponent
    );
  }
}));








const InputSharedPercentWithMultiSelectAddItems = inject("CaptureExecMobx", "DatabaseMobx")(observer(
class InputSharedPercentWithMultiSelectAddItems extends Component { //props: p_fieldTypeObj, p_valueRaw, p_valuesToOnlyIncludeArray, p_valuesToNotIncludeArray, p_forceSaveCallEvenIfValueNotChangedTF, p_tabIndex, p_errorTF, f_onChange
  //Multiple Items with Shared Percentage Input (Capture Owners [Team/Division], Reasons Won/Lost, Contacts [without percents])
  constructor(props) {
    super(props);
    this.state = {
      s_isAddingNewItemTF: false,
      s_selectingShortcutPresetTF: false,
      s_selectedShortcutPresetsCaptureManagerPresetID: undefined, //if turned on in Admin (System Setup - Shortcut Presets subtab), this is used to select and inject a preset of Users to be Capture Managers with a preset percentage split
    };
  }

  onclick_add_item = () => {
    this.setState({s_isAddingNewItemTF: true});
  }

  onclick_cancel_add_item = () => {
    this.setState({s_isAddingNewItemTF: false});
  }

  onclick_save_add_selected_new_items = (i_newItemIDsComma) => {
    const newItemIDsArray = JSFUNC.convert_comma_list_to_int_array(i_newItemIDsComma);
    const numNewItems = newItemIDsArray.length;
    const previously0SelectedItemsTF = (!JSFUNC.text_or_number_is_filled_out_tf(this.props.p_valueRaw)); //prior to inserting these new items, were there any selected items in the list
    const newItemPercentsArray = ((previously0SelectedItemsTF) ? (JSFUNC.array_of_equal_ints_add_up_to_100(numNewItems)) : (JSFUNC.array_fill(numNewItems, 0))); //if these are the first items being added, split their new percents equally to add up to 100, otherwise the new items are set to 0 when appending to an existing list
    const updatedIdPercentColonCommaList = JSFUNC.insert_values_into_colon_comma_list(this.props.p_valueRaw, newItemIDsArray, newItemPercentsArray);
    this.setState({s_isAddingNewItemTF:false});
    this.call_onchange_sharedpercent(updatedIdPercentColonCommaList);
  }

  onchange_item_percent = (i_itemID, i_newPercent0to100) => {
    const updatedIdPercentColonCommaList = JSFUNC.update_or_insert_value_into_colon_comma_list(this.props.p_valueRaw, i_itemID, i_newPercent0to100);
    this.call_onchange_sharedpercent(updatedIdPercentColonCommaList);

    //reset any selected shortcut preset when editing the sharedpercent items
    this.setState({s_selectedShortcutPresetsCaptureManagerPresetID:undefined});
  }

  onremove_item = (i_itemID) => {
    var updatedIdPercentColonCommaList = JSFUNC.remove_item_from_colon_comma_list_by_id(this.props.p_valueRaw, i_itemID);

    //if there is only 1 item remaining, force its percentage to 100%
    const updatedIdPercentArrayOfObjs = JSFUNC.convert_colon_comma_list_to_ints_arrayOfObjs(updatedIdPercentColonCommaList, "itemID", "percent0to100");
    if(updatedIdPercentArrayOfObjs.length === 1) {
      updatedIdPercentColonCommaList = JSFUNC.update_or_insert_value_into_colon_comma_list(updatedIdPercentColonCommaList, updatedIdPercentArrayOfObjs[0].itemID, 100);
    }

    this.call_onchange_sharedpercent(updatedIdPercentColonCommaList);

    //reset any selected shortcut preset when editing the sharedpercent items
    this.setState({s_selectedShortcutPresetsCaptureManagerPresetID:undefined});
  }

  onclick_open_shortcut_preset = () => {
    this.setState({s_selectingShortcutPresetTF:true});
  }

  onclick_close_shortcut_preset = () => {
    this.setState({s_selectingShortcutPresetTF:false});
  }

  onchange_shortcut_presets_capture_manager_preset = (i_selectedShortcutPresetCaptureManagerPresetID) => {
    var updatedCaptureManagersIDsColonPercentComma = ""; //reset field if preset select is cleared
    if(JSFUNC.select_int_is_filled_out_tf(i_selectedShortcutPresetCaptureManagerPresetID)) { //if a preset is selected, inject the preset colon comma value as the current Capture Manager value
      const selectedShortcutPresetCaptureManagerPresetMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_shortcut_presets_capture_managers", i_selectedShortcutPresetCaptureManagerPresetID);
      updatedCaptureManagersIDsColonPercentComma = selectedShortcutPresetCaptureManagerPresetMap.get("user_ids_colon_percents_comma");
    }

    this.setState({s_selectedShortcutPresetsCaptureManagerPresetID:i_selectedShortcutPresetCaptureManagerPresetID});
    this.call_onchange_sharedpercent(updatedCaptureManagersIDsColonPercentComma);
  }

  call_onchange_sharedpercent = (i_updatedIdPercentColonCommaList) => {
    if(JSFUNC.is_function(this.props.f_onChange)) {
      this.props.f_onChange(i_updatedIdPercentColonCommaList);
    }
  }

  render() {
    const s_isAddingNewItemTF = this.state.s_isAddingNewItemTF;
    const s_selectingShortcutPresetTF = this.state.s_selectingShortcutPresetTF;
    const s_selectedShortcutPresetsCaptureManagerPresetID = this.state.s_selectedShortcutPresetsCaptureManagerPresetID;

    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valueRaw = this.props.p_valueRaw;
    const p_valuesToOnlyIncludeArray = this.props.p_valuesToOnlyIncludeArray;
    const p_valuesToNotIncludeArray = this.props.p_valuesToNotIncludeArray;
    const p_forceSaveCallEvenIfValueNotChangedTF = this.props.p_forceSaveCallEvenIfValueNotChangedTF;
    const p_tabIndex = this.props.p_tabIndex;
    const p_errorTF = this.props.p_errorTF;

    const c_productStylingObj = this.props.CaptureExecMobx.c_productStylingObj;
    const c_companyShortcutPresetsCaptureManagersOnCreateNewCaptureTF = this.props.DatabaseMobx.c_companyShortcutPresetsCaptureManagersOnCreateNewCaptureTF;
    const c_selectShortcutPresetsCaptureManagerPresetFieldTypeObj = this.props.DatabaseMobx.c_selectShortcutPresetsCaptureManagerPresetFieldTypeObj;

    const selectWithSearchDataObj = p_fieldTypeObj.selectWithSearchDataObj;

    //tab index
    const startTabIndex = ((JSFUNC.is_number(p_tabIndex) && (p_tabIndex > 0)) ? (p_tabIndex) : (0));

    //the p_fieldTypeObj used to create the multiselect when adding a new item has the same selectWithSearchDataObj as this sharedpercent, but needs its p_fieldTypeObj flags changed from a sharedpercent to a multiselect
    const newOverwriteSwsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true};
    const addNewItemMultiSelectFieldTypeObj = this.props.DatabaseMobx.create_new_copy_field_type_obj_from_old_field_type_obj_and_field_input_type_and_sws_options_obj(p_fieldTypeObj, "select", newOverwriteSwsOptionsObj);
    
    //convert given p_valueRaw colonCommaList input to an arrayOfObjs, sorted by percent desc
    var selectedItemsArrayOfObjs = JSFUNC.convert_colon_comma_list_to_ints_arrayOfObjs(p_valueRaw, "itemID", "percent0to100"); //each selectedItemObj contains fields "itemID", "percent0to100", and "valueMask"
    const numSelectedItems = selectedItemsArrayOfObjs.length;
    const zeroItemsSelectedTF = (numSelectedItems === 0);

    var itemIDsToNotIncludeOrAlreadyAddedArray = []; //get the selected itemIDs as an array to provide as the selectmulti valuesToNotIncludeArray when adding a new item
    if(JSFUNC.is_array(p_valuesToNotIncludeArray)) { //if an array of values to not include in the select is provided, initialize with those IDs to be hidden, then append items already added to the list below
      itemIDsToNotIncludeOrAlreadyAddedArray = p_valuesToNotIncludeArray;
    }

    var percentTotal = 0;
    var numFilledOutItemsAdded = 0; //numSelectedItems taking the length of selectedItemsArrayOfObjs also counts added items that are not valid (ids that do not exist), which causes the 'all items have been added' to show up at the wrong time, get an accurate count here
    if(zeroItemsSelectedTF) { //if there are 0 items added, the percent total is considered 100% "unassigned" and is ok to save
      percentTotal = 100;
    }
    else {
      const itemsAlreadyAddedArray = JSFUNC.get_column_vector_from_arrayOfObjs(selectedItemsArrayOfObjs, "itemID");
      itemIDsToNotIncludeOrAlreadyAddedArray = JSFUNC.concat_arrays_or_values_into_new_array(itemIDsToNotIncludeOrAlreadyAddedArray, itemsAlreadyAddedArray);

      //loop through each item and add the valueMask to the arrayOfObjs while totaling the percents
      for(let selectedItemObj of selectedItemsArrayOfObjs) {
        var valueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(selectedItemObj.itemID, addNewItemMultiSelectFieldTypeObj);
        selectedItemObj.valueMask = ((valueMaskSortIfoObj.isFilledOutTF) ? (valueMaskSortIfoObj.valueMaskPlainText) : (valueMaskSortIfoObj.valueMask)); //use plaintext if it's filled out to avoid using the capture link
        percentTotal += selectedItemObj.percent0to100;
        if(valueMaskSortIfoObj.isFilledOutTF) {
          numFilledOutItemsAdded++;
        }
      }
    }
    const percentTotalIsNot100TF = (percentTotal !== 100);
    const allItemsAddedTF = (numFilledOutItemsAdded >= selectWithSearchDataObj.valueArray.length); //true if every single user/division in the system has been added to this once, leaving none to pick from, do not allow the Add Item button to be pushed if this is the case

    //item list
    var itemsListComponent = null;
    if(zeroItemsSelectedTF) {
      itemsListComponent = (
        <div className="microTopMargin microBottomMargin textCenter">
          <font className="fontItalic fontTextLight">
            {selectWithSearchDataObj.unselectedDisplay}
          </font>
        </div>
      );
    }
    else {
      itemsListComponent = (
        <SharedPercentItemsList
          p_selectedItemsArrayOfObjs={selectedItemsArrayOfObjs}
          p_allPercentsErrorTF={percentTotalIsNot100TF}
          f_onChangeItemPercent={this.onchange_item_percent}
          p_startTabIndex={startTabIndex}
          f_onRemoveItem={this.onremove_item}
        />
      );
    }

    //error text
    var errorTextComponent = null;
    if(percentTotalIsNot100TF) {
      errorTextComponent = (
        <ErrorText
          p_class="smallTopMargin smallBottomMargin textCenter"
          p_text={"All percents must total 100 (currently " + percentTotal + ")"}
        />
      );
    }

    //add item button
    var addItemButtonComponent = null;
    if(!s_isAddingNewItemTF) {
      if(!allItemsAddedTF) { //still some items available to add, draw the add button ready to push
        addItemButtonComponent = (
          <div className="smallFullPad displayFlexColumnHcVc">
            <CEButton
              p_type="add"
              p_text={"Add " + selectWithSearchDataObj.itemName}
              p_tabIndex={startTabIndex + numSelectedItems + 1} //tabIndex of the add button put after the last percent box
              f_onClick={this.onclick_add_item}
            />
          </div>
        );
      }
      else { //every item in the select has been added and there are no more to choose from
        addItemButtonComponent = (
          <div className="smallFullPad displayFlexColumnHcVc">
            <font className="fontItalic fontTextLighter">
              {((zeroItemsSelectedTF) ? ("It is not possible to add an item as there are no options in this list") : ("All possible items have been added"))}
            </font>
          </div>
        );
      }
    }
    else {
      addItemButtonComponent = (
        <div className="smallFullPad bgLightGrayGradient" style={{border:"solid 1px #ddd"}}>
          <div className="displayFlexRow smallTopMargin">
            <CaptureExecInputInlineOrFloatingWithSaveCancel
              p_fieldDisplayName={undefined}
              p_fieldTypeObj={addNewItemMultiSelectFieldTypeObj}
              p_valueRaw=""
              p_valuesToOnlyIncludeArray={p_valuesToOnlyIncludeArray}
              p_valuesToNotIncludeArray={itemIDsToNotIncludeOrAlreadyAddedArray}
              p_contactsZoomedCompanyID={undefined}
              p_selectInitOptionsBoxOpenTF={true}
              p_fieldValueVerticallyAlignedTF={true}
              p_editInFloatingBoxTF={false}
              p_floatingBoxTitle={undefined}
              p_initialValueIsBlankValueTF={false}
              p_forceSaveCallEvenIfValueNotChangedTF={p_forceSaveCallEvenIfValueNotChangedTF}
              f_onSaveChanged={this.onclick_save_add_selected_new_items}
              f_onCancel={this.onclick_cancel_add_item}
            />
          </div>
        </div>
      );
    }

    var injectShortcutPresetComponent = null;
    if(p_fieldTypeObj.sharedPercentCaptureManagersTF) { //if this sharedpercent is specifically Capture Managers selecting CE Users in a sharedpercent
      if(c_companyShortcutPresetsCaptureManagersOnCreateNewCaptureTF) { //if this customer has the Admin setting in Shortcut Presets turned on for injecting preset Capture Manager setups
        injectShortcutPresetComponent = (
          <div className="displayFlexColumnHcVc smallTopMargin">
            <div className="borderT1ddd" style={{width:"80%", maxWidth:"40em"}} />
            {(s_selectingShortcutPresetTF) ? (
              <>
                <div className="medTopMargin border1bbb bgLighterGray bigBottomPad lrMedPad" style={{width:"100%", maxWidth:"50em"}}>
                  <div className="microBottomMargin displayFlexRow">
                    <div className="flex11a medTopPad">
                      <font className="font09 fontItalic fontTextLight">
                        {"Shortcut Presets available to quickly fill in " + c_productStylingObj.productName + " Users"}
                      </font>
                    </div>
                    <div className="flex00a displayFlexColumnHcVc tbMicroMargin borderL1ddd textCenter" style={{paddingLeft:"0.8em"}}>
                      <LibraryReact.InteractiveDiv
                        p_class="flex00a hoverFontUnderline cursorPointer"
                        f_onClick={this.onclick_close_shortcut_preset}>
                        <font className="font09 fontItalic fontTextLighter">
                          {"close"}
                        </font>
                      </LibraryReact.InteractiveDiv>
                    </div>
                  </div>
                  <GenericInputOrSelectFromInputType
                    p_fieldTypeObj={c_selectShortcutPresetsCaptureManagerPresetFieldTypeObj}
                    p_valueRaw={s_selectedShortcutPresetsCaptureManagerPresetID}
                    f_onChangeOrOnSelect={this.onchange_shortcut_presets_capture_manager_preset}
                  />
                </div>
              </>
            ) : (
              <LibraryReact.InteractiveDiv
                p_class="smallTopMargin lrMedPad textCenter hoverFontUnderline cursorPointer"
                p_title="Click this to choose Users from a list of Shortcut Presets set up by your Admin"
                f_onClick={this.onclick_open_shortcut_preset}>
                <font className="font09 fontItalic fontTextLight">
                  {"Shortcut Presets available to quickly fill in " + c_productStylingObj.productName + " Users"}
                </font>
              </LibraryReact.InteractiveDiv>
            )}
          </div>
        );
      }
    }

    return(
      <div className={((p_errorTF) ? ("border borderColorRed") : ("border1transparent"))}>
        {itemsListComponent}
        {errorTextComponent}
        {addItemButtonComponent}
        {injectShortcutPresetComponent}
      </div>
    );
  }
}));

function SharedPercentItemsList(props) { //props: p_selectedItemsArrayOfObjs, p_allPercentsErrorTF, p_startTabIndex, f_onChangeItemPercent(i_itemID, i_newValue), f_onKeyDownEnterPercent(), f_onRemoveItem(i_itemID)
  return(
    props.p_selectedItemsArrayOfObjs.map((selectedItemObj, itemIndex) =>
      <SharedPercentItem
        key={JSFUNC.rc_unique_row_key(selectedItemObj.itemID, itemIndex)}
        p_selectedItemObj={selectedItemObj}
        p_onlyOneItemAddedTF={(props.p_selectedItemsArrayOfObjs.length === 1)}
        p_tabIndex={props.p_startTabIndex + 1 + itemIndex}
        p_percentErrorTF={props.p_allPercentsErrorTF}
        f_onChangeItemPercent={props.f_onChangeItemPercent}
        f_onKeyDownEnterPercent={props.f_onKeyDownEnterPercent}
        f_onRemoveItem={props.f_onRemoveItem}
      />
    )
  );
}

class SharedPercentItem extends Component { //props: p_selectedItemObj, p_onlyOneItemAddedTF, p_tabIndex, p_percentErrorTF, f_onChangeItemPercent, f_onKeyDownEnterPercent, f_onRemoveItem
  onchange_percent = (i_newPercent0to100) => {
    if(JSFUNC.is_function(this.props.f_onChangeItemPercent)) {
      this.props.f_onChangeItemPercent(this.props.p_selectedItemObj.itemID, i_newPercent0to100);
    }
  }

  onclick_remove_x = () => {
    if(JSFUNC.is_function(this.props.f_onRemoveItem)) {
      this.props.f_onRemoveItem(this.props.p_selectedItemObj.itemID);
    }
  }

  render() {
    return(
      <div className="displayFlexRowVc smallBottomMargin">
        <div className="flex11a lrMargin breakWord">
          {this.props.p_selectedItemObj.valueMask}
        </div>
        {(this.props.p_onlyOneItemAddedTF) ? (
          <div className="flex00a lrMargin fontItalic fontTextLight" style={{flexBasis:"4.5em"}}>
            {this.props.p_selectedItemObj.percent0to100 + "%"}
          </div>
        ) : (
          <div className="flex00a" style={{flexBasis:"5.5em"}}>
            <LibraryReact.Percent
              p_value={this.props.p_selectedItemObj.percent0to100}
              p_min={0}
              p_max={100}
              p_decimalsTF={false}
              p_blankValue={0} //percent_int_0to100 and percent_decimal_0to100 force a number to be typed, cannot be blank
              p_class={undefined}
              p_styleObj={{width:"100%"}}
              p_tabIndex={this.props.p_tabIndex}
              p_title={undefined}
              p_errorTF={this.props.p_percentErrorTF}
              f_onChange={this.onchange_percent}
              f_onKeyDownEnter={this.props.f_onKeyDownEnterPercent}
            />
          </div>
        )}
        <RemoveItemXWithRedHover f_onClick={this.onclick_remove_x} />
      </div>
    );
  }
}



export const InputCaptureFavorite = inject("UserMobx")(observer(
class InputCaptureFavorite extends Component { //props: p_favoriteTF, p_standardSizeTrueCSTCellSizeFalse, f_onClick
  onclick_favorite_icon = () => {
    if(JSFUNC.is_function(this.props.f_onClick)) {
      const updatedCaptureFavoriteTF = ((this.props.p_favoriteTF) ? (false) : (true));
      this.props.f_onClick(updatedCaptureFavoriteTF);
    }
  }

  render() {
    const p_favoriteTF = this.props.p_favoriteTF; //input value raw
    const p_standardSizeTrueCSTCellSizeFalse = JSFUNC.prop_value(this.props.p_standardSizeTrueCSTCellSizeFalse, true);

    var sizeEm = 1.9;
    if(!p_standardSizeTrueCSTCellSizeFalse) {
      sizeEm = this.props.UserMobx.c_userCaptureTableRowHeightOptionsObj.cellCaptureFavoritesDirectEditSizeEm;
    }

    var svgFavoriteIconComponent = null;
    if(p_standardSizeTrueCSTCellSizeFalse) {
      if(p_favoriteTF) {
        svgFavoriteIconComponent = this.props.UserMobx.c_svgFavoriteIconStdSizeFav;
      }
      else {
        svgFavoriteIconComponent = this.props.UserMobx.c_svgFavoriteIconStdSizeNotFav;
      }
    }
    else {
      if(p_favoriteTF) {
        svgFavoriteIconComponent = this.props.UserMobx.c_svgFavoriteIconCSTSizeFav;
      }
      else {
        svgFavoriteIconComponent = this.props.UserMobx.c_svgFavoriteIconCSTSizeNotFav;
      }
    }

    return(
      <div
        className="flex00a displayFlexColumnHcVc cursorPointer"
        style={{height:sizeEm + "em", width:sizeEm + "em"}}
        title={((p_favoriteTF) ? ("Marked as Favorite") : ("Not marked as Favorite")) + "\n[Click to " + ((p_favoriteTF) ? ("unmark") : ("mark")) + " Capture as a favorite]"}
        onClick={this.onclick_favorite_icon}>
        {svgFavoriteIconComponent}
      </div>
    );
  }
}));




const InputCapturePriorityLevel = inject("DatabaseMobx")(observer(
class InputCapturePriorityLevel extends Component { //props: p_valueRaw, f_onSelect
  render() {
    const p_valueRaw = this.props.p_valueRaw;

    const c_capturePriorityLevelsEditConstantsObj = this.props.DatabaseMobx.c_capturePriorityLevelsEditConstantsObj;
    const c_capturePriorityLevelsArrayOfObjs = this.props.DatabaseMobx.c_capturePriorityLevelsArrayOfObjs;

    const numCapturePriorityLevels = c_capturePriorityLevelsEditConstantsObj.numCapturePriorityLevels;
    const zeroPriorityLevelsTF = c_capturePriorityLevelsEditConstantsObj.zeroPriorityLevelsTF;
    const onePriorityLevelTF = c_capturePriorityLevelsEditConstantsObj.onePriorityLevelTF;
    const containerWidthEm = c_capturePriorityLevelsEditConstantsObj.containerWidthEm;
    const containerHeightEm = c_capturePriorityLevelsEditConstantsObj.containerHeightEm;
    const containerHalfWidthEm = c_capturePriorityLevelsEditConstantsObj.containerHalfWidthEm;
    const containerHalfHeightEm = c_capturePriorityLevelsEditConstantsObj.containerHalfHeightEm;
    const centerCircleDiameterEm = c_capturePriorityLevelsEditConstantsObj.centerCircleDiameterEm;
    const centerCircleRadiusEm = c_capturePriorityLevelsEditConstantsObj.centerCircleRadiusEm;
    const centerCircleBorderColor = c_capturePriorityLevelsEditConstantsObj.centerCircleBorderColor;
    const centerCircleUnselectedBgColor = c_capturePriorityLevelsEditConstantsObj.centerCircleUnselectedBgColor;
    const centerCircleTopEm = c_capturePriorityLevelsEditConstantsObj.centerCircleTopEm;
    const centerCircleLeftEm = c_capturePriorityLevelsEditConstantsObj.centerCircleLeftEm;
    const orbitDiameterEm = c_capturePriorityLevelsEditConstantsObj.orbitDiameterEm;
    const orbitRadiusEm = c_capturePriorityLevelsEditConstantsObj.orbitRadiusEm;
    const orbitCenterRadiusFromCenterEm = c_capturePriorityLevelsEditConstantsObj.orbitCenterRadiusFromCenterEm;
    const orbitBorderColor = c_capturePriorityLevelsEditConstantsObj.orbitBorderColor;
    const orbitUnselectedBgColor = c_capturePriorityLevelsEditConstantsObj.orbitUnselectedBgColor;

    if(zeroPriorityLevelsTF) {
      return(null);
    }

    const onePriorityLevelAndIsCurrentlySelectedTF = (onePriorityLevelTF && (p_valueRaw === c_capturePriorityLevelsArrayOfObjs[0]["id"]));

    var selectionHoverText = "No Priority selected";
    var centerCircleInsideTextOrUndefined = undefined;
    for(let capturePriorityLevelObj of c_capturePriorityLevelsArrayOfObjs) {
      if(p_valueRaw === capturePriorityLevelObj.id) {
        selectionHoverText = "Marked as '" + capturePriorityLevelObj.name + "'";
        centerCircleInsideTextOrUndefined = capturePriorityLevelObj.sort;
        break;
      }
    }

    return(
      <div
        className="flex00a positionRelative"
        style={{width:containerHeightEm + "em", height:containerHeightEm + "em"}}
        title={selectionHoverText}>
        <InputCapturePriorityLevelSingleOrbitCircle
          p_valueRaw={p_valueRaw}
          p_capturePriorityLevelID={c_capturePriorityLevelsArrayOfObjs[0]["id"]}
          p_top={centerCircleTopEm}
          p_left={centerCircleLeftEm}
          p_diameterEm={centerCircleDiameterEm}
          p_borderColor={centerCircleBorderColor}
          p_bgColor={((onePriorityLevelAndIsCurrentlySelectedTF) ? (c_capturePriorityLevelsArrayOfObjs[0]["color"]) : (centerCircleUnselectedBgColor))}
          p_insideText={centerCircleInsideTextOrUndefined}
          p_title={((onePriorityLevelAndIsCurrentlySelectedTF) ? (c_capturePriorityLevelsArrayOfObjs[0]["name"]) : (undefined))}
          f_onClick={((onePriorityLevelTF) ? (this.props.f_onSelect) : (undefined))}
        />
        {c_capturePriorityLevelsArrayOfObjs.map((m_capturePriorityLevelObj, m_index) =>
          <InputCapturePriorityLevelSingleOrbitCircle
            p_valueRaw={p_valueRaw}
            p_capturePriorityLevelID={m_capturePriorityLevelObj.id}
            p_top={m_capturePriorityLevelObj.orbitTopEm}
            p_left={m_capturePriorityLevelObj.orbitLeftEm}
            p_diameterEm={orbitDiameterEm}
            p_borderColor={orbitBorderColor}
            p_bgColor={((p_valueRaw === m_capturePriorityLevelObj.id) ? (m_capturePriorityLevelObj.color) : (orbitUnselectedBgColor))}
            p_insideText={undefined}
            p_title={((p_valueRaw === m_capturePriorityLevelObj.id) ? ("[Click to unmark this with no Priority]") : ("[Click to mark as '" + m_capturePriorityLevelObj.name + "']"))}
            f_onClick={this.props.f_onSelect}
          />
        )}
      </div>
    );
  }
}));


class InputCapturePriorityLevelSingleOrbitCircle extends Component { //props: p_valueRaw, p_capturePriorityLevelID, p_top, p_left, p_diameterEm, p_borderColor, p_bgColor, p_insideText, p_title, f_onClick
  onclick_capture_priority_level_orbit = () => {
    const p_valueRaw = this.props.p_valueRaw;
    const p_capturePriorityLevelID = this.props.p_capturePriorityLevelID;

    if(JSFUNC.is_function(this.props.f_onClick)) {
      const newCapturePriorityLevelID = ((p_valueRaw === p_capturePriorityLevelID) ? (0) : (p_capturePriorityLevelID));
      this.props.f_onClick(newCapturePriorityLevelID);
    }
  }

  render() {
    const p_valueRaw = this.props.p_valueRaw;
    const p_capturePriorityLevelID = this.props.p_capturePriorityLevelID;
    const p_top = this.props.p_top;
    const p_left = this.props.p_left;
    const p_diameterEm = this.props.p_diameterEm;
    const p_borderColor = this.props.p_borderColor;
    const p_bgColor = this.props.p_bgColor;
    const p_insideText = this.props.p_insideText;
    const p_title = this.props.p_title;

    const hasClickFunctionTF = JSFUNC.is_function(this.props.f_onClick);

    return(
      <div
        className={"positionAbsolute displayFlexColumnHcVc textCenter " + ((hasClickFunctionTF) ? ("cursorPointer") : (""))}
        style={{transition:"0.35s", top:p_top + "em", left:p_left + "em", width:p_diameterEm + "em", height:p_diameterEm + "em", border:"solid 1px #" + p_borderColor, borderRadius:p_diameterEm + "em", background:"#" + p_bgColor}}
        title={p_title}
        onClick={this.onclick_capture_priority_level_orbit}>
        {(p_insideText !== undefined) &&
          <font className="fontItalic fontTextLight">
            {p_insideText}
          </font>
        }
      </div>
    );
  }
}









const InputStylingStringOptions = inject("DatabaseMobx", "UserMobx")(observer(
class InputStylingStringOptions extends Component { //props: p_fieldTypeObj, p_valueRaw, p_tabIndex, f_onChange
  constructor(props) {
    super(props);
    
    const p_valueRaw = this.props.p_valueRaw;

    const presetStylingObj = this.props.DatabaseMobx.get_preset_styling_obj_from_styling_string_comma_list_or_preset_colon_id_string(p_valueRaw);

    var initialLatestSelectedStylingPresetIDOrUndefined = undefined;
    var initialTempSelectingStylingPresetIDOrUndefined = undefined;
    if(presetStylingObj.presetTF) {
      initialLatestSelectedStylingPresetIDOrUndefined = presetStylingObj.presetID;
      initialTempSelectingStylingPresetIDOrUndefined = presetStylingObj.presetID;
    }

    this.state = {
      s_stylingViewFlag: "viewEditStyle", //"viewEditStyle", "selectPreset"
      s_latestSelectedStylingPresetIDOrUndefined: initialLatestSelectedStylingPresetIDOrUndefined, //latest presetID selected (or initial passed as input from p_valueRaw), not changed if s_tempSelectingStylingPresetIDOrUndefined is selected but cancelled, used for save operations to save changed values to latest preset selected
      s_unsavedPresetChangesFlag: "noChanges", //"noChanges", "unsavedChanges", "saving", "successSaving", "errorSaving"
      s_tempSelectingStylingPresetIDOrUndefined: initialTempSelectingStylingPresetIDOrUndefined //used when selecting a preset to load
    };
  }

  onclick_styling_vertical_dots_menu_load_preset_style = () => {
    const s_latestSelectedStylingPresetIDOrUndefined = this.state.s_latestSelectedStylingPresetIDOrUndefined;

    this.setState({
      s_stylingViewFlag: "selectPreset",
      s_tempSelectingStylingPresetIDOrUndefined: s_latestSelectedStylingPresetIDOrUndefined
    });
  }

  onselect_preset = (i_selectedStylingPresetID) => {
    this.setState({s_tempSelectingStylingPresetIDOrUndefined:i_selectedStylingPresetID});
  }

  onload_selected_preset = () => {
    const s_tempSelectingStylingPresetIDOrUndefined = this.state.s_tempSelectingStylingPresetIDOrUndefined;
    const f_onChange = this.props.f_onChange;

    if(JSFUNC.is_function(f_onChange)) {
      var selectedPresetStylingString = ""; //if the select is cleared and Load is clicked, the styling string is cleared to blank with all switches off
      if(JSFUNC.select_int_is_filled_out_tf(s_tempSelectingStylingPresetIDOrUndefined)) {
        selectedPresetStylingString = "presetID:" + s_tempSelectingStylingPresetIDOrUndefined;
      }
      f_onChange(selectedPresetStylingString);
    }

    this.setState({
      s_stylingViewFlag: "viewEditStyle", //return back to normal view
      s_latestSelectedStylingPresetIDOrUndefined: s_tempSelectingStylingPresetIDOrUndefined,
      s_unsavedPresetChangesFlag: "noChanges",
      s_tempSelectingStylingPresetIDOrUndefined: s_tempSelectingStylingPresetIDOrUndefined
    });
  }

  oncancel_select_preset = () => {
    this.setState({s_stylingViewFlag:"viewEditStyle"});
  }

  onclick_styling_vertical_dots_menu_save_changes_to_open_preset = () => {
    const s_latestSelectedStylingPresetIDOrUndefined = this.state.s_latestSelectedStylingPresetIDOrUndefined;

    const p_valueRaw = this.props.p_valueRaw;

    if(JSFUNC.is_number_not_nan_gt_0(s_latestSelectedStylingPresetIDOrUndefined)) {
      this.setState({s_unsavedPresetChangesFlag:"saving"});

      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - InputStylingStringOptions", "onclick_styling_vertical_dots_menu_save_changes_to_open_preset", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

      C_CallPhpTblUID.add_update("tbl_a_styling_string_presets", s_latestSelectedStylingPresetIDOrUndefined, "styling_string_comma_list", p_valueRaw, "s");

      const functionOnSuccess = (i_parseResponse) => {
        if(i_parseResponse.outputObj.u0 === "1") {
          this.setState({s_unsavedPresetChangesFlag:"successSaving"});
        }
        else {
          this.setState({s_unsavedPresetChangesFlag:"errorSaving"});
        }
      }
      C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

      const functionOnError = () => {
        this.setState({s_unsavedPresetChangesFlag:"errorSaving"});
      }
      C_CallPhpTblUID.add_function("onError", functionOnError);

      C_CallPhpTblUID.execute();
    }
  }

  onclick_styling_vertical_dots_menu_save_as_new_preset = (i_newPresetNameString) => {
    const p_valueRaw = this.props.p_valueRaw;

    const o_userID = this.props.UserMobx.o_userID;

    this.setState({s_unsavedPresetChangesFlag:"saving"});

    const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - InputStylingStringOptions", "onclick_styling_vertical_dots_menu_save_as_new_preset", [], []);
    const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);

    C_CallPhpTblUID.add_insert("tbl_a_styling_string_presets", ["filter_flag_admin0_prop1", "created_by_user_id", "name", "styling_string_comma_list"], [1, o_userID, i_newPresetNameString, p_valueRaw], ["i", "i", "s", "s"]);

    const functionOnSuccess = (i_parseResponse) => {
      const newlyInsertedPresetID = i_parseResponse.outputObj.i0;
      if(newlyInsertedPresetID > 0) {
        this.setState({
          s_latestSelectedStylingPresetIDOrUndefined: newlyInsertedPresetID,
          s_unsavedPresetChangesFlag: "noChanges",
          s_tempSelectingStylingPresetIDOrUndefined: newlyInsertedPresetID,
        });
      }
      else {
        this.setState({s_unsavedPresetChangesFlag:"errorSaving"});
      }
    }
    C_CallPhpTblUID.add_function("onSuccess", functionOnSuccess);

    const functionOnError = () => {
      this.setState({s_unsavedPresetChangesFlag:"errorSaving"});
    }
    C_CallPhpTblUID.add_function("onError", functionOnError);

    C_CallPhpTblUID.execute();
  }

  onclick_styling_vertical_dots_menu_delete_preset = () => {
    const s_latestSelectedStylingPresetIDOrUndefined = this.state.s_latestSelectedStylingPresetIDOrUndefined;

    if(JSFUNC.is_number_not_nan_gt_0(s_latestSelectedStylingPresetIDOrUndefined)) {
      const jsDescription = JSFUNC.js_description_from_action("CEGeneralReact - InputStylingStringOptions", "onclick_styling_vertical_dots_menu_delete_preset", [], []);
      const C_CallPhpTblUID = new JSPHP.ClassCallPhpTblUID(jsDescription);
      C_CallPhpTblUID.add_delete("tbl_a_styling_string_presets", s_latestSelectedStylingPresetIDOrUndefined);
      C_CallPhpTblUID.execute();
    }

    this.setState({
      s_latestSelectedStylingPresetIDOrUndefined: undefined,
      s_unsavedPresetChangesFlag: "noChanges",
      s_tempSelectingStylingPresetIDOrUndefined: undefined,
    });
  }

  onswitch_bold = () => { this.call_onselect_from_updated_preset_styling_obj(true, false, false, false, false, false, false, false); }
  onswitch_italic = () => { this.call_onselect_from_updated_preset_styling_obj(false, true, false, false, false, false, false, false); }
  onswitch_font_color = () => { this.call_onselect_from_updated_preset_styling_obj(false, false, true, false, false, false, false, false); }
  onselect_font_color = (i_selectedColor) => { this.call_onselect_from_updated_preset_styling_obj(false, false, false, i_selectedColor, false, false, false, false); }
  onswitch_highlight = () => { this.call_onselect_from_updated_preset_styling_obj(false, false, false, false, true, false, false, false); }
  onselect_highlight_color = (i_selectedColor) => { this.call_onselect_from_updated_preset_styling_obj(false, false, false, false, false, i_selectedColor, false, false); }
  onswitch_border = () => { this.call_onselect_from_updated_preset_styling_obj(false, false, false, false, false, false, true, false); }
  onselect_border_color = (i_selectedColor) => { this.call_onselect_from_updated_preset_styling_obj(false, false, false, false, false, false, false, i_selectedColor); }

  call_onselect_from_updated_preset_styling_obj = (i_boldToggleTF, i_italicToggleTF, i_fontToggleTF, i_fontColor, i_highlightToggleTF, i_highlightColor, i_borderToggleTF, i_borderColor) => {
    const p_valueRaw = this.props.p_valueRaw;
    const f_onChange = this.props.f_onChange;

    const presetStylingObj = this.props.DatabaseMobx.get_preset_styling_obj_from_styling_string_comma_list_or_preset_colon_id_string(p_valueRaw);

    if(JSFUNC.is_function(f_onChange)) {
      const updatedBoldTF = ((i_boldToggleTF) ? (!presetStylingObj.boldTF) : (presetStylingObj.boldTF));

      const updatedItalicTF = ((i_italicToggleTF) ? (!presetStylingObj.italicTF) : (presetStylingObj.italicTF));

      var updatedFontColor = "";
      if(i_fontToggleTF) { updatedFontColor = ((presetStylingObj.fontColorTF) ? ("") : ("333333")); }
      else if(JSFUNC.string_is_filled_out_tf(i_fontColor)) { updatedFontColor = i_fontColor; }
      else { updatedFontColor = ((presetStylingObj.fontColorTF) ? (presetStylingObj.fontSelectedColor) : ("")); }

      var updatedHighlightColor = "";
      if(i_highlightToggleTF) { updatedHighlightColor = ((presetStylingObj.highlightTF) ? ("") : ("eeeeee")); }
      else if(JSFUNC.string_is_filled_out_tf(i_highlightColor)) { updatedHighlightColor = i_highlightColor; }
      else { updatedHighlightColor = ((presetStylingObj.highlightTF) ? (presetStylingObj.highlightSelectedColor) : ("")); }

      var updatedBorderColor = "";
      if(i_borderToggleTF) { updatedBorderColor = ((presetStylingObj.borderTF) ? ("") : ("aaaaaa")); }
      else if(JSFUNC.string_is_filled_out_tf(i_borderColor)) { updatedBorderColor = i_borderColor; }
      else { updatedBorderColor = ((presetStylingObj.borderTF) ? (presetStylingObj.borderSelectedColor) : ("")); }

      const updatePresetStylingObj = JSFUNC.convert_styling_tf_flags_and_colors_to_styling_obj(updatedBoldTF, updatedItalicTF, updatedFontColor, updatedHighlightColor, updatedBorderColor);
      const updatedPresetStylingStringCommaList = JSFUNC.convert_styling_obj_to_styling_string_comma_list(updatePresetStylingObj);
      f_onChange(updatedPresetStylingStringCommaList);
    }

    this.setState({s_unsavedPresetChangesFlag:"unsavedChanges"});
  }

  /*onclick_styling_tab = (i_stylingViewFlag) => {
    this.onselect_styling_tab(i_stylingViewFlag);

    if(i_stylingViewFlag === "customStyle") {
      const p_valueRaw = this.props.p_valueRaw;

      //get all the properties of the selected preset style, convert it to a custom styling string without the preset
      var presetStylingObj = this.props.DatabaseMobx.get_preset_styling_obj_from_styling_string_comma_list_or_preset_colon_id_string(p_valueRaw);
      presetStylingObj.presetTF = false; //remove that this is a preset, convert it to a custom style with the same properties as the preset

      this.call_onchange_with_styling_string_comma_list_or_styling_obj(presetStylingObj);
    }
    else if(i_stylingViewFlag === "loadPreset") {
      this.call_onchange_with_styling_string_comma_list_or_styling_obj("");
    }
  }

  call_onchange_with_styling_string_comma_list_or_styling_obj = (i_stylingStringCommaListOrStylingObj) => {
    if(JSFUNC.is_function(this.props.f_onChange)) {
      var stylingStringCommaList = "";
      if(JSFUNC.is_string(i_stylingStringCommaListOrStylingObj)) { //input is styling string comma list
        stylingStringCommaList = i_stylingStringCommaListOrStylingObj;
      }
      else { //input is presetStylingObj or stylingObj
        if(i_stylingStringCommaListOrStylingObj.presetTF && !JSFUNC.select_int_is_filled_out_tf(i_stylingStringCommaListOrStylingObj.presetID)) { //if the preset select is cleared, don't return "preset:-1", but rather return "" to have no preset selected
          stylingStringCommaList = "";
        }
        else { //convert stylingObj to a styling string comma list
          stylingStringCommaList = JSFUNC.convert_preset_styling_obj_to_preset_string_or_styling_string_comma_list(i_stylingStringCommaListOrStylingObj);
        }
      }
      this.props.f_onChange(stylingStringCommaList);
    }
  }*/

  render() {
    const s_stylingViewFlag = this.state.s_stylingViewFlag;
    const s_latestSelectedStylingPresetIDOrUndefined = this.state.s_latestSelectedStylingPresetIDOrUndefined;
    const s_unsavedPresetChangesFlag = this.state.s_unsavedPresetChangesFlag;
    const s_tempSelectingStylingPresetIDOrUndefined = this.state.s_tempSelectingStylingPresetIDOrUndefined;

    const p_fieldTypeObj = this.props.p_fieldTypeObj;
    const p_valueRaw = this.props.p_valueRaw;
    const p_tabIndex = this.props.p_tabIndex;
    
    const c_tbl_a_styling_string_presets = this.props.DatabaseMobx.c_tbl_a_styling_string_presets;
    const o_userID = this.props.UserMobx.o_userID;

    //state vars
    var stylingViewFlagViewEditStyleTF = false;
    var stylingViewFlagSelectPresetTF = false;
    if(s_stylingViewFlag === "viewEditStyle") { stylingViewFlagViewEditStyleTF = true; }
    else if(s_stylingViewFlag === "selectPreset") { stylingViewFlagSelectPresetTF = true; }

    const presetSelectedAsLatestTF = JSFUNC.is_number_not_nan_gt_0(s_latestSelectedStylingPresetIDOrUndefined);

    var unsavedPresetChangesIsNoChangesTF = false;
    var unsavedPresetChangesIsUnsavedChangesTF = false;
    var unsavedPresetChangesIsSavingTF = false;
    var unsavedPresetChangesIsSuccessSavingTF = false;
    var unsavedPresetChangesIsErrorSavingTF = false;
    if(s_unsavedPresetChangesFlag === "noChanges") { unsavedPresetChangesIsNoChangesTF = true; }
    if(s_unsavedPresetChangesFlag === "unsavedChanges") { unsavedPresetChangesIsUnsavedChangesTF = true; }
    else if(s_unsavedPresetChangesFlag === "saving") { unsavedPresetChangesIsSavingTF = true; }
    else if(s_unsavedPresetChangesFlag === "successSaving") { unsavedPresetChangesIsSuccessSavingTF = true; }
    else if(s_unsavedPresetChangesFlag === "errorSaving") { unsavedPresetChangesIsErrorSavingTF = true; }

    //props vars
    const stylingStringFilterAdminTF = p_fieldTypeObj.stylingStringFilterAdminTF;
    const stylingStringFilterProposalManagementTF = p_fieldTypeObj.stylingStringFilterProposalManagementTF;
    const stylingStringDefaultFontClassName = p_fieldTypeObj.stylingStringDefaultFontClassName;
    const stylingStringBoldOptionTF = p_fieldTypeObj.stylingStringBoldOptionTF;
    
    const presetStylingObj = this.props.DatabaseMobx.get_preset_styling_obj_from_styling_string_comma_list_or_preset_colon_id_string(p_valueRaw); //create a presetStylingObj, which has all fields from a stylingObj, plus presetTF, presetID, presetExistsTF, presetName

    const tabIndexInt = ((JSFUNC.is_number_not_nan_gt_0(p_tabIndex)) ? (p_tabIndex) : (1));

    //filtered/sorted styling presets (admin has all shared admin, prop users have only their presets)
    var filteredStylingStringPresetsArrayOfObjs = [];
    if(stylingStringFilterAdminTF) {
      filteredStylingStringPresetsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(c_tbl_a_styling_string_presets, ["filter_flag_admin0_prop1"], [0], "nameLowercase", true);
    }
    else if(stylingStringFilterProposalManagementTF) {
      filteredStylingStringPresetsArrayOfObjs = JSFUNC.filtered_sorted_arrayOfObjs_from_mapOfMaps_matching_field_value(c_tbl_a_styling_string_presets, ["filter_flag_admin0_prop1", "created_by_user_id"], [1, o_userID], "nameLowercase", true);
    }

    //create the select fieldTypeObj for preset styling strings (filtered for proposal management flag and per userID so each user has private presets)
    var selectPresetStylingStringFieldTypeObj = undefined;
    if(stylingViewFlagSelectPresetTF) {
      const swsOptionsObj = {hasSearchTF:true, hasClearSelectionTF:true};
      const selectPresetStylingStringSwsDataObj = this.props.DatabaseMobx.create_sws_data_obj_from_arrayOfObjs_and_vd_column_names("Styling Preset", filteredStylingStringPresetsArrayOfObjs, "id", false, "nameAndStyleStringCommaList", swsOptionsObj);
      selectPresetStylingStringFieldTypeObj = this.props.DatabaseMobx.create_field_type_obj("select", selectPresetStylingStringSwsDataObj);
    }

    var latestSelectedPresetExistsTF = false;
    var latestSelectedPresetNameOrNoneText = "--No preset selected--";
    var latestSelectedPresetNameOrNoneFontClass = "fontItalic fontTextLighter";
    if(presetSelectedAsLatestTF) {
      latestSelectedPresetExistsTF = (JSFUNC.get_first_obj_from_arrayOfObjs_matching_field_value(filteredStylingStringPresetsArrayOfObjs, "id", s_latestSelectedStylingPresetIDOrUndefined) !== undefined);
      const latestSelectedStylingStringPresetMap = this.props.DatabaseMobx.tbl_row_map_from_id("tbl_a_styling_string_presets", s_latestSelectedStylingPresetIDOrUndefined);
      latestSelectedPresetNameOrNoneText = latestSelectedStylingStringPresetMap.get("name");
      latestSelectedPresetNameOrNoneFontClass = "";
    }

    const stylingVerticalDotsMenuItemsArrayOfObjs = [];
    stylingVerticalDotsMenuItemsArrayOfObjs.push({
      displayName: "Load a Preset Style",
      functionOnClickMenuItem: this.onclick_styling_vertical_dots_menu_load_preset_style
    });
    if(presetSelectedAsLatestTF && latestSelectedPresetExistsTF && unsavedPresetChangesIsUnsavedChangesTF) { //having unsaved changes offers this 'save changes' option
      stylingVerticalDotsMenuItemsArrayOfObjs.push({
        displayName: "Save Changes to Preset '" + latestSelectedPresetNameOrNoneText + "'",
        confirmType: "confirm",
        confirmTitle: "Overwrite Preset",
        confirmButton1Name: "Save Changes",
        confirmMessage: "Are you sure you want to overwrite the preset '" + latestSelectedPresetNameOrNoneText + "' with the current style changes?",
        functionOnClickConfirmButton: this.onclick_styling_vertical_dots_menu_save_changes_to_open_preset
      });
    }
    stylingVerticalDotsMenuItemsArrayOfObjs.push({
      displayName: "Save Settings as new Preset",
      confirmType: "inputText",
      confirmTitle: "Save Settings as new Preset",
      confirmButton1Name: "Create New Preset",
      confirmTextInitialValue: ((presetSelectedAsLatestTF) ? (latestSelectedPresetNameOrNoneText) : ("New Styling Preset")),
      confirmTextMustBeFilledOutTF: true,
      confirmMessage: "Enter a name for this new style preset:",
      functionOnClickConfirmButton: this.onclick_styling_vertical_dots_menu_save_as_new_preset
    });
    if(presetSelectedAsLatestTF && latestSelectedPresetExistsTF) {
      stylingVerticalDotsMenuItemsArrayOfObjs.push({
        displayName: "Delete Preset '" + latestSelectedPresetNameOrNoneText + "'",
        confirmType: "delete",
        confirmTitle: "Delete Preset",
        confirmButton1Name: "Delete",
        confirmMessage: "Are you sure you want to delete the preset '" + latestSelectedPresetNameOrNoneText + "'?",
        functionOnClickConfirmButton: this.onclick_styling_vertical_dots_menu_delete_preset
      });
    }

    var unsavedPresetChangesText = "";
    if(presetSelectedAsLatestTF) {
      if(unsavedPresetChangesIsUnsavedChangesTF) { unsavedPresetChangesText = "Changes unsaved"; }
      else if(unsavedPresetChangesIsSavingTF) { unsavedPresetChangesText = "Saving changes..."; }
      else if(unsavedPresetChangesIsSuccessSavingTF) { unsavedPresetChangesText = "Changes saved to '" + latestSelectedPresetNameOrNoneText + "'"; }
      else if(unsavedPresetChangesIsErrorSavingTF) { unsavedPresetChangesText = "Error saving changes"; }
    }

    return(
      <div className="flex00a displayFlexColumn border1bbb">
        {(false) &&
          <>
            <div className="smallFullPad font09" style={{border:"solid 1px #00a"}}>
              <div className="fontItalic fontTextLighter">{"p_valueRaw:"}</div><div>{p_valueRaw}</div>
            </div>
            <div className="smallFullPad font09" style={{border:"solid 1px #0a0"}}>
              <div className="font08 fontItalic fontTextLighter">{"s_stylingViewFlag:"}</div><div>{JSFUNC.print(s_stylingViewFlag)}</div>
              <div className="font08 fontItalic fontTextLighter">{"s_latestSelectedStylingPresetIDOrUndefined:"}</div><div>{JSFUNC.print(s_latestSelectedStylingPresetIDOrUndefined)}</div>
              <div className="font08 fontItalic fontTextLighter">{"s_unsavedPresetChangesFlag:"}</div><div>{JSFUNC.print(s_unsavedPresetChangesFlag)}</div>
              <div className="font08 fontItalic fontTextLighter">{"s_tempSelectingStylingPresetIDOrUndefined:"}</div><div>{JSFUNC.print(s_tempSelectingStylingPresetIDOrUndefined)}</div>
            </div>
          </>
        }
        {(stylingViewFlagViewEditStyleTF) &&
          <>
            <div className="flex00a displayFlexRow" style={{flexBasis:"2em"}}>
              <div className="flex11a displayFlexColumnVc lrPad" title={latestSelectedPresetNameOrNoneText}>
                <LibraryReact.NowrapEllipsis p_fontClass={latestSelectedPresetNameOrNoneFontClass}>
                  {latestSelectedPresetNameOrNoneText}
                </LibraryReact.NowrapEllipsis>
              </div>
              <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"1.5em"}}>
                <VerticalDotsMenu p_menuItemsArrayOfObjs={stylingVerticalDotsMenuItemsArrayOfObjs} />
              </div>
            </div>
            {JSFUNC.string_is_filled_out_tf(unsavedPresetChangesText) &&
              <div className="flex00a displayFlexColumnHcVc microBottomMargin lrPad textCenter" title={unsavedPresetChangesText}>
                <LibraryReact.NowrapEllipsis p_fontClass="font09 fontItalic fontTextLight">
                  {unsavedPresetChangesText}
                </LibraryReact.NowrapEllipsis>
              </div>
            }
          </>
        }
        {(stylingViewFlagSelectPresetTF) &&
          <div className="flex00a displayFlexColumn smallFullPad">
            <LibraryReact.DivFont p_fontClass="font09 fontItalic fontTextLight">
              {"Select a Preset Style to apply to this text"}
            </LibraryReact.DivFont>
            <div className="microTopMargin">
              <GenericInputOrSelectFromInputType
                p_fieldTypeObj={selectPresetStylingStringFieldTypeObj}
                p_valueRaw={s_tempSelectingStylingPresetIDOrUndefined}
                p_selectInitOptionsBoxOpenTF={true}
                f_onChangeOrOnSelect={this.onselect_preset}
              />
            </div>
            <div className="displayFlexRowHcVc flexWrap smallTopMargin">
              <div className="flex00a lrMedPad">
                <CEButton p_type="blue" p_text="Load" f_onClick={this.onload_selected_preset} />
              </div>
              <div className="flex00a lrMedPad">
                <CEButton p_type="gray" p_text="Cancel" f_onClick={this.oncancel_select_preset} />
              </div>
            </div>
          </div>
        }
        <div className="flex11a displayFlexColumn borderT1bbb smallFullPad">
          <div className="lrMedMargin medBottomMargin textCenter">
            <StyledTextDiv p_stylingObj={presetStylingObj} p_nowrapTF={true}>
              {"Style"}
            </StyledTextDiv>
          </div>
          <StylingFieldSwitchWithLabelAndColorEditor
            p_isEditableTF={stylingStringBoldOptionTF}
            p_switchLabel="Bold"
            p_switchOnTF={presetStylingObj.boldTF}
            p_switchHoverText={((stylingStringBoldOptionTF) ? ("Switch to turn on/off 'Bold' text styling") : ("'Bold' styling is always applied by default for this text"))}
            p_selectedColor={undefined}
            p_colorHoverText={undefined}
            p_switchTabIndex={tabIndexInt}
            f_onSwitchField={this.onswitch_bold}
            f_onSelectColor={undefined}
          />
          <StylingFieldSwitchWithLabelAndColorEditor
            p_isEditableTF={true}
            p_switchLabel="Italic"
            p_switchOnTF={presetStylingObj.italicTF}
            p_switchHoverText="Switch to turn on/off 'Italic' text styling"
            p_selectedColor={undefined}
            p_colorHoverText={undefined}
            p_switchTabIndex={(tabIndexInt + 2)}
            f_onSwitchField={this.onswitch_italic}
            f_onSelectColor={undefined}
          />
          <StylingFieldSwitchWithLabelAndColorEditor
            p_isEditableTF={true}
            p_switchLabel="Font Color"
            p_switchOnTF={presetStylingObj.fontColorTF}
            p_switchHoverText="Switch to turn on/off 'Font Color' text styling"
            p_selectedColor={presetStylingObj.fontSelectedColor}
            p_colorHoverText="Select a custom Font Color"
            p_switchTabIndex={(tabIndexInt + 4)}
            f_onSwitchField={this.onswitch_font_color}
            f_onSelectColor={this.onselect_font_color}
          />
          <StylingFieldSwitchWithLabelAndColorEditor
            p_isEditableTF={true}
            p_switchLabel="Highlight"
            p_switchOnTF={presetStylingObj.highlightTF}
            p_switchHoverText="Switch to turn on/off 'Highlight' text styling"
            p_selectedColor={presetStylingObj.highlightSelectedColor}
            p_colorHoverText="Select a custom Highlight Color behind the text"
            p_switchTabIndex={(tabIndexInt + 6)}
            f_onSwitchField={this.onswitch_highlight}
            f_onSelectColor={this.onselect_highlight_color}
          />
          <StylingFieldSwitchWithLabelAndColorEditor
            p_isEditableTF={true}
            p_switchLabel="Border"
            p_switchOnTF={presetStylingObj.borderTF}
            p_switchHoverText="Switch to turn on/off 'Border' text styling"
            p_selectedColor={presetStylingObj.borderSelectedColor}
            p_colorHoverText="Select a custom Border Color around the text"
            p_switchTabIndex={(tabIndexInt + 8)}
            f_onSwitchField={this.onswitch_border}
            f_onSelectColor={this.onselect_border_color}
          />
        </div>
      </div>
    );
  }
}));


function StylingFieldSwitchWithLabelAndColorEditor(props) { //props: p_isEditableTF, p_switchLabel, p_switchOnTF, p_switchHoverText, p_selectedColor, p_colorHoverText, p_tabIndex, f_onSwitchField, f_onSelectColor
  const p_isEditableTF = props.p_isEditableTF;
  const p_switchLabel = props.p_switchLabel;
  const p_switchOnTF = props.p_switchOnTF;
  const p_switchHoverText = props.p_switchHoverText;
  const p_selectedColor = props.p_selectedColor;
  const p_colorHoverText = props.p_colorHoverText;
  const p_tabIndex = props.p_tabIndex;
  const f_onSwitchField = props.f_onSwitchField;
  const f_onSelectColor = props.f_onSelectColor;

  return(
    <div className="displayFlexRowVc flexWrap" style={{height:"2.1em"}}>
      <div className="flex00a" style={{flexBasis:"5.5em"}}>
        <span className="fontDarkBlue">
          {p_switchLabel}
        </span>
      </div>
      <div className="flex00a" style={{flexBasis:"4em"}} title={((p_isEditableTF) ? (undefined) : (p_switchHoverText))}>
        {(p_isEditableTF) ? (
          <SwitchWithTextAndConfirmBox
            p_isOnTF={p_switchOnTF}
            p_sizeEm={3.4}
            p_onColor="ddaa00"
            p_tabIndex={p_tabIndex}
            p_title={p_switchHoverText}
            f_onSwitch={f_onSwitchField}
          />
        ) : (
          <span className="fontItalic fontTextLighter">
            {"N/A"}
          </span>
        )}
      </div>
      {(JSFUNC.is_function(f_onSelectColor) && p_switchOnTF) &&
        <div className="flex00a" style={{flexBasis:"6em"}}>
          <LibraryReact.Color
            p_value={p_selectedColor}
            p_class={undefined}
            p_styleObj={{width:"100%", height:"2em"}}
            p_tabIndex={(p_tabIndex + 1)}
            p_title={p_colorHoverText}
            f_onChange={f_onSelectColor}
          />
        </div>
      }
      <div className="flex11a" />
    </div>
  );
}


export function StyledTextDiv(props) { //props: p_stylingObj, p_nowrapTF, children
  const p_stylingObj = props.p_stylingObj;
  const p_nowrapTF = props.p_nowrapTF;

  var fontClass = undefined;
  if(p_stylingObj.boldTF || p_stylingObj.italicTF) {
    fontClass = ((p_stylingObj.boldTF) ? ("fontBold") : ("")) + " " + ((p_stylingObj.italicTF) ? ("fontItalic") : (""));
  }

  var fontHashColor = undefined;
  if(p_stylingObj.fontColorTF) {
    fontHashColor = "#" + p_stylingObj.fontSelectedColor;
  }

  //if a background highlight needs to be drawn, use the p_nowrapTF input to reapply nowrap inside of the highlight div
  if(p_stylingObj.highlightTF || p_stylingObj.borderTF) {
    const border = ((p_stylingObj.borderTF) ? ("1px solid #" + p_stylingObj.borderSelectedColor) : (undefined));
    const background = ((p_stylingObj.highlightTF) ? ("#" + p_stylingObj.highlightSelectedColor) : (undefined));
    return(
      <div style={{border:border, background:background, padding:"0 0.15em"}}>
        {(p_nowrapTF) ? (
          <LibraryReact.NowrapEllipsis p_fontClass={fontClass} p_fontStyleObj={{color:fontHashColor}}>
            {props.children}
          </LibraryReact.NowrapEllipsis>
        ) : (
          <span className={fontClass} style={{color:fontHashColor}}>
            {props.children}
          </span>
        )}
      </div>
    );
  }

  //without highlight, no need for surrounding background color div, nowrap properties applied correctly from parent div
  return(
    <span className={fontClass} style={{color:fontHashColor}}>
      {props.children}
    </span>
  );
}













//=====================================================================================================================================================================================
export const InsertOrEditFieldsFormFloatingBox = inject("DatabaseMobx")(observer(
class InsertOrEditFieldsFormFloatingBox extends Component { //props: 
  //p_insertTrueEditFalse, p_iefFieldsArrayOfObjs, p_itemName, p_floatingBoxTrblFlag, p_floatingBoxTitle, p_containerClass, p_fieldClass, p_fieldWidth, 
  //f_onClickSaveSingleFieldEdit(i_iefFieldObj, i_newValue), f_onClickInsertCreate(i_newFieldDbNamesValuesObj), f_onClickClose
  //
  //p_iefFieldsArrayOfObjs: [{
  //  fieldDisplayName, 
  //  fieldDbName, 
  //  fieldTypeObj, 
  //  valueRaw, 
  //  heightEm, 
  //  requiredNotEmptyTF,
  //  editFieldFloatingBoxTitle
  //}]

  constructor(props) {
    super(props);

    const p_iefFieldsArrayOfObjs = this.props.p_iefFieldsArrayOfObjs;

    var initializedLocalFieldsValuesObj = {};
    for(let iefFieldObj of p_iefFieldsArrayOfObjs) {
      var initializedValueRawOrBlankValue = undefined;
      if(iefFieldObj.valueRaw !== undefined) {
        initializedValueRawOrBlankValue = iefFieldObj.valueRaw;
      }
      else if(iefFieldObj.fieldTypeObj !== undefined) {
        initializedValueRawOrBlankValue = iefFieldObj.fieldTypeObj.blankValue;
      }
      initializedLocalFieldsValuesObj[iefFieldObj.fieldDbName] = initializedValueRawOrBlankValue;
    }

    this.state = {
      s_localFieldsValuesObj: initializedLocalFieldsValuesObj,
      s_requiredFieldErrorsObj: {},
      s_requiredValidationActiveTF: false
    };
  }

  required_field_errors_obj = (i_fieldsValuesObj) => {
    const p_iefFieldsArrayOfObjs = this.props.p_iefFieldsArrayOfObjs;

    var requiredFieldErrorsObj = {};
    for(let iefFieldObj of p_iefFieldsArrayOfObjs) {
      if(iefFieldObj.requiredNotEmptyTF === true) {
        const fieldDisplayName = iefFieldObj.fieldDisplayName;
        const fieldDbName = iefFieldObj.fieldDbName;
        const fieldTypeObj = iefFieldObj.fieldTypeObj;
        const fieldValueRaw = i_fieldsValuesObj[fieldDbName];

        var valueIsFilledOutTF = false;
        if(fieldTypeObj !== undefined) {
          valueIsFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(fieldValueRaw, fieldTypeObj);
        }
        else {
          valueIsFilledOutTF = JSFUNC.text_or_number_is_filled_out_tf(fieldValueRaw);
        }

        if(!valueIsFilledOutTF) {
          requiredFieldErrorsObj[fieldDbName] = fieldDisplayName + " must be filled out";
        }
      }
    }

    return(requiredFieldErrorsObj);
  }
  
  onclick_save_form = () => {
    const s_localFieldsValuesObj = this.state.s_localFieldsValuesObj;
    const s_requiredFieldErrorsObj = this.state.s_requiredFieldErrorsObj;

    const f_onClickInsertCreate = this.props.f_onClickInsertCreate;

    const requiredFieldErrorsObj = this.required_field_errors_obj(s_localFieldsValuesObj);

    //if there are required field errors with the current field values, set the error state to show the error indicators on the form fields and do not proceed with saving
    if(JSFUNC.is_obj_not_empty(requiredFieldErrorsObj)) {
      this.setState({
        s_requiredFieldErrorsObj: requiredFieldErrorsObj,
        s_requiredValidationActiveTF: true
      });
      return;
    }

    //if there were previously required field errors being shown, but now there are not any errors, clear the error state to remove the error indicators from the form fields
    if(JSFUNC.is_obj_not_empty(s_requiredFieldErrorsObj)) {
      this.setState({s_requiredFieldErrorsObj:{}});
    }

    //(insert mode only) pass the local fields values object to the insert create function so that the new record can be created with all of the field values at once
    if(JSFUNC.is_function(f_onClickInsertCreate)) {
      f_onClickInsertCreate(s_localFieldsValuesObj);
    }
  }

  onsave_update_single_field_value_insert_or_edit_mode = (i_iefFieldObj, i_newValue) => {
    const s_localFieldsValuesObj = this.state.s_localFieldsValuesObj;
    const s_requiredValidationActiveTF = this.state.s_requiredValidationActiveTF;

    const p_insertTrueEditFalse = this.props.p_insertTrueEditFalse;
    const f_onClickSaveSingleFieldEdit = this.props.f_onClickSaveSingleFieldEdit;

    if(p_insertTrueEditFalse) { //if in insert mode, update the local fields values object with the new value so that it can be saved all at once when the user clicks the main 'Create' button
      var updatedLocalFieldsValuesObj = JSFUNC.copy_obj(s_localFieldsValuesObj);
      updatedLocalFieldsValuesObj[i_iefFieldObj.fieldDbName] = i_newValue;
      if(s_requiredValidationActiveTF) {
        //after first save-triggered required validation, keep checking on each change so errors appear/disappear in real time
        const updatedRequiredFieldErrorsObj = this.required_field_errors_obj(updatedLocalFieldsValuesObj);

        this.setState({
          s_localFieldsValuesObj: updatedLocalFieldsValuesObj,
          s_requiredFieldErrorsObj: updatedRequiredFieldErrorsObj
        });
      }
      else {
        this.setState({s_localFieldsValuesObj:updatedLocalFieldsValuesObj});
      }
    }
    else { //if in edit mode, immediately save the new value for the single field that was edited
      if(JSFUNC.is_function(f_onClickSaveSingleFieldEdit)) {
        f_onClickSaveSingleFieldEdit(i_iefFieldObj, i_newValue);
      }
    }
  }

  render() {
    const s_localFieldsValuesObj = this.state.s_localFieldsValuesObj;
    const s_requiredFieldErrorsObj = this.state.s_requiredFieldErrorsObj;

    const p_insertTrueEditFalse = this.props.p_insertTrueEditFalse;
    const p_iefFieldsArrayOfObjs = this.props.p_iefFieldsArrayOfObjs;
    const p_itemName = JSFUNC.prop_value(this.props.p_itemName, "Item");
    const p_floatingBoxTrblFlag = JSFUNC.prop_value(this.props.p_floatingBoxTrblFlag, "smallVertical");
    const p_floatingBoxTitle = this.props.p_floatingBoxTitle;
    const p_containerClass = this.props.p_containerClass;
    const p_fieldClass = this.props.p_fieldClass;
    const p_fieldWidth = JSFUNC.prop_value(this.props.p_fieldWidth, "10em");
    const f_onClickSaveSingleFieldEdit = this.props.f_onClickSaveSingleFieldEdit;
    const f_onClickInsertCreate = this.props.f_onClickInsertCreate;
    const f_onClickClose = this.props.f_onClickClose;

    return(
      <FloatingBoxWithSaveCancel
        p_trblFlag={p_floatingBoxTrblFlag}
        p_title={p_floatingBoxTitle}
        f_onClickSave={((p_insertTrueEditFalse) ? (undefined) : (f_onClickClose))}
        f_onClickCancel={((p_insertTrueEditFalse) ? (f_onClickClose) : (undefined))}>
        <div className="flex11a yScroll medFullPad">
          {p_iefFieldsArrayOfObjs.map((m_iefFieldObj, m_index) => 
            <CaptureExecFieldEditSaveCancel
              key={m_iefFieldObj.fieldDbName}
              p_ceEditItemString={(m_iefFieldObj.fieldDbName + m_index)}
              p_modeEditSaveCancelTrueInputFalse={(!p_insertTrueEditFalse)}
              p_isContactFieldTF={false}
              p_fieldDisplayName={m_iefFieldObj.fieldDisplayName}
              p_fieldTypeObj={m_iefFieldObj.fieldTypeObj}
              p_valueRaw={((p_insertTrueEditFalse) ? (s_localFieldsValuesObj[m_iefFieldObj.fieldDbName]) : (p_iefFieldsArrayOfObjs[m_index].valueRaw))}
              p_valueMask={undefined}
              p_valueMaskPlainText={undefined}
              p_valueIsEditableTFU={true}
              p_valuesToOnlyIncludeArray={undefined}
              p_valuesToNotIncludeArray={undefined}
              p_containerClass={p_containerClass}
              p_containerHeight={((m_iefFieldObj.heightEm !== undefined) ? (m_iefFieldObj.heightEm + "em") : (undefined))}
              p_fieldClass={p_fieldClass}
              p_fieldFontColor={undefined}
              p_fieldHighlightColor={undefined}
              p_fieldBorderColor={undefined}
              p_fieldWidth={p_fieldWidth}
              p_fieldNowrapTF={undefined}
              p_fieldHoverText={undefined}
              p_fieldDashedUnderlineTF={undefined}
              p_valueClass={undefined}
              p_valueMaxHeight={undefined}
              p_valueHoverTextTF={undefined}
              p_fieldValueVerticallyAlignedTF={false}
              p_floatingBoxTitle={m_iefFieldObj.editFieldFloatingBoxTitle}
              p_errorTF={JSFUNC.string_is_filled_out_tf(s_requiredFieldErrorsObj[m_iefFieldObj.fieldDbName])}
              p_errorText={s_requiredFieldErrorsObj[m_iefFieldObj.fieldDbName]}
              p_tabIndex={(m_index + 1)}
              f_onSaveChanged={(i_newValue) => { this.onsave_update_single_field_value_insert_or_edit_mode(m_iefFieldObj, i_newValue); }}
            />
          )}
        </div>
        {(p_insertTrueEditFalse) &&
          <div className="flex00a displayFlexRowHcVc borderT1bbb" style={{flexBasis:"3em"}}>
            <div className="flex00a lrBigMargin">
              <CEButton
                p_text={"Create New " + p_itemName}
                p_type="blue"
                f_onClick={this.onclick_save_form}
              />
            </div>
            <div className="flex00a lrBigMargin">
              <CEButton
                p_text="Cancel"
                p_type="gray"
                f_onClick={f_onClickClose}
              />
            </div>
          </div>
        }
      </FloatingBoxWithSaveCancel>
    );
  }
}));















//=====================================================================================================================================================================================
export const FloatingBoxWithSaveCancel = inject("CaptureExecMobx")(observer(
class FloatingBoxWithSaveCancel extends Component { //props: p_trblFlag, p_title, p_zIndexWithinParentOrUndefinedForceFront, p_cancelConfirmationMessage, p_backdropBgOpacity0to1, p_bgColorClass, p_shadowColor, f_onClickSave, f_onClickCancel, children
  constructor(props) {
    super(props);
    this.state = {
      s_isConfirmingCancelTF: false
    };
  }

  onclick_cancel_to_confirm = () => {
    this.setState({s_isConfirmingCancelTF:true});
  }

  onconfirm_cancellation = () => {
    this.setState({s_isConfirmingCancelTF:false});
    if(JSFUNC.is_function(this.props.f_onClickCancel)) {
      this.props.f_onClickCancel();
    }
  }

  oncancel_cancellation = () => {
    this.setState({s_isConfirmingCancelTF:false});
  }

  render() {
    const s_isConfirmingCancelTF = this.state.s_isConfirmingCancelTF;

    const p_trblFlag = JSFUNC.prop_value(this.props.p_trblFlag, "textareaEdit");
    const p_title = this.props.p_title;
    const p_zIndexWithinParentOrUndefinedForceFront = this.props.p_zIndexWithinParentOrUndefinedForceFront; //undefined (default) forces the floating box to be in front of all other elements regardless of their z-index using createPortal() and document.body injection, 1-N uses z-index within the structure of the parent hierarchy (but wrongly inherits any drag/drop, cursor, or other parent attributes)
    const p_cancelConfirmationMessage = this.props.p_cancelConfirmationMessage; //if not undefined, pushing cancel will first bring up a confirmation box that must be affirmed to complete the cancel operation (avoids data loss when trying to click save, but missing)
    const p_backdropBgOpacity0to1 = JSFUNC.prop_value(this.props.p_backdropBgOpacity0to1, 0.2); //number 1 (black) to 0 (transparent)
    const p_bgColorClass = JSFUNC.prop_value(this.props.p_bgColorClass, "bgWhite");
    const p_shadowColor = JSFUNC.prop_value(this.props.p_shadowColor, "666666");
    const f_onClickSave = this.props.f_onClickSave;
    const f_onClickCancel = this.props.f_onClickCancel;

    const o_mediaQueryFlag = this.props.CaptureExecMobx.o_mediaQueryFlag;
    const c_currentSystemRightEdgeDueToHelpPanelEm = this.props.CaptureExecMobx.c_currentSystemRightEdgeDueToHelpPanelEm;
    
    const saveIsFunctionTF = JSFUNC.is_function(f_onClickSave);
    const cancelIsFunctionTF = JSFUNC.is_function(f_onClickCancel);

    //define arrays necessary to define floating box position, 6 sizes per array for each of the 6 (1,2,3,4,5,6) o_mediaQueryFlag sizes
    var trblArray = undefined; //all 4 directions equal (% or em) size
    var tbArray = undefined; //top/bottom equal
    var lrArray = undefined; //left/right equal
    var topArray = undefined; //top definition
    var bottomArray = undefined; //bottom definition
    var heightArray = undefined; //height definition
    if(p_trblFlag === "confirmBox") {
      lrArray = ["5%", "22%", "28%", "33%", "35%", "35%"];
      topArray = ["20%", "20%", "20%", "20%", "20%", "20%"];
    }
    else if(p_trblFlag === "smallVertical") {
      tbArray = ["1em", "10%", "12%", "14%", "15%", "15%"];
      lrArray = ["1em", "13%", "24%", "31%", "35%", "35%"];
    }
    else if(p_trblFlag === "medium") {
      tbArray = ["1em", "2em", "3%", "5%", "7%", "7%"];
      lrArray = ["1em", "5%", "18%", "22%", "25%", "25%"];
    }
    else if(p_trblFlag === "large") {
      tbArray = ["1em", "1em", "2em", "2%", "3%", "3%"];
      lrArray = ["1em", "1em", "2em", "2%", "5%", "5%"];
    }
    else if(p_trblFlag === "copyCapture") {
      tbArray = ["1em", "2em", "3%", "4%", "5%", "5%"];
      lrArray = ["1em", "10%", "15%", "25%", "30%", "30%"];
    }
    else if(p_trblFlag === "contactsSystemSelect") {
      tbArray = ["1em", "2em", "1%", "2%", "3%", "3%"];
      lrArray = ["1em", "2em", "3%", "5%", "10%", "10%"];
    }
    else if(p_trblFlag === "tasks") {
      tbArray = ["1em", "2em", "2em", "3%", "5%", "5%"];
      lrArray = ["1em", "2em", "5%", "10%", "15%", "15%"];
    }
    else if(p_trblFlag === "teammateContracts") {
      tbArray = ["1em", "2em", "2em", "2em", "2em", "2em"];
      lrArray = ["1em", "2em", "4%", "6%", "8%", "8%"];
    }
    else if(p_trblFlag === "teammateSurvey") {
      tbArray = ["1em", "2em", "2em", "2em", "2em", "2em"];
      lrArray = ["1em", "2em", "10%", "15%", "20%", "20%"];
    }
    else if(p_trblFlag === "themes") {
      tbArray = ["1em", "2em", "10%", "15%", "15%", "15%"];
      lrArray = ["1em", "2em", "4%", "6%", "15%", "15%"];
    }
    else if(p_trblFlag === "risks") {
      tbArray = ["1em", "2em", "10%", "15%", "20%", "20%"];
      lrArray = ["1em", "2em", "4%", "6%", "8%", "8%"];
    }
    else if(p_trblFlag === "budgetFundingRequest") {
      tbArray = ["1em", "2em", "2em", "3%", "5%", "5%"];
      lrArray = ["1em", "2em", "10%", "20%", "25%", "25%"];
    }
    else if(p_trblFlag === "conversations") {
      tbArray = ["1em", "2em", "2em", "3%", "5%", "5%"];
      lrArray = ["1em", "2em", "5%", "10%", "15%", "15%"];
    }
    else if(p_trblFlag === "divexecGraphsEdit") {
      tbArray = ["1em", "2em", "2em", "2em", "3%", "3%"];
      lrArray = ["1em", "2em", "10%", "15%", "20%", "20%"];
    }
    else if(p_trblFlag === "addEditDeleteTableEditItem") {
      tbArray = ["1em", "2em", "5%", "10%", "10%", "10%"];
      lrArray = ["1em", "15%", "25%", "30%", "35%", "35%"];
    }
    else if(p_trblFlag === "addEditDeleteTableNewCaptureField") {
      tbArray = ["1em", "2em", "2em", "2em", "2em", "2em"];
      lrArray = ["1em", "2em", "2em", "2em", "2em", "2em"];
    }
    else if(p_trblFlag === "addEditDeleteTableEditQuestion") {
      tbArray = ["1em", "2em", "3%", "4%", "5%", "5%"];
      lrArray = ["1em", "10%", "15%", "20%", "23%", "23%"];
    }
    else if(p_trblFlag === "divexecPerformanceEditQuota") {
      tbArray = ["1em", "2em", "3%", "4%", "5%", "5%"];
      lrArray = ["1em", "2em", "5%", "10%", "15%", "15%"];
    }
    else if(p_trblFlag === "divexecSelectPublicGraph") {
      tbArray = ["1em", "2em", "5%", "10%", "15%", "15%"];
      lrArray = ["1em", "10%", "15%", "25%", "30%", "30%"];
    }
    else if(p_trblFlag === "broadcastReader") {
      tbArray = ["1em", "2em", "5%", "10%", "15%", "15%"];
      lrArray = ["1em", "10%", "15%", "25%", "30%", "30%"];
    }
    else if(p_trblFlag === "uploadFileErrors") {
      tbArray = ["1em", "2em", "5%", "10%", "15%", "15%"];
      lrArray = ["1em", "10%", "15%", "25%", "30%", "30%"];
    }
    else if(p_trblFlag === "adminCaptureTemplatesSelectXmlType") {
      lrArray = ["1em", "10%", "20%", "30%", "35%", "35%"];
      topArray = ["20%", "20%", "20%", "20%", "20%", "20%"];
      bottomArray = ["30%", undefined, undefined, undefined, undefined, undefined];
      heightArray = [undefined, "17em", "17em", "17em", "17em", "17em"];
    }
    else if(p_trblFlag === "debrief") {
      trblArray = ["1em", "2em", "10%", "10%", "10%", "10%"];
    }
    else if(p_trblFlag === "textareaEdit") {
      trblArray = ["1em", "2em", "10%", "15%", "20%", "20%"];
    }
    else { //can override the top/right/bottom/left width that the floating box is away from the screen edges using this prop
      trblArray = [p_trblFlag, p_trblFlag, p_trblFlag, p_trblFlag, p_trblFlag, p_trblFlag];
    }

    const mqfIndex = (o_mediaQueryFlag - 1);

    const trblTF = JSFUNC.is_array(trblArray);
    const tbTF = JSFUNC.is_array(tbArray);
    const lrTF = JSFUNC.is_array(lrArray);
    const topTF = JSFUNC.is_array(topArray);
    const bottomTF = JSFUNC.is_array(bottomArray);
    const heightTF = JSFUNC.is_array(heightArray);

    var top = undefined;
    if(trblTF) { top = trblArray[mqfIndex]; }
    else if(tbTF) { top = tbArray[mqfIndex]; }
    else if(topTF) { top = topArray[mqfIndex]; }

    var right = undefined;
    if(trblTF) { right = trblArray[mqfIndex]; }
    else if(lrTF) { right = lrArray[mqfIndex]; }

    var bottom = undefined;
    if(trblTF) { bottom = trblArray[mqfIndex]; }
    else if(tbTF) { bottom = tbArray[mqfIndex]; }
    else if(bottomTF) { bottom = bottomArray[mqfIndex]; }

    var left = undefined;
    if(trblTF) { left = trblArray[mqfIndex]; }
    else if(lrTF) { left = lrArray[mqfIndex]; }

    var height = undefined;
    if(heightTF) { height = heightArray[mqfIndex]; }

    //cancel/confirm cancel (or save if it's the only option) function to close floating box
    var functionToCloseFloatingBoxOrUndefined = undefined;
    if(cancelIsFunctionTF && JSFUNC.string_is_filled_out_tf(p_cancelConfirmationMessage)) { //if p_cancelConfirmationMessage is provided and f_onClickCancel is a valid function, call the confirm cancellation process within this floating box
      functionToCloseFloatingBoxOrUndefined = this.onclick_cancel_to_confirm;
    }
    else if(saveIsFunctionTF || cancelIsFunctionTF) {
      if(cancelIsFunctionTF) { //if both save and cancel are provided, use the cancel function instead of the save for cancel/esc key actions
        functionToCloseFloatingBoxOrUndefined = f_onClickCancel;
      }
      else if(saveIsFunctionTF) { //if save is the only function, use that to close the floating box
        functionToCloseFloatingBoxOrUndefined = f_onClickSave;
      }
    }

    var saveCancelIconContainderWidthsEm = 2.2;
    var includeSpacingtoRightOfSaveCancelIconstF = true;
    if(!(saveIsFunctionTF && cancelIsFunctionTF)) { //if there's only 1 button but not both, make it bigger with no spacing on the right side to make the click area bigger all the way to the right edge
      saveCancelIconContainderWidthsEm = 3;
      includeSpacingtoRightOfSaveCancelIconstF = false;
    }

    return(
      <>
        <LibraryReact.FloatingBox
          p_forceToZIndexFrontWithPortalTF={(p_zIndexWithinParentOrUndefinedForceFront === undefined)}
          p_backdropZIndex={p_zIndexWithinParentOrUndefinedForceFront}
          p_backdropTop={0}
          p_backdropRight={c_currentSystemRightEdgeDueToHelpPanelEm + "em"}
          p_backdropBottom={0}
          p_backdropLeft={0}
          p_backdropBgColor="000000"
          p_backdropBgOpacity0to1={p_backdropBgOpacity0to1}
          p_top={top}
          p_right={right}
          p_bottom={bottom}
          p_left={left}
          p_height={height}
          p_shadowColor={p_shadowColor}
          p_borderColor="888888"
          p_bgColorClass={p_bgColorClass}
          p_bgColor={undefined}
          f_onKeyDownEsc={functionToCloseFloatingBoxOrUndefined}>
          <div className="flex00a displayFlexRow borderB1ddd" style={{height:"3em"}}>
            <div className="flex11a displayFlexColumnVc lrMedPad" title={p_title}>
              <LibraryReact.NowrapEllipsis p_fontClass="font12 fontTextLight">
                {p_title}
              </LibraryReact.NowrapEllipsis>
            </div>
            {(saveIsFunctionTF) &&
              <EditSaveCancelIcon
                p_iconType="save"
                p_containerWidthEm={saveCancelIconContainderWidthsEm}
                p_tabIndex={998}
                f_onClick={f_onClickSave}
              />
            }
            {(cancelIsFunctionTF) &&
              <EditSaveCancelIcon
                p_iconType="cancel"
                p_containerWidthEm={saveCancelIconContainderWidthsEm}
                p_tabIndex={999}
                f_onClick={functionToCloseFloatingBoxOrUndefined}
              />
            }
            {(includeSpacingtoRightOfSaveCancelIconstF) &&
              <div className="flex00a" style={{flexBasis:"0.4em"}} />
            }
          </div>
          {this.props.children}
        </LibraryReact.FloatingBox>
        {(s_isConfirmingCancelTF) &&
          <ConfirmBox
            p_type="confirm"
            p_title="Confirm Cancellation"
            p_button1Name="Confirm Cancellation"
            p_button2Name="Go Back"
            f_onClickConfirm={this.onconfirm_cancellation}
            f_onClickCancel={this.oncancel_cancellation}>
            {p_cancelConfirmationMessage}
          </ConfirmBox>
        }
      </>
    );
  }
}));


export class EditInlineWithSaveCancel extends Component { //props: p_fieldValueVerticallyAlignedTF, p_cancelConfirmationMessage, f_onClickSave, f_onClickCancel, children
  constructor(props) {
    super(props);
    this.state = {
      s_isConfirmingCancelTF: false
    };
  }

  onclick_cancel_to_confirm = () => {
    this.setState({s_isConfirmingCancelTF:true});
  }

  onconfirm_cancellation = () => {
    this.setState({s_isConfirmingCancelTF:false});
    if(JSFUNC.is_function(this.props.f_onClickCancel)) {
      this.props.f_onClickCancel();
    }
  }

  oncancel_cancellation = () => {
    this.setState({s_isConfirmingCancelTF:false});
  }

  render() {
    const s_isConfirmingCancelTF = this.state.s_isConfirmingCancelTF;

    const p_fieldValueVerticallyAlignedTF = JSFUNC.prop_value(this.props.p_fieldValueVerticallyAlignedTF, false);
    const p_cancelConfirmationMessage = this.props.p_cancelConfirmationMessage;

    const containerFlexRowClass = ((p_fieldValueVerticallyAlignedTF) ? ("displayFlexRowVc") : ("displayFlexRow"));

    return(
      <>
        <LibraryReact.InteractiveDiv
          p_class={"flex11a " + containerFlexRowClass}
          f_onKeyDownEsc={((p_cancelConfirmationMessage === undefined) ? (this.props.f_onClickCancel) : (this.onclick_cancel_to_confirm))}>
          {(this.props.f_onClickSave !== undefined) &&
            <EditSaveCancelIcon
              p_iconType="save"
              p_tabIndex={998}
              f_onClick={this.props.f_onClickSave}
            />
          }
          {(this.props.f_onClickCancel !== undefined) &&
            <EditSaveCancelIcon
              p_iconType="cancel"
              p_tabIndex={999}
              f_onClick={((p_cancelConfirmationMessage === undefined) ? (this.props.f_onClickCancel) : (this.onclick_cancel_to_confirm))}
            />
          }
          <div className="flex11a positionRelative lrMargin">
            {this.props.children}
          </div>
        </LibraryReact.InteractiveDiv>
        {(s_isConfirmingCancelTF) &&
          <ConfirmBox
            p_type="confirm"
            p_title="Confirm Cancellation"
            p_button1Name="Confirm Cancellation"
            p_button2Name="Go Back"
            f_onClickConfirm={this.onconfirm_cancellation}
            f_onClickCancel={this.oncancel_cancellation}>
            {p_cancelConfirmationMessage}
          </ConfirmBox>
        }
      </>
    );
  }
}


























//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//Data Table with filtering, column sort, pages
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
//&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&
export const DataTableWithFiltersColSortPages = inject("DatabaseMobx")(observer(
class DataTableWithFiltersColSortPages extends Component { //props:
  //p_dataTableDisplayName, p_dataTableDisplayShortName, p_dataIsLoadingTF, p_dataLoadingErrorTF, p_dataArrayOfObjs, p_uniqueIDColumnValueRawDbName, p_displayColumnsArrayOfObjs, 
  //p_verticalDotsMenuItemsArrayOfObjsOrUndefined, p_numRowsPerPage, p_selectedBgColorClass, p_selectedFontClass, p_canClickHoverColorClass,
  //f_onClickDataRow(i_dataRowUniqueIDClicked)
  //
  //p_displayColumnsArrayOfObjs:
  //  valueRawDbName
  //  fieldTypeObjOrUndefined                               fieldTypeObj: masks the data raw value, undefined: prints the raw value with no masking rules (useful for displaying prebuilt html message blocks)
  //  altMaskDbNameOrUndefined                              altMaskDbName: dbName in data to use as a display mask for this field (instead of masking the raw value based on the fieldTypeObj), useful for a select where the filter can still filter raw selected IDs, but the display is different from the normal masking
  //  columnDisplayName
  //  flex01
  //  flexBasisEm
  //  alignClassName
  //  filterTypeOrUndefined                                 "minMaxDate", "multiSelect", "searchText"
  //  filterMultiSelectMustIncludeValueOrFalseOrUndefined   undefined - all select options shown, false - only options within the column data show up, [value] - this value is forced to be a select option even if it is not in the column data (like your own userID)
  //  sortInitialIsAscTFOrUndefined
  //
  //Example Input Data:
  //  p_dataArrayOfObjs: [
  //    {id:1, datetime_utc:"2025-10-12 16:00:00", user_id:6, text_field:"test1"},
  //    {id:2, datetime_utc:"2025-10-12 17:00:00", user_id:13, text_field:"test2"}
  //  ]
  //
  //  p_displayColumnsArrayOfObjs: [
  //    {valueRawDbName:"datetime_utc", fieldTypeObjOrUndefined:c_genericDateTimeNaturalFieldTypeObj, columnDisplayName:"Date", flex01:0, flexBasisEm:11.5, alignClassName:"", filterTypeOrUndefined:"minMaxDate", filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:false},
  //    {valueRawDbName:"user_id", fieldTypeObjOrUndefined:c_selectUserDeactivatedHiddenUnlessCheckedFieldTypeObj, columnDisplayName:"CE User", flex01:1, flexBasisEm:100, alignClassName:"", filterTypeOrUndefined:"multiSelect", filterMultiSelectMustIncludeValueOrFalseOrUndefined:1, sortInitialIsAscTFOrUndefined:undefined},
  //    {valueRawDbName:"text_field", fieldTypeObjOrUndefined:c_genericTextFieldTypeObj, columnDisplayName:"Text Field", flex01:1, flexBasisEm:200, alignClassName:"", filterTypeOrUndefined:"searchText", filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:undefined}
  //  ]
  render() {
    const p_dataTableDisplayName = this.props.p_dataTableDisplayName;
    const p_dataTableDisplayShortName = this.props.p_dataTableDisplayShortName;
    const p_dataIsLoadingTF = this.props.p_dataIsLoadingTF;
    const p_dataLoadingErrorTF = this.props.p_dataLoadingErrorTF;
    const p_dataArrayOfObjs = this.props.p_dataArrayOfObjs;
    const p_uniqueIDColumnValueRawDbName = this.props.p_uniqueIDColumnValueRawDbName;
    const p_displayColumnsArrayOfObjs = this.props.p_displayColumnsArrayOfObjs;
    const p_verticalDotsMenuItemsArrayOfObjsOrUndefined = this.props.p_verticalDotsMenuItemsArrayOfObjsOrUndefined;
    const p_numRowsPerPage = this.props.p_numRowsPerPage;
    const p_filterContainerWithEm = this.props.p_filterContainerWithEm;
    const p_selectedBgColorClass = JSFUNC.prop_value(this.props.p_selectedBgColorClass, "bgBlueGradient");
    const p_selectedFontClass = JSFUNC.prop_value(this.props.p_selectedFontClass, "fontTextLight");
    const p_canClickHoverColorClass = JSFUNC.prop_value(this.props.p_canClickHoverColorClass, "hoverLighterBlueGradient");
    const f_onClickDataRow = this.props.f_onClickDataRow;

    //create a styling obj
    const dtStylingObj = {
      dataTableDisplayName: p_dataTableDisplayName,
      dataTableDisplayShortName: p_dataTableDisplayShortName,
      dataIsLoadingTF: p_dataIsLoadingTF,
      dataLoadingErrorTF: p_dataLoadingErrorTF,
      numRowsPerPage: p_numRowsPerPage,
      filterContainerWithEm: p_filterContainerWithEm,
      selectedBgColorClass: p_selectedBgColorClass,
      selectedFontClass: p_selectedFontClass,
      canClickHoverColorClass: p_canClickHoverColorClass,
      pageButtonWidthEm: 2.2,
      pageButtonHeightEm: 1.4,
      pageButtonCanClickBgClass: p_selectedBgColorClass + " " + p_canClickHoverColorClass,
      pageButtonCanClickFontClass: p_selectedFontClass,
      pageButtonCantClickBgClass: "bgLightestBlue",
      pageButtonCantClickFontClass: "fontTextLighter"
    };

    //expand the columns input with precomputed flags
    var expandedColumnsArrayOfObjs = [];
    var columnIndex = 0;
    for(let columnObj of p_displayColumnsArrayOfObjs) {
      var expandedColumnObj = JSFUNC.copy_obj_simple(columnObj); //columnObj: {valueRawDbName:"datetime_utc", fieldTypeObjOrUndefined:c_genericDateTimeNaturalFieldTypeObj, columnDisplayName:"Date", flex01:0, flexBasisEm:11.5, alignClassName:"", filterTypeOrUndefined:"minMaxDate", filterMultiSelectMustIncludeValueOrFalseOrUndefined:undefined, sortInitialIsAscTFOrUndefined:false}

      var valueMaskDbName = columnObj.valueRawDbName + "_dtVM";
      var valueSortDbName = columnObj.valueRawDbName + "_dtS";
      var valueRawFilterCompareDbName = columnObj.valueRawDbName + "_dtF"; //value raw converted to a format (if needed) to compare to filter (for minMaxDate need to convert raw dateTimeUtc values to local date values, for searchText this is a lowercase text version of the valueMaskPlainText)
      var fieldTypeObjIsUndefinedTF = (columnObj.fieldTypeObjOrUndefined === undefined);
      var altMaskDbNameIsUndefinedTF = (columnObj.altMaskDbNameOrUndefined === undefined);
      var filterTabIndex = ((columnIndex * 2) + 1); //put filter tab indices spaced by 2 to allow for min/max dates that have 2 filters
      var filterMinMaxDateTF = (columnObj.filterTypeOrUndefined === "minMaxDate");
      var filterMultiSelectTF = (columnObj.filterTypeOrUndefined === "multiSelect");
      var filterSearchTextTF = (columnObj.filterTypeOrUndefined === "searchText");
      
      //multiselect filter values to not include (any value not within the full dataset in this column, can be forced with input filterMultiSelectMustIncludeValueOrFalseOrUndefined to always include a particular value even if not in the data [like my own userID])
      var filterMultiSelectFieldTypeObjOrUndefined = undefined;
      var filterMultiSelectValuesAreStringsTF = false;
      var filterMultiSelectValuesToNotIncludeArrayOrUndefined = undefined;
      if(filterMultiSelectTF) {
        if(!fieldTypeObjIsUndefinedTF) {
          if(columnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj !== undefined) {
            if(JSFUNC.is_array(columnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.valueArray)) {
              //convert single select, multiselect (to ensure search/clear), or sharedpercent to multiselect
              var newOverwriteSwsOptionsObj = {isMultiSelectTF:true, hasSearchTF:true, hasClearSelectionTF:true};
              filterMultiSelectFieldTypeObjOrUndefined = this.props.DatabaseMobx.create_new_copy_field_type_obj_from_old_field_type_obj_and_field_input_type_and_sws_options_obj(columnObj.fieldTypeObjOrUndefined, "select", newOverwriteSwsOptionsObj);

              //get if this column select/multiselect has int or string raw data
              filterMultiSelectValuesAreStringsTF = columnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.valuesAreStringsTF;

              //get all unique values from this multiselect filter data column (all other values not in this unique set will be removed as multiselect options, resulting in a multiselect that only has options for what is in the data)
              var columnUniqueDataValuesArray = [];
              if(columnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.isMultiSelectTF) { //if raw data is a multiselect, need to extract each value from the raw data comma lists of each data cell
                for(let dataObj of p_dataArrayOfObjs) {
                  var columnDataValueCommaListString = dataObj[columnObj.valueRawDbName];
                  var columnDataValuesArray = [];
                  if(columnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.valuesAreStringsTF) { //break raw strings multiselect "one,two,three" into ["one", "two", "three"]
                    columnDataValuesArray = JSFUNC.convert_comma_list_to_array(columnDataValueCommaListString);
                  }
                  else { //break raw ints  multiselect "1,2,3" into [1, 2, 3]
                    columnDataValuesArray = JSFUNC.convert_comma_list_to_int_array(columnDataValueCommaListString);
                  }
                  for(let columnDataValue of columnDataValuesArray) {
                    if(!JSFUNC.in_array(columnDataValue, columnUniqueDataValuesArray)) {
                      columnUniqueDataValuesArray.push(columnDataValue);
                    }
                  }
                }
              }
              else { //normal data with single raw value (text, date/datetime, select)
                for(let dataObj of p_dataArrayOfObjs) {
                  var columnDataValue = dataObj[columnObj.valueRawDbName];
                  if(!JSFUNC.in_array(columnDataValue, columnUniqueDataValuesArray)) {
                    columnUniqueDataValuesArray.push(columnDataValue);
                  }
                }
              }

              //get all values in this multiselect options list, add to array those that are not in the data to 'not include'
              if(columnObj.filterMultiSelectMustIncludeValueOrFalseOrUndefined !== false) { //keep all select options if filterMultiSelectMustIncludeValueOrFalseOrUndefined is false (keeps filterMultiSelectValuesToNotIncludeArrayOrUndefined as undefined for the select)
                filterMultiSelectValuesToNotIncludeArrayOrUndefined = [];
                for(let multiSelectValue of columnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.valueArray) {
                  if(!JSFUNC.in_array(multiSelectValue, columnUniqueDataValuesArray)) {
                    filterMultiSelectValuesToNotIncludeArrayOrUndefined.push(multiSelectValue);
                  }
                }
                
                //if a filterMultiSelectMustIncludeValueOrFalseOrUndefined was specified for this multiselect filter column, remove that value from the 'not include' list to force it into the multiselect list of options, regardless of whether that value appears in the data column (such as forcing your userID to always show up in the user list)
                if(columnObj.filterMultiSelectMustIncludeValueOrFalseOrUndefined !== undefined) {
                  filterMultiSelectValuesToNotIncludeArrayOrUndefined = JSFUNC.remove_all_values_from_array(columnObj.filterMultiSelectMustIncludeValueOrFalseOrUndefined, filterMultiSelectValuesToNotIncludeArrayOrUndefined);
                }

                //if the resulting values to not include array is empty, return it to undefined for the filter multiselect component
                if(!JSFUNC.is_array_not_empty(filterMultiSelectValuesToNotIncludeArrayOrUndefined)) {
                  filterMultiSelectValuesToNotIncludeArrayOrUndefined = undefined;
                }
              }
            }
          }
        }
      }

      expandedColumnObj.columnIndex = columnIndex;
      expandedColumnObj.valueMaskDbName = valueMaskDbName;
      expandedColumnObj.valueSortDbName = valueSortDbName;
      expandedColumnObj.valueRawFilterCompareDbName = valueRawFilterCompareDbName; //value raw converted to a format (if needed) to compare to filter (for minMaxDate need to convert raw dateTimeUtc values to local date values)
      expandedColumnObj.fieldTypeObjIsUndefinedTF = fieldTypeObjIsUndefinedTF;
      expandedColumnObj.altMaskDbNameIsUndefinedTF = altMaskDbNameIsUndefinedTF;
      expandedColumnObj.filterTabIndex = filterTabIndex; //put filter tab indices spaced by 2 to allow for min/max dates that have 2 filters
      expandedColumnObj.filterMinMaxDateTF = filterMinMaxDateTF;
      expandedColumnObj.filterMultiSelectTF = filterMultiSelectTF;
      expandedColumnObj.filterSearchTextTF = filterSearchTextTF;
      expandedColumnObj.filterMultiSelectFieldTypeObjOrUndefined = filterMultiSelectFieldTypeObjOrUndefined;
      expandedColumnObj.filterMultiSelectValuesAreStringsTF = filterMultiSelectValuesAreStringsTF;
      expandedColumnObj.filterMultiSelectValuesToNotIncludeArrayOrUndefined = filterMultiSelectValuesToNotIncludeArrayOrUndefined;

      expandedColumnsArrayOfObjs.push(expandedColumnObj); //expandedColumnObj {..., columnIndex:0, valueMaskDbName:"datetime_utc_dtVM", valueSortDbName:"datetime_utc_dtS", valueRawFilterCompareDbName:"datetime_utc_dtF", filterTabIndex:1, filterMinMaxDateTF:true, filterMultiSelectTF:false, filterSearchTextTF:false, filterMultiSelectValuesToNotIncludeArrayOrUndefined:undefined}

      columnIndex++;
    }

    //expand the data, computing mask and sort values from the raw data values
    var expandedDataArrayOfObjs = [];
    for(let dataObj of p_dataArrayOfObjs) {
      var expandedDataObj = JSFUNC.copy_obj(dataObj); //dataObj: {id:1, datetime_utc:"2025-10-12 16:00:00", user_id:6, text_field:"test1"}

      for(let expandedColumnObj of expandedColumnsArrayOfObjs) {
        var dataValueRaw = dataObj[expandedColumnObj.valueRawDbName];

        //initialize mask/sort/filter values
        var dataValueMask = "";
        var dataValueSort = 1;
        var dataValueRawFilterCompare = "";
        if(expandedColumnObj.fieldTypeObjIsUndefinedTF) { //if fieldTypeObjOrUndefined is undefined, there is no special masking of the raw value, instead the mask is the raw value (like an html message), which has no sorting or filter comparison
          dataValueMask = dataValueRaw;
        }
        else { //fieldTypeObjOrUndefined is set, use it to mask the raw value
          var dataValueMaskSortIfoObj = this.props.DatabaseMobx.value_mask_sort_ifo_obj_from_value_raw_and_field_type_obj(dataValueRaw, expandedColumnObj.fieldTypeObjOrUndefined);
          dataValueMask = dataValueMaskSortIfoObj.valueMask;
          dataValueSort = dataValueMaskSortIfoObj.valueSort;

          //if an alternative mask field was provided, overwrite the mask with that data field value (instead of the mask computed above, but still use the sort and the raw filter compare computed here)
          if(!expandedColumnObj.altMaskDbNameIsUndefinedTF) {
            dataValueMask = dataObj[expandedColumnObj.altMaskDbNameOrUndefined];
          }

          //for most filters, the raw value is what is used for the filter mechanism, in the specific case of dateTime, the filters are simple dates (without time), so a local date is exracted from the raw datetime for use in the filter
          dataValueRawFilterCompare = dataValueRaw;
          if(expandedColumnObj.filterMinMaxDateTF && expandedColumnObj.fieldTypeObjOrUndefined.dateTimeTF) { //for minMaxDate, the filter comparison value is converted to a date (without time)
            dataValueRawFilterCompare = JSFUNC.get_Ymd_date_local_from_natural_datetime_utc(dataValueRaw);
          }
          else if(expandedColumnObj.filterMultiSelectTF && expandedColumnObj.fieldTypeObjOrUndefined.selectTF && expandedColumnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.isMultiSelectTF) { //for multiSelect, if the column is also a multiselect with raw comma list data values, convert those comma lists to arrays
            if(expandedColumnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.valuesAreStringsTF) {
              dataValueRawFilterCompare = JSFUNC.convert_comma_list_to_array(dataValueRaw);
            }
            else {
              dataValueRawFilterCompare = JSFUNC.convert_comma_list_to_int_array(dataValueRaw);
            }
          }
          else if(expandedColumnObj.filterSearchTextTF) { //for searchText, the filter comparison value is converted to lowercase
            dataValueRawFilterCompare = JSFUNC.num2str(dataValueMaskSortIfoObj.valueMaskPlainText).toLowerCase();
          }
        }

        expandedDataObj[expandedColumnObj.valueMaskDbName] = dataValueMask;
        expandedDataObj[expandedColumnObj.valueSortDbName] = dataValueSort;
        expandedDataObj[expandedColumnObj.valueRawFilterCompareDbName] = dataValueRawFilterCompare;
      }

      expandedDataArrayOfObjs.push(expandedDataObj); //expandedDataObj: {..., datetime_utc_dtVM:"Oct 12, 2025 12:00 PM", datetime_utc_dtS:"2025-10-12 12:00:00", datetime_utc_dtF:"2025-10-12", user_id_dtVM:"Drew UPE (Contracts)", user_id_dtS:"000000000003", user_id_dtF:6}
    }

    return(
      <DataTableWithFiltersColSortPagesAfterRawDataExpansion
        p_expandedDataArrayOfObjs={expandedDataArrayOfObjs}
        p_uniqueIDColumnValueRawDbName={p_uniqueIDColumnValueRawDbName}
        p_expandedColumnsArrayOfObjs={expandedColumnsArrayOfObjs}
        p_verticalDotsMenuItemsArrayOfObjsOrUndefined={p_verticalDotsMenuItemsArrayOfObjsOrUndefined}
        p_dtStylingObj={dtStylingObj}
        f_onClickDataRow={f_onClickDataRow}
      />
    );
  }
}));


const DataTableWithFiltersColSortPagesAfterRawDataExpansion = inject("DatabaseMobx")(observer(
class DataTableWithFiltersColSortPagesAfterRawDataExpansion extends Component { //props: p_expandedDataArrayOfObjs, p_uniqueIDColumnValueRawDbName, p_expandedColumnsArrayOfObjs, p_verticalDotsMenuItemsArrayOfObjsOrUndefined, p_dtStylingObj, f_onClickDataRow(i_dataRowUniqueIDClicked)
  constructor(props) {
    super(props);

    const p_expandedColumnsArrayOfObjs = this.props.p_expandedColumnsArrayOfObjs;

    //initialze the column filter values (none have any set values initially)
    var initialColumnFilterSelectedValuesArray = [];
    for(let expandedColumnObj of p_expandedColumnsArrayOfObjs) {
      var initialFilterValueOrUndefined = undefined;
      if(expandedColumnObj.filterMinMaxDateTF) {
        initialFilterValueOrUndefined = {minDate:JSFUNC.blank_date(), maxDate:JSFUNC.blank_date()} //date (without time) is used for date or datetime column type filters
      }
      else if(expandedColumnObj.filterMultiSelectTF) {
        initialFilterValueOrUndefined = ""; //blank value for a multiselect (used for both select or multiselect column field types, filter is always forced to be multiselect)
      }
      else if(expandedColumnObj.filterSearchTextTF) {
        initialFilterValueOrUndefined = ""; //blank value for a search text is ""
      }
      initialColumnFilterSelectedValuesArray.push(initialFilterValueOrUndefined);
    }

    //first column with sortInitialIsAscTFOrUndefined set to true or false is the initial sorted column
    var initialSortColumnIndex = 0;
    var initialSortIAscTF = false;
    for(let expandedColumnObj of p_expandedColumnsArrayOfObjs) {
      if((expandedColumnObj.sortInitialIsAscTFOrUndefined === true) || (expandedColumnObj.sortInitialIsAscTFOrUndefined === false)) {
        initialSortColumnIndex = expandedColumnObj.columnIndex;
        initialSortIAscTF = expandedColumnObj.sortInitialIsAscTFOrUndefined;
        break;
      }
    }

    this.state = {
      s_columnFilterSelectedValuesArray: initialColumnFilterSelectedValuesArray,
      s_sortColumnIndex: initialSortColumnIndex,
      s_sortIsAscTF: initialSortIAscTF
    }
  }

  onchange_column_filter_value = (i_columnIndex, i_updatedFilterValue) => {
    const s_columnFilterSelectedValuesArray = this.state.s_columnFilterSelectedValuesArray;

    var updatedColumnFilterSelectedValuesArray = JSFUNC.copy_array(s_columnFilterSelectedValuesArray);
    updatedColumnFilterSelectedValuesArray[i_columnIndex] = i_updatedFilterValue;

    this.setState({s_columnFilterSelectedValuesArray:updatedColumnFilterSelectedValuesArray});
  }

  onclick_column_header = (i_columnIndex, i_columnDbName) => {
    const s_sortColumnIndex = this.state.s_sortColumnIndex;
    const s_sortIsAscTF = this.state.s_sortIsAscTF;

    if(i_columnIndex === s_sortColumnIndex) { //clicked column already sorted, flip the direction of the sort
      const updatedSortIsAscTF = (!s_sortIsAscTF);
      this.setState({s_sortIsAscTF:updatedSortIsAscTF});
    }
    else {
      this.setState({
        s_sortColumnIndex: i_columnIndex,
        s_sortIsAscTF: true
      });
    }
  }

  render() {
    const s_columnFilterSelectedValuesArray = this.state.s_columnFilterSelectedValuesArray;
    const s_sortColumnIndex = this.state.s_sortColumnIndex;
    const s_sortIsAscTF = this.state.s_sortIsAscTF;

    const p_expandedDataArrayOfObjs = this.props.p_expandedDataArrayOfObjs;
    const p_uniqueIDColumnValueRawDbName = this.props.p_uniqueIDColumnValueRawDbName;
    const p_expandedColumnsArrayOfObjs = this.props.p_expandedColumnsArrayOfObjs;
    const p_verticalDotsMenuItemsArrayOfObjsOrUndefined = this.props.p_verticalDotsMenuItemsArrayOfObjsOrUndefined;
    const p_dtStylingObj = this.props.p_dtStylingObj;
    const f_onClickDataRow = this.props.f_onClickDataRow;

    const c_genericTextFieldTypeObj = this.props.DatabaseMobx.c_genericTextFieldTypeObj;
    const c_genericDateFieldTypeObj = this.props.DatabaseMobx.c_genericDateFieldTypeObj;

    //computations for each column (name with sort, filters)
    var computedColumnsArrayOfObjs = [];
    var sortFieldDbNameOrUndefined = undefined; //also get which column dbName is currently sorted from the column index
    for(let expandedColumnObj of p_expandedColumnsArrayOfObjs) {
      var displayNameWithSortArrow = expandedColumnObj.columnDisplayName;
      var filterSelectedValue = s_columnFilterSelectedValuesArray[expandedColumnObj.columnIndex];
      var filterFilledOutTF = false; //TF (or obj of {minTF/maxTF}) for each column if the corresponding filter (if the column has a filter) is filled out with any user entered value
      var filterMultiSelectValuesArrayOrUndefined = undefined; //filter multiselect raw id comma lists converted to array (or undefined if column is not a multiselect filter)
      var filterSearchTextValueLowercaseOrUndefined = undefined; //filter searchText text input is converted to lowercase here for comparison to all lowercase plaintext masked data in this column

      //column display name with sort arrow if sorted
      if(expandedColumnObj.columnIndex === s_sortColumnIndex) {
        displayNameWithSortArrow += " " + ((s_sortIsAscTF) ? (" \u25BC") : (" \u25B2"));
        sortFieldDbNameOrUndefined = expandedColumnObj.valueSortDbName;
      }

      //filter filled out tf and multiselect values comma list converted to an int array
      if(expandedColumnObj.filterMinMaxDateTF) {
        var minDateFilterFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(filterSelectedValue.min, c_genericDateFieldTypeObj);
        var maxDateFilterFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(filterSelectedValue.max, c_genericDateFieldTypeObj);
        filterFilledOutTF = {minTF:minDateFilterFilledOutTF, maxTF:maxDateFilterFilledOutTF};
      }
      else if(expandedColumnObj.filterMultiSelectTF) {
        filterFilledOutTF = JSFUNC.selectmulti_is_filled_out_tf(filterSelectedValue); //comma list string of selected filter values (like userIDs "1,7,3,19" converted to [1,7,3,19])
        if(filterFilledOutTF) {
          if(expandedColumnObj.filterMultiSelectValuesAreStringsTF) { //select/multiselect raw data strings
            filterMultiSelectValuesArrayOrUndefined = JSFUNC.convert_comma_list_to_array(filterSelectedValue);
          }
          else { //select/multiselect raw data ints
            filterMultiSelectValuesArrayOrUndefined = JSFUNC.convert_comma_list_to_int_array(filterSelectedValue);
          }
        }
      }
      else if(expandedColumnObj.filterSearchTextTF) {
        filterFilledOutTF = this.props.DatabaseMobx.value_is_filled_out_tf_from_value_raw_and_field_type_obj(filterSelectedValue, c_genericTextFieldTypeObj);
        if(filterFilledOutTF) {
          filterSearchTextValueLowercaseOrUndefined = JSFUNC.num2str(filterSelectedValue).toLowerCase();
        }
      }

      computedColumnsArrayOfObjs.push({
        displayNameWithSortArrow: displayNameWithSortArrow,
        filterSelectedValue: filterSelectedValue,
        filterFilledOutTF: filterFilledOutTF,
        filterMultiSelectValuesArrayOrUndefined: filterMultiSelectValuesArrayOrUndefined,
        filterSearchTextValueLowercaseOrUndefined: filterSearchTextValueLowercaseOrUndefined
      });
    }

    //filter items based on filter(s) filled out
    var filteredSortedExpandedDataArrayOfObjs = [];
    for(let expandedDataObj of p_expandedDataArrayOfObjs) {
      var dataRowMatchesAllFiltersTF = true;

      for(let expandedColumnObj of p_expandedColumnsArrayOfObjs) {
        var computedColumnObj = computedColumnsArrayOfObjs[expandedColumnObj.columnIndex];

        if(expandedColumnObj.filterMinMaxDateTF && (computedColumnObj.filterFilledOutTF.minTF || computedColumnObj.filterFilledOutTF.maxTF)) { //min/max date filter pair (make sure at least 1 of them is filled out which requires checking the raw data against the filter)
          var dataValueRawFilterCompare = expandedDataObj[expandedColumnObj.valueRawFilterCompareDbName]; //get data raw value (converted for filter comparison) for this dataRow and column combination
          if(!((!computedColumnObj.filterFilledOutTF.minTF || (dataValueRawFilterCompare >= computedColumnObj.filterSelectedValue.min)) && (!computedColumnObj.filterFilledOutTF.maxTF || (dataValueRawFilterCompare <= computedColumnObj.filterSelectedValue.max)))) { //if this data cell date/datetime does not fall between the min (if on) and max (if on) filters, whole data row doesn't match
            dataRowMatchesAllFiltersTF = false;
            break;
          }
        }
        else if(expandedColumnObj.filterMultiSelectTF && computedColumnObj.filterFilledOutTF) { //if the data cell select raw value is not one of the multiselected filter values, whole data row doesn't match
          if(JSFUNC.is_array(computedColumnObj.filterMultiSelectValuesArrayOrUndefined)) {
            var dataValueRawFilterCompare = expandedDataObj[expandedColumnObj.valueRawFilterCompareDbName]; //get data raw value (converted for filter comparison) for this dataRow and column combination
            if(expandedColumnObj.fieldTypeObjOrUndefined.selectWithSearchDataObj.isMultiSelectTF) {
              if(!JSFUNC.any_of_array1_is_in_array2(dataValueRawFilterCompare, computedColumnObj.filterMultiSelectValuesArrayOrUndefined)) {
                dataRowMatchesAllFiltersTF = false;
                break;
              }
            }
            else {
              if(!JSFUNC.in_array(dataValueRawFilterCompare, computedColumnObj.filterMultiSelectValuesArrayOrUndefined)) {
                dataRowMatchesAllFiltersTF = false;
                break;
              }
            }
          }
        }
        else if(expandedColumnObj.filterSearchTextTF && computedColumnObj.filterFilledOutTF) {
          var dataValueRawFilterCompare = expandedDataObj[expandedColumnObj.valueRawFilterCompareDbName]; //get data raw value (converted for filter comparison) for this dataRow and column combination
          if(!JSFUNC.input_lowercase_string_contains_lowercase_search_term_string_tf(dataValueRawFilterCompare, computedColumnObj.filterSearchTextValueLowercaseOrUndefined)) {
            dataRowMatchesAllFiltersTF = false;
            break;
          }
        }
      }

      if(dataRowMatchesAllFiltersTF) {
        filteredSortedExpandedDataArrayOfObjs.push(expandedDataObj);
      }
    }

    //sort items based on selected sort column and direction
    if(sortFieldDbNameOrUndefined !== undefined) {
      JSFUNC.sort_arrayOfObjs(filteredSortedExpandedDataArrayOfObjs, sortFieldDbNameOrUndefined, s_sortIsAscTF);
    }

    return(
      <DataTableWithFiltersColSortPagesAfterFilterSort
        p_filteredSortedExpandedDataArrayOfObjs={filteredSortedExpandedDataArrayOfObjs}
        p_uniqueIDColumnValueRawDbName={p_uniqueIDColumnValueRawDbName}
        p_expandedColumnsArrayOfObjs={p_expandedColumnsArrayOfObjs}
        p_computedColumnsArrayOfObjs={computedColumnsArrayOfObjs}
        p_verticalDotsMenuItemsArrayOfObjsOrUndefined={p_verticalDotsMenuItemsArrayOfObjsOrUndefined}
        p_dtStylingObj={p_dtStylingObj}
        f_onChangeFilterValue={this.onchange_column_filter_value}
        f_onClickHeader={this.onclick_column_header}
        f_onClickDataRow={f_onClickDataRow}
      />
    );
  }
}));


class DataTableWithFiltersColSortPagesAfterFilterSort extends Component { //props: 
  //p_filteredSortedExpandedDataArrayOfObjs, p_uniqueIDColumnValueRawDbName, p_expandedColumnsArrayOfObjs, p_computedColumnsArrayOfObjs, p_verticalDotsMenuItemsArrayOfObjsOrUndefined, p_dtStylingObj, 
  //f_onChangeFilterValue(i_columnIndex, i_updatedFilterValue), 
  //f_onClickHeader(i_columnIndex, i_columnDbName), f_onClickDataRow(i_dataRowUniqueIDClicked)
  constructor(props) {
    super(props);
    this.state = {
      s_currentPageNumber: 1,
      s_clickedDataRowUniqueID: -1
    }
  }

  onchange_column_filter_value = (i_columnIndex, i_updatedFilterValue) => {
    const f_onChangeFilterValue = this.props.f_onChangeFilterValue;

    //reset the selected page number to 1 when any filter value is changed
    this.setState({s_currentPageNumber:1});

    if(JSFUNC.is_function(f_onChangeFilterValue)) {
      f_onChangeFilterValue(i_columnIndex, i_updatedFilterValue);
    }
  }

  onclick_increment_current_page_number = () => {
    const s_currentPageNumber = this.state.s_currentPageNumber;
    const updatedPageNumber = (s_currentPageNumber + 1);
    this.setState({s_currentPageNumber:updatedPageNumber});
  }

  onclick_decrement_current_page_number = () => {
    const s_currentPageNumber = this.state.s_currentPageNumber;
    const updatedPageNumber = (s_currentPageNumber - 1);
    this.setState({s_currentPageNumber:updatedPageNumber});
  }

  onclick_data_row = (i_dataRowUniqueIDClicked) => {
    const s_clickedDataRowUniqueID = this.state.s_clickedDataRowUniqueID;
    const f_onClickDataRow = this.props.f_onClickDataRow;

    var updatedDataRowUniqueIDClicked = -1;
    if(i_dataRowUniqueIDClicked !== s_clickedDataRowUniqueID) {
      updatedDataRowUniqueIDClicked = i_dataRowUniqueIDClicked;
    }
    this.setState({s_clickedDataRowUniqueID:updatedDataRowUniqueIDClicked});

    if(JSFUNC.is_function(f_onClickDataRow)) {
      f_onClickDataRow(i_dataRowUniqueIDClicked);
    }
  }

  render() {
    const s_currentPageNumber = this.state.s_currentPageNumber;
    const s_clickedDataRowUniqueID = this.state.s_clickedDataRowUniqueID;

    const p_filteredSortedExpandedDataArrayOfObjs = this.props.p_filteredSortedExpandedDataArrayOfObjs;
    const p_uniqueIDColumnValueRawDbName = this.props.p_uniqueIDColumnValueRawDbName;
    const p_expandedColumnsArrayOfObjs = this.props.p_expandedColumnsArrayOfObjs;
    const p_computedColumnsArrayOfObjs = this.props.p_computedColumnsArrayOfObjs;
    const p_verticalDotsMenuItemsArrayOfObjsOrUndefined = this.props.p_verticalDotsMenuItemsArrayOfObjsOrUndefined;
    const p_dtStylingObj = this.props.p_dtStylingObj;
    const f_onChangeFilterValue = this.props.f_onChangeFilterValue;
    const f_onClickHeader = this.props.f_onClickHeader;

    const columnValueMaskDbNamesArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_expandedColumnsArrayOfObjs, "valueMaskDbName");
    const columnsFlex01Array = JSFUNC.get_column_vector_from_arrayOfObjs(p_expandedColumnsArrayOfObjs, "flex01");
    const columnsFlexBasisEmArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_expandedColumnsArrayOfObjs, "flexBasisEm");
    const columnAlignClassNamesOrEmptyStringsArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_expandedColumnsArrayOfObjs, "alignClassName");
    const columnDisplayNamesArray = JSFUNC.get_column_vector_from_arrayOfObjs(p_computedColumnsArrayOfObjs, "displayNameWithSortArrow");

    //compute information about current page and page increment/decrement (on filtered data list)
    const filteredTotalNumDataRows = p_filteredSortedExpandedDataArrayOfObjs.length;
    const currentPageFirstRowNumber = ((filteredTotalNumDataRows > 0) ? (((s_currentPageNumber - 1) * p_dtStylingObj.numRowsPerPage) + 1) : (0));
    var currentPageLastRowNumber = (s_currentPageNumber * p_dtStylingObj.numRowsPerPage);
    if(filteredTotalNumDataRows < currentPageLastRowNumber) {
      currentPageLastRowNumber = filteredTotalNumDataRows;
    }
    const canIncrementCurrentPageNumberTF = (currentPageLastRowNumber < filteredTotalNumDataRows);
    const canDecrementCurrentPageNumberTF = (s_currentPageNumber > 1);

    //filtered items passed through secondary filter for only items on this current page
    var filteredSortedDataMaskRowsOnSelectedPageArrayOfObjs = [];
    var dataRowNumber = 1;
    for(let expandedDataObj of p_filteredSortedExpandedDataArrayOfObjs) {
      if((dataRowNumber >= currentPageFirstRowNumber) && (dataRowNumber <= currentPageLastRowNumber)) { //only include (filtered/sorted) data rows that can be shown on the currently selected page number
        //get each display column mask value in an array
        var dataValueMasksArray = [];
        for(let columnValueMaskDbName of columnValueMaskDbNamesArray) {
          dataValueMasksArray.push(expandedDataObj[columnValueMaskDbName]);
        }

        //develop a random unique key for each row that changes when pages are changed to fully redraw with correct rows
        filteredSortedDataMaskRowsOnSelectedPageArrayOfObjs.push({
          key: "id" + expandedDataObj[p_uniqueIDColumnValueRawDbName] + "_" + JSFUNC.key_rand(),
          uniqueID: expandedDataObj[p_uniqueIDColumnValueRawDbName],
          dataValueMasksArray: dataValueMasksArray
        });
      }
      dataRowNumber++;
    }

    var dataTableOrLoadingMessageComponent = null;
    if(p_dtStylingObj.dataIsLoadingTF) {
      dataTableOrLoadingMessageComponent = (
        <EmptyScreenWhiteWithLoadingAnimation>
          {"Loading the " + p_dtStylingObj.dataTableDisplayName + " data..."}
        </EmptyScreenWhiteWithLoadingAnimation>
      );
    }
    else if(p_dtStylingObj.dataLoadingErrorTF) {
      dataTableOrLoadingMessageComponent = (
        <EmptyScreenMessage p_fontClass="font11 fontItalic fontRed">
          <div>{"There was an issue loading the " + p_dtStylingObj.dataTableDisplayName + " data."}</div>
          <div>{"Switch tabs and come back to this one to try reloading."}</div>
        </EmptyScreenMessage>
      );
    }
    else {
      dataTableOrLoadingMessageComponent = (
        <div className="flex11a yScroll yScrollBottomPad">
          {filteredSortedDataMaskRowsOnSelectedPageArrayOfObjs.map((m_dataMaskRowObj) =>
            <DataRow
              key={m_dataMaskRowObj.key}
              p_itemID={m_dataMaskRowObj.uniqueID}
              p_flex01Array={columnsFlex01Array}
              p_flexBasisEmArray={columnsFlexBasisEmArray}
              p_columnValueMaskDbNamesArray={columnValueMaskDbNamesArray}
              p_dataArray={m_dataMaskRowObj.dataValueMasksArray}
              p_alignClassNameOrEmptyStringArray={columnAlignClassNamesOrEmptyStringsArray}
              p_class={((m_dataMaskRowObj.uniqueID === s_clickedDataRowUniqueID) ? ("bgLighterBlue") : (undefined))}
              p_heightLimit={((m_dataMaskRowObj.uniqueID === s_clickedDataRowUniqueID) ? (undefined) : ("2em"))}
              p_title="[Click to view all content in this data row]"
              f_onClick={this.onclick_data_row}
            />
          )}
        </div>
      );
    }

    return(
      <>
        <div className="flex00a displayFlexRow borderB1bbb bgLightesterGray">
          <div className="flex11a displayFlexRow flexWrap tbPad">
            <DataTablePageAndFilterContainer p_label={"Pages of " + p_dtStylingObj.dataTableDisplayShortName + " Entries"} p_width="17em" p_isFilledOutTF={false} p_dtStylingObj={p_dtStylingObj}>
              <div className="displayFlexRowVc bgAlmostWhite border bevelBorderColors tbMicroPad lrMedPad">
                <div className="flex00a">
                  <ButtonPageIncrementOrDecrement
                    p_incTrueDecFalse={false}
                    p_canClickTF={canDecrementCurrentPageNumberTF}
                    p_widthEm={p_dtStylingObj.pageButtonWidthEm}
                    p_heightEm={p_dtStylingObj.pageButtonHeightEm}
                    p_canClickBgClass={p_dtStylingObj.pageButtonCanClickBgClass}
                    p_canClickFontClass={p_dtStylingObj.pageButtonCanClickFontClass}
                    p_cantClickBgClass={p_dtStylingObj.pageButtonCantClickBgClass}
                    p_cantClickFontClass={p_dtStylingObj.pageButtonCantClickFontClass}
                    f_onClick={this.onclick_decrement_current_page_number}
                  />
                </div>
                <div className="flex11a lrPad textCenter">
                  <font className="">
                    {currentPageFirstRowNumber + " - " + currentPageLastRowNumber + " of " + filteredTotalNumDataRows}
                  </font>
                </div>
                <div className="flex00a">
                  <ButtonPageIncrementOrDecrement
                    p_incTrueDecFalse={true}
                    p_canClickTF={canIncrementCurrentPageNumberTF}
                    p_widthEm={p_dtStylingObj.pageButtonWidthEm}
                    p_heightEm={p_dtStylingObj.pageButtonHeightEm}
                    p_canClickBgClass={p_dtStylingObj.pageButtonCanClickBgClass}
                    p_canClickFontClass={p_dtStylingObj.pageButtonCanClickFontClass}
                    p_cantClickBgClass={p_dtStylingObj.pageButtonCantClickBgClass}
                    p_cantClickFontClass={p_dtStylingObj.pageButtonCantClickFontClass}
                    f_onClick={this.onclick_increment_current_page_number}
                  />
                </div>
              </div>
            </DataTablePageAndFilterContainer>
            {p_expandedColumnsArrayOfObjs.map((m_expandedColumnObj, m_index) =>
              <DataTableSingleFieldFilter
                key={"ff" + m_expandedColumnObj.valueRawDbName}
                p_expandedColumnObj={m_expandedColumnObj}
                p_computedColumnObj={p_computedColumnsArrayOfObjs[m_index]}
                p_dtStylingObj={p_dtStylingObj}
                f_onChangeFilterValue={this.onchange_column_filter_value}
              />
            )}
          </div>
          {(p_verticalDotsMenuItemsArrayOfObjsOrUndefined !== undefined) &&
            <div className="flex00a displayFlexColumnHcVc" style={{flexBasis:"2.5em"}}>
              <VerticalDotsMenu
                p_menuItemsArrayOfObjs={p_verticalDotsMenuItemsArrayOfObjsOrUndefined}
              />
            </div>
          }
        </div>
        <ColumnHeaderRow
          p_flex01Array={columnsFlex01Array}
          p_flexBasisEmArray={columnsFlexBasisEmArray}
          p_columnValueMaskDbNamesArray={columnValueMaskDbNamesArray}
          p_columnDisplayNamesArray={columnDisplayNamesArray}
          f_onClickHeader={f_onClickHeader}
        />
        {dataTableOrLoadingMessageComponent}
      </>
    );
  }
}


const DataTableSingleFieldFilter = inject("DatabaseMobx")(observer(
class DataTableSingleFieldFilter extends Component { //props: p_expandedColumnObj, p_computedColumnObj, p_dtStylingObj, f_onChangeFilterValue(i_columnIndex, i_updatedFilterValue)
  onchange_filter_date_min = (i_selectedDate) => {
    const p_expandedColumnObj = this.props.p_expandedColumnObj;
    const p_computedColumnObj = this.props.p_computedColumnObj;
    const f_onChangeFilterValue = this.props.f_onChangeFilterValue;

    const updatedFilterValue = {min:i_selectedDate, max:p_computedColumnObj.filterSelectedValue.max};

    if(JSFUNC.is_function(f_onChangeFilterValue)) {
      f_onChangeFilterValue(p_expandedColumnObj.columnIndex, updatedFilterValue);
    }
  }

  onchange_filter_date_max = (i_selectedDate) => {
    const p_expandedColumnObj = this.props.p_expandedColumnObj;
    const p_computedColumnObj = this.props.p_computedColumnObj;
    const f_onChangeFilterValue = this.props.f_onChangeFilterValue;

    const updatedFilterValue = {min:p_computedColumnObj.filterSelectedValue.min, max:i_selectedDate};

    if(JSFUNC.is_function(f_onChangeFilterValue)) {
      f_onChangeFilterValue(p_expandedColumnObj.columnIndex, updatedFilterValue);
    }
  }

  onchange_filter_multiselect = (i_selectedValuesCommaListString) => {
    const p_expandedColumnObj = this.props.p_expandedColumnObj;
    const f_onChangeFilterValue = this.props.f_onChangeFilterValue;

    if(JSFUNC.is_function(f_onChangeFilterValue)) {
      f_onChangeFilterValue(p_expandedColumnObj.columnIndex, i_selectedValuesCommaListString);
    }
  }

  onchange_filter_search_text = (i_updatedSearchText) => {
    const p_expandedColumnObj = this.props.p_expandedColumnObj;
    const f_onChangeFilterValue = this.props.f_onChangeFilterValue;

    if(JSFUNC.is_function(f_onChangeFilterValue)) {
      f_onChangeFilterValue(p_expandedColumnObj.columnIndex, i_updatedSearchText);
    }
  }

  render() {
    const p_expandedColumnObj = this.props.p_expandedColumnObj;
    const p_computedColumnObj = this.props.p_computedColumnObj;
    const p_dtStylingObj = this.props.p_dtStylingObj;

    const c_genericDateFieldTypeObj = this.props.DatabaseMobx.c_genericDateFieldTypeObj;

    if(p_expandedColumnObj.filterMinMaxDateTF) {
      return(
        <>
          <DataTablePageAndFilterContainer p_label="Date Min" p_width={undefined} p_isFilledOutTF={p_computedColumnObj.filterFilledOutTF.minTF} p_dtStylingObj={p_dtStylingObj}>
            <GenericInputOrSelectFromInputType
              p_fieldTypeObj={c_genericDateFieldTypeObj}
              p_valueRaw={p_computedColumnObj.filterSelectedValue.min}
              p_tabIndex={p_expandedColumnObj.filterTabIndex}
              f_onChangeOrOnSelect={this.onchange_filter_date_min}
            />
          </DataTablePageAndFilterContainer>
          <DataTablePageAndFilterContainer p_label="Date Max" p_width={undefined} p_isFilledOutTF={p_computedColumnObj.filterFilledOutTF.maxTF} p_dtStylingObj={p_dtStylingObj}>
            <GenericInputOrSelectFromInputType
              p_fieldTypeObj={c_genericDateFieldTypeObj}
              p_valueRaw={p_computedColumnObj.filterSelectedValue.max}
              p_tabIndex={(p_expandedColumnObj.filterTabIndex + 1)}
              f_onChangeOrOnSelect={this.onchange_filter_date_max}
            />
          </DataTablePageAndFilterContainer>
        </>
      );
    }

    if(p_expandedColumnObj.filterMultiSelectTF) {
      return(
        <DataTablePageAndFilterContainer p_label={"Filter by " + p_expandedColumnObj.columnDisplayName} p_width={p_dtStylingObj.filterContainerWithEm + "em"} p_isFilledOutTF={p_computedColumnObj.filterFilledOutTF} p_dtStylingObj={p_dtStylingObj}>
          <GenericInputOrSelectFromInputType
            p_fieldTypeObj={p_expandedColumnObj.filterMultiSelectFieldTypeObjOrUndefined}
            p_valueRaw={p_computedColumnObj.filterSelectedValue}
            p_valuesToNotIncludeArray={p_expandedColumnObj.filterMultiSelectValuesToNotIncludeArrayOrUndefined}
            p_tabIndex={p_expandedColumnObj.filterTabIndex}
            f_onChangeOrOnSelect={this.onchange_filter_multiselect}
          />
        </DataTablePageAndFilterContainer>
      );
    }

    if(p_expandedColumnObj.filterSearchTextTF) {
      return(
        <DataTablePageAndFilterContainer p_label={"Filter by " + p_expandedColumnObj.columnDisplayName} p_width={p_dtStylingObj.filterContainerWithEm + "em"} p_isFilledOutTF={p_computedColumnObj.filterFilledOutTF} p_dtStylingObj={p_dtStylingObj}>
          <SearchInputTextWithClearX
            p_inputText={p_computedColumnObj.filterSelectedValue}
            p_placeholderText={"Filter '" + p_expandedColumnObj.columnDisplayName + "'..."}
            p_includeSearchIconTF={true}
            p_heightEm={1.8}
            p_tabIndex={p_expandedColumnObj.filterTabIndex}
            f_onChange={this.onchange_filter_search_text}
          />
        </DataTablePageAndFilterContainer>
      );
    }

    return(null);
  }
}));


function DataTablePageAndFilterContainer(props) { //props: p_label, p_width, p_isFilledOutTF, p_dtStylingObj, children
  const p_label = props.p_label;
  const p_width = props.p_width;
  const p_isFilledOutTF = props.p_isFilledOutTF;
  const p_dtStylingObj = props.p_dtStylingObj;

  return(
    <div
      className={"flex00a lrMargin " + ((p_isFilledOutTF) ? (p_dtStylingObj.selectedBgColorClass) : ("")) + " tbMicroPad lrPad"}
      style={{width:p_width}}>
      <div className="microBottomMargin textCenter">
        <font className={"font09 fontItalic " + ((p_isFilledOutTF) ? (p_dtStylingObj.selectedFontClass) : ("fontTextLight"))}>
          {p_label}
        </font>
      </div>
      <div>
        {props.children}
      </div>
    </div>
  );
}



export class ColumnHeaderRow extends Component { //props: p_flex01Array, p_flexBasisEmArray, p_columnValueMaskDbNamesArray, p_columnDisplayNamesArray, f_onClickHeader(i_columnIndex, i_columnDbName)
  render() {
    const p_flex01Array = this.props.p_flex01Array;
    const p_flexBasisEmArray = this.props.p_flexBasisEmArray;
    const p_columnValueMaskDbNamesArray = this.props.p_columnValueMaskDbNamesArray;
    const p_columnDisplayNamesArray = this.props.p_columnDisplayNamesArray;
    const f_onClickHeader = this.props.f_onClickHeader;

    return(
      <div className="flex00a displayFlexRowVc textCenter fontItalic fontBold fontTextLighter" style={{flexBasis:"2em", borderBottom:"solid 1px #aaa"}}>
        {p_columnDisplayNamesArray.map((m_columnDisplayName, m_index) =>
          <ColumnHeader
            p_columnIndex={m_index}
            p_flex01={p_flex01Array[m_index]}
            p_flexBasisEm={p_flexBasisEmArray[m_index]}
            p_columnValueMaskDbName={p_columnValueMaskDbNamesArray[m_index]}
            p_columnDisplayName={m_columnDisplayName}
            f_onClick={f_onClickHeader}
          />
        )}
      </div>
    );
  }
}

class ColumnHeader extends Component { //props: p_columnIndex, p_flex01, p_flexBasisEm, p_columnValueMaskDbName, p_columnDisplayName, f_onClick(i_columnIndex, i_columnDbName)
  onclick_header = () => {
    const p_columnIndex = this.props.p_columnIndex;
    const p_columnValueMaskDbName = this.props.p_columnValueMaskDbName;
    const f_onClick = this.props.f_onClick;

    if(JSFUNC.is_function(f_onClick)) {
      this.props.f_onClick(p_columnIndex, p_columnValueMaskDbName);
    }
  }

  render() {
    const p_columnIndex = this.props.p_columnIndex;
    const p_flex01 = this.props.p_flex01;
    const p_flexBasisEm = this.props.p_flexBasisEm;
    const p_columnValueMaskDbName = this.props.p_columnValueMaskDbName;
    const p_columnDisplayName = this.props.p_columnDisplayName;
    const f_onClick = this.props.f_onClick;

    const firstColumnTF = (p_columnIndex === 0);
    const hasOnClickTF = JSFUNC.is_function(f_onClick);

    return(
      <div
        key={"CH_" + p_columnValueMaskDbName}
        className={((p_flex01 === 1) ? ("flex11a") : ("flex00a")) + " " + ((firstColumnTF) ? ("") : ("borderL1ddd")) + " lrPad " + ((hasOnClickTF) ? ("cursorPointer") : (""))}
        style={{flexBasis:p_flexBasisEm + "em"}}
        title={p_columnDisplayName}
        onClick={((hasOnClickTF) ? (this.onclick_header) : (undefined))}>
        <LibraryReact.NowrapEllipsis>
          {p_columnDisplayName}
        </LibraryReact.NowrapEllipsis>
      </div>
    );
  }
}

export class DataRow extends Component { //props: p_itemID, p_flex01Array, p_flexBasisEmArray, p_columnValueMaskDbNamesArray, p_dataArray, p_alignClassNameOrEmptyStringArray, p_class, p_heightLimit, p_title, f_onClick
  onclick_data_row = () => {
    const p_itemID = this.props.p_itemID;
    const f_onClick = this.props.f_onClick;

    if(JSFUNC.is_function(f_onClick)) {
      f_onClick(p_itemID);
    }
  }

  render() {
    const p_itemID = this.props.p_itemID;
    const p_flex01Array = this.props.p_flex01Array;
    const p_flexBasisEmArray = this.props.p_flexBasisEmArray;
    const p_columnValueMaskDbNamesArray = this.props.p_columnValueMaskDbNamesArray;
    const p_dataArray = this.props.p_dataArray;
    const p_alignClassNameOrEmptyStringArray = this.props.p_alignClassNameOrEmptyStringArray;
    const p_class = JSFUNC.prop_value(this.props.p_class, "");
    const p_heightLimit = this.props.p_heightLimit;
    const p_title = this.props.p_title;
    const f_onClick = this.props.f_onClick;

    const hasAlignClassNamesTF = JSFUNC.is_array(p_alignClassNameOrEmptyStringArray);
    const hasOnClickTF = JSFUNC.is_function(f_onClick);

    return(
      <div
        className={"displayFlexRow borderB1eee overflowHidden " + p_class + " " + ((hasOnClickTF) ? ("hoverLighterBlueGradient cursorPointer") : (""))}
        style={{maxHeight:p_heightLimit}}
        title={p_title}
        onClick={((hasOnClickTF) ? (this.onclick_data_row) : (undefined))}>
        {p_columnValueMaskDbNamesArray.map((m_columnValueMaskDbName, m_index) =>
          <div
            key={m_columnValueMaskDbName + "_" + p_itemID}
            className={((p_flex01Array[m_index] === 1) ? ("flex11a") : ("flex00a")) + " smallFullPad breakWord " + ((hasAlignClassNamesTF) ? (p_alignClassNameOrEmptyStringArray[m_index]) : (""))}
            style={{flexBasis:p_flexBasisEmArray[m_index] + "em"}}>
            {p_dataArray[m_index]}
          </div>
        )}
      </div>
    );
  }
}

